
  const cities= [
    {
      value: '1',
      label: '32 Ml',
      type: 'City'
    },
    {
      value: '2',
      label: '10th Mile',
      type: 'City'
    },
    {
      value: '3',
      label: '14th Mile Stone',
      type: 'City'
    },
    {
      value: '4',
      label: 'A.S.Peta',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5',
      label: 'Aachara',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6',
      label: 'Aachyunthapuram',
      type: 'City'
    },
    {
      value: '7',
      label: 'Aadsar',
      type: 'City'
    },
    {
      value: '8',
      label: 'Aalamuru',
      type: 'City'
    },
    {
      value: '9',
      label: 'Aambegaon',
      type: 'City'
    },
    {
      value: '10',
      label: 'Aambur',
      type: 'City'
    },
    {
      value: '11',
      label: 'Aanjangaon',
      type: 'City'
    },
    {
      value: '12',
      label: 'Aanjar',
      type: 'City'
    },
    {
      value: '13',
      label: 'Aantra',
      type: 'City'
    },
    {
      value: '14',
      label: 'Aarya Nagar',
      type: 'City'
    },
    {
      value: '15',
      label: 'Aaspur',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '16',
      label: 'Aathankarai',
      type: 'City'
    },
    {
      value: '17',
      label: 'Aathipatti',
      type: 'City'
    },
    {
      value: '18',
      label: 'Aau(Phalodi)',
      type: 'City'
    },
    {
      value: '19',
      label: 'Aauwa',
      type: 'City'
    },
    {
      value: '20',
      label: 'Aavanam kaikaati',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '21',
      label: 'Aba',
      type: 'City'
    },
    {
      value: '22',
      label: 'Abbigeri',
      type: 'City'
    },
    {
      value: '23',
      label: 'Abhanpur',
      type: 'City'
    },
    {
      value: '24',
      label: 'Abhona',
      type: 'City'
    },
    {
      value: '25',
      label: 'Abhrampara',
      type: 'City'
    },
    {
      value: '26',
      label: 'Abiramam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '27',
      label: 'Abloli',
      type: 'City'
    },
    {
      value: '28',
      label: 'Abohar',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '29',
      label: 'Abu Road',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '30',
      label: 'Abubshahar',
      type: 'City'
    },
    {
      value: '31',
      label: 'Achanta',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '32',
      label: 'Achara',
      type: 'City'
    },
    {
      value: '33',
      label: 'Adaiya Karungulam',
      type: 'City'
    },
    {
      value: '34',
      label: 'Adajan  Surat',
      type: 'City'
    },
    {
      value: '35',
      label: 'Adalaj',
      type: 'City'
    },
    {
      value: '36',
      label: 'Adalhat',
      type: 'City'
    },
    {
      value: '37',
      label: 'Adampur Mandi',
      type: 'City'
    },
    {
      value: '38',
      label: 'Adapaka',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '39',
      label: 'Adas',
      type: 'City'
    },
    {
      value: '40',
      label: 'Adawad',
      type: 'City'
    },
    {
      value: '41',
      label: 'Adda Road',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '42',
      label: 'Addanki',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '43',
      label: 'Addavaram',
      type: 'City'
    },
    {
      value: '44',
      label: 'Addu',
      type: 'City'
    },
    {
      value: '45',
      label: 'Adesar',
      type: 'City'
    },
    {
      value: '46',
      label: 'Adgaon',
      type: 'City'
    },
    {
      value: '47',
      label: 'Adigoppula',
      type: 'City'
    },
    {
      value: '48',
      label: 'Adilabad',
      type: 'City',
      'state': 'Telangana'
    },
    {
      value: '49',
      label: 'Adimali',
      type: 'City'
    },
    {
      value: '50',
      label: 'Adipur',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '51',
      label: 'Adirampattinam',
      type: 'City'
    },
    {
      value: '52',
      label: 'Adivare',
      type: 'City'
    },
    {
      value: '53',
      label: 'Adiyakkamangalam',
      type: 'City'
    },
    {
      value: '54',
      label: 'Adkur',
      type: 'City'
    },
    {
      value: '55',
      label: 'Adlabs Imagica',
      type: 'City'
    },
    {
      value: '56',
      label: 'Adoni',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '57',
      label: 'Adoor',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '58',
      label: 'Adsul',
      type: 'City'
    },
    {
      value: '59',
      label: 'Adtala',
      type: 'City'
    },
    {
      value: '60',
      label: 'Adur (Maharashtra)',
      type: 'City'
    },
    {
      value: '61',
      label: 'Aduthurai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '62',
      label: 'Advana',
      type: 'City'
    },
    {
      value: '63',
      label: 'Afzalpur',
      type: 'City'
    },
    {
      value: '64',
      label: 'Agar',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '65',
      label: 'Agara',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '66',
      label: 'Agariya',
      type: 'City'
    },
    {
      value: '67',
      label: 'Agarpura',
      type: 'City'
    },
    {
      value: '68',
      label: 'Agartala',
      type: 'City',
      'state': 'Tripura'
    },
    {
      value: '69',
      label: 'Agasthiyarpatti  Ambasamudram',
      type: 'City'
    },
    {
      value: '70',
      label: 'Agatrai',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '71',
      label: 'Agatti island',
      type: 'City'
    },
    {
      value: '72',
      label: 'Agiripalli',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '73',
      label: 'Agolai',
      type: 'City'
    },
    {
      value: '74',
      label: 'Agra',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '75',
      label: 'Agra, UP',
      type: 'City'
    },
    {
      value: '76',
      label: 'Aguilares',
      type: 'City'
    },
    {
      value: '77',
      label: 'Agumbe',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '78',
      label: 'Aheri (Maharashtra)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '79',
      label: 'Ahiwara',
      type: 'City'
    },
    {
      value: '80',
      label: 'Ahmadpur',
      type: 'City'
    },
    {
      value: '81',
      label: 'Ahmedabad',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '82',
      label: 'Ahmedabad (Airport)',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '83',
      label: 'Ahmedgarh',
      type: 'City'
    },
    {
      value: '84',
      label: 'Ahmednagar',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '85',
      label: 'Ahmednagar, Maharashtra',
      type: 'City'
    },
    {
      value: '86',
      label: 'Ahmedpur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '87',
      label: 'Ahobilam',
      type: 'City'
    },
    {
      value: '88',
      label: 'Ahore',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '89',
      label: 'Ailnabad',
      type: 'City'
    },
    {
      value: '90',
      label: 'Aima',
      type: 'City'
    },
    {
      value: '91',
      label: 'Ainapur',
      type: 'City'
    },
    {
      value: '92',
      label: 'Airoli',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '93',
      label: 'Airwa Katra',
      type: 'City'
    },
    {
      value: '94',
      label: 'Aithor',
      type: 'City'
    },
    {
      value: '95',
      label: 'Ajanta (Aurangabad)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '96',
      label: 'Ajantha Ellora package',
      type: 'City'
    },
    {
      value: '97',
      label: 'Ajara',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '98',
      label: 'Ajaygarh',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '99',
      label: 'Ajeetgarh',
      type: 'City'
    },
    {
      value: '100',
      label: 'Ajeetpura',
      type: 'City'
    },
    {
      value: '101',
      label: 'Ajekar',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '102',
      label: 'Ajmer',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '103',
      label: 'Ajodar',
      type: 'City'
    },
    {
      value: '104',
      label: 'Akadiya',
      type: 'City'
    },
    {
      value: '105',
      label: 'Akala',
      type: 'City'
    },
    {
      value: '106',
      label: 'Akalkot',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '107',
      label: 'Akbarpur',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '108',
      label: 'Akbarpur, Telangana',
      type: 'City'
    },
    {
      value: '109',
      label: 'Akbarpur, UP',
      type: 'City'
    },
    {
      value: '110',
      label: 'Akhaj',
      type: 'City'
    },
    {
      value: '111',
      label: 'Akhara Balapur',
      type: 'City'
    },
    {
      value: '112',
      label: 'Akividu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '113',
      label: 'Akkalkot',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '114',
      label: 'Akkalkuva',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '115',
      label: 'Akki Alur',
      type: 'City'
    },
    {
      value: '116',
      label: 'Aklera',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '117',
      label: 'Akluj',
      type: 'City'
    },
    {
      value: '118',
      label: 'Akluj (Solapur)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '119',
      label: 'Akola (Buldhana)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '120',
      label: 'Akola, Rajasthan',
      type: 'City'
    },
    {
      value: '121',
      label: 'Akolali-Jaliya',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '122',
      label: 'Akolawadi',
      type: 'City'
    },
    {
      value: '123',
      label: 'Akoli',
      type: 'City'
    },
    {
      value: '124',
      label: 'Akot',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '125',
      label: 'Akpa',
      type: 'City'
    },
    {
      value: '126',
      label: 'Alagankulam',
      type: 'City'
    },
    {
      value: '127',
      label: 'Alagapuri',
      type: 'City'
    },
    {
      value: '128',
      label: 'Alagiapandiapuram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '129',
      label: 'Alagiyamandapam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '130',
      label: 'Alakode',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '131',
      label: 'Alampur, Himachal Pradesh',
      type: 'City'
    },
    {
      value: '132',
      label: 'Alampuram',
      type: 'City'
    },
    {
      value: '133',
      label: 'Alamsar',
      type: 'City'
    },
    {
      value: '134',
      label: 'Aland',
      type: 'City'
    },
    {
      value: '135',
      label: 'Alandi',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '136',
      label: 'Alang',
      type: 'City'
    },
    {
      value: '137',
      label: 'Alangar',
      type: 'City'
    },
    {
      value: '138',
      label: 'Alangaru',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '139',
      label: 'Alangudi',
      type: 'City'
    },
    {
      value: '140',
      label: 'Alangudi (Pudhukottai)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '141',
      label: 'Alangulam (Tirunelveli)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '142',
      label: 'Alanthalai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '143',
      label: 'Alapadu',
      type: 'City'
    },
    {
      value: '144',
      label: 'Alappuzha',
      type: 'City'
    },
    {
      value: '145',
      label: 'Alasan',
      type: 'City'
    },
    {
      value: '146',
      label: 'Alathur(Tamilnadu)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '147',
      label: 'Alathur, Kerala',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '148',
      label: 'Alephata',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '149',
      label: 'Aler',
      type: 'City'
    },
    {
      value: '150',
      label: 'Aliabad',
      type: 'City'
    },
    {
      value: '151',
      label: 'Alibag',
      type: 'City'
    },
    {
      value: '152',
      label: 'Aliganj',
      type: 'City'
    },
    {
      value: '153',
      label: 'Aligarh',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '154',
      label: 'Alirajpur',
      type: 'City'
    },
    {
      value: '155',
      label: 'Allagadda',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '156',
      label: 'Allahabad',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '157',
      label: 'Allavaram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '158',
      label: 'Allen',
      type: 'City'
    },
    {
      value: '159',
      label: 'Alleppey',
      type: 'City'
    },
    {
      value: '160',
      label: 'Almatti',
      type: 'City'
    },
    {
      value: '161',
      label: 'Almel',
      type: 'City'
    },
    {
      value: '162',
      label: 'Almora',
      type: 'City'
    },
    {
      value: '163',
      label: 'Along',
      type: 'City'
    },
    {
      value: '164',
      label: 'Alote',
      type: 'City'
    },
    {
      value: '165',
      label: 'Alsindi',
      type: 'City'
    },
    {
      value: '166',
      label: 'Alsisar',
      type: 'City'
    },
    {
      value: '167',
      label: 'Alur',
      type: 'City'
    },
    {
      value: '168',
      label: 'Aluva',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '169',
      label: 'Alwar',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '170',
      label: 'Alwarkurichi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '171',
      label: 'Alwarthirunagari',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '172',
      label: 'Alwaye',
      type: 'City'
    },
    {
      value: '173',
      label: 'Amadalavalasa',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '174',
      label: 'Amalapuram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '175',
      label: 'Amalner (Jalgaon)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '176',
      label: 'Amanganj',
      type: 'City'
    },
    {
      value: '177',
      label: 'Amarapur',
      type: 'City'
    },
    {
      value: '178',
      label: 'Amaravathi',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '179',
      label: 'Amargadh',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '180',
      label: 'Amaria',
      type: 'City'
    },
    {
      value: '181',
      label: 'Amarkantak',
      type: 'City'
    },
    {
      value: '182',
      label: 'Amarnagar',
      type: 'City'
    },
    {
      value: '183',
      label: 'Amarnath Yatra',
      type: 'City'
    },
    {
      value: '184',
      label: 'Amarpatan',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '185',
      label: 'Amarwara',
      type: 'City'
    },
    {
      value: '186',
      label: 'Ambad (Jalna)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '187',
      label: 'Ambaguda',
      type: 'City'
    },
    {
      value: '188',
      label: 'Ambah',
      type: 'City'
    },
    {
      value: '189',
      label: 'Ambaji',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '190',
      label: 'Ambajipeta',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '191',
      label: 'Ambajogai',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '192',
      label: 'Ambala (HR)',
      type: 'City',
      'state': 'Haryana'
    },
    {
      value: '193',
      label: 'Ambalapuzha',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '194',
      label: 'Ambalavanapuram',
      type: 'City'
    },
    {
      value: '195',
      label: 'Amballur',
      type: 'City'
    },
    {
      value: '196',
      label: 'Ambalner',
      type: 'City'
    },
    {
      value: '197',
      label: 'Ambardi',
      type: 'City'
    },
    {
      value: '198',
      label: 'Ambarnath',
      type: 'City'
    },
    {
      value: '199',
      label: 'Ambasamutram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '200',
      label: 'Ambassa',
      type: 'City'
    },
    {
      value: '201',
      label: 'Ambattur',
      type: 'City'
    },
    {
      value: '202',
      label: 'Ambayathode',
      type: 'City'
    },
    {
      value: '203',
      label: 'Ambedkar Nagar',
      type: 'City'
    },
    {
      value: '204',
      label: 'Amber Fort',
      type: 'City'
    },
    {
      value: '205',
      label: 'Ambernath',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '206',
      label: 'Ambet',
      type: 'City'
    },
    {
      value: '207',
      label: 'Ambikanagar',
      type: 'City'
    },
    {
      value: '208',
      label: 'Ambikapur, Chhattisgarh',
      type: 'City'
    },
    {
      value: '209',
      label: 'Ambilikkai',
      type: 'City'
    },
    {
      value: '210',
      label: 'Ambur',
      type: 'City'
    },
    {
      value: '211',
      label: 'Amdapur (Buldhana)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '212',
      label: 'Amdi',
      type: 'City'
    },
    {
      value: '213',
      label: 'Ameni',
      type: 'City'
    },
    {
      value: '214',
      label: 'Amet',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '215',
      label: 'Amethi',
      type: 'City'
    },
    {
      value: '216',
      label: 'Amgaon',
      type: 'City'
    },
    {
      value: '217',
      label: 'Amingad',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '218',
      label: 'Amirgadh',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '219',
      label: 'Amjhera',
      type: 'City'
    },
    {
      value: '220',
      label: 'Amla',
      type: 'City'
    },
    {
      value: '221',
      label: 'Amlapur',
      type: 'City'
    },
    {
      value: '222',
      label: 'Amlari',
      type: 'City'
    },
    {
      value: '223',
      label: 'Amli',
      type: 'City'
    },
    {
      value: '224',
      label: 'Ammainaickanur',
      type: 'City'
    },
    {
      value: '225',
      label: 'Ammaiyappan',
      type: 'City'
    },
    {
      value: '226',
      label: 'Ammanpuram',
      type: 'City'
    },
    {
      value: '227',
      label: 'Ammapattinam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '228',
      label: 'Ammapettai',
      type: 'City'
    },
    {
      value: '229',
      label: 'Ammenalli',
      type: 'City'
    },
    {
      value: '230',
      label: 'Amnour',
      type: 'City'
    },
    {
      value: '231',
      label: 'Ampani',
      type: 'City'
    },
    {
      value: '232',
      label: 'Ampar',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '233',
      label: 'Amran',
      type: 'City'
    },
    {
      value: '234',
      label: 'Amrapur',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '235',
      label: 'Amravati',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '236',
      label: 'Amreli',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '237',
      label: 'Amritsar',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '238',
      label: 'Amroha',
      type: 'City'
    },
    {
      value: '239',
      label: 'Amroli',
      type: 'City'
    },
    {
      value: '240',
      label: 'Amroniya',
      type: 'City'
    },
    {
      value: '241',
      label: 'Amruthalur',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '242',
      label: 'Anadra',
      type: 'City'
    },
    {
      value: '243',
      label: 'Anaikarai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '244',
      label: 'Anaimalai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '245',
      label: 'Anakapalli',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '246',
      label: 'Anakara',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '247',
      label: 'Anand',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '248',
      label: 'Anand Vihar',
      type: 'City'
    },
    {
      value: '249',
      label: 'Anandpar',
      type: 'City'
    },
    {
      value: '250',
      label: 'Anandpuri',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '251',
      label: 'Anandur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '252',
      label: 'Anantapalli',
      type: 'City'
    },
    {
      value: '253',
      label: 'Anantapur Bypass',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '254',
      label: 'Ananthagiri',
      type: 'City'
    },
    {
      value: '255',
      label: 'Ananthapalli',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '256',
      label: 'Ananthapur',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '257',
      label: 'Ananthapuram',
      type: 'City'
    },
    {
      value: '258',
      label: 'Ananthavaram',
      type: 'City'
    },
    {
      value: '259',
      label: 'Anantnag',
      type: 'City'
    },
    {
      value: '260',
      label: 'Anaparthi',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '261',
      label: 'Anavatti',
      type: 'City'
    },
    {
      value: '262',
      label: 'Anchtageri',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '263',
      label: 'Andagaduru',
      type: 'City'
    },
    {
      value: '264',
      label: 'Andagalur Gate',
      type: 'City'
    },
    {
      value: '265',
      label: 'Andauli',
      type: 'City'
    },
    {
      value: '266',
      label: 'Andhera',
      type: 'City'
    },
    {
      value: '267',
      label: 'Andimadam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '268',
      label: 'Andipanthal',
      type: 'City'
    },
    {
      value: '269',
      label: 'Anegudde',
      type: 'City'
    },
    {
      value: '270',
      label: 'Anewadi',
      type: 'City'
    },
    {
      value: '271',
      label: 'Angalakuduru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '272',
      label: 'Angallu',
      type: 'City'
    },
    {
      value: '273',
      label: 'Angamaly',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '274',
      label: 'Angol',
      type: 'City'
    },
    {
      value: '275',
      label: 'Anida',
      type: 'City'
    },
    {
      value: '276',
      label: 'Aniyapuram',
      type: 'City'
    },
    {
      value: '277',
      label: 'Anjad',
      type: 'City'
    },
    {
      value: '278',
      label: 'Anjala',
      type: 'City'
    },
    {
      value: '279',
      label: 'Anjana',
      type: 'City'
    },
    {
      value: '280',
      label: 'Anjangaon',
      type: 'City'
    },
    {
      value: '281',
      label: 'Anjangaon (Amravati)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '282',
      label: 'Anjani',
      type: 'City'
    },
    {
      value: '283',
      label: 'Anjaniya',
      type: 'City'
    },
    {
      value: '284',
      label: 'Anjar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '285',
      label: 'Anjarakandy',
      type: 'City'
    },
    {
      value: '286',
      label: 'Anjugramam',
      type: 'City'
    },
    {
      value: '287',
      label: 'Anjuna',
      type: 'City'
    },
    {
      value: '288',
      label: 'Ankadiya',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '289',
      label: 'Ankadiya Mota',
      type: 'City'
    },
    {
      value: '290',
      label: 'Ankalamma Guduru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '291',
      label: 'Ankali',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '292',
      label: 'Ankleshwar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '293',
      label: 'Ankleshwar Bypass',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '294',
      label: 'Ankola',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '295',
      label: 'Ankolwadi',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '296',
      label: 'Annadevarapeta',
      type: 'City'
    },
    {
      value: '297',
      label: 'Annambhotlavari Palem',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '298',
      label: 'Annanji  Vadaveeranaickenpatty',
      type: 'City'
    },
    {
      value: '299',
      label: 'Annaram',
      type: 'City',
      'state': 'Telangana'
    },
    {
      value: '300',
      label: 'Annasamudram Pet',
      type: 'City'
    },
    {
      value: '301',
      label: 'Annavaram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '302',
      label: 'Annavarapadu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '303',
      label: 'Anni',
      type: 'City'
    },
    {
      value: '304',
      label: 'Annigeri',
      type: 'City'
    },
    {
      value: '305',
      label: 'Annur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '306',
      label: 'Anoopgarh',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '307',
      label: 'Ansing',
      type: 'City'
    },
    {
      value: '308',
      label: 'Anta',
      type: 'City'
    },
    {
      value: '309',
      label: 'Antagarh',
      type: 'City'
    },
    {
      value: '310',
      label: 'Anthiyur',
      type: 'City'
    },
    {
      value: '311',
      label: 'Anthoniyarpuram',
      type: 'City'
    },
    {
      value: '312',
      label: 'Anti',
      type: 'City'
    },
    {
      value: '313',
      label: 'Antofagasta',
      type: 'City'
    },
    {
      value: '314',
      label: 'Antroli',
      type: 'City'
    },
    {
      value: '315',
      label: 'Anturli',
      type: 'City'
    },
    {
      value: '316',
      label: 'Anu',
      type: 'City'
    },
    {
      value: '317',
      label: 'Anupgarh',
      type: 'City'
    },
    {
      value: '318',
      label: 'Anuppur',
      type: 'City'
    },
    {
      value: '319',
      label: 'Appapuram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '320',
      label: 'Appikatla',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '321',
      label: 'Arai',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '322',
      label: 'Arakot',
      type: 'City'
    },
    {
      value: '323',
      label: 'Aralikottai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '324',
      label: 'Aralvaimozhi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '325',
      label: 'Arambagh (West Bengal)',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '326',
      label: 'Arambol',
      type: 'City'
    },
    {
      value: '327',
      label: 'Arang',
      type: 'City'
    },
    {
      value: '328',
      label: 'Arangaon',
      type: 'City'
    },
    {
      value: '329',
      label: 'Arani',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '330',
      label: 'Aranmanai Pudhur  Theni',
      type: 'City'
    },
    {
      value: '331',
      label: 'Aranthangi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '332',
      label: 'Araria',
      type: 'City'
    },
    {
      value: '333',
      label: 'Araria Court',
      type: 'City'
    },
    {
      value: '334',
      label: 'Araria Zeromile',
      type: 'City'
    },
    {
      value: '335',
      label: 'Arate',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '336',
      label: 'Aravakurichi',
      type: 'City'
    },
    {
      value: '337',
      label: 'Aravali',
      type: 'City'
    },
    {
      value: '338',
      label: 'Arcot',
      type: 'City'
    },
    {
      value: '339',
      label: 'Ardavaram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '340',
      label: 'Ardhapur',
      type: 'City'
    },
    {
      value: '341',
      label: 'Ardhavaram',
      type: 'City'
    },
    {
      value: '342',
      label: 'Areekode',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '343',
      label: 'Arehole',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '344',
      label: 'Arehole  Kirimanjeshwar',
      type: 'City'
    },
    {
      value: '345',
      label: 'Areraj',
      type: 'City'
    },
    {
      value: '346',
      label: 'Ari',
      type: 'City'
    },
    {
      value: '347',
      label: 'Arimalam',
      type: 'City'
    },
    {
      value: '348',
      label: 'Ariyalur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '349',
      label: 'Arjansar',
      type: 'City'
    },
    {
      value: '350',
      label: 'Arjansukh',
      type: 'City'
    },
    {
      value: '351',
      label: 'Arjuni',
      type: 'City'
    },
    {
      value: '352',
      label: 'Arjunsar',
      type: 'City'
    },
    {
      value: '353',
      label: 'Arkar',
      type: 'City'
    },
    {
      value: '354',
      label: 'Arki',
      type: 'City'
    },
    {
      value: '355',
      label: 'Armarikala',
      type: 'City'
    },
    {
      value: '356',
      label: 'Armoor',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '357',
      label: 'Armori',
      type: 'City'
    },
    {
      value: '358',
      label: 'Arnaud',
      type: 'City'
    },
    {
      value: '359',
      label: 'Arnej',
      type: 'City'
    },
    {
      value: '360',
      label: 'Arni, Maharashtra',
      type: 'City'
    },
    {
      value: '361',
      label: 'Aroli',
      type: 'City'
    },
    {
      value: '362',
      label: 'Aron',
      type: 'City'
    },
    {
      value: '363',
      label: 'Aroor (Alappuzha)',
      type: 'City'
    },
    {
      value: '364',
      label: 'Aroor (Tamil Nadu)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '365',
      label: 'Arrah',
      type: 'City'
    },
    {
      value: '366',
      label: 'Arrah (bihar)',
      type: 'City'
    },
    {
      value: '367',
      label: 'Arroyito',
      type: 'City'
    },
    {
      value: '368',
      label: 'Arsikere',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '369',
      label: 'Arthuna',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '370',
      label: 'Arthungal Bye Pass',
      type: 'City'
    },
    {
      value: '371',
      label: 'Arumanai',
      type: 'City'
    },
    {
      value: '372',
      label: 'Arumuganeri',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '373',
      label: 'Aruppukottai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '374',
      label: 'Aruppukottai Bypass',
      type: 'City'
    },
    {
      value: '375',
      label: 'Arusha',
      type: 'City'
    },
    {
      value: '376',
      label: 'Aruvankadu',
      type: 'City'
    },
    {
      value: '377',
      label: 'Arvi',
      type: 'City'
    },
    {
      value: '378',
      label: 'Arwal',
      type: 'City'
    },
    {
      value: '379',
      label: 'Aryankavu',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '380',
      label: 'Asada',
      type: 'City'
    },
    {
      value: '381',
      label: 'Asalgaon',
      type: 'City'
    },
    {
      value: '382',
      label: 'Asambia',
      type: 'City'
    },
    {
      value: '383',
      label: 'Asansol',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '384',
      label: 'Asari Sindhiyan',
      type: 'City'
    },
    {
      value: '385',
      label: 'Aseda',
      type: 'City'
    },
    {
      value: '386',
      label: 'Ashiv',
      type: 'City'
    },
    {
      value: '387',
      label: 'Ashoknagar',
      type: 'City'
    },
    {
      value: '388',
      label: 'Ashoknagar (MP)',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '389',
      label: 'Ashta Mod',
      type: 'City'
    },
    {
      value: '390',
      label: 'Ashta, MP',
      type: 'City'
    },
    {
      value: '391',
      label: 'Ashtavinayak',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '392',
      label: 'Ashtavinayak Darshan',
      type: 'City'
    },
    {
      value: '393',
      label: 'Ashti',
      type: 'City'
    },
    {
      value: '394',
      label: 'Ashti (Beed)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '395',
      label: 'Asifabad',
      type: 'City'
    },
    {
      value: '396',
      label: 'Asind',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '397',
      label: 'Asnahara',
      type: 'City'
    },
    {
      value: '398',
      label: 'Asnawar',
      type: 'City'
    },
    {
      value: '399',
      label: 'Asodar',
      type: 'City'
    },
    {
      value: '400',
      label: 'Asop',
      type: 'City'
    },
    {
      value: '401',
      label: 'Asotra',
      type: 'City'
    },
    {
      value: '402',
      label: 'Aspur',
      type: 'City'
    },
    {
      value: '403',
      label: 'Asron',
      type: 'City'
    },
    {
      value: '404',
      label: 'Assam University',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '405',
      label: 'Asta Phata',
      type: 'City'
    },
    {
      value: '406',
      label: 'Asuncion Del Paraguay',
      type: 'City'
    },
    {
      value: '407',
      label: 'Asurde',
      type: 'City'
    },
    {
      value: '408',
      label: 'Aswapuram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '409',
      label: 'Aswaraopeta',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '410',
      label: 'Atarra',
      type: 'City'
    },
    {
      value: '411',
      label: 'Atchutapuram',
      type: 'City'
    },
    {
      value: '412',
      label: 'Athangudi',
      type: 'City'
    },
    {
      value: '413',
      label: 'Athani',
      type: 'City'
    },
    {
      value: '414',
      label: 'Athani(Karnataka)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '415',
      label: 'Athani(Kerala)',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '416',
      label: 'Athani, Karnataka',
      type: 'City'
    },
    {
      value: '417',
      label: 'Athani, Kerala',
      type: 'City'
    },
    {
      value: '418',
      label: 'Athikadai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '419',
      label: 'Athikkadai',
      type: 'City'
    },
    {
      value: '420',
      label: 'Athipatti',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '421',
      label: 'Athirampattinam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '422',
      label: 'Athiyuthu',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '423',
      label: 'Athner',
      type: 'City'
    },
    {
      value: '424',
      label: 'Atholi',
      type: 'City'
    },
    {
      value: '425',
      label: 'Athoor',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '426',
      label: 'Athota',
      type: 'City'
    },
    {
      value: '427',
      label: 'Athur',
      type: 'City'
    },
    {
      value: '428',
      label: 'Atit',
      type: 'City'
    },
    {
      value: '429',
      label: 'Atkot',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '430',
      label: 'Atkuru',
      type: 'City'
    },
    {
      value: '431',
      label: 'Atmakur',
      type: 'City'
    },
    {
      value: '432',
      label: 'Atmakur (Kurnool)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '433',
      label: 'Atmakur (Nellore)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '434',
      label: 'Atmakur Kurnool',
      type: 'City'
    },
    {
      value: '435',
      label: 'Atmakur Nellore',
      type: 'City'
    },
    {
      value: '436',
      label: 'Atola',
      type: 'City'
    },
    {
      value: '437',
      label: 'Atpadi',
      type: 'City'
    },
    {
      value: '438',
      label: 'Atraa',
      type: 'City'
    },
    {
      value: '439',
      label: 'Atraila',
      type: 'City'
    },
    {
      value: '440',
      label: 'Atraulia',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '441',
      label: 'Atreyapuram',
      type: 'City'
    },
    {
      value: '442',
      label: 'Atru',
      type: 'City'
    },
    {
      value: '443',
      label: 'Attayampatt',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '444',
      label: 'Atthikadai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '445',
      label: 'Attili',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '446',
      label: 'Attingal',
      type: 'City',
      'state': 'Kerala'
    }
    ,
    {
      value: '447',
      label: 'Attoor',
      type: 'City'
    },
    {
      value: '448',
      label: 'Attur',
      type: 'City'
    },
    {
      value: '449',
      label: 'Attur (Salem)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '450',
      label: 'Attur(Thoothukudi)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '451',
      label: 'Atul',
      type: 'City'
    },
    {
      value: '452',
      label: 'Aturgaon',
      type: 'City'
    },
    {
      value: '453',
      label: 'Aulakh',
      type: 'City'
    },
    {
      value: '454',
      label: 'Aundha Nagnath',
      type: 'City'
    },
    {
      value: '455',
      label: 'Aundha Nagnath (Hingoli)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '456',
      label: 'Aurad',
      type: 'City'
    },
    {
      value: '457',
      label: 'Aurad Shahajani',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '458',
      label: 'Aurai',
      type: 'City'
    },
    {
      value: '459',
      label: 'Auraiya',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '460',
      label: 'Aurangabad',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '461',
      label: 'Aurangabad (Bihar)',
      type: 'City'
    },
    {
      value: '462',
      label: 'Aurangabad, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '463',
      label: 'Aurangabad, Bihar',
      type: 'City'
    },
    {
      value: '464',
      label: 'Aurangabad, Maharashtra',
      type: 'City'
    },
    {
      value: '465',
      label: 'Aurangabad, UP',
      type: 'City'
    },
    {
      value: '466',
      label: 'Ausa',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '467',
      label: 'Aut',
      type: 'City'
    },
    {
      value: '468',
      label: 'Authoor',
      type: 'City'
    },
    {
      value: '469',
      label: 'Authoor North',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '470',
      label: 'Authoor South',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '471',
      label: 'Avadi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '472',
      label: 'Avanam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '473',
      label: 'Avanam Kaikatti',
      type: 'City'
    },
    {
      value: '474',
      label: 'Avanigadda',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '475',
      label: 'Avellaneda',
      type: 'City'
    },
    {
      value: '476',
      label: 'Aversa',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '477',
      label: 'Avidi',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '478',
      label: 'Avinashi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '479',
      label: 'Avudaiyapuram',
      type: 'City'
    },
    {
      value: '480',
      label: 'Avudaiyarkoil',
      type: 'City'
    },
    {
      value: '481',
      label: 'Awah Devi',
      type: 'City'
    },
    {
      value: '482',
      label: 'Ayakkaranbulam  Vedaranyam',
      type: 'City'
    },
    {
      value: '483',
      label: 'Ayakkaranpulam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '484',
      label: 'Ayalur',
      type: 'City'
    },
    {
      value: '485',
      label: 'Ayanur',
      type: 'City'
    },
    {
      value: '486',
      label: 'Ayarkunnum',
      type: 'City'
    },
    {
      value: '487',
      label: 'Ayikkarapadi',
      type: 'City'
    },
    {
      value: '488',
      label: 'Ayodhya',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '489',
      label: 'Ayodhya Allhbad Varanasi',
      type: 'City'
    },
    {
      value: '490',
      label: 'Ayodhyapuram',
      type: 'City'
    },
    {
      value: '491',
      label: 'Ayoor',
      type: 'City'
    },
    {
      value: '492',
      label: 'Ayyalur',
      type: 'City'
    },
    {
      value: '493',
      label: 'Ayyampettai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '494',
      label: 'Azahiamandapam',
      type: 'City'
    },
    {
      value: '495',
      label: 'Azamgarh',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '496',
      label: 'Azhagankulam',
      type: 'City'
    },
    {
      value: '497',
      label: 'Azhagapuri',
      type: 'City'
    },
    {
      value: '498',
      label: 'Azhagiapandiapuram',
      type: 'City'
    },
    {
      value: '499',
      label: 'Azhagiyamandapam',
      type: 'City'
    },
    {
      value: '500',
      label: 'B.C Road  Bantwal',
      type: 'City'
    },
    {
      value: '501',
      label: 'B.D.AJunction/LeeMeridian',
      type: 'City'
    },
    {
      value: '502',
      label: 'B.Nidamanuru',
      type: 'City'
    },
    {
      value: '503',
      label: 'Baari',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '504',
      label: 'Babaganj',
      type: 'City'
    },
    {
      value: '505',
      label: 'Babai',
      type: 'City'
    },
    {
      value: '506',
      label: 'Babaliya',
      type: 'City'
    },
    {
      value: '507',
      label: 'Babapur',
      type: 'City'
    },
    {
      value: '508',
      label: 'Babarpur',
      type: 'City'
    },
    {
      value: '509',
      label: 'Babhaleshwar',
      type: 'City'
    },
    {
      value: '510',
      label: 'Babhanpur',
      type: 'City'
    },
    {
      value: '511',
      label: 'Babhulgaon',
      type: 'City'
    },
    {
      value: '512',
      label: 'Babina',
      type: 'City'
    },
    {
      value: '513',
      label: 'Bableshwar Dr S Y',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '514',
      label: 'Babra',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '515',
      label: 'Babri',
      type: 'City'
    },
    {
      value: '516',
      label: 'Babu Lal Nagar Indore',
      type: 'City'
    },
    {
      value: '517',
      label: 'Babuganj',
      type: 'City'
    },
    {
      value: '518',
      label: 'Bacheli',
      type: 'City'
    },
    {
      value: '519',
      label: 'Bachhrawan',
      type: 'City'
    },
    {
      value: '520',
      label: 'Bada Malhera',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '521',
      label: 'Badadiya',
      type: 'City'
    },
    {
      value: '522',
      label: 'Badagaon',
      type: 'City'
    },
    {
      value: '523',
      label: 'Badah',
      type: 'City'
    },
    {
      value: '524',
      label: 'Badahapur',
      type: 'City'
    },
    {
      value: '525',
      label: 'Badakara',
      type: 'City'
    },
    {
      value: '526',
      label: 'Badal',
      type: 'City'
    },
    {
      value: '527',
      label: 'Badami',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '528',
      label: 'Badarpur(Assam)',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '529',
      label: 'Badarwas',
      type: 'City'
    },
    {
      value: '530',
      label: 'Badaun',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '531',
      label: 'Badawada',
      type: 'City'
    },
    {
      value: '532',
      label: 'Baddi (Himachal Pradesh)',
      type: 'City'
    },
    {
      value: '533',
      label: 'Badel',
      type: 'City'
    },
    {
      value: '534',
      label: 'Badgaon',
      type: 'City'
    },
    {
      value: '535',
      label: 'Badgi(Galiakot)',
      type: 'City'
    },
    {
      value: '536',
      label: 'Badhada',
      type: 'City'
    },
    {
      value: '537',
      label: 'Badhni',
      type: 'City',
      'state': 'Jharkhand'
    },
    {
      value: '538',
      label: 'Badi Khatu',
      type: 'City'
    },
    {
      value: '539',
      label: 'Badi Safer',
      type: 'City'
    },
    {
      value: '540',
      label: 'Badia Keema',
      type: 'City'
    },
    {
      value: '541',
      label: 'Badisadri (rajasthan)',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '542',
      label: 'Badiyadka',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '543',
      label: 'Badlapur (maharashtra)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '544',
      label: 'Badlapur, UP',
      type: 'City'
    },
    {
      value: '545',
      label: 'Badnagar, Indore',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '546',
      label: 'Badnaur',
      type: 'City'
    },
    {
      value: '547',
      label: 'Badnawar',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '548',
      label: 'Badnera',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '549',
      label: 'Badodiya',
      type: 'City'
    },
    {
      value: '550',
      label: 'Badoli',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '551',
      label: 'Badrinath Kedarnath Yatra',
      type: 'City'
    },
    {
      value: '552',
      label: 'Badsar',
      type: 'City'
    },
    {
      value: '553',
      label: 'Badvel',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '554',
      label: 'Badyar',
      type: 'City'
    },
    {
      value: '555',
      label: 'Bagalkot',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '556',
      label: 'Bagar',
      type: 'City'
    },
    {
      value: '557',
      label: 'Bagasara',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '558',
      label: 'Bagdana',
      type: 'City'
    },
    {
      value: '559',
      label: 'Bagdogra',
      type: 'City'
    },
    {
      value: '560',
      label: 'Bagdu',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '561',
      label: 'Bagepalli',
      type: 'City'
    },
    {
      value: '562',
      label: 'Baggar (Gujarat)',
      type: 'City'
    },
    {
      value: '563',
      label: 'Bagha Purana',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '564',
      label: 'Baghera',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '565',
      label: 'Baghi',
      type: 'City'
    },
    {
      value: '566',
      label: 'Bagholi',
      type: 'City'
    },
    {
      value: '567',
      label: 'Bagicha',
      type: 'City'
    },
    {
      value: '568',
      label: 'Bagidora',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '569',
      label: 'Bagoda',
      type: 'City'
    },
    {
      value: '570',
      label: 'Bagodara',
      type: 'City'
    },
    {
      value: '571',
      label: 'Bagodra',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '572',
      label: 'Bagor',
      type: 'City'
    },
    {
      value: '573',
      label: 'Bagot',
      type: 'City'
    },
    {
      value: '574',
      label: 'Bagra',
      type: 'City'
    },
    {
      value: '575',
      label: 'Bagra (Rajasthan)',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '576',
      label: 'Bagru',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '577',
      label: 'Bagwadar',
      type: 'City'
    },
    {
      value: '578',
      label: 'Bah',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '579',
      label: 'Bahadurpur, Punjab',
      type: 'City'
    },
    {
      value: '580',
      label: 'Bahal',
      type: 'City'
    },
    {
      value: '581',
      label: 'Bahalda',
      type: 'City'
    },
    {
      value: '582',
      label: 'Bahalgarh',
      type: 'City'
    },
    {
      value: '583',
      label: 'Bahel',
      type: 'City'
    },
    {
      value: '584',
      label: 'Bahigaon',
      type: 'City'
    },
    {
      value: '585',
      label: 'Bahli',
      type: 'City'
    },
    {
      value: '586',
      label: 'Bahraich',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '587',
      label: 'Bahroad',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '588',
      label: 'Baihar',
      type: 'City'
    },
    {
      value: '589',
      label: 'Baihata Chariali',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '590',
      label: 'Baijnath',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '591',
      label: 'Baikampady',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '592',
      label: 'Baikunthapur (West Bengal)',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '593',
      label: 'Baikunthpur',
      type: 'City'
    },
    {
      value: '594',
      label: 'Bail hongala',
      type: 'City'
    },
    {
      value: '595',
      label: 'Bailadila',
      type: 'City'
    },
    {
      value: '596',
      label: 'Bailhongal',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '597',
      label: 'Bailur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '598',
      label: 'Bain',
      type: 'City'
    },
    {
      value: '599',
      label: 'Bairagarh',
      type: 'City'
    },
    {
      value: '600',
      label: 'Bairiya',
      type: 'City'
    },
    {
      value: '601',
      label: 'Bairumbe',
      type: 'City'
    },
    {
      value: '602',
      label: 'Baitalpur',
      type: 'City'
    },
    {
      value: '603',
      label: 'Bajag',
      type: 'City'
    },
    {
      value: '604',
      label: 'Bajagoli',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '605',
      label: 'Bajaura',
      type: 'City'
    },
    {
      value: '606',
      label: 'Bajegoli',
      type: 'City'
    },
    {
      value: '607',
      label: 'Bajipura (Gujarat)',
      type: 'City'
    },
    {
      value: '608',
      label: 'Bajpe',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '609',
      label: 'Bajrol',
      type: 'City'
    },
    {
      value: '610',
      label: 'Bajud',
      type: 'City'
    },
    {
      value: '611',
      label: 'Bakaner',
      type: 'City'
    },
    {
      value: '612',
      label: 'Bakani',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '613',
      label: 'Bakewar',
      type: 'City'
    },
    {
      value: '614',
      label: 'Bakhrot',
      type: 'City'
    },
    {
      value: '615',
      label: 'Bakor',
      type: 'City'
    },
    {
      value: '616',
      label: 'Bakra Gaon Rd',
      type: 'City'
    },
    {
      value: '617',
      label: 'Bakra Rd',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '618',
      label: 'Baktara',
      type: 'City'
    },
    {
      value: '619',
      label: 'Bala',
      type: 'City'
    },
    {
      value: '620',
      label: 'Balachaur',
      type: 'City'
    },
    {
      value: '621',
      label: 'Baladia',
      type: 'City'
    },
    {
      value: '622',
      label: 'Balaghat',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '623',
      label: 'Balaji (Rajasthan)',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '624',
      label: 'Balamtakali',
      type: 'City'
    },
    {
      value: '625',
      label: 'Balana',
      type: 'City'
    },
    {
      value: '626',
      label: 'Balangir',
      type: 'City'
    },
    {
      value: '627',
      label: 'Balapanur',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '628',
      label: 'Balapur, Gujarat',
      type: 'City'
    },
    {
      value: '629',
      label: 'Balapur, Maharashtra',
      type: 'City'
    },
    {
      value: '630',
      label: 'Balaramapuram',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '631',
      label: 'Balasinor',
      type: 'City'
    },
    {
      value: '632',
      label: 'Balasore',
      type: 'City'
    },
    {
      value: '633',
      label: 'Balbleshwar',
      type: 'City'
    },
    {
      value: '634',
      label: 'Baldana',
      type: 'City'
    },
    {
      value: '635',
      label: 'Baldevgarh',
      type: 'City'
    },
    {
      value: '636',
      label: 'Baldiya',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '637',
      label: 'Baldwara',
      type: 'City'
    },
    {
      value: '638',
      label: 'Balehonnur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '639',
      label: 'Balel Pipariya',
      type: 'City'
    },
    {
      value: '640',
      label: 'Balenga',
      type: 'City'
    },
    {
      value: '641',
      label: 'Balesar',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '642',
      label: 'Baleshwar',
      type: 'City'
    },
    {
      value: '643',
      label: 'Balharshah',
      type: 'City'
    },
    {
      value: '644',
      label: 'Bali',
      type: 'City'
    },
    {
      value: '645',
      label: 'Balisana',
      type: 'City'
    },
    {
      value: '646',
      label: 'Balkonda',
      type: 'City'
    },
    {
      value: '647',
      label: 'Ballabgarh  Faridabad',
      type: 'City'
    },
    {
      value: '648',
      label: 'Ballari',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '649',
      label: 'Ballia',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '650',
      label: 'Balmer',
      type: 'City'
    },
    {
      value: '651',
      label: 'Balod',
      type: 'City'
    },
    {
      value: '652',
      label: 'Baloda Bazar',
      type: 'City'
    },
    {
      value: '653',
      label: 'Balotra',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '654',
      label: 'Balrampur(Chhattisgarh)',
      type: 'City'
    },
    {
      value: '655',
      label: 'Balrampur (UP)',
      type: 'City'
    },
    {
      value: '656',
      label: 'Balsamud',
      type: 'City'
    },
    {
      value: '657',
      label: 'Balurghat',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '658',
      label: 'Balva',
      type: 'City'
    },
    {
      value: '659',
      label: 'Balwara',
      type: 'City'
    },
    {
      value: '660',
      label: 'Balwasa',
      type: 'City'
    },
    {
      value: '661',
      label: 'Bamanwas',
      type: 'City'
    },
    {
      value: '662',
      label: 'Bambavade',
      type: 'City'
    },
    {
      value: '663',
      label: 'Bambhaniya',
      type: 'City'
    },
    {
      value: '664',
      label: 'Bambuliya',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '665',
      label: 'Bamhani',
      type: 'City'
    },
    {
      value: '666',
      label: 'Bamitha',
      type: 'City'
    },
    {
      value: '667',
      label: 'Bamla',
      type: 'City'
    },
    {
      value: '668',
      label: 'Bamnala',
      type: 'City'
    },
    {
      value: '669',
      label: 'Bamnasa(Gir)',
      type: 'City'
    },
    {
      value: '670',
      label: 'Bamnod',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '671',
      label: 'Bamor',
      type: 'City'
    },
    {
      value: '672',
      label: 'Bamore Kalan',
      type: 'City'
    },
    {
      value: '673',
      label: 'Bamori',
      type: 'City'
    },
    {
      value: '674',
      label: 'Banaganapalli',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '675',
      label: 'Banahatti',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '676',
      label: 'Banaras',
      type: 'City'
    },
    {
      value: '677',
      label: 'Banas',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '678',
      label: 'Banasthali',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '679',
      label: 'Banavasi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '680',
      label: 'Banbasa',
      type: 'City'
    },
    {
      value: '681',
      label: 'Banda',
      type: 'City'
    },
    {
      value: '682',
      label: 'Banda(Maharashtra)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '683',
      label: 'Banda (MP)',
      type: 'City'
    },
    {
      value: '684',
      label: 'Banda(UP)',
      type: 'City'
    },
    {
      value: '685',
      label: 'Bandahu',
      type: 'City'
    },
    {
      value: '686',
      label: 'Bandakpur',
      type: 'City'
    },
    {
      value: '687',
      label: 'Bandal',
      type: 'City'
    },
    {
      value: '688',
      label: 'Bandanwara',
      type: 'City'
    },
    {
      value: '689',
      label: 'Bandar Sindri',
      type: 'City'
    },
    {
      value: '690',
      label: 'Bandarchua',
      type: 'City'
    },
    {
      value: '691',
      label: 'Bandarduwa',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '692',
      label: 'Bandarulanka',
      type: 'City'
    },
    {
      value: '693',
      label: 'Bandhala',
      type: 'City'
    },
    {
      value: '694',
      label: 'Bandhuguda',
      type: 'City'
    },
    {
      value: '695',
      label: 'Bandikui',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '696',
      label: 'Bandipur',
      type: 'City'
    },
    {
      value: '697',
      label: 'Bandri',
      type: 'City'
    },
    {
      value: '698',
      label: 'Banera',
      type: 'City'
    },
    {
      value: '699',
      label: 'Baneria',
      type: 'City'
    },
    {
      value: '700',
      label: 'Banethi',
      type: 'City'
    },
    {
      value: '701',
      label: 'Banga',
      type: 'City'
    },
    {
      value: '702',
      label: 'Bangalore (All Locations)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '703',
      label: 'Bangana',
      type: 'City'
    },
    {
      value: '704',
      label: 'Bangaon',
      type: 'City'
    },
    {
      value: '705',
      label: 'Bangarda',
      type: 'City'
    },
    {
      value: '706',
      label: 'Bangarupalem',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '707',
      label: 'Bangkok',
      type: 'City'
    },
    {
      value: '708',
      label: 'Bangla',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '709',
      label: 'Bangla Choraha',
      type: 'City'
    },
    {
      value: '710',
      label: 'Bangra',
      type: 'City'
    },
    {
      value: '711',
      label: 'Banihal',
      type: 'City'
    },
    {
      value: '712',
      label: 'Banikhet',
      type: 'City'
    },
    {
      value: '713',
      label: 'Baniyagaon',
      type: 'City'
    },
    {
      value: '714',
      label: 'Banjar',
      type: 'City'
    },
    {
      value: '715',
      label: 'Bankapur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '716',
      label: 'Bankhandi',
      type: 'City'
    },
    {
      value: '717',
      label: 'Bankhedi',
      type: 'City'
    },
    {
      value: '718',
      label: 'Banki Mongra',
      type: 'City'
    },
    {
      value: '719',
      label: 'Bankoda',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '720',
      label: 'Bankombo',
      type: 'City'
    },
    {
      value: '721',
      label: 'Bankora',
      type: 'City'
    },
    {
      value: '722',
      label: 'Bankura',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '723',
      label: 'Banmankhi',
      type: 'City'
    },
    {
      value: '724',
      label: 'Bannadka',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '725',
      label: 'Bannadka Belvai',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '726',
      label: 'Banni',
      type: 'City'
    },
    {
      value: '727',
      label: 'Banot',
      type: 'City'
    },
    {
      value: '728',
      label: 'Banpuri',
      type: 'City'
    },
    {
      value: '729',
      label: 'Bansdih',
      type: 'City'
    },
    {
      value: '730',
      label: 'Banshkandi',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '731',
      label: 'Bansi Bazar',
      type: 'City'
    },
    {
      value: '732',
      label: 'Bansi (Rajasthan)',
      type: 'City'
    },
    {
      value: '733',
      label: 'Banswada(Andhra Pradesh)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '734',
      label: 'Banswara',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '735',
      label: 'Bantakal',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '736',
      label: 'Banthadi',
      type: 'City'
    },
    {
      value: '737',
      label: 'Bantumilli',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '738',
      label: 'Bantumilli (andhra pradesh)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '739',
      label: 'Bantva (Gujarat)',
      type: 'City'
    },
    {
      value: '740',
      label: 'Bantva Devli',
      type: 'City'
    },
    {
      value: '741',
      label: 'Bantwal',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '742',
      label: 'Banur',
      type: 'City'
    },
    {
      value: '743',
      label: 'Baori',
      type: 'City'
    },
    {
      value: '744',
      label: 'Bap',
      type: 'City'
    },
    {
      value: '745',
      label: 'Bapatla',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '746',
      label: 'Bapawar',
      type: 'City'
    },
    {
      value: '747',
      label: 'Bar (rajasthan)',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '748',
      label: 'Bar(UP)',
      type: 'City'
    },
    {
      value: '749',
      label: 'Bara',
      type: 'City'
    },
    {
      value: '750',
      label: 'Barabanki',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '751',
      label: 'Barad',
      type: 'City'
    },
    {
      value: '752',
      label: 'Baradiya',
      type: 'City'
    },
    {
      value: '753',
      label: 'Baraftana',
      type: 'City'
    },
    {
      value: '754',
      label: 'Baragwanath',
      type: 'City'
    },
    {
      value: '755',
      label: 'Barahali',
      type: 'City'
    },
    {
      value: '756',
      label: 'Baramati',
      type: 'City'
    },
    {
      value: '757',
      label: 'Baramkela',
      type: 'City'
    },
    {
      value: '758',
      label: 'Baran',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '759',
      label: 'Barar',
      type: 'City'
    },
    {
      value: '760',
      label: 'Barasat (West Bengal)',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '761',
      label: 'Baratang Island',
      type: 'City',
      'state': 'Andaman & Nicobar Islands'
    },
    {
      value: '762',
      label: 'Baraut',
      type: 'City'
    },
    {
      value: '763',
      label: 'Barbil',
      type: 'City'
    },
    {
      value: '764',
      label: 'Bardiya',
      type: 'City'
    },
    {
      value: '765',
      label: 'Bardoli',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '766',
      label: 'Bareilly',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '767',
      label: 'Barela',
      type: 'City'
    },
    {
      value: '768',
      label: 'Bareli',
      type: 'City'
    },
    {
      value: '769',
      label: 'Bargaon',
      type: 'City'
    },
    {
      value: '770',
      label: 'Bargarh',
      type: 'City'
    },
    {
      value: '771',
      label: 'Barghat',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '772',
      label: 'Bargi',
      type: 'City'
    },
    {
      value: '773',
      label: 'Barhalganj',
      type: 'City'
    },
    {
      value: '774',
      label: 'Barhani Bazar',
      type: 'City'
    },
    {
      value: '775',
      label: 'Barhi',
      type: 'City'
    },
    {
      value: '776',
      label: 'Bari',
      type: 'City'
    },
    {
      value: '777',
      label: 'Bari Sadri',
      type: 'City'
    },
    {
      value: '778',
      label: 'Baribramana',
      type: 'City'
    },
    {
      value: '779',
      label: 'Baripada',
      type: 'City'
    },
    {
      value: '780',
      label: 'Bariya',
      type: 'City'
    },
    {
      value: '781',
      label: 'Barka Gaon',
      type: 'City'
    },
    {
      value: '782',
      label: 'Barkhera',
      type: 'City'
    },
    {
      value: '783',
      label: 'Barkur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '784',
      label: 'Barloot',
      type: 'City'
    },
    {
      value: '785',
      label: 'Barmaan',
      type: 'City'
    },
    {
      value: '786',
      label: 'Barman Mota',
      type: 'City'
    },
    {
      value: '787',
      label: 'Barmana',
      type: 'City'
    },
    {
      value: '788',
      label: 'Barmer',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '789',
      label: 'Barnagar',
      type: 'City'
    },
    {
      value: '790',
      label: 'Barnala',
      type: 'City'
    },
    {
      value: '791',
      label: 'Barod',
      type: 'City'
    },
    {
      value: '792',
      label: 'Baroda',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '793',
      label: 'Barodameo',
      type: 'City'
    },
    {
      value: '794',
      label: 'Barodia (MP)',
      type: 'City'
    },
    {
      value: '795',
      label: 'Barodia, Rajasthan',
      type: 'City'
    },
    {
      value: '796',
      label: 'Barodiya Kalan',
      type: 'City'
    },
    {
      value: '797',
      label: 'Barog',
      type: 'City'
    },
    {
      value: '798',
      label: 'Baroli',
      type: 'City'
    },
    {
      value: '799',
      label: 'Baroodi',
      type: 'City'
    },
    {
      value: '800',
      label: 'Barpatoli',
      type: 'City'
    },
    {
      value: '801',
      label: 'Barpeta Road',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '802',
      label: 'Barrackpore (West Bengal)',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '803',
      label: 'BARROS ARANA',
      type: 'City'
    },
    {
      value: '804',
      label: 'Barsar',
      type: 'City'
    },
    {
      value: '805',
      label: 'Barshi',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '806',
      label: 'Barsur',
      type: 'City'
    },
    {
      value: '807',
      label: 'Barth Sahib',
      type: 'City'
    },
    {
      value: '808',
      label: 'Barthata',
      type: 'City'
    },
    {
      value: '809',
      label: 'Barua Sagar',
      type: 'City'
    },
    {
      value: '810',
      label: 'Barvala',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '811',
      label: 'Barwaha',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '812',
      label: 'Barwala (HR)',
      type: 'City',
      'state': 'Haryana'
    },
    {
      value: '813',
      label: 'Barwala (Gujarat)',
      type: 'City'
    },
    {
      value: '814',
      label: 'Barwala (punjab)',
      type: 'City'
    },
    {
      value: '815',
      label: 'Barwali',
      type: 'City'
    },
    {
      value: '816',
      label: 'Barwani',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '817',
      label: 'Basahi',
      type: 'City'
    },
    {
      value: '818',
      label: 'Basavakalyan',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '819',
      label: 'Basavana Bagewadi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '820',
      label: 'Basavapattana',
      type: 'City'
    },
    {
      value: '821',
      label: 'Baskhari',
      type: 'City'
    },
    {
      value: '822',
      label: 'Basmath',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '823',
      label: 'Basna',
      type: 'City'
    },
    {
      value: '824',
      label: 'Basoda',
      type: 'City'
    },
    {
      value: '825',
      label: 'Baspa',
      type: 'City'
    },
    {
      value: '826',
      label: 'Basroor Surveyors',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '827',
      label: 'Basrur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '828',
      label: 'Bassi',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '829',
      label: 'Bastar',
      type: 'City'
    },
    {
      value: '830',
      label: 'Bastawade',
      type: 'City'
    },
    {
      value: '831',
      label: 'Basti',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '832',
      label: 'Batala',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '833',
      label: 'Batari',
      type: 'City'
    },
    {
      value: '834',
      label: 'Batauli',
      type: 'City'
    },
    {
      value: '835',
      label: 'Bathalagundu',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '836',
      label: 'Bathalapalli',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '837',
      label: 'Bathinda',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '838',
      label: 'Batiyagarh',
      type: 'City'
    },
    {
      value: '839',
      label: 'Batkala',
      type: 'City'
    },
    {
      value: '840',
      label: 'Batkanangale',
      type: 'City'
    },
    {
      value: '841',
      label: 'Batlagundu',
      type: 'City'
    },
    {
      value: '842',
      label: 'Batnavalli',
      type: 'City'
    },
    {
      value: '843',
      label: 'Batta',
      type: 'City'
    },
    {
      value: '844',
      label: 'Batva',
      type: 'City'
    },
    {
      value: '845',
      label: 'Bavada',
      type: 'City'
    },
    {
      value: '846',
      label: 'Bavadi',
      type: 'City'
    },
    {
      value: '847',
      label: 'Bavla',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '848',
      label: 'Bawadi',
      type: 'City'
    },
    {
      value: '849',
      label: 'Bawal (Rajasthan)',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '850',
      label: 'Bawari',
      type: 'City'
    },
    {
      value: '851',
      label: 'Bawatara',
      type: 'City'
    },
    {
      value: '852',
      label: 'Bayad',
      type: 'City'
    },
    {
      value: '853',
      label: 'Bayana',
      type: 'City'
    },
    {
      value: '854',
      label: 'Baytu',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '855',
      label: 'Bazpatti',
      type: 'City'
    },
    {
      value: '856',
      label: 'Bazpur',
      type: 'City'
    },
    {
      value: '857',
      label: 'BC Road',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '858',
      label: 'Beas',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '859',
      label: 'Beawar',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '860',
      label: 'Becharaji',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '861',
      label: 'Bediya (Gujarat)',
      type: 'City'
    },
    {
      value: '862',
      label: 'Bediya, MP',
      type: 'City'
    },
    {
      value: '863',
      label: 'Beed',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '864',
      label: 'Beejadi',
      type: 'City'
    },
    {
      value: '865',
      label: 'Beenjhbayala',
      type: 'City'
    },
    {
      value: '866',
      label: 'Beera',
      type: 'City'
    },
    {
      value: '867',
      label: 'Beerapally',
      type: 'City'
    },
    {
      value: '868',
      label: 'Begar',
      type: 'City'
    },
    {
      value: '869',
      label: 'Begu (HR)',
      type: 'City'
    },
    {
      value: '870',
      label: 'Begu (Rajasthan)',
      type: 'City'
    },
    {
      value: '871',
      label: 'Begumganj',
      type: 'City'
    },
    {
      value: '872',
      label: 'Begun',
      type: 'City'
    },
    {
      value: '873',
      label: 'Begusarai',
      type: 'City'
    },
    {
      value: '874',
      label: 'Behed',
      type: 'City'
    },
    {
      value: '875',
      label: 'Behera',
      type: 'City'
    },
    {
      value: '876',
      label: 'Behrampur',
      type: 'City'
    },
    {
      value: '877',
      label: 'Behrod',
      type: 'City'
    },
    {
      value: '878',
      label: 'Behror',
      type: 'City'
    },
    {
      value: '879',
      label: 'Bejai',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '880',
      label: 'Bejai  Mangaluru',
      type: 'City'
    },
    {
      value: '881',
      label: 'Bela (Gujarat)',
      type: 'City'
    },
    {
      value: '882',
      label: 'Belagal',
      type: 'City'
    },
    {
      value: '883',
      label: 'Belagavi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '884',
      label: 'Belapur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '885',
      label: 'Belaswadi',
      type: 'City'
    },
    {
      value: '886',
      label: 'Belavadi',
      type: 'City'
    },
    {
      value: '887',
      label: 'Belewadi',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '888',
      label: 'Belgaum',
      type: 'City'
    },
    {
      value: '889',
      label: 'Belhari',
      type: 'City'
    },
    {
      value: '890',
      label: 'Belkheda',
      type: 'City'
    },
    {
      value: '891',
      label: 'Belkund',
      type: 'City'
    },
    {
      value: '892',
      label: 'Bellampally',
      type: 'City'
    },
    {
      value: '893',
      label: 'Bellare',
      type: 'City'
    },
    {
      value: '894',
      label: 'Bellary',
      type: 'City'
    },
    {
      value: '895',
      label: 'Belman',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '896',
      label: 'Belsand',
      type: 'City'
    },
    {
      value: '897',
      label: 'Belthangady',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '898',
      label: 'Belthara Road',
      type: 'City'
    },
    {
      value: '899',
      label: 'Belthur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '900',
      label: 'Belukurichi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '901',
      label: 'Belur (Hassan)',
      type: 'City'
    },
    {
      value: '902',
      label: 'Belur (Badami)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '903',
      label: 'Beluve',
      type: 'City'
    },
    {
      value: '904',
      label: 'Belvadi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '905',
      label: 'Belvai',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '906',
      label: 'Bemali',
      type: 'City'
    },
    {
      value: '907',
      label: 'Bemetara',
      type: 'City'
    },
    {
      value: '908',
      label: 'Bendamurlanka',
      type: 'City'
    },
    {
      value: '909',
      label: 'Bengaluru',
      type: 'City'
    },
    {
      value: '910',
      label: 'Bengre',
      type: 'City'
    },
    {
      value: '911',
      label: 'Benibari',
      type: 'City'
    },
    {
      value: '912',
      label: 'Benipatti',
      type: 'City'
    },
    {
      value: '913',
      label: 'Benur',
      type: 'City'
    },
    {
      value: '914',
      label: 'Beohari',
      type: 'City'
    },
    {
      value: '915',
      label: 'Berasia',
      type: 'City'
    },
    {
      value: '916',
      label: 'Berhampore',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '917',
      label: 'Berhampur',
      type: 'City'
    },
    {
      value: '918',
      label: 'Beri',
      type: 'City'
    },
    {
      value: '919',
      label: 'Bero',
      type: 'City'
    },
    {
      value: '920',
      label: 'Besant nagar',
      type: 'City'
    },
    {
      value: '921',
      label: 'Bestavaripeta',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '922',
      label: 'Betamcherla',
      type: 'City'
    },
    {
      value: '923',
      label: 'Betma',
      type: 'City'
    },
    {
      value: '924',
      label: 'Bettiah',
      type: 'City'
    },
    {
      value: '925',
      label: 'Betul',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '926',
      label: 'Bewar',
      type: 'City'
    },
    {
      value: '927',
      label: 'Bhabhar',
      type: 'City'
    },
    {
      value: '928',
      label: 'Bhabua',
      type: 'City'
    },
    {
      value: '929',
      label: 'Bhacha',
      type: 'City'
    },
    {
      value: '930',
      label: 'Bhachau',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '931',
      label: 'Bhad',
      type: 'City'
    },
    {
      value: '932',
      label: 'Bhada',
      type: 'City'
    },
    {
      value: '933',
      label: 'Bhadar',
      type: 'City'
    },
    {
      value: '934',
      label: 'Bhadara',
      type: 'City'
    },
    {
      value: '935',
      label: 'Bhader',
      type: 'City'
    },
    {
      value: '936',
      label: 'Bhadeya',
      type: 'City'
    },
    {
      value: '937',
      label: 'Bhadgaon',
      type: 'City'
    },
    {
      value: '938',
      label: 'Bhadi',
      type: 'City'
    },
    {
      value: '939',
      label: 'Bhadiyadka',
      type: 'City'
    },
    {
      value: '940',
      label: 'Bhadkha',
      type: 'City'
    },
    {
      value: '941',
      label: 'Bhadla',
      type: 'City'
    },
    {
      value: '942',
      label: 'Bhadohi',
      type: 'City'
    },
    {
      value: '943',
      label: 'Bhadoriya',
      type: 'City'
    },
    {
      value: '944',
      label: 'Bhadra (Rajasthan)',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '945',
      label: 'Bhadrachalam',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '946',
      label: 'Bhadragiri',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '947',
      label: 'Bhadrajun',
      type: 'City'
    },
    {
      value: '948',
      label: 'Bhadran',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '949',
      label: 'Bhadravati (Karnataka)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '950',
      label: 'Bhadravati (Maharashtra)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '951',
      label: 'Bhadrod',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '952',
      label: 'Bhadsora',
      type: 'City'
    },
    {
      value: '953',
      label: 'Bhadthar',
      type: 'City'
    },
    {
      value: '954',
      label: 'Bhadvan',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '955',
      label: 'Bhaga Bazar',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '956',
      label: 'Bhagalpur',
      type: 'City'
    },
    {
      value: '957',
      label: 'Bhager',
      type: 'City'
    },
    {
      value: '958',
      label: 'Bhagwanpura',
      type: 'City'
    },
    {
      value: '959',
      label: 'Bhainsdehi',
      type: 'City'
    },
    {
      value: '960',
      label: 'Bhainsrorgarh',
      type: 'City'
    },
    {
      value: '961',
      label: 'Bhairamgarh',
      type: 'City'
    },
    {
      value: '962',
      label: 'Bhairumbe',
      type: 'City'
    },
    {
      value: '963',
      label: 'Bhaisola',
      type: 'City'
    },
    {
      value: '964',
      label: 'Bhaiyathan',
      type: 'City'
    },
    {
      value: '965',
      label: 'Bhakarapet',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '966',
      label: 'Bhalej',
      type: 'City'
    },
    {
      value: '967',
      label: 'Bhaleri',
      type: 'City'
    },
    {
      value: '968',
      label: 'Bhalgam',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '969',
      label: 'Bhalki',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '970',
      label: 'Bhalvav',
      type: 'City'
    },
    {
      value: '971',
      label: 'Bhamodra',
      type: 'City'
    },
    {
      value: '972',
      label: 'Bhamori',
      type: 'City'
    },
    {
      value: '973',
      label: 'Bhanchha',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '974',
      label: 'Bhandara',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '975',
      label: 'Bhandariya',
      type: 'City'
    },
    {
      value: '976',
      label: 'Bhandawpur',
      type: 'City'
    },
    {
      value: '977',
      label: 'Bhandu',
      type: 'City'
    },
    {
      value: '978',
      label: 'Bhandup',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '979',
      label: 'Bhanduri',
      type: 'City'
    },
    {
      value: '980',
      label: 'Bhanegaon',
      type: 'City'
    },
    {
      value: '981',
      label: 'Bhangala',
      type: 'City'
    },
    {
      value: '982',
      label: 'Bhangor',
      type: 'City'
    },
    {
      value: '983',
      label: 'Bhaniyana',
      type: 'City'
    },
    {
      value: '984',
      label: 'Bhanjanagar',
      type: 'City'
    },
    {
      value: '985',
      label: 'Bhanpura (MP)',
      type: 'City'
    },
    {
      value: '986',
      label: 'Bhanpura(MP) ',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '987',
      label: 'Bhanpuri',
      type: 'City'
    },
    {
      value: '988',
      label: 'Bhansi',
      type: 'City'
    },
    {
      value: '989',
      label: 'Bhanupratappur',
      type: 'City'
    },
    {
      value: '990',
      label: 'Bhanvad',
      type: 'City'
    },
    {
      value: '991',
      label: 'Bhaptiahi',
      type: 'City'
    },
    {
      value: '992',
      label: 'Bharanu',
      type: 'City'
    },
    {
      value: '993',
      label: 'Bharapar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '994',
      label: 'Bharari Ghat',
      type: 'City'
    },
    {
      value: '995',
      label: 'Bharat Kup',
      type: 'City'
    },
    {
      value: '996',
      label: 'Bharatpur',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '997',
      label: 'Bharauli',
      type: 'City'
    },
    {
      value: '998',
      label: 'Bhareri',
      type: 'City'
    },
    {
      value: '999',
      label: 'Bharmour',
      type: 'City'
    },
    {
      value: '1000',
      label: 'Bharol',
      type: 'City'
    },
    {
      value: '1001',
      label: 'Bharoori',
      type: 'City'
    },
    {
      value: '1002',
      label: 'Bharowal',
      type: 'City'
    },
    {
      value: '1003',
      label: 'Bharsoola Road',
      type: 'City'
    },
    {
      value: '1004',
      label: 'Bhartana',
      type: 'City'
    },
    {
      value: '1005',
      label: 'Bharuch',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1006',
      label: 'Bharunda',
      type: 'City'
    },
    {
      value: '1007',
      label: 'Bharuwa Sumerpur',
      type: 'City'
    },
    {
      value: '1008',
      label: 'Bharwain',
      type: 'City'
    },
    {
      value: '1009',
      label: 'Bhatala',
      type: 'City'
    },
    {
      value: '1010',
      label: 'Bhatewar',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1011',
      label: 'Bhatgaon',
      type: 'City'
    },
    {
      value: '1012',
      label: 'Bhatiya',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1013',
      label: 'Bhatkal',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1014',
      label: 'Bhatnavilli',
      type: 'City'
    },
    {
      value: '1015',
      label: 'Bhattu',
      type: 'City'
    },
    {
      value: '1016',
      label: 'Bhatwan',
      type: 'City'
    },
    {
      value: '1017',
      label: 'Bhavabhi Khijadiya',
      type: 'City'
    },
    {
      value: '1018',
      label: 'Bhavardi',
      type: 'City'
    },
    {
      value: '1019',
      label: 'Bhavnagar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1020',
      label: 'Bhawanathpur',
      type: 'City'
    },
    {
      value: '1021',
      label: 'Bhawani Mandi',
      type: 'City'
    },
    {
      value: '1022',
      label: 'Bhawanigarh',
      type: 'City'
    },
    {
      value: '1023',
      label: 'Bhawanipatna',
      type: 'City'
    },
    {
      value: '1024',
      label: 'Bhawanipur',
      type: 'City'
    },
    {
      value: '1025',
      label: 'Bhawarna',
      type: 'City'
    },
    {
      value: '1026',
      label: 'Bhayavadar',
      type: 'City'
    },
    {
      value: '1027',
      label: 'Bheemarayana Gudi',
      type: 'City'
    },
    {
      value: '1028',
      label: 'Bhel',
      type: 'City'
    },
    {
      value: '1029',
      label: 'Bherunda',
      type: 'City'
    },
    {
      value: '1030',
      label: 'Bhesan',
      type: 'City'
    },
    {
      value: '1031',
      label: 'Bhesawa',
      type: 'City'
    },
    {
      value: '1032',
      label: 'Bheshan',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1033',
      label: 'Bhigwan',
      type: 'City'
    },
    {
      value: '1034',
      label: 'Bhikangaon',
      type: 'City'
    },
    {
      value: '1035',
      label: 'Bhikhodai',
      type: 'City'
    },
    {
      value: '1036',
      label: 'Bhikhowal',
      type: 'City'
    },
    {
      value: '1037',
      label: 'Bhila',
      type: 'City'
    },
    {
      value: '1038',
      label: 'Bhilad',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1039',
      label: 'Bhilai',
      type: 'City'
    },
    {
      value: '1040',
      label: 'Bhildi',
      type: 'City'
    },
    {
      value: '1041',
      label: 'Bhilkua',
      type: 'City'
    },
    {
      value: '1042',
      label: 'Bhiloda',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1043',
      label: 'Bhiluda',
      type: 'City'
    },
    {
      value: '1044',
      label: 'Bhilwada',
      type: 'City'
    },
    {
      value: '1045',
      label: 'Bhilwara',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1046',
      label: 'Bhim',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1047',
      label: 'Bhimadole',
      type: 'City'
    },
    {
      value: '1048',
      label: 'Bhimadolu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1049',
      label: 'Bhimanapalli',
      type: 'City'
    },
    {
      value: '1050',
      label: 'Bhimasar',
      type: 'City'
    },
    {
      value: '1051',
      label: 'Bhimashankar',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1052',
      label: 'Bhimavaram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1053',
      label: 'Bhimdatta',
      type: 'City'
    },
    {
      value: '1054',
      label: 'Bhimdeval',
      type: 'City'
    },
    {
      value: '1055',
      label: 'Bhimora',
      type: 'City'
    },
    {
      value: '1056',
      label: 'Bhimpur',
      type: 'City'
    },
    {
      value: '1057',
      label: 'Bhinai',
      type: 'City'
    },
    {
      value: '1058',
      label: 'Bhind',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '1059',
      label: 'Bhinder',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1060',
      label: 'Bhingewadi',
      type: 'City'
    },
    {
      value: '1061',
      label: 'Bhingrad',
      type: 'City'
    },
    {
      value: '1062',
      label: 'Bhinmal',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1063',
      label: 'Bhinyad',
      type: 'City'
    },
    {
      value: '1064',
      label: 'Bhira',
      type: 'City'
    },
    {
      value: '1065',
      label: 'Bhira Kheri',
      type: 'City'
    },
    {
      value: '1066',
      label: 'Bhirani',
      type: 'City'
    },
    {
      value: '1067',
      label: 'Bhitarwar',
      type: 'City'
    },
    {
      value: '1068',
      label: 'Bhivghat',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1069',
      label: 'Bhiwadi',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1070',
      label: 'Bhiwandi',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1071',
      label: 'Bhiwani',
      type: 'City',
      'state': 'Haryana'
    },
    {
      value: '1072',
      label: 'Bhiwapur',
      type: 'City'
    },
    {
      value: '1073',
      label: 'Bhod',
      type: 'City'
    },
    {
      value: '1074',
      label: 'Bhogat',
      type: 'City'
    },
    {
      value: '1075',
      label: 'Bhognipur',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '1076',
      label: 'Bhogpur',
      type: 'City'
    },
    {
      value: '1077',
      label: 'Bhokar',
      type: 'City'
    },
    {
      value: '1078',
      label: 'Bhokardan',
      type: 'City'
    },
    {
      value: '1079',
      label: 'Bhoma',
      type: 'City'
    },
    {
      value: '1080',
      label: 'Bhongir',
      type: 'City'
    },
    {
      value: '1081',
      label: 'Bhoom',
      type: 'City'
    },
    {
      value: '1082',
      label: 'Bhopal',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '1083',
      label: 'Bhopalgarh',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1084',
      label: 'Bhopalpatnam',
      type: 'City'
    },
    {
      value: '1085',
      label: 'Bhoranj',
      type: 'City'
    },
    {
      value: '1086',
      label: 'Bhorda',
      type: 'City'
    },
    {
      value: '1087',
      label: 'Bhorol',
      type: 'City'
    },
    {
      value: '1088',
      label: 'Bhota',
      type: 'City'
    },
    {
      value: '1089',
      label: 'Bhrahanpur',
      type: 'City'
    },
    {
      value: '1090',
      label: 'Bhramavar',
      type: 'City'
    },
    {
      value: '1091',
      label: 'Bhubaneswar',
      type: 'City'
    },
    {
      value: '1092',
      label: 'Bhucho Mandi',
      type: 'City'
    },
    {
      value: '1093',
      label: 'Bhudagumpa',
      type: 'City'
    },
    {
      value: '1094',
      label: 'Bhuibavada',
      type: 'City'
    },
    {
      value: '1095',
      label: 'Bhuinj',
      type: 'City'
    },
    {
      value: '1096',
      label: 'Bhuj',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1097',
      label: 'Bhujpur',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1098',
      label: 'Bhukarka',
      type: 'City'
    },
    {
      value: '1099',
      label: 'Bhulana',
      type: 'City'
    },
    {
      value: '1100',
      label: 'Bhumkar Chowk',
      type: 'City'
    },
    {
      value: '1101',
      label: 'Bhunas',
      type: 'City'
    },
    {
      value: '1102',
      label: 'Bhunav',
      type: 'City'
    },
    {
      value: '1103',
      label: 'Bhunga',
      type: 'City'
    },
    {
      value: '1104',
      label: 'Bhuntar',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '1105',
      label: 'Bhupalsagar',
      type: 'City'
    },
    {
      value: '1106',
      label: 'Bhuranpura',
      type: 'City'
    },
    {
      value: '1107',
      label: 'Bhusaval',
      type: 'City'
    },
    {
      value: '1108',
      label: 'Bhusaval Railway Station',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1109',
      label: 'Bhusawal',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1110',
      label: 'Bhusawar',
      type: 'City'
    },
    {
      value: '1111',
      label: 'Bhutaha',
      type: 'City'
    },
    {
      value: '1112',
      label: 'Bhutdi',
      type: 'City'
    },
    {
      value: '1113',
      label: 'Bhutti',
      type: 'City'
    },
    {
      value: '1114',
      label: 'Bhuva',
      type: 'City'
    },
    {
      value: '1115',
      label: 'Bhuvanagiri',
      type: 'City'
    },
    {
      value: '1116',
      label: 'Biaora',
      type: 'City'
    },
    {
      value: '1117',
      label: 'Bibi',
      type: 'City'
    },
    {
      value: '1118',
      label: 'Biblsar',
      type: 'City'
    },
    {
      value: '1119',
      label: 'Bichhiwada',
      type: 'City'
    },
    {
      value: '1120',
      label: 'Bichhiwara',
      type: 'City'
    },
    {
      value: '1121',
      label: 'Bichhiya, MP',
      type: 'City'
    },
    {
      value: '1122',
      label: 'Bichkunda',
      type: 'City'
    },
    {
      value: '1123',
      label: 'Bicholim',
      type: 'City',
      'state': 'Goa'
    },
    {
      value: '1124',
      label: 'Bidada',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1125',
      label: 'Bidadi',
      type: 'City'
    },
    {
      value: '1126',
      label: 'Bidar',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1127',
      label: 'Bidarugod',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1128',
      label: 'Bidasar',
      type: 'City'
    },
    {
      value: '1129',
      label: 'Bidhuna',
      type: 'City'
    },
    {
      value: '1130',
      label: 'Bidkalkatte',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1131',
      label: 'Bidla',
      type: 'City'
    },
    {
      value: '1132',
      label: 'Bidri',
      type: 'City'
    },
    {
      value: '1133',
      label: 'Bidupur',
      type: 'City'
    },
    {
      value: '1134',
      label: 'Bighapur',
      type: 'City'
    },
    {
      value: '1135',
      label: 'Bigod',
      type: 'City'
    },
    {
      value: '1136',
      label: 'Bihar',
      type: 'City'
    },
    {
      value: '1137',
      label: 'Bihar Sharif',
      type: 'City'
    },
    {
      value: '1138',
      label: 'Biharigarh',
      type: 'City'
    },
    {
      value: '1139',
      label: 'Bihpuria',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '1140',
      label: 'Bihta',
      type: 'City'
    },
    {
      value: '1141',
      label: 'Bijadandi',
      type: 'City'
    },
    {
      value: '1142',
      label: 'Bijadi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1143',
      label: 'Bijainagar',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1144',
      label: 'Bijapur',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1145',
      label: 'Bijapur, Chhattisgarh',
      type: 'City'
    },
    {
      value: '1146',
      label: 'Bijawar',
      type: 'City'
    },
    {
      value: '1147',
      label: 'Bijhar',
      type: 'City'
    },
    {
      value: '1148',
      label: 'Bijnor',
      type: 'City'
    },
    {
      value: '1149',
      label: 'Bijolia',
      type: 'City'
    },
    {
      value: '1150',
      label: 'Bijoliya',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1151',
      label: 'Bijoor',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1152',
      label: 'Bijwad',
      type: 'City'
    },
    {
      value: '1153',
      label: 'Bikaner',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1154',
      label: 'Bikkavolu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1155',
      label: 'Bikram',
      type: 'City'
    },
    {
      value: '1156',
      label: 'Bikramganj',
      type: 'City'
    },
    {
      value: '1157',
      label: 'Bilagi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1158',
      label: 'Bilara',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1159',
      label: 'BilasPur',
      type: 'City'
    },
    {
      value: '1160',
      label: 'Bilaspur (Chhattisgarh)',
      type: 'City'
    },
    {
      value: '1161',
      label: 'Bilaspur (Himachal Pradesh)',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '1162',
      label: 'Bilgi',
      type: 'City'
    },
    {
      value: '1163',
      label: 'Bilgram',
      type: 'City'
    },
    {
      value: '1164',
      label: 'Bilhaur',
      type: 'City'
    },
    {
      value: '1165',
      label: 'Bilimora',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1166',
      label: 'Biliya',
      type: 'City'
    },
    {
      value: '1167',
      label: 'Biliyala',
      type: 'City'
    },
    {
      value: '1168',
      label: 'Bilkha',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1169',
      label: 'Biloli',
      type: 'City'
    },
    {
      value: '1170',
      label: 'Bilwada',
      type: 'City'
    },
    {
      value: '1171',
      label: 'Bilyala',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1172',
      label: 'Bina',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '1173',
      label: 'Binaganj',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '1174',
      label: 'Bindar',
      type: 'City'
    },
    {
      value: '1175',
      label: 'Bindki',
      type: 'City'
    },
    {
      value: '1176',
      label: 'Bindra Bazar',
      type: 'City'
    },
    {
      value: '1177',
      label: 'Binjasi',
      type: 'City'
    },
    {
      value: '1178',
      label: 'Bir',
      type: 'City'
    },
    {
      value: '1179',
      label: 'Birahandi',
      type: 'City'
    },
    {
      value: '1180',
      label: 'Birdha',
      type: 'City'
    },
    {
      value: '1181',
      label: 'Birdpur',
      type: 'City'
    },
    {
      value: '1182',
      label: 'Birpur',
      type: 'City'
    },
    {
      value: '1183',
      label: 'Birsinghpur',
      type: 'City'
    },
    {
      value: '1184',
      label: 'Birul Bazar',
      type: 'City'
    },
    {
      value: '1185',
      label: 'Birur',
      type: 'City'
    },
    {
      value: '1186',
      label: 'Bisalkoppa',
      type: 'City'
    },
    {
      value: '1187',
      label: 'Bisalpur',
      type: 'City'
    },
    {
      value: '1188',
      label: 'Bishangarh',
      type: 'City'
    },
    {
      value: '1189',
      label: 'Bishrampur',
      type: 'City'
    },
    {
      value: '1190',
      label: 'Bissau',
      type: 'City'
    },
    {
      value: '1191',
      label: 'Bisu Kalan',
      type: 'City'
    },
    {
      value: '1192',
      label: 'Bita',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1193',
      label: 'Bithal',
      type: 'City'
    },
    {
      value: '1194',
      label: 'Bithauli',
      type: 'City'
    },
    {
      value: '1195',
      label: 'Bithlakatte',
      type: 'City'
    },
    {
      value: '1196',
      label: 'Biyavara',
      type: 'City'
    },
    {
      value: '1197',
      label: 'Black Bridge',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1198',
      label: 'Boat cruise',
      type: 'City'
    },
    {
      value: '1199',
      label: 'Bobas',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1200',
      label: 'Bobbili',
      type: 'City'
    },
    {
      value: '1201',
      label: 'Bodduvaripalem',
      type: 'City'
    },
    {
      value: '1202',
      label: 'Bodegaon',
      type: 'City'
    },
    {
      value: '1203',
      label: 'Bodhan, Telangana',
      type: 'City'
    },
    {
      value: '1204',
      label: 'Bodhgaya',
      type: 'City'
    },
    {
      value: '1205',
      label: 'Bodi',
      type: 'City'
    },
    {
      value: '1206',
      label: 'Bodigama',
      type: 'City'
    },
    {
      value: '1207',
      label: 'Bodinayakanur',
      type: 'City'
    },
    {
      value: '1208',
      label: 'Bodiya',
      type: 'City'
    },
    {
      value: '1209',
      label: 'Bodki',
      type: 'City'
    },
    {
      value: '1210',
      label: 'Bodwad',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1211',
      label: 'Boipariguda',
      type: 'City'
    },
    {
      value: '1212',
      label: 'Boisar',
      type: 'City'
    },
    {
      value: '1213',
      label: 'Bokakhat',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '1214',
      label: 'Bokaro',
      type: 'City',
      'state': 'Jharkhand'
    },
    {
      value: '1215',
      label: 'Bolangir',
      type: 'City'
    },
    {
      value: '1216',
      label: 'Boliya',
      type: 'City'
    },
    {
      value: '1217',
      label: 'Bolundra',
      type: 'City'
    },
    {
      value: '1218',
      label: 'Boogaon',
      type: 'City'
    },
    {
      value: '1219',
      label: 'Borai',
      type: 'City'
    },
    {
      value: '1220',
      label: 'Boraj(Adilabad)',
      type: 'City'
    },
    {
      value: '1221',
      label: 'Borala',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1222',
      label: 'Borana',
      type: 'City'
    },
    {
      value: '1223',
      label: 'Borawar',
      type: 'City'
    },
    {
      value: '1224',
      label: 'Borda',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1225',
      label: 'Bordehi',
      type: 'City'
    },
    {
      value: '1226',
      label: 'Bordi Samadhiyala',
      type: 'City'
    },
    {
      value: '1227',
      label: 'Borgaon Manju',
      type: 'City'
    },
    {
      value: '1228',
      label: 'Borgaon, Chhattisgarh',
      type: 'City'
    },
    {
      value: '1229',
      label: 'Bori',
      type: 'City'
    },
    {
      value: '1230',
      label: 'Borigumma',
      type: 'City'
    },
    {
      value: '1231',
      label: 'Boriyapura',
      type: 'City'
    },
    {
      value: '1232',
      label: 'Borlipanchatan(Maharashtra)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1233',
      label: 'Borsad',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1234',
      label: 'Borta',
      type: 'City'
    },
    {
      value: '1235',
      label: 'Borvav',
      type: 'City'
    },
    {
      value: '1236',
      label: 'Botad',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1237',
      label: 'Botla Palem',
      type: 'City'
    },
    {
      value: '1238',
      label: 'Boudh',
      type: 'City'
    },
    {
      value: '1239',
      label: 'Brahmanacheruv',
      type: 'City'
    },
    {
      value: '1240',
      label: 'Brahmanagudem',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1241',
      label: 'Brahmangaon',
      type: 'City'
    },
    {
      value: '1242',
      label: 'Brahmano Ki Sareri',
      type: 'City'
    },
    {
      value: '1243',
      label: 'Brahmanwada',
      type: 'City'
    },
    {
      value: '1244',
      label: 'Brahmapur, Bihar',
      type: 'City'
    },
    {
      value: '1245',
      label: 'Brahmapuri',
      type: 'City'
    },
    {
      value: '1246',
      label: 'Brahmavar',
      type: 'City'
    },
    {
      value: '1247',
      label: 'Brahmavara',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1248',
      label: 'Brahmpukhar',
      type: 'City'
    },
    {
      value: '1249',
      label: 'Bramavara',
      type: 'City'
    },
    {
      value: '1250',
      label: 'Bramhapuri (Chandrapur)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1251',
      label: 'Brg Industrial Park',
      type: 'City'
    },
    {
      value: '1252',
      label: 'Buchireddypalem',
      type: 'City'
    },
    {
      value: '1253',
      label: 'Budaun',
      type: 'City'
    },
    {
      value: '1254',
      label: 'Budhanpur',
      type: 'City'
    },
    {
      value: '1255',
      label: 'Budhel',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1256',
      label: 'Budhlada',
      type: 'City'
    },
    {
      value: '1257',
      label: 'Budhni',
      type: 'City'
    },
    {
      value: '1258',
      label: 'Budsu',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1259',
      label: 'Budugumpa',
      type: 'City'
    },
    {
      value: '1260',
      label: 'Bugga',
      type: 'City'
    },
    {
      value: '1261',
      label: 'Buhana',
      type: 'City'
    },
    {
      value: '1262',
      label: 'Bulandshahr',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '1263',
      label: 'Buldhana',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1264',
      label: 'BULNES',
      type: 'City'
    },
    {
      value: '1265',
      label: 'Bundi',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1266',
      label: 'Buniadpur',
      type: 'City'
    },
    {
      value: '1267',
      label: 'Burdwan',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '1268',
      label: 'Burgur',
      type: 'City'
    },
    {
      value: '1269',
      label: 'Burhanpur',
      type: 'City'
    },
    {
      value: '1270',
      label: 'Burhanpur(Maharashtra)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1271',
      label: 'Burhanpur, UP',
      type: 'City'
    },
    {
      value: '1272',
      label: 'Burla',
      type: 'City'
    },
    {
      value: '1273',
      label: 'Bushal',
      type: 'City'
    },
    {
      value: '1274',
      label: 'Butati',
      type: 'City'
    },
    {
      value: '1275',
      label: 'Butibori',
      type: 'City'
    },
    {
      value: '1276',
      label: 'Buttelanka',
      type: 'City'
    },
    {
      value: '1277',
      label: 'Butwal',
      type: 'City'
    },
    {
      value: '1278',
      label: 'Buxar',
      type: 'City'
    },
    {
      value: '1279',
      label: 'Buxwaha',
      type: 'City'
    },
    {
      value: '1280',
      label: 'Byadagi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1281',
      label: 'Byavar',
      type: 'City'
    },
    {
      value: '1282',
      label: 'Bylakuppe',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1283',
      label: 'Bylur',
      type: 'City'
    },
    {
      value: '1284',
      label: 'Byndoor',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1285',
      label: 'C.B.D Belapur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1286',
      label: 'CACHAPOAL',
      type: 'City'
    },
    {
      value: '1287',
      label: 'CAJON',
      type: 'City'
    },
    {
      value: '1288',
      label: 'Calama',
      type: 'City'
    },
    {
      value: '1289',
      label: 'Calangute',
      type: 'City'
    },
    {
      value: '1290',
      label: 'Calcutta',
      type: 'City'
    },
    {
      value: '1291',
      label: 'Calicut',
      type: 'City'
    },
    {
      value: '1292',
      label: 'Campirganj',
      type: 'City'
    },
    {
      value: '1293',
      label: 'Canacona',
      type: 'City',
      'state': 'Goa'
    },
    {
      value: '1294',
      label: 'capetwon',
      type: 'City'
    },
    {
      value: '1295',
      label: 'Casilda',
      type: 'City'
    },
    {
      value: '1296',
      label: 'Catriel',
      type: 'City'
    },
    {
      value: '1297',
      label: 'Caucete',
      type: 'City'
    },
    {
      value: '1298',
      label: 'Centenario',
      type: 'City'
    },
    {
      value: '1299',
      label: 'Central',
      type: 'City'
    },
    {
      value: '1300',
      label: 'Chaba',
      type: 'City'
    },
    {
      value: '1301',
      label: 'Chabbewal',
      type: 'City'
    },
    {
      value: '1302',
      label: 'Chabhadiya',
      type: 'City'
    },
    {
      value: '1303',
      label: 'Chabi',
      type: 'City'
    },
    {
      value: '1304',
      label: 'Chabua',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '1305',
      label: 'Chacabuco',
      type: 'City'
    },
    {
      value: '1306',
      label: 'Chadayamangalam',
      type: 'City'
    },
    {
      value: '1307',
      label: 'Chadhiar',
      type: 'City'
    },
    {
      value: '1308',
      label: 'Chadi',
      type: 'City'
    },
    {
      value: '1309',
      label: 'Chadiar',
      type: 'City'
    },
    {
      value: '1310',
      label: 'Chadotar',
      type: 'City'
    },
    {
      value: '1311',
      label: 'Chagalamarri',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1312',
      label: 'Chagallu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1313',
      label: 'Chagran',
      type: 'City'
    },
    {
      value: '1314',
      label: 'Chahuwali',
      type: 'City'
    },
    {
      value: '1315',
      label: 'Chaibasa',
      type: 'City',
      'state': 'Jharkhand'
    },
    {
      value: '1316',
      label: 'Chail',
      type: 'City'
    },
    {
      value: '1317',
      label: 'Chail-Chowk',
      type: 'City'
    },
    {
      value: '1318',
      label: 'Chailla',
      type: 'City'
    },
    {
      value: '1319',
      label: 'Chajari',
      type: 'City'
    },
    {
      value: '1320',
      label: 'Chakan',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1321',
      label: 'Chakghat',
      type: 'City'
    },
    {
      value: '1322',
      label: 'Chakia',
      type: 'City'
    },
    {
      value: '1323',
      label: 'Chakkarakal',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '1324',
      label: 'Chakkargadh',
      type: 'City'
    },
    {
      value: '1325',
      label: 'Chakrava',
      type: 'City'
    },
    {
      value: '1326',
      label: 'Chakrda',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1327',
      label: 'Chakshu',
      type: 'City'
    },
    {
      value: '1328',
      label: 'Chakur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1329',
      label: 'Chala',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '1330',
      label: 'Chalakudi',
      type: 'City'
    },
    {
      value: '1331',
      label: 'Chalala',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1332',
      label: 'Chalinze',
      type: 'City'
    },
    {
      value: '1333',
      label: 'Chalisgaon',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1334',
      label: 'Challakere',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1335',
      label: 'Challapalli',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1336',
      label: 'Challavanipeta',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1337',
      label: 'Chalode',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '1338',
      label: 'Chamaradi',
      type: 'City'
    },
    {
      value: '1339',
      label: 'Chamarajanagar',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1340',
      label: 'Chamba (Himachal Pradesh)',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '1341',
      label: 'Chamberry',
      type: 'City'
    },
    {
      value: '1342',
      label: 'Chambi',
      type: 'City'
    },
    {
      value: '1343',
      label: 'Chamorshi',
      type: 'City'
    },
    {
      value: '1344',
      label: 'Champaran',
      type: 'City'
    },
    {
      value: '1345',
      label: 'Chamukha',
      type: 'City'
    },
    {
      value: '1346',
      label: 'Chamunda',
      type: 'City'
    },
    {
      value: '1347',
      label: 'Chanair',
      type: 'City'
    },
    {
      value: '1348',
      label: 'Chanaka',
      type: 'City'
    },
    {
      value: '1349',
      label: 'Chanasma',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1350',
      label: 'Chanaur',
      type: 'City'
    },
    {
      value: '1351',
      label: 'Chanda',
      type: 'City'
    },
    {
      value: '1352',
      label: 'Chandaluru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1353',
      label: 'Chandan',
      type: 'City'
    },
    {
      value: '1354',
      label: 'Chandauli',
      type: 'City'
    },
    {
      value: '1355',
      label: 'Chandausi',
      type: 'City'
    },
    {
      value: '1356',
      label: 'Chandavar',
      type: 'City'
    },
    {
      value: '1357',
      label: 'Chandawal',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1358',
      label: 'Chandela',
      type: 'City'
    },
    {
      value: '1359',
      label: 'Chanderi',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '1360',
      label: 'Chandgad',
      type: 'City'
    },
    {
      value: '1361',
      label: 'Chandigarh(punjab)',
      type: 'City',
      'state': 'Chandigarh'
    },
    {
      value: '1362',
      label: 'Chandikhol',
      type: 'City'
    },
    {
      value: '1363',
      label: 'Chandili',
      type: 'City'
    },
    {
      value: '1364',
      label: 'Chandisar',
      type: 'City'
    },
    {
      value: '1365',
      label: 'Chandla',
      type: 'City'
    },
    {
      value: '1366',
      label: 'Chandoli',
      type: 'City'
    },
    {
      value: '1367',
      label: 'Chandoor',
      type: 'City'
    },
    {
      value: '1368',
      label: 'Chandpur',
      type: 'City'
    },
    {
      value: '1369',
      label: 'Chandragiri',
      type: 'City'
    },
    {
      value: '1370',
      label: 'Chandragutti',
      type: 'City'
    },
    {
      value: '1371',
      label: 'Chandrai',
      type: 'City'
    },
    {
      value: '1372',
      label: 'Chandrampalem',
      type: 'City'
    },
    {
      value: '1373',
      label: 'Chandrapur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1374',
      label: 'Chandras',
      type: 'City'
    },
    {
      value: '1375',
      label: 'Chandrasekharapuram',
      type: 'City'
    },
    {
      value: '1376',
      label: 'Chandravati',
      type: 'City'
    },
    {
      value: '1377',
      label: 'Chandur Bazar',
      type: 'City'
    },
    {
      value: '1378',
      label: 'Chandur Railway',
      type: 'City'
    },
    {
      value: '1379',
      label: 'ChandurBazar',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1380',
      label: 'Chandwad (Nashik)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1381',
      label: 'Chandwaji',
      type: 'City'
    },
    {
      value: '1382',
      label: 'Changanacherry',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '1383',
      label: 'Changanassery',
      type: 'City'
    },
    {
      value: '1384',
      label: 'Changaveti',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '1385',
      label: 'Changodar',
      type: 'City'
    },
    {
      value: '1386',
      label: 'Changoi',
      type: 'City'
    },
    {
      value: '1387',
      label: 'Changotola',
      type: 'City'
    },
    {
      value: '1388',
      label: 'Chankoya',
      type: 'City'
    },
    {
      value: '1389',
      label: 'Channagiri',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1390',
      label: 'Channapatna',
      type: 'City'
    },
    {
      value: '1391',
      label: 'Channarayapattana',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1392',
      label: 'Channo',
      type: 'City'
    },
    {
      value: '1393',
      label: 'Chapadgaon',
      type: 'City'
    },
    {
      value: '1394',
      label: 'Chapda',
      type: 'City'
    },
    {
      value: '1395',
      label: 'Chapoli',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1396',
      label: 'Chapora',
      type: 'City'
    },
    {
      value: '1397',
      label: 'Chappath',
      type: 'City'
    },
    {
      value: '1398',
      label: 'Chaprada',
      type: 'City'
    },
    {
      value: '1399',
      label: 'Charadva',
      type: 'City'
    },
    {
      value: '1400',
      label: 'Charama',
      type: 'City'
    },
    {
      value: '1401',
      label: 'Charan Samadhiyala',
      type: 'City'
    },
    {
      value: '1402',
      label: 'Charaniya',
      type: 'City'
    },
    {
      value: '1403',
      label: 'Charata',
      type: 'City'
    },
    {
      value: '1404',
      label: 'Charbhuja',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1405',
      label: 'Charbhuja  Rawatbhata',
      type: 'City'
    },
    {
      value: '1406',
      label: 'Charkha',
      type: 'City'
    },
    {
      value: '1407',
      label: 'Charkhadiya',
      type: 'City'
    },
    {
      value: '1408',
      label: 'Charkhi Dadri',
      type: 'City'
    },
    {
      value: '1409',
      label: 'Charna',
      type: 'City'
    },
    {
      value: '1410',
      label: 'Charodiya',
      type: 'City'
    },
    {
      value: '1411',
      label: 'Charoti',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1412',
      label: 'Charthana',
      type: 'City'
    },
    {
      value: '1413',
      label: 'Chatra',
      type: 'City'
    },
    {
      value: '1414',
      label: 'Chatrala',
      type: 'City'
    },
    {
      value: '1415',
      label: 'Chatrapatti',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '1416',
      label: 'Chatrapur',
      type: 'City'
    },
    {
      value: '1417',
      label: 'Chattanchal',
      type: 'City'
    },
    {
      value: '1418',
      label: 'Chatti',
      type: 'City'
    },
    {
      value: '1419',
      label: 'Chaturbhujpur',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '1420',
      label: 'Chaubepur',
      type: 'City'
    },
    {
      value: '1421',
      label: 'Chauke',
      type: 'City'
    },
    {
      value: '1422',
      label: 'Chaumahla (Rajasthan)',
      type: 'City'
    },
    {
      value: '1423',
      label: 'Chauntra',
      type: 'City'
    },
    {
      value: '1424',
      label: 'Chauri Chaura',
      type: 'City'
    },
    {
      value: '1425',
      label: 'Chauta',
      type: 'City'
    },
    {
      value: '1426',
      label: 'Chautala',
      type: 'City'
    },
    {
      value: '1427',
      label: 'Chavadi',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '1428',
      label: 'Chavakkad',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '1429',
      label: 'Chavand',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1430',
      label: 'Chawa',
      type: 'City'
    },
    {
      value: '1431',
      label: 'Chawand',
      type: 'City'
    },
    {
      value: '1432',
      label: 'Chawandiya',
      type: 'City'
    },
    {
      value: '1433',
      label: 'Cheepurupalli',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1434',
      label: 'Chejerla',
      type: 'City'
    },
    {
      value: '1435',
      label: 'Chelak',
      type: 'City'
    },
    {
      value: '1436',
      label: 'Chelari',
      type: 'City'
    },
    {
      value: '1437',
      label: 'Chembur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1438',
      label: 'Chemmad',
      type: 'City'
    },
    {
      value: '1439',
      label: 'Chempanthotty',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '1440',
      label: 'Chemperi',
      type: 'City'
    },
    {
      value: '1441',
      label: 'Chempi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1442',
      label: 'Chengalpattu',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '1443',
      label: 'Chengannur',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '1444',
      label: 'Chengi',
      type: 'City'
    },
    {
      value: '1445',
      label: 'Chennai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '1446',
      label: 'Chennapatna',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1447',
      label: 'Chennimalai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '1448',
      label: 'Chennur',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1449',
      label: 'Cherali',
      type: 'City'
    },
    {
      value: '1450',
      label: 'Cheranmahadevi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '1451',
      label: 'Cheravathur',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '1452',
      label: 'Cherkala',
      type: 'City'
    },
    {
      value: '1453',
      label: 'Cherla',
      type: 'City'
    },
    {
      value: '1454',
      label: 'Cherpulassery',
      type: 'City'
    },
    {
      value: '1455',
      label: 'Cherragada',
      type: 'City'
    },
    {
      value: '1456',
      label: 'Cherthala',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '1457',
      label: 'Cherukupalli',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1458',
      label: 'Cherukuru',
      type: 'City'
    },
    {
      value: '1459',
      label: 'Cherukuwada',
      type: 'City'
    },
    {
      value: '1460',
      label: 'Cherupuzha',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '1461',
      label: 'Cheruvathur',
      type: 'City'
    },
    {
      value: '1462',
      label: 'Chetpet',
      type: 'City'
    },
    {
      value: '1463',
      label: 'Chettikulam',
      type: 'City'
    },
    {
      value: '1464',
      label: 'Cheyyar',
      type: 'City'
    },
    {
      value: '1465',
      label: 'Cheyyeru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1466',
      label: 'Chhani Badi',
      type: 'City'
    },
    {
      value: '1467',
      label: 'Chhapar',
      type: 'City'
    },
    {
      value: '1468',
      label: 'Chhapari',
      type: 'City'
    },
    {
      value: '1469',
      label: 'Chhapi',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1470',
      label: 'Chhapra, MP',
      type: 'City'
    },
    {
      value: '1471',
      label: 'Chhata',
      type: 'City'
    },
    {
      value: '1472',
      label: 'Chhatapur',
      type: 'City'
    },
    {
      value: '1473',
      label: 'Chhatar',
      type: 'City'
    },
    {
      value: '1474',
      label: 'Chhatarpur',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '1475',
      label: 'Chhatarpur, Jharkhand',
      type: 'City'
    },
    {
      value: '1476',
      label: 'Chhatikara',
      type: 'City'
    },
    {
      value: '1477',
      label: 'Chhatral',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1478',
      label: 'Chhattargarh',
      type: 'City'
    },
    {
      value: '1479',
      label: 'Chhegaon Makhan',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '1480',
      label: 'Chher (Atps Colony)',
      type: 'City'
    },
    {
      value: '1481',
      label: 'Chher Moti',
      type: 'City'
    },
    {
      value: '1482',
      label: 'Chher Nani',
      type: 'City'
    },
    {
      value: '1483',
      label: 'Chhibramau',
      type: 'City'
    },
    {
      value: '1484',
      label: 'Chhindgarh',
      type: 'City'
    },
    {
      value: '1485',
      label: 'Chhindwara',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '1486',
      label: 'Chhipa Barod',
      type: 'City'
    },
    {
      value: '1487',
      label: 'Chhokarwara',
      type: 'City'
    },
    {
      value: '1488',
      label: 'Chhota Udaipur',
      type: 'City'
    },
    {
      value: '1489',
      label: 'Chhoti Khatu',
      type: 'City'
    },
    {
      value: '1490',
      label: 'Chhoti Sadri',
      type: 'City'
    },
    {
      value: '1491',
      label: 'Chhoti Safer ',
      type: 'City'
    },
    {
      value: '1492',
      label: 'Chhutmalpur',
      type: 'City'
    },
    {
      value: '1493',
      label: 'Chichola',
      type: 'City'
    },
    {
      value: '1494',
      label: 'Chicholi',
      type: 'City'
    },
    {
      value: '1495',
      label: 'Chichondi Patil',
      type: 'City'
    },
    {
      value: '1496',
      label: 'Chickmagaluru',
      type: 'City'
    },
    {
      value: '1497',
      label: 'Chidambaram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '1498',
      label: 'Chidava',
      type: 'City'
    },
    {
      value: '1499',
      label: 'Chigalli',
      type: 'City'
    },
    {
      value: '1500',
      label: 'Chikalthana',
      type: 'City'
    },
    {
      value: '1501',
      label: 'Chikarda',
      type: 'City'
    },
    {
      value: '1502',
      label: 'Chikhali (Gujarat)',
      type: 'City'
    },
    {
      value: '1503',
      label: 'Chikhli  Buldhana',
      type: 'City'
    },
    {
      value: '1504',
      label: 'Chikkaballapur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1505',
      label: 'Chikkaballapura',
      type: 'City'
    },
    {
      value: '1506',
      label: 'Chikkala',
      type: 'City'
    },
    {
      value: '1507',
      label: 'Chikkamagalore',
      type: 'City'
    },
    {
      value: '1508',
      label: 'Chikkeri',
      type: 'City'
    },
    {
      value: '1509',
      label: 'Chikkerur',
      type: 'City'
    },
    {
      value: '1510',
      label: 'Chikkodi',
      type: 'City'
    },
    {
      value: '1511',
      label: 'Chikmagalur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1512',
      label: 'Chikodi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1513',
      label: 'Chilakaluripet',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1514',
      label: 'Chilakapadu',
      type: 'City'
    },
    {
      value: '1515',
      label: 'Chilakapalem',
      type: 'City'
    },
    {
      value: '1516',
      label: 'Chilamkur',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1517',
      label: 'Chilecito',
      type: 'City'
    },
    {
      value: '1518',
      label: 'Chilkahar',
      type: 'City'
    },
    {
      value: '1519',
      label: 'Chilla',
      type: 'City'
    },
    {
      value: '1520',
      label: 'Chillakallu',
      type: 'City'
    },
    {
      value: '1521',
      label: 'Chillan',
      type: 'City'
    },
    {
      value: '1522',
      label: 'Chilma Bazar',
      type: 'City'
    },
    {
      value: '1523',
      label: 'Chiloda',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1524',
      label: 'Chilpi, MP',
      type: 'City'
    },
    {
      value: '1525',
      label: 'Chimakurthy',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1526',
      label: 'Chimthana',
      type: 'City'
    },
    {
      value: '1527',
      label: 'Chinarikatla',
      type: 'City'
    },
    {
      value: '1528',
      label: 'Chinchali',
      type: 'City'
    },
    {
      value: '1529',
      label: 'Chinchinada',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1530',
      label: 'Chinchpada',
      type: 'City'
    },
    {
      value: '1531',
      label: 'Chinchpur',
      type: 'City'
    },
    {
      value: '1532',
      label: 'Chindi',
      type: 'City'
    },
    {
      value: '1533',
      label: 'Chingavanam',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '1534',
      label: 'Chinna Dharapuram',
      type: 'City'
    },
    {
      value: '1535',
      label: 'Chinnakanal',
      type: 'City'
    },
    {
      value: '1536',
      label: 'Chinnalapatti',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '1537',
      label: 'Chinnamandem',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1538',
      label: 'Chinnamanur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '1539',
      label: 'Chinnar',
      type: 'City'
    },
    {
      value: '1540',
      label: 'Chinnasalem',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '1541',
      label: 'Chinnathurai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '1542',
      label: 'Chinnur',
      type: 'City'
    },
    {
      value: '1543',
      label: 'Chintaparthi',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1544',
      label: 'Chintpurni',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '1545',
      label: 'Chinturu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1546',
      label: 'Chipawand',
      type: 'City'
    },
    {
      value: '1547',
      label: 'Chiplun',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1548',
      label: 'Chipurupalli',
      type: 'City'
    },
    {
      value: '1549',
      label: 'Chiragaon',
      type: 'City'
    },
    {
      value: '1550',
      label: 'Chirai',
      type: 'City'
    },
    {
      value: '1551',
      label: 'Chiraidongri',
      type: 'City'
    },
    {
      value: '1552',
      label: 'Chirala',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1553',
      label: 'Chiraptla',
      type: 'City'
    },
    {
      value: '1554',
      label: 'Chirawa',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1555',
      label: 'Chirimiri',
      type: 'City'
    },
    {
      value: '1556',
      label: 'Chiroda',
      type: 'City'
    },
    {
      value: '1557',
      label: 'Chital',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1558',
      label: 'Chitalwana',
      type: 'City'
    },
    {
      value: '1559',
      label: 'Chitamba',
      type: 'City'
    },
    {
      value: '1560',
      label: 'Chitbaragaon',
      type: 'City'
    },
    {
      value: '1561',
      label: 'Chitrada',
      type: 'City'
    },
    {
      value: '1562',
      label: 'Chitradurga',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1563',
      label: 'Chitrakoot',
      type: 'City'
    },
    {
      value: '1564',
      label: 'Chitrod',
      type: 'City'
    },
    {
      value: '1565',
      label: 'Chittapur',
      type: 'City'
    },
    {
      value: '1566',
      label: 'Chittarical',
      type: 'City'
    },
    {
      value: '1567',
      label: 'Chittarkottai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '1568',
      label: 'Chittaur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1569',
      label: 'Chittaurgarh',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1570',
      label: 'Chittod',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '1571',
      label: 'Chittode',
      type: 'City'
    },
    {
      value: '1572',
      label: 'Chittoor (Karnataka)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1573',
      label: 'Chittoor (Rajasthan)',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1574',
      label: 'Chittoor (Andhra Pradesh)',
      type: 'City'
    },
    {
      value: '1575',
      label: 'Chitvel',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1576',
      label: 'Chivaluru',
      type: 'City'
    },
    {
      value: '1577',
      label: 'Chohtan',
      type: 'City'
    },
    {
      value: '1578',
      label: 'Chokawada',
      type: 'City'
    },
    {
      value: '1579',
      label: 'Choki Sorath',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1580',
      label: 'Chokli',
      type: 'City'
    },
    {
      value: '1581',
      label: 'Cholapuram',
      type: 'City'
    },
    {
      value: '1582',
      label: 'Cholingar',
      type: 'City'
    },
    {
      value: '1583',
      label: 'Chomu',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1584',
      label: 'Chonda',
      type: 'City'
    },
    {
      value: '1585',
      label: 'Chooling',
      type: 'City'
    },
    {
      value: '1586',
      label: 'Choora',
      type: 'City'
    },
    {
      value: '1587',
      label: 'Chopal',
      type: 'City'
    },
    {
      value: '1588',
      label: 'Chopan',
      type: 'City'
    },
    {
      value: '1589',
      label: 'Chopda',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1590',
      label: 'Chopna',
      type: 'City'
    },
    {
      value: '1591',
      label: 'Chorau',
      type: 'City'
    },
    {
      value: '1592',
      label: 'Chordi',
      type: 'City'
    },
    {
      value: '1593',
      label: 'Chorla',
      type: 'City'
    },
    {
      value: '1594',
      label: 'Chorma',
      type: 'City'
    },
    {
      value: '1595',
      label: 'Chorwad',
      type: 'City'
    },
    {
      value: '1596',
      label: 'Chotia (Chhattisgarh)',
      type: 'City'
    },
    {
      value: '1597',
      label: 'Chotila',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1598',
      label: 'Chotra',
      type: 'City'
    },
    {
      value: '1599',
      label: 'Chottanikara',
      type: 'City'
    },
    {
      value: '1600',
      label: 'Chouk',
      type: 'City'
    },
    {
      value: '1601',
      label: 'Chouparan',
      type: 'City'
    },
    {
      value: '1602',
      label: 'Chousala',
      type: 'City'
    },
    {
      value: '1603',
      label: 'Chowari',
      type: 'City'
    },
    {
      value: '1604',
      label: 'Chowk',
      type: 'City'
    },
    {
      value: '1605',
      label: 'Ch-Peta',
      type: 'City'
    },
    {
      value: '1606',
      label: 'Chuda',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1607',
      label: 'Chuda Sorath',
      type: 'City'
    },
    {
      value: '1608',
      label: 'Chudapali',
      type: 'City'
    },
    {
      value: '1609',
      label: 'Chudva',
      type: 'City'
    },
    {
      value: '1610',
      label: 'Churag',
      type: 'City'
    },
    {
      value: '1611',
      label: 'Churhat',
      type: 'City'
    },
    {
      value: '1612',
      label: 'Churu',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1613',
      label: 'Cochin',
      type: 'City'
    },
    {
      value: '1614',
      label: 'Coimbatore',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '1615',
      label: 'Colachel',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '1616',
      label: 'Colombo',
      type: 'City'
    },
    {
      value: '1617',
      label: 'Colonelganj',
      type: 'City'
    },
    {
      value: '1618',
      label: 'Colva',
      type: 'City'
    },
    {
      value: '1619',
      label: 'Concepcion',
      type: 'City'
    },
    {
      value: '1620',
      label: 'Concordia',
      type: 'City'
    },
    {
      value: '1621',
      label: 'Coonoor',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '1622',
      label: 'Coorg',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1623',
      label: 'Cordoba',
      type: 'City'
    },
    {
      value: '1624',
      label: 'Corrientes',
      type: 'City'
    },
    {
      value: '1625',
      label: 'Courtallam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '1626',
      label: 'Covai Market',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '1627',
      label: 'Cross Land',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1628',
      label: 'Cuddalore',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '1629',
      label: 'Cuddapah',
      type: 'City'
    },
    {
      value: '1630',
      label: 'Cumbum (Andhra Pradesh)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1631',
      label: 'Cumbum(Tamil Nadu)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '1632',
      label: 'Cuncolim',
      type: 'City'
    },
    {
      value: '1633',
      label: 'Cuttack',
      type: 'City'
    },
    {
      value: '1634',
      label: 'Dabani',
      type: 'City'
    },
    {
      value: '1635',
      label: 'Dabhadi',
      type: 'City'
    },
    {
      value: '1636',
      label: 'Dabhashi',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1637',
      label: 'Dabhoi',
      type: 'City'
    },
    {
      value: '1638',
      label: 'Dabhol',
      type: 'City'
    },
    {
      value: '1639',
      label: 'Dabi',
      type: 'City'
    },
    {
      value: '1640',
      label: 'Daboh',
      type: 'City'
    },
    {
      value: '1641',
      label: 'Dabok',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1642',
      label: 'Dabra',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '1643',
      label: 'Dabri',
      type: 'City'
    },
    {
      value: '1644',
      label: 'Dabugaon',
      type: 'City'
    },
    {
      value: '1645',
      label: 'Dabwali, HR',
      type: 'City'
    },
    {
      value: '1646',
      label: 'Dada Bhagwan',
      type: 'City'
    },
    {
      value: '1647',
      label: 'Dada Sibha',
      type: 'City'
    },
    {
      value: '1648',
      label: 'Dadal',
      type: 'City'
    },
    {
      value: '1649',
      label: 'Dadar, Maharashtra',
      type: 'City'
    },
    {
      value: '1650',
      label: 'Dadhol',
      type: 'City'
    },
    {
      value: '1651',
      label: 'Dadma',
      type: 'City'
    },
    {
      value: '1652',
      label: 'Dadrewa',
      type: 'City'
    },
    {
      value: '1653',
      label: 'Dadva',
      type: 'City'
    },
    {
      value: '1654',
      label: 'Dag',
      type: 'City'
    },
    {
      value: '1655',
      label: 'Daggubadu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1656',
      label: 'Dagguluru',
      type: 'City'
    },
    {
      value: '1657',
      label: 'Daghiya',
      type: 'City'
    },
    {
      value: '1658',
      label: 'Dahagaon',
      type: 'City'
    },
    {
      value: '1659',
      label: 'Dahegam',
      type: 'City'
    },
    {
      value: '1660',
      label: 'Dahej',
      type: 'City'
    },
    {
      value: '1661',
      label: 'Dahi',
      type: 'City'
    },
    {
      value: '1662',
      label: 'Dahikonga',
      type: 'City'
    },
    {
      value: '1663',
      label: 'Dahinsara',
      type: 'City'
    },
    {
      value: '1664',
      label: 'Dahinthara',
      type: 'City'
    },
    {
      value: '1665',
      label: 'Dahisara',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1666',
      label: 'Dahithara',
      type: 'City'
    },
    {
      value: '1667',
      label: 'Dahivel',
      type: 'City'
    },
    {
      value: '1668',
      label: 'Dahod',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1669',
      label: 'Daiya',
      type: 'City'
    },
    {
      value: '1670',
      label: 'Dakor',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1671',
      label: 'Dalan',
      type: 'City'
    },
    {
      value: '1672',
      label: 'Dalauda',
      type: 'City'
    },
    {
      value: '1673',
      label: 'Dalhousie',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '1674',
      label: 'Dalimb',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1675',
      label: 'Dalkhania',
      type: 'City'
    },
    {
      value: '1676',
      label: 'Dalkhola',
      type: 'City'
    },
    {
      value: '1677',
      label: 'Dalla',
      type: 'City'
    },
    {
      value: '1678',
      label: 'Dalli Rajhara',
      type: 'City'
    },
    {
      value: '1679',
      label: 'Dalpatpur',
      type: 'City'
    },
    {
      value: '1680',
      label: 'Dalsinghsarai',
      type: 'City'
    },
    {
      value: '1681',
      label: 'Daltonganj',
      type: 'City',
      'state': 'Jharkhand'
    },
    {
      value: '1682',
      label: 'Damakheda',
      type: 'City'
    },
    {
      value: '1683',
      label: 'Damalcheruvu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1684',
      label: 'Daman',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1685',
      label: 'Damanjodi',
      type: 'City'
    },
    {
      value: '1686',
      label: 'Dammapeta',
      type: 'City'
    },
    {
      value: '1687',
      label: 'Damnagar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1688',
      label: 'Damoh',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '1689',
      label: 'Damta',
      type: 'City'
    },
    {
      value: '1690',
      label: 'Damua',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '1691',
      label: 'Dandamudi',
      type: 'City'
    },
    {
      value: '1692',
      label: 'Dandeli',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1693',
      label: 'Dandru',
      type: 'City'
    },
    {
      value: '1694',
      label: 'Dangar',
      type: 'City'
    },
    {
      value: '1695',
      label: 'Dangiyawas',
      type: 'City'
    },
    {
      value: '1696',
      label: 'Dangra',
      type: 'City'
    },
    {
      value: '1697',
      label: 'Dangri',
      type: 'City'
    },
    {
      value: '1698',
      label: 'Danitola',
      type: 'City'
    },
    {
      value: '1699',
      label: 'Danpur',
      type: 'City'
    },
    {
      value: '1700',
      label: 'Danta',
      type: 'City'
    },
    {
      value: '1701',
      label: 'Danta Ramgarh',
      type: 'City'
    },
    {
      value: '1702',
      label: 'Dantewada',
      type: 'City'
    },
    {
      value: '1703',
      label: 'Dantiwada',
      type: 'City'
    },
    {
      value: '1704',
      label: 'Dantrai',
      type: 'City'
    },
    {
      value: '1705',
      label: 'Dapoli',
      type: 'City'
    },
    {
      value: '1706',
      label: 'Dapora',
      type: 'City'
    },
    {
      value: '1707',
      label: 'Dappar',
      type: 'City'
    },
    {
      value: '1708',
      label: 'Dara',
      type: 'City'
    },
    {
      value: '1709',
      label: 'Daramali',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1710',
      label: 'Darang',
      type: 'City'
    },
    {
      value: '1711',
      label: 'Darapuram',
      type: 'City'
    }
    ,
    {
      value: '1712',
      label: 'Darba Kalan',
      type: 'City'
    },
    {
      value: '1713',
      label: 'Darbha',
      type: 'City'
    },
    {
      value: '1714',
      label: 'Darbhanga',
      type: 'City'
    },
    {
      value: '1715',
      label: 'Dared',
      type: 'City'
    },
    {
      value: '1716',
      label: 'Dariba',
      type: 'City'
    },
    {
      value: '1717',
      label: 'Darjeeling ',
      type: 'City'
    },
    {
      value: '1718',
      label: 'Darlaghat',
      type: 'City'
    },
    {
      value: '1719',
      label: 'Daroh',
      type: 'City'
    },
    {
      value: '1720',
      label: 'Darsadi',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1721',
      label: 'Darshadi',
      type: 'City'
    },
    {
      value: '1722',
      label: 'Darsi',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1723',
      label: 'Darwha',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1724',
      label: 'Daryapur (Maharashtra)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1725',
      label: 'Dasada',
      type: 'City'
    },
    {
      value: '1726',
      label: 'Dasaj',
      type: 'City'
    },
    {
      value: '1727',
      label: 'Dasanakoppa',
      type: 'City'
    },
    {
      value: '1728',
      label: 'Daspalla',
      type: 'City'
    },
    {
      value: '1729',
      label: 'Daspan',
      type: 'City'
    },
    {
      value: '1730',
      label: 'Dasuya',
      type: 'City'
    },
    {
      value: '1731',
      label: 'Data (Rajasthan)',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1732',
      label: 'Datala',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1733',
      label: 'Datardi',
      type: 'City'
    },
    {
      value: '1734',
      label: 'Datia',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '1735',
      label: 'Datrana',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1736',
      label: 'Dattigaon',
      type: 'City'
    },
    {
      value: '1737',
      label: 'Daudnagar',
      type: 'City'
    },
    {
      value: '1738',
      label: 'Daulatgarh',
      type: 'City'
    },
    {
      value: '1739',
      label: 'Daulatpur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1740',
      label: 'Daulatpur  Una',
      type: 'City'
    },
    {
      value: '1741',
      label: 'Daulatpura, Punjab',
      type: 'City'
    },
    {
      value: '1742',
      label: 'Daulatpura, Rajasthan',
      type: 'City'
    },
    {
      value: '1743',
      label: 'Daund',
      type: 'City'
    },
    {
      value: '1744',
      label: 'Daurana',
      type: 'City'
    },
    {
      value: '1745',
      label: 'Dausa',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1746',
      label: 'Davanagere',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1747',
      label: 'Davli',
      type: 'City'
    },
    {
      value: '1748',
      label: 'Dawaleswaram',
      type: 'City'
    },
    {
      value: '1749',
      label: 'Dawana',
      type: 'City'
    },
    {
      value: '1750',
      label: 'Dayalpura',
      type: 'City'
    },
    {
      value: '1751',
      label: 'Dayapar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1752',
      label: 'De Sai Camp',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1753',
      label: 'Deaulgaon Raja',
      type: 'City'
    },
    {
      value: '1754',
      label: 'Debari',
      type: 'City'
    },
    {
      value: '1755',
      label: 'Deccan',
      type: 'City'
    },
    {
      value: '1756',
      label: 'Dechu',
      type: 'City'
    },
    {
      value: '1757',
      label: 'Dedakadi',
      type: 'City'
    },
    {
      value: '1758',
      label: 'Dedan',
      type: 'City'
    },
    {
      value: '1759',
      label: 'Deedwana',
      type: 'City'
    },
    {
      value: '1760',
      label: 'Deeg',
      type: 'City'
    },
    {
      value: '1761',
      label: 'Deem',
      type: 'City'
    },
    {
      value: '1762',
      label: 'Deepnagar',
      type: 'City'
    },
    {
      value: '1763',
      label: 'Deepnagar (Maharashtra)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1764',
      label: 'Degana',
      type: 'City'
    },
    {
      value: '1765',
      label: 'Degaon',
      type: 'City'
    },
    {
      value: '1766',
      label: 'Degav',
      type: 'City'
    },
    {
      value: '1767',
      label: 'Degavada',
      type: 'City'
    },
    {
      value: '1768',
      label: 'Degloor',
      type: 'City'
    },
    {
      value: '1769',
      label: 'Deha',
      type: 'City'
    },
    {
      value: '1770',
      label: 'Deharda',
      type: 'City'
    },
    {
      value: '1771',
      label: 'Dehra',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '1772',
      label: 'Dehra Gopipur',
      type: 'City'
    },
    {
      value: '1773',
      label: 'Dehra, Himachal Pradesh',
      type: 'City'
    },
    {
      value: '1774',
      label: 'Dehra mod, Rajasthan',
      type: 'City'
    },
    {
      value: '1775',
      label: 'Dehradun',
      type: 'City'
    },
    {
      value: '1776',
      label: 'Dehri on sone (Bihar)',
      type: 'City'
    },
    {
      value: '1777',
      label: 'Dehu',
      type: 'City'
    },
    {
      value: '1778',
      label: 'Delakhari',
      type: 'City'
    },
    {
      value: '1779',
      label: 'Deldar',
      type: 'City'
    },
    {
      value: '1780',
      label: 'Delhi',
      type: 'City',
      'state': 'Delhi'
    },
    {
      value: '1781',
      label: 'Delvada',
      type: 'City'
    },
    {
      value: '1782',
      label: 'Demai',
      type: 'City'
    },
    {
      value: '1783',
      label: 'Denap',
      type: 'City'
    },
    {
      value: '1784',
      label: 'Denduluru',
      type: 'City'
    },
    {
      value: '1785',
      label: 'Denok',
      type: 'City'
    },
    {
      value: '1786',
      label: 'Deobhog',
      type: 'City'
    },
    {
      value: '1787',
      label: 'Deogarh',
      type: 'City'
    },
    {
      value: '1788',
      label: 'Deola',
      type: 'City'
    },
    {
      value: '1789',
      label: 'Deolapar',
      type: 'City'
    },
    {
      value: '1790',
      label: 'Deoli Auwa',
      type: 'City'
    },
    {
      value: '1791',
      label: 'Deoli, Maharashtra',
      type: 'City'
    },
    {
      value: '1792',
      label: 'Deoli, Rajasthan',
      type: 'City'
    },
    {
      value: '1793',
      label: 'Deoni',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1794',
      label: 'Deori, Chhattisgarh',
      type: 'City'
    },
    {
      value: '1795',
      label: 'Deori, MP',
      type: 'City'
    },
    {
      value: '1796',
      label: 'Deoria (UP)',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '1797',
      label: 'Deotalab',
      type: 'City'
    },
    {
      value: '1798',
      label: 'Dera Bassi',
      type: 'City'
    },
    {
      value: '1799',
      label: 'Dera, Bihar',
      type: 'City'
    },
    {
      value: '1800',
      label: 'Deradi Janbai',
      type: 'City'
    },
    {
      value: '1801',
      label: 'Deralakatte',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1802',
      label: 'Deralakatte  Someshwar',
      type: 'City'
    },
    {
      value: '1803',
      label: 'Derdi Kumbhaji',
      type: 'City'
    },
    {
      value: '1804',
      label: 'Dergaon',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '1805',
      label: 'Deripipriya',
      type: 'City'
    },
    {
      value: '1806',
      label: 'Desaguadero La Paz',
      type: 'City'
    },
    {
      value: '1807',
      label: 'Desai Camp',
      type: 'City'
    },
    {
      value: '1808',
      label: 'Desalpar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1809',
      label: 'Deshgaon',
      type: 'City'
    },
    {
      value: '1810',
      label: 'Deshnokh',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1811',
      label: 'Deshotar',
      type: 'City'
    },
    {
      value: '1812',
      label: 'Desuri',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1813',
      label: 'Detad',
      type: 'City'
    },
    {
      value: '1814',
      label: 'Deulgaon Mahi',
      type: 'City'
    },
    {
      value: '1815',
      label: 'Deulgaon Mali',
      type: 'City'
    },
    {
      value: '1816',
      label: 'Deulgaon Raja (Buldhana)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1817',
      label: 'Deur Budruk',
      type: 'City'
    },
    {
      value: '1818',
      label: 'Devadhanapatti',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '1819',
      label: 'Devadurga',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1820',
      label: 'Devaka',
      type: 'City'
    },
    {
      value: '1821',
      label: 'Devakigalol',
      type: 'City'
    },
    {
      value: '1822',
      label: 'Devakottai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '1823',
      label: 'Devali',
      type: 'City'
    },
    {
      value: '1824',
      label: 'Devaliya',
      type: 'City'
    },
    {
      value: '1825',
      label: 'Devalki',
      type: 'City'
    },
    {
      value: '1826',
      label: 'Devanakonda',
      type: 'City'
    },
    {
      value: '1827',
      label: 'Devapur',
      type: 'City'
    },
    {
      value: '1828',
      label: 'Devar Hippargi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1829',
      label: 'Devarapally',
      type: 'City'
    },
    {
      value: '1830',
      label: 'Devarkulam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '1831',
      label: 'Devbag',
      type: 'City'
    },
    {
      value: '1832',
      label: 'Devda, Gujarat',
      type: 'City'
    },
    {
      value: '1833',
      label: 'Devda, Rajasthan',
      type: 'City'
    },
    {
      value: '1834',
      label: 'Devdi',
      type: 'City'
    },
    {
      value: '1835',
      label: 'Devendra Nagar',
      type: 'City'
    },
    {
      value: '1836',
      label: 'Devgad',
      type: 'City'
    },
    {
      value: '1837',
      label: 'Devgadh Baria',
      type: 'City'
    },
    {
      value: '1838',
      label: 'Devgalraja',
      type: 'City'
    },
    {
      value: '1839',
      label: 'Devgam',
      type: 'City'
    },
    {
      value: '1840',
      label: 'Devgarh(Rajasthan)',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1841',
      label: 'Devguradiya Temple',
      type: 'City'
    },
    {
      value: '1842',
      label: 'Devikot',
      type: 'City'
    },
    {
      value: '1843',
      label: 'Devipattinam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '1844',
      label: 'Devka',
      type: 'City'
    },
    {
      value: '1845',
      label: 'Devki Galol (Bhesan)',
      type: 'City'
    },
    {
      value: '1846',
      label: 'Devla',
      type: 'City'
    },
    {
      value: '1847',
      label: 'Devla (Nashik)',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1848',
      label: 'Devli',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1849',
      label: 'Devpar',
      type: 'City'
    },
    {
      value: '1850',
      label: 'Devrajia',
      type: 'City'
    },
    {
      value: '1851',
      label: 'Devri',
      type: 'City'
    },
    {
      value: '1852',
      label: 'Devrukh',
      type: 'City'
    },
    {
      value: '1853',
      label: 'Dewair',
      type: 'City'
    },
    {
      value: '1854',
      label: 'Dewas',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '1855',
      label: 'Dhabi Kalan',
      type: 'City'
    },
    {
      value: '1856',
      label: 'Dhad',
      type: 'City'
    },
    {
      value: '1857',
      label: 'Dhajdi',
      type: 'City'
    },
    {
      value: '1858',
      label: 'Dhaka',
      type: 'City'
    },
    {
      value: '1859',
      label: 'Dhakdi',
      type: 'City'
    },
    {
      value: '1860',
      label: 'Dhakhava',
      type: 'City'
    },
    {
      value: '1861',
      label: 'Dhakoni',
      type: 'City'
    },
    {
      value: '1862',
      label: 'Dhakuakhana',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '1863',
      label: 'Dhakwa Bazzar',
      type: 'City'
    },
    {
      value: '1864',
      label: 'Dhalegaon (Beed)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1865',
      label: 'Dhalgaon',
      type: 'City'
    },
    {
      value: '1866',
      label: 'Dhaliara',
      type: 'City'
    },
    {
      value: '1867',
      label: 'Dhalli',
      type: 'City'
    },
    {
      value: '1868',
      label: 'Dhamanahandi',
      type: 'City'
    },
    {
      value: '1869',
      label: 'Dhamangaon',
      type: 'City'
    },
    {
      value: '1870',
      label: 'Dhamangaon Badhe',
      type: 'City'
    },
    {
      value: '1871',
      label: 'Dhambhola',
      type: 'City'
    },
    {
      value: '1872',
      label: 'Dhamdha',
      type: 'City'
    },
    {
      value: '1873',
      label: 'Dhamel',
      type: 'City'
    },
    {
      value: '1874',
      label: 'Dhameta',
      type: 'City'
    },
    {
      value: '1875',
      label: 'Dhamnod',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '1876',
      label: 'Dhamtari',
      type: 'City'
    },
    {
      value: '1877',
      label: 'Dhan Ghata',
      type: 'City'
    },
    {
      value: '1878',
      label: 'Dhanau',
      type: 'City'
    },
    {
      value: '1879',
      label: 'Dhanbad',
      type: 'City',
      'state': 'Jharkhand'
    },
    {
      value: '1880',
      label: 'Dhanbad, Jharkhand',
      type: 'City'
    },
    {
      value: '1881',
      label: 'Dhandhuka',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1882',
      label: 'Dhanera',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1883',
      label: 'Dhaneta',
      type: 'City'
    },
    {
      value: '1884',
      label: 'Dhaneypur',
      type: 'City'
    },
    {
      value: '1885',
      label: 'Dhangadhi',
      type: 'City'
    },
    {
      value: '1886',
      label: 'Dhangdhra',
      type: 'City'
    },
    {
      value: '1887',
      label: 'Dhangota',
      type: 'City'
    },
    {
      value: '1888',
      label: 'Dhaniya Mau',
      type: 'City'
    },
    {
      value: '1889',
      label: 'Dhanji Ka Wada',
      type: 'City'
    },
    {
      value: '1890',
      label: 'Dhank',
      type: 'City'
    },
    {
      value: '1891',
      label: 'Dhanla',
      type: 'City'
    },
    {
      value: '1892',
      label: 'Dhanora',
      type: 'City'
    },
    {
      value: '1893',
      label: 'Dhanpunji',
      type: 'City'
    },
    {
      value: '1894',
      label: 'Dhanpur',
      type: 'City'
    },
    {
      value: '1895',
      label: 'Dhansa',
      type: 'City'
    },
    {
      value: '1896',
      label: 'Dhansura',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1897',
      label: 'Dhanwar',
      type: 'City'
    },
    {
      value: '1898',
      label: 'Dhar',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '1899',
      label: 'Dhar, Gujarat',
      type: 'City'
    },
    {
      value: '1900',
      label: 'Dhar, MP',
      type: 'City'
    },
    {
      value: '1901',
      label: 'Dharai',
      type: 'City'
    },
    {
      value: '1902',
      label: 'Dharampur',
      type: 'City'
    },
    {
      value: '1903',
      label: 'Dharampur  Mandi',
      type: 'City'
    },
    {
      value: '1904',
      label: 'Dharampur  Solan',
      type: 'City'
    },
    {
      value: '1905',
      label: 'Dharampur (Gujarat)',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1906',
      label: 'Dharampuri',
      type: 'City'
    },
    {
      value: '1907',
      label: 'Dharamshala',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '1908',
      label: 'Dharangaon',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1909',
      label: 'Dharapuram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '1910',
      label: 'Dhareshwar',
      type: 'City'
    },
    {
      value: '1911',
      label: 'Dhargani',
      type: 'City'
    },
    {
      value: '1912',
      label: 'Dhargaon',
      type: 'City'
    },
    {
      value: '1913',
      label: 'Dhari',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1914',
      label: 'Dhariwal',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '1915',
      label: 'Dhariyawad',
      type: 'City'
    },
    {
      value: '1916',
      label: 'Dharmabad',
      type: 'City'
    },
    {
      value: '1917',
      label: 'Dharmagarh',
      type: 'City'
    },
    {
      value: '1918',
      label: 'Dharmaj',
      type: 'City'
    },
    {
      value: '1919',
      label: 'Dharmajchowkdi',
      type: 'City'
    },
    {
      value: '1920',
      label: 'Dharmanagar',
      type: 'City',
      'state': 'Tripura'
    },
    {
      value: '1921',
      label: 'Dharmapuri',
      type: 'City'
    },
    {
      value: '1922',
      label: 'Dharmapuri (Tamil Nadu)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '1923',
      label: 'Dharmapuri (Telangana)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1924',
      type: 'City'
    },
    {
      value: '1925',
      label: 'Dharmasthala',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1926',
      label: 'Dharmavaram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1927',
      label: 'Dharmjaygarh',
      type: 'City'
    },
    {
      value: '1928',
      label: 'Dharmshala',
      type: 'City'
    },
    {
      value: '1929',
      label: 'Dharna',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '1930',
      label: 'Dharni',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '1931',
      label: 'Dharnodhar',
      type: 'City'
    },
    {
      value: '1932',
      label: 'Dharoi',
      type: 'City'
    },
    {
      value: '1933',
      label: 'Dharol',
      type: 'City'
    },
    {
      value: '1934',
      label: 'Dhartale',
      type: 'City'
    },
    {
      value: '1935',
      label: 'Dharuheda',
      type: 'City',
      'state': 'Haryana'
    },
    {
      value: '1936',
      label: 'Dharuhera',
      type: 'City'
    },
    {
      value: '1937',
      label: 'Dharur',
      type: 'City'
    },
    {
      value: '1938',
      label: 'Dharva',
      type: 'City'
    },
    {
      value: '1939',
      label: 'Dharvala',
      type: 'City'
    },
    {
      value: '1940',
      label: 'Dharwa',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1941',
      label: 'Dharwad',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '1942',
      label: 'Dhasa',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1943',
      label: 'Dhaula Kuan',
      type: 'City'
    },
    {
      value: '1944',
      label: 'Dhavaleswaram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1945',
      label: 'Dhawa',
      type: 'City'
    },
    {
      value: '1946',
      label: 'Dhawas',
      type: 'City'
    },
    {
      value: '1947',
      label: 'Dhebar',
      type: 'City'
    },
    {
      value: '1948',
      label: 'Dhebewadi',
      type: 'City'
    },
    {
      value: '1949',
      label: 'Dheera',
      type: 'City'
    },
    {
      value: '1950',
      label: 'Dhekan Moha',
      type: 'City'
    },
    {
      value: '1951',
      label: 'Dhekiajuli',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '1952',
      label: 'Dhekna',
      type: 'City'
    },
    {
      value: '1953',
      label: 'Dhemaji',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '1954',
      label: 'Dhenkanal',
      type: 'City'
    },
    {
      value: '1955',
      label: 'Dhigawa',
      type: 'City'
    },
    {
      value: '1956',
      label: 'Dhima',
      type: 'City'
    },
    {
      value: '1957',
      label: 'Dhingsara',
      type: 'City'
    },
    {
      value: '1958',
      label: 'Dhinoj',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1959',
      label: 'Dhoh',
      type: 'City'
    },
    {
      value: '1960',
      label: 'Dhokadava',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1961',
      label: 'Dhoki (Maharashtra)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1962',
      label: 'Dhola',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1963',
      label: 'Dholai Bazar',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '1964',
      label: 'Dholasa',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1965',
      label: 'Dholera (Gujarat)',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1966',
      label: 'Dholidhar',
      type: 'City'
    },
    {
      value: '1967',
      label: 'Dholka',
      type: 'City'
    },
    {
      value: '1968',
      label: 'Dholpur',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1969',
      label: 'Dholva',
      type: 'City'
    },
    {
      value: '1970',
      label: 'Dhondaicha',
      type: 'City'
    },
    {
      value: '1971',
      label: 'Dhone',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '1972',
      label: 'Dhonera',
      type: 'City'
    },
    {
      value: '1973',
      label: 'Dhoraji',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1974',
      label: 'Dhorimanna',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1975',
      label: 'Dhrangadhra',
      type: 'City'
    },
    {
      value: '1976',
      label: 'Dhrol',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1977',
      label: 'Dhudhian Wali',
      type: 'City'
    },
    {
      value: '1978',
      label: 'Dhule',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1979',
      label: 'Dhulia',
      type: 'City'
    },
    {
      value: '1980',
      label: 'Dhuma',
      type: 'City'
    },
    {
      value: '1981',
      label: 'Dhumbadiya',
      type: 'City'
    },
    {
      value: '1982',
      label: 'Dhunai',
      type: 'City'
    },
    {
      value: '1983',
      label: 'Dhunthiyan',
      type: 'City'
    },
    {
      value: '1984',
      label: 'Dhuri',
      type: 'City'
    },
    {
      value: '1985',
      label: 'Dhusiya',
      type: 'City'
    },
    {
      value: '1986',
      label: 'Dhutarpur',
      type: 'City'
    },
    {
      value: '1987',
      label: 'Dhuvaran',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '1988',
      label: 'Dibrugarh',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '1989',
      label: 'Dichpally',
      type: 'City'
    },
    {
      value: '1990',
      label: 'Didwana',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '1991',
      label: 'Digboi',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '1992',
      label: 'Digha',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '1993',
      label: 'Dighanchi',
      type: 'City'
    },
    {
      value: '1994',
      label: 'Digraj',
      type: 'City'
    },
    {
      value: '1995',
      label: 'Digras (Yavatmal)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '1996',
      label: 'Diken',
      type: 'City'
    },
    {
      value: '1997',
      label: 'Dimapur',
      type: 'City',
      'state': 'Nagaland'
    },
    {
      value: '1998',
      label: 'Dinanagar',
      type: 'City'
    },
    {
      value: '1999',
      label: 'Dinara (MP)',
      type: 'City'
    },
    {
      value: '2000',
      label: 'Dindigul',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '2001',
      label: 'Dindivanam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '2002',
      label: 'Dindori, MP',
      type: 'City'
    },
    {
      value: '2003',
      label: 'Dindrud',
      type: 'City'
    },
    {
      value: '2004',
      label: 'Dingor',
      type: 'City'
    },
    {
      value: '2005',
      label: 'Disa',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2006',
      label: 'Dithori',
      type: 'City'
    },
    {
      value: '2007',
      label: 'Ditla',
      type: 'City'
    },
    {
      value: '2008',
      label: 'Diu',
      type: 'City',
      'state': 'Daman & Diu'
    },
    {
      value: '2009',
      label: 'Diu',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2010',
      label: 'Divasa',
      type: 'City'
    },
    {
      value: '2011',
      label: 'Divda Bada',
      type: 'City'
    },
    {
      value: '2012',
      label: 'Diveagar',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2013',
      label: 'Diyatra',
      type: 'City'
    },
    {
      value: '2014',
      label: 'Diyodar',
      type: 'City'
    },
    {
      value: '2015',
      label: 'Dobcherla',
      type: 'City'
    },
    {
      value: '2016',
      label: 'Dobhada',
      type: 'City'
    },
    {
      value: '2017',
      label: 'Dobhi, Bihar',
      type: 'City'
    },
    {
      value: '2018',
      label: 'Dochi',
      type: 'City'
    },
    {
      value: '2019',
      label: 'Dodamarg',
      type: 'City'
    },
    {
      value: '2020',
      label: 'Dodar',
      type: 'City'
    },
    {
      value: '2021',
      label: 'Dodavali',
      type: 'City'
    },
    {
      value: '2022',
      label: 'Doddaballapura',
      type: 'City'
    },
    {
      value: '2023',
      label: 'Dohrighat',
      type: 'City'
    },
    {
      value: '2024',
      label: 'Doiphodia',
      type: 'City'
    },
    {
      value: '2025',
      label: 'Dol Kamal',
      type: 'City'
    },
    {
      value: '2026',
      label: 'Dolasa',
      type: 'City'
    },
    {
      value: '2027',
      label: 'Dolatpar',
      type: 'City'
    },
    {
      value: '2028',
      label: 'Dolatper',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2029',
      label: 'Dolatpura (Maharashtra)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2030',
      label: 'Dolpura',
      type: 'City'
    },
    {
      value: '2031',
      label: 'Dolti',
      type: 'City'
    },
    {
      value: '2032',
      label: 'Domariyaganj',
      type: 'City'
    },
    {
      value: '2033',
      label: 'Dombivali',
      type: 'City'
    },
    {
      value: '2034',
      label: 'Dombivli',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2035',
      label: 'Dombiwali',
      type: 'City'
    },
    {
      value: '2036',
      label: 'Dommeru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2037',
      label: 'Dondaicha',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2038',
      label: 'Dondi',
      type: 'City'
    },
    {
      value: '2039',
      label: 'Dongaon (Buldhana)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2040',
      label: 'Dongar',
      type: 'City'
    },
    {
      value: '2041',
      label: 'Dongargarh',
      type: 'City'
    },
    {
      value: '2042',
      label: 'Dongarkada',
      type: 'City'
    },
    {
      value: '2043',
      label: 'Dongarkinhi',
      type: 'City'
    },
    {
      value: '2044',
      label: 'Doomdooma',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '2045',
      label: 'Doopadakatte',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2046',
      label: 'Doraguda',
      type: 'City'
    },
    {
      value: '2047',
      label: 'Doraha',
      type: 'City'
    },
    {
      value: '2048',
      label: 'Dornal',
      type: 'City'
    },
    {
      value: '2049',
      label: 'Dornapal',
      type: 'City'
    },
    {
      value: '2050',
      label: 'Doru Shahabad',
      type: 'City'
    },
    {
      value: '2051',
      label: 'Dosarka',
      type: 'City'
    },
    {
      value: '2052',
      label: 'Double Chowki',
      type: 'City'
    },
    {
      value: '2053',
      label: 'Dousa',
      type: 'City'
    },
    {
      value: '2054',
      label: 'Dowlaiswaram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2055',
      label: 'Draksharamam',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2056',
      label: 'Draman',
      type: 'City'
    },
    {
      value: '2057',
      label: 'Dron',
      type: 'City'
    },
    {
      value: '2058',
      label: 'Dronadula',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2059',
      label: 'Dubacherla',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2060',
      label: 'Dubna',
      type: 'City'
    },
    {
      value: '2061',
      label: 'Duddukuru (Prakasham District)',
      type: 'City'
    },
    {
      value: '2062',
      label: 'Dudgaon',
      type: 'City'
    },
    {
      value: '2063',
      label: 'Dudhai',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2064',
      label: 'Dudhala',
      type: 'City'
    },
    {
      value: '2065',
      label: 'Dudhala gir',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2066',
      label: 'Dudhi',
      type: 'City'
    },
    {
      value: '2067',
      label: 'Dudu',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '2068',
      label: 'Duggiralla',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2069',
      label: 'Dugla',
      type: 'City'
    },
    {
      value: '2070',
      label: 'Duldula',
      type: 'City'
    },
    {
      value: '2071',
      label: 'Dulhara',
      type: 'City'
    },
    {
      value: '2072',
      label: 'Duliajan',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '2073',
      label: 'Duliyana',
      type: 'City'
    },
    {
      value: '2074',
      label: 'Dumaria',
      type: 'City'
    },
    {
      value: '2075',
      label: 'Dumiyani',
      type: 'City'
    },
    {
      value: '2076',
      label: 'Dunawa',
      type: 'City'
    },
    {
      value: '2077',
      label: 'Dunera',
      type: 'City'
    },
    {
      value: '2078',
      label: 'Dungar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2079',
      label: 'Dungargarh',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '2080',
      label: 'Dungarpur',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '2081',
      label: 'Dungla',
      type: 'City'
    },
    {
      value: '2082',
      label: 'Dungrana',
      type: 'City'
    },
    {
      value: '2083',
      label: 'Dungri',
      type: 'City'
    },
    {
      value: '2084',
      label: 'Durban',
      type: 'City'
    },
    {
      value: '2085',
      label: 'Durban Station',
      type: 'City'
    },
    {
      value: '2086',
      label: 'Durg',
      type: 'City'
    },
    {
      value: '2087',
      label: 'Durgapur (West Bengal)',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '2088',
      label: 'Durgatola',
      type: 'City'
    },
    {
      value: '2089',
      label: 'Duriyur',
      type: 'City'
    },
    {
      value: '2090',
      label: 'Dusrabid',
      type: 'City'
    },
    {
      value: '2091',
      label: 'Duttalur',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2092',
      label: 'Duttnagar',
      type: 'City'
    },
    {
      value: '2093',
      label: 'Duvva',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2094',
      label: 'Duvvuru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2095',
      label: 'Dwaraka Tirumala',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2096',
      label: 'Dwarapudi',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2097',
      label: 'Dwarkathirumala',
      type: 'City'
    },
    {
      value: '2098',
      label: 'Eachoor',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '2099',
      label: 'Eachur',
      type: 'City'
    },
    {
      value: '2100',
      label: 'Eachur  Munderi',
      type: 'City'
    },
    {
      value: '2101',
      label: 'Eamankulam',
      type: 'City'
    },
    {
      value: '2102',
      label: 'Echal Karanji',
      type: 'City'
    },
    {
      value: '2103',
      label: 'Edakkad',
      type: 'City'
    },
    {
      value: '2104',
      label: 'Edalabad',
      type: 'City'
    },
    {
      value: '2105',
      label: 'Edambadal',
      type: 'City'
    },
    {
      value: '2106',
      label: 'Edamon',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '2107',
      label: 'Edamuttam',
      type: 'City'
    },
    {
      value: '2108',
      label: 'Edappally',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '2109',
      label: 'Edappally  Kochi',
      type: 'City'
    },
    {
      value: '2110',
      label: 'Edarikode',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '2111',
      label: 'Edugurallapalli',
      type: 'City'
    },
    {
      value: '2112',
      label: 'Edur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2113',
      label: 'Edurulanka',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2114',
      label: 'Eepuru',
      type: 'City'
    },
    {
      value: '2115',
      label: 'Egmore',
      type: 'City'
    },
    {
      value: '2116',
      label: 'Ekalara',
      type: 'City'
    },
    {
      value: '2117',
      label: 'Eklingji',
      type: 'City'
    },
    {
      value: '2118',
      label: 'Ekma',
      type: 'City'
    },
    {
      value: '2119',
      label: 'Elana',
      type: 'City'
    },
    {
      value: '2120',
      label: 'Elankulam',
      type: 'City'
    },
    {
      value: '2121',
      label: 'Elappara',
      type: 'City'
    },
    {
      value: '2122',
      label: 'Elayankudi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '2123',
      label: 'Eleswaram',
      type: 'City'
    },
    {
      value: '2124',
      label: 'Ellapur',
      type: 'City'
    },
    {
      value: '2125',
      label: 'Ellenabad',
      type: 'City'
    },
    {
      value: '2126',
      label: 'Ellora (Aurangabad)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2127',
      label: 'Eluru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2128',
      label: 'Elurupadu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2129',
      label: 'Emmiganur',
      type: 'City'
    },
    {
      value: '2130',
      label: 'Endroy',
      type: 'City'
    },
    {
      value: '2131',
      label: 'Engaon',
      type: 'City'
    },
    {
      value: '2132',
      label: 'Engapuzha',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '2133',
      label: 'Enkepadu',
      type: 'City'
    },
    {
      value: '2134',
      label: 'Enugu',
      type: 'City'
    },
    {
      value: '2135',
      label: 'Eppodumvendran',
      type: 'City'
    },
    {
      value: '2136',
      label: 'Eppodumvenran',
      type: 'City'
    },
    {
      value: '2137',
      label: 'Epurupalem',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '2138',
      label: 'Eral',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '2139',
      label: 'Eramalloor',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '2140',
      label: 'Erandol (Jalgaon)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2141',
      label: 'Erattupetta',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '2142',
      label: 'ERCILLA',
      type: 'City'
    },
    {
      value: '2143',
      label: 'Erikode',
      type: 'City'
    },
    {
      value: '2144',
      label: 'Ermal',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2145',
      label: 'Ernakulam',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '2146',
      label: 'Erode',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '2147',
      label: 'Erode Bypass',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '2148',
      label: 'Erode Bypass (Chithode)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '2149',
      label: 'Errabore',
      type: 'City'
    },
    {
      value: '2150',
      label: 'Erraguntla',
      type: 'City'
    },
    {
      value: '2151',
      label: 'Erravaram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2152',
      label: 'Erumapatti',
      type: 'City'
    },
    {
      value: '2153',
      label: 'Erumapatty',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '2154',
      label: 'Erumeli',
      type: 'City'
    },
    {
      value: '2155',
      label: 'Erumeli North',
      type: 'City'
    },
    {
      value: '2156',
      label: 'Erumely',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '2157',
      label: 'Eruvadi',
      type: 'City'
    },
    {
      value: '2158',
      label: 'Eruvadi (Tirunelveli)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '2159',
      label: 'Ervadi',
      type: 'City'
    },
    {
      value: '2160',
      label: 'Ervadi (Ramanathapuram)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '2161',
      label: 'Ervadi Road  Vallioor',
      type: 'City'
    },
    {
      value: '2162',
      label: 'Esperanza',
      type: 'City'
    },
    {
      value: '2163',
      label: 'Esquel',
      type: 'City'
    },
    {
      value: '2164',
      label: 'Esquina',
      type: 'City'
    },
    {
      value: '2165',
      label: 'Essar  Bed',
      type: 'City'
    },
    {
      value: '2166',
      label: 'Etah',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '2167',
      label: 'Etawah',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '2168',
      label: 'Etawah UP',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '2169',
      label: 'Ethakota',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2170',
      label: 'Ettayapuram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '2171',
      label: 'Ettimadi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '2172',
      label: 'Ettumanoor',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '2173',
      label: 'Examba',
      type: 'City'
    },
    {
      value: '2174',
      label: 'Fagane',
      type: 'City'
    },
    {
      value: '2175',
      label: 'Fagu',
      type: 'City'
    },
    {
      value: '2176',
      label: 'Faidani',
      type: 'City'
    },
    {
      value: '2177',
      label: 'Faizabad',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '2178',
      label: 'Faizabad, Telangana',
      type: 'City'
    },
    {
      value: '2179',
      label: 'Faizpur (Jalgaon)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2180',
      label: 'Falla',
      type: 'City'
    },
    {
      value: '2181',
      label: 'Falna',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '2182',
      label: 'Farakka',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '2183',
      label: 'Farangipete',
      type: 'City'
    },
    {
      value: '2184',
      label: 'Fardapur',
      type: 'City'
    },
    {
      value: '2185',
      label: 'Faridabad',
      type: 'City',
      'state': 'Haryana'
    },
    {
      value: '2186',
      label: 'Faridkot',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '2187',
      label: 'Faridpur',
      type: 'City'
    },
    {
      value: '2188',
      label: 'Farrukhabad',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '2189',
      label: 'Fatehabad',
      type: 'City',
      'state': 'Haryana'
    },
    {
      value: '2190',
      label: 'Fatehgarh',
      type: 'City'
    },
    {
      value: '2191',
      label: 'Fatehnagar',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '2192',
      label: 'Fatehpur',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '2193',
      label: 'Fatehpur Sikri',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '2194',
      label: 'Fatehpur, Himachal Pradesh',
      type: 'City'
    },
    {
      value: '2195',
      label: 'Fatehpur, Rajasthan',
      type: 'City'
    },
    {
      value: '2196',
      label: 'Fathenagar',
      type: 'City'
    },
    {
      value: '2197',
      label: 'Fatsar',
      type: 'City'
    },
    {
      value: '2198',
      label: 'Fattepur',
      type: 'City'
    },
    {
      value: '2199',
      label: 'Fazilka',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '2200',
      label: 'Fazilnagar',
      type: 'City'
    },
    {
      value: '2201',
      label: 'Fedara',
      type: 'City'
    },
    {
      value: '2202',
      label: 'Ferozepur',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '2203',
      label: 'Fifad',
      type: 'City'
    },
    {
      value: '2204',
      label: 'Firmat',
      type: 'City'
    },
    {
      value: '2205',
      label: 'Firozabad',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '2206',
      label: 'Firozpur',
      type: 'City',
      'state': 'Delhi'
    },
    {
      value: '2207',
      label: 'Forbesganj',
      type: 'City'
    },
    {
      value: '2208',
      label: 'Formosa',
      type: 'City'
    },
    {
      value: '2209',
      label: 'Fray Bentos C/C',
      type: 'City'
    },
    {
      value: '2210',
      label: 'Fulertal',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '2211',
      label: 'Fulki',
      type: 'City'
    },
    {
      value: '2212',
      label: 'Fundari',
      type: 'City'
    },
    {
      value: '2213',
      label: 'Fursatganj',
      type: 'City'
    },
    {
      value: '2214',
      label: 'Futishanko',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '2215',
      label: 'Gabbur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2216',
      label: 'Gadag',
      type: 'City'
    },
    {
      value: '2217',
      label: 'Gadarpur',
      type: 'City'
    },
    {
      value: '2218',
      label: 'Gadarwara',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '2219',
      label: 'Gadasarai',
      type: 'City'
    },
    {
      value: '2220',
      label: 'Gadchiroli',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2221',
      label: 'Gaddankeri Cross',
      type: 'City'
    },
    {
      value: '2222',
      label: 'Gadga',
      type: 'City'
    },
    {
      value: '2223',
      label: 'Gadh',
      type: 'City'
    },
    {
      value: '2224',
      label: 'Gadhada',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2225',
      label: 'Gadhakada',
      type: 'City'
    },
    {
      value: '2226',
      label: 'Gadhali',
      type: 'City'
    },
    {
      value: '2227',
      label: 'Gadhi',
      type: 'City'
    },
    {
      value: '2228',
      label: 'Gadhinglaj',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2229',
      label: 'Gadhshisha',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2230',
      label: 'Gadra Road',
      type: 'City'
    },
    {
      value: '2231',
      label: 'Gaduli',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2232',
      label: 'Gagal',
      type: 'City'
    },
    {
      value: '2233',
      label: 'Gaganbawda',
      type: 'City'
    },
    {
      value: '2234',
      label: 'Gagra',
      type: 'City'
    },
    {
      value: '2235',
      label: 'Gagret',
      type: 'City'
    },
    {
      value: '2236',
      label: 'Gagriya',
      type: 'City'
    },
    {
      value: '2237',
      label: 'Gairatganj',
      type: 'City'
    },
    {
      value: '2238',
      label: 'Gaisabad',
      type: 'City'
    },
    {
      value: '2239',
      label: 'Gajendragadh',
      type: 'City'
    },
    {
      value: '2240',
      label: 'Gajner',
      type: 'City'
    },
    {
      value: '2241',
      label: 'Gajraula',
      type: 'City'
    },
    {
      value: '2242',
      label: 'Gajsinghpur',
      type: 'City'
    },
    {
      value: '2243',
      label: 'Gajuwaka  Visakhapatnam',
      type: 'City'
    },
    {
      value: '2244',
      label: 'Gal Kotadi',
      type: 'City'
    },
    {
      value: '2245',
      label: 'Gala',
      type: 'City'
    },
    {
      value: '2246',
      label: 'Galagali',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2247',
      label: 'Galath',
      type: 'City'
    },
    {
      value: '2248',
      label: 'Galiakot',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '2249',
      label: 'Galian',
      type: 'City'
    },
    {
      value: '2250',
      label: 'Galiveedu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2251',
      label: 'Galodar',
      type: 'City'
    },
    {
      value: '2252',
      label: 'Galodiya',
      type: 'City'
    },
    {
      value: '2253',
      label: 'Galore',
      type: 'City'
    },
    {
      value: '2254',
      label: 'Galore  Hamirpur',
      type: 'City'
    },
    {
      value: '2255',
      label: 'Gama Pipaliya',
      type: 'City'
    },
    {
      value: '2256',
      label: 'Gambhoi',
      type: 'City'
    },
    {
      value: '2257',
      label: 'Gamharia',
      type: 'City',
      'state': 'Jharkhand'
    },
    {
      value: '2258',
      label: 'Ganagapur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2259',
      label: 'Ganapavaram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2260',
      label: 'Ganaur',
      type: 'City'
    },
    {
      value: '2261',
      label: 'Gandai',
      type: 'City'
    },
    {
      value: '2262',
      label: 'Gandepalli',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2263',
      label: 'Gander',
      type: 'City'
    },
    {
      value: '2264',
      label: 'Gandhav',
      type: 'City'
    },
    {
      value: '2265',
      label: 'Gandhav Goliya',
      type: 'City'
    },
    {
      value: '2266',
      label: 'Gandhi Sagar Dam',
      type: 'City'
    },
    {
      value: '2267',
      label: 'Gandhidham',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2268',
      label: 'Gandhinagar',
      type: 'City'
    },
    {
      value: '2269',
      label: 'Gandhinagar, Gujarat',
      type: 'City'
    },
    {
      value: '2270',
      label: 'Gandhinagar, Karnataka',
      type: 'City'
    },
    {
      value: '2271',
      label: 'Gandi',
      type: 'City'
    },
    {
      value: '2272',
      label: 'Ganeshgudi',
      type: 'City'
    },
    {
      value: '2273',
      label: 'Ganeshkhind  Pune',
      type: 'City'
    },
    {
      value: '2274',
      label: 'Gangadhara Nellore',
      type: 'City'
    },
    {
      value: '2275',
      label: 'Gangakhed',
      type: 'City'
    },
    {
      value: '2276',
      label: 'Gangakhed (Parbhani)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2277',
      label: 'Gangalasan',
      type: 'City'
    },
    {
      value: '2278',
      label: 'Gangamasla',
      type: 'City'
    },
    {
      value: '2279',
      label: 'Ganganagar',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '2280',
      label: 'Gangapur',
      type: 'City'
    },
    {
      value: '2281',
      label: 'Gangapur City',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2282',
      label: 'Gangapur Rajasthan',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '2283',
      label: 'Gangapur(Rajasthan)',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '2284',
      label: 'Gangapur, Rajasthan',
      type: 'City'
    },
    {
      value: '2285',
      label: 'Gangapur, UP',
      type: 'City'
    },
    {
      value: '2286',
      label: 'Gangar Talai',
      type: 'City'
    },
    {
      value: '2287',
      label: 'Gangaram',
      type: 'City'
    },
    {
      value: '2288',
      label: 'Gangarampur',
      type: 'City'
    },
    {
      value: '2289',
      label: 'Gangarar',
      type: 'City'
    },
    {
      value: '2290',
      label: 'Gangavathi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2291',
      label: 'Gangawati',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2292',
      label: 'Gangda',
      type: 'City'
    },
    {
      value: '2293',
      label: 'Gangeruwa',
      type: 'City'
    },
    {
      value: '2294',
      label: 'Gangoli',
      type: 'City'
    },
    {
      value: '2295',
      label: 'Gangolli',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2296',
      label: 'Gangrar',
      type: 'City'
    },
    {
      value: '2297',
      label: 'Gangtok',
      type: 'City',
      'state': 'Sikkim'
    },
    {
      value: '2298',
      label: 'Ganj Basoda',
      type: 'City'
    },
    {
      value: '2299',
      label: 'Ganjimutt',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2300',
      label: 'Gannavaram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2301',
      label: 'Gannavaram, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '2302',
      label: 'Gannavaram, Telangana',
      type: 'City'
    },
    {
      value: '2303',
      label: 'Ganoda',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '2304',
      label: 'Ganoh',
      type: 'City'
    },
    {
      value: '2305',
      label: 'Ganpati Pule',
      type: 'City'
    },
    {
      value: '2306',
      label: 'Ganpatipule',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2307',
      label: 'Gantalkatte',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2308',
      label: 'Gaonkhadi',
      type: 'City'
    },
    {
      value: '2309',
      label: 'Garag Bail Hongala',
      type: 'City'
    },
    {
      value: '2310',
      label: 'Garakhedi Rd',
      type: 'City'
    },
    {
      value: '2311',
      label: 'Garal',
      type: 'City'
    },
    {
      value: '2312',
      label: 'Garamali',
      type: 'City'
    },
    {
      value: '2313',
      label: 'Garani',
      type: 'City'
    },
    {
      value: '2314',
      label: 'Gargoti',
      type: 'City'
    },
    {
      value: '2315',
      label: 'Gargoti (Kolhapur)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2316',
      label: 'Garh Jamula',
      type: 'City'
    },
    {
      value: '2317',
      label: 'Garhakota',
      type: 'City'
    },
    {
      value: '2318',
      label: 'Garhdiwala',
      type: 'City'
    },
    {
      value: '2319',
      label: 'Garhmukteshwar',
      type: 'City'
    },
    {
      value: '2320',
      label: 'Garhshankar',
      type: 'City'
    },
    {
      value: '2321',
      label: 'Garhwa',
      type: 'City',
      'state': 'Jharkhand'
    },
    {
      value: '2322',
      label: 'Garhwa Road',
      type: 'City'
    },
    {
      value: '2323',
      label: 'Gariadhar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2324',
      label: 'Garividi',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2325',
      label: 'Gariyadhar',
      type: 'City'
    },
    {
      value: '2326',
      label: 'Garladinne',
      type: 'City'
    },
    {
      value: '2327',
      label: 'Garli',
      type: 'City'
    },
    {
      value: '2328',
      label: 'Garoth',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '2329',
      label: 'Garsana',
      type: 'City'
    },
    {
      value: '2330',
      label: 'Gauri Bazar',
      type: 'City'
    },
    {
      value: '2331',
      label: 'Gauriganj',
      type: 'City'
    },
    {
      value: '2332',
      label: 'Gautam Nagar',
      type: 'City'
    },
    {
      value: '2333',
      label: 'Gavadka',
      type: 'City'
    },
    {
      value: '2334',
      label: 'Gavan',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2335',
      label: 'Gavarlapalem',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2336',
      label: 'Gawasen',
      type: 'City'
    },
    {
      value: '2337',
      label: 'Gaya',
      type: 'City'
    },
    {
      value: '2338',
      label: 'Gayghat',
      type: 'City'
    },
    {
      value: '2339',
      label: 'Gazipur, Telangana',
      type: 'City'
    },
    {
      value: '2340',
      label: 'Gazipur, UP',
      type: 'City'
    },
    {
      value: '2341',
      label: 'Geedam',
      type: 'City'
    },
    {
      value: '2342',
      label: 'General Pinedo',
      type: 'City'
    },
    {
      value: '2343',
      label: 'Georai',
      type: 'City'
    },
    {
      value: '2344',
      label: 'George',
      type: 'City'
    },
    {
      value: '2345',
      label: 'Germiston',
      type: 'City'
    },
    {
      value: '2346',
      label: 'Gersoppa',
      type: 'City'
    },
    {
      value: '2347',
      label: 'Gerusoppa',
      type: 'City'
    },
    {
      value: '2348',
      label: 'Gerusoppa Falls',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2349',
      label: 'Ghaduli',
      type: 'City'
    },
    {
      value: '2350',
      label: 'Ghaghas',
      type: 'City'
    },
    {
      value: '2351',
      label: 'Ghanahatti',
      type: 'City'
    },
    {
      value: '2352',
      label: 'Ghandla',
      type: 'City'
    },
    {
      value: '2353',
      label: 'Ghanerao',
      type: 'City'
    },
    {
      value: '2354',
      label: 'Ghanghali',
      type: 'City'
    },
    {
      value: '2355',
      label: 'Ghankheda',
      type: 'City'
    },
    {
      value: '2356',
      label: 'Ghanpur',
      type: 'City'
    },
    {
      value: '2357',
      label: 'Ghantiyali',
      type: 'City'
    },
    {
      value: '2358',
      label: 'Ghantiyan',
      type: 'City'
    },
    {
      value: '2359',
      label: 'Gharaunda',
      type: 'City'
    },
    {
      value: '2360',
      label: 'Ghargaon',
      type: 'City'
    },
    {
      value: '2361',
      label: 'Gharghoda',
      type: 'City'
    },
    {
      value: '2362',
      label: 'Gharni',
      type: 'City'
    },
    {
      value: '2363',
      label: 'Gharsana',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '2364',
      label: 'Ghaseri',
      type: 'City'
    },
    {
      value: '2365',
      label: 'Ghat Bamuriya',
      type: 'City'
    },
    {
      value: '2366',
      label: 'Ghata Gaon',
      type: 'City'
    },
    {
      value: '2367',
      label: 'Ghatabillod',
      type: 'City'
    },
    {
      value: '2368',
      label: 'Ghatampur',
      type: 'City'
    },
    {
      value: '2369',
      label: 'Ghatanji',
      type: 'City'
    },
    {
      value: '2370',
      label: 'Ghatiya',
      type: 'City'
    },
    {
      value: '2371',
      label: 'Ghatkopar',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2372',
      label: 'Ghatnandur',
      type: 'City'
    },
    {
      value: '2373',
      label: 'Ghatol',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '2374',
      label: 'Ghatoli',
      type: 'City'
    },
    {
      value: '2375',
      label: 'Ghatprabha',
      type: 'City'
    },
    {
      value: '2376',
      label: 'Ghatvad',
      type: 'City'
    },
    {
      value: '2377',
      label: 'Ghaziabad',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '2378',
      label: 'Ghazipur',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '2379',
      label: 'Gherdi',
      type: 'City'
    },
    {
      value: '2380',
      label: 'Gheti',
      type: 'City'
    },
    {
      value: '2381',
      label: 'Gheu',
      type: 'City'
    },
    {
      value: '2382',
      label: 'Ghilamara',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '2383',
      label: 'Ghodbandar',
      type: 'City'
    },
    {
      value: '2384',
      label: 'Ghodegaon',
      type: 'City'
    },
    {
      value: '2385',
      label: 'GhodiDhaal',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2386',
      label: 'Ghoghavadar',
      type: 'City'
    },
    {
      value: '2387',
      label: 'Ghonsare',
      type: 'City'
    },
    {
      value: '2388',
      label: 'Ghoradongri',
      type: 'City'
    },
    {
      value: '2389',
      label: 'Ghosla',
      type: 'City'
    },
    {
      value: '2390',
      label: 'Ghughrala',
      type: 'City'
    },
    {
      value: '2391',
      label: 'Ghughri',
      type: 'City'
    },
    {
      value: '2392',
      label: 'Ghugus',
      type: 'City'
    },
    {
      value: '2393',
      label: 'Ghumarwin',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '2394',
      label: 'Ghuwara',
      type: 'City'
    },
    {
      value: '2395',
      label: 'Giddalur',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2396',
      label: 'Giddarbaha',
      type: 'City'
    },
    {
      value: '2397',
      label: 'Gidderbaha',
      type: 'City'
    },
    {
      value: '2398',
      label: 'Gigasan',
      type: 'City'
    },
    {
      value: '2399',
      label: 'Gilaula',
      type: 'City'
    },
    {
      value: '2400',
      label: 'Gilund',
      type: 'City'
    },
    {
      value: '2401',
      label: 'Gimavi Phata',
      type: 'City'
    },
    {
      value: '2402',
      label: 'Gingani',
      type: 'City'
    },
    {
      value: '2403',
      label: 'Gingee',
      type: 'City'
    },
    {
      value: '2404',
      label: 'Gingla',
      type: 'City'
    },
    {
      value: '2405',
      label: 'Girab',
      type: 'City'
    },
    {
      value: '2406',
      label: 'Girgadhada',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2407',
      label: 'Girla',
      type: 'City'
    },
    {
      value: '2408',
      label: 'Gla Rd  Bharthia',
      type: 'City'
    },
    {
      value: '2409',
      label: 'Gngotri Kedarnth Badrinth',
      type: 'City'
    },
    {
      value: '2410',
      label: 'Goa',
      type: 'City',
      'state': 'Goa'
    },
    {
      value: '2411',
      label: 'Goa Package',
      type: 'City',
      'state': 'Goa'
    },
    {
      value: '2412',
      label: 'Goa Package 2n 3d Itdc',
      type: 'City'
    },
    {
      value: '2413',
      label: 'Goa Package 3n 4d Itdc',
      type: 'City'
    },
    {
      value: '2414',
      label: 'Goa Sightseeing',
      type: 'City'
    },
    {
      value: '2415',
      label: 'Goa(Panaji)',
      type: 'City'
    },
    {
      value: '2416',
      label: 'Goa(Panjim)',
      type: 'City'
    },
    {
      value: '2417',
      label: 'Gobi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '2418',
      label: 'Gobi  ',
      type: 'City'
    },
    {
      value: '2419',
      label: 'Gobichettipalaiyam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '2420',
      label: 'Gobichettipalayam',
      type: 'City'
    },
    {
      value: '2421',
      label: 'Gobindgarh',
      type: 'City'
    },
    {
      value: '2422',
      label: 'Godan',
      type: 'City'
    },
    {
      value: '2423',
      label: 'Godavarikhani',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2424',
      label: 'Godavarikhani  Ramagundam',
      type: 'City'
    },
    {
      value: '2425',
      label: 'Godbandar',
      type: 'City'
    },
    {
      value: '2426',
      label: 'Godhavadar',
      type: 'City'
    },
    {
      value: '2427',
      label: 'Godhawata',
      type: 'City'
    },
    {
      value: '2428',
      label: 'Godhra',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2429',
      label: 'Godhra (Ambe Dham)',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2430',
      label: 'Goga Medi',
      type: 'City'
    },
    {
      value: '2431',
      label: 'Gogamedi',
      type: 'City'
    },
    {
      value: '2432',
      label: 'Gogamukh',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '2433',
      label: 'Goganda',
      type: 'City'
    },
    {
      value: '2434',
      label: 'Gogawa',
      type: 'City'
    },
    {
      value: '2435',
      label: 'Gogunda',
      type: 'City'
    },
    {
      value: '2436',
      label: 'Gohana',
      type: 'City'
    },
    {
      value: '2437',
      label: 'Gohpur',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '2438',
      label: 'Gojariya',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2439',
      label: 'Gokak',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2440',
      label: 'Gokarna',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2441',
      label: 'Gokarna Cross',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2442',
      label: 'Gokarna Rd  Madangeri',
      type: 'City'
    },
    {
      value: '2443',
      label: 'Gokavaram',
      type: 'City'
    },
    {
      value: '2444',
      label: 'Gokharvala',
      type: 'City'
    },
    {
      value: '2445',
      label: 'Gokharvala Mota',
      type: 'City'
    },
    {
      value: '2446',
      label: 'Gokharwala',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2447',
      label: 'Gol',
      type: 'City'
    },
    {
      value: '2448',
      label: 'Gol  Ummedabad',
      type: 'City'
    },
    {
      value: '2449',
      label: 'Gola',
      type: 'City'
    },
    {
      value: '2450',
      label: 'Gola (UP)',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '2451',
      label: 'Gola Gokaran Nath',
      type: 'City'
    },
    {
      value: '2452',
      label: 'Goladhar',
      type: 'City'
    },
    {
      value: '2453',
      label: 'Golaghat',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '2454',
      label: 'Golakotivaripalem',
      type: 'City'
    },
    {
      value: '2455',
      label: 'Golana',
      type: 'City'
    },
    {
      value: '2456',
      label: 'Gole',
      type: 'City'
    },
    {
      value: '2457',
      label: 'Goliangadi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2458',
      label: 'Gollapalem',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2459',
      label: 'Gollaprolu',
      type: 'City'
    },
    {
      value: '2460',
      label: 'Gollapudi',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2461',
      label: 'Gollavilli',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2462',
      label: 'Golu Ka',
      type: 'City'
    },
    {
      value: '2463',
      label: 'Golu Ka Mor',
      type: 'City'
    },
    {
      value: '2464',
      label: 'Goluka',
      type: 'City'
    },
    {
      value: '2465',
      label: 'Goluwala',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '2466',
      label: 'Gomewadi',
      type: 'City'
    },
    {
      value: '2467',
      label: 'Gomta',
      type: 'City'
    },
    {
      value: '2468',
      label: 'Gomti',
      type: 'City'
    },
    {
      value: '2469',
      label: 'Gomti (Rajasthan)',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '2470',
      label: 'Gomti Choraya',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2471',
      label: 'Gomti Chorya  Kelwa',
      type: 'City'
    },
    {
      value: '2472',
      label: 'Gona',
      type: 'City'
    },
    {
      value: '2473',
      label: 'Gonda',
      type: 'City'
    },
    {
      value: '2474',
      label: 'Gondal',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2475',
      label: 'Gondgaon',
      type: 'City'
    },
    {
      value: '2476',
      label: 'Gondia',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2477',
      label: 'Gondpur',
      type: 'City'
    },
    {
      value: '2478',
      label: 'Goniana',
      type: 'City'
    },
    {
      value: '2479',
      label: 'Gonikoppal',
      type: 'City'
    },
    {
      value: '2480',
      label: 'Gonspur',
      type: 'City'
    },
    {
      value: '2481',
      label: 'Gooty',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2482',
      label: 'Gopalapuram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2483',
      label: 'Gopalganj',
      type: 'City'
    },
    {
      value: '2484',
      label: 'Gopalganj, Bihar',
      type: 'City'
    },
    {
      value: '2485',
      label: 'Gopalganj, MP',
      type: 'City'
    },
    {
      value: '2486',
      label: 'Gopalgram',
      type: 'City'
    },
    {
      value: '2487',
      label: 'Gopalpur',
      type: 'City'
    },
    {
      value: '2488',
      label: 'Gopalpura, MP',
      type: 'City'
    },
    {
      value: '2489',
      label: 'Gopalpura, Rajasthan',
      type: 'City'
    },
    {
      value: '2490',
      label: 'Gopavaram',
      type: 'City'
    },
    {
      value: '2491',
      label: 'Gopichettipalayam',
      type: 'City'
    },
    {
      value: '2492',
      label: 'Gopiganj',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '2493',
      label: 'Gopnath',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2494',
      label: 'Goradaka',
      type: 'City'
    },
    {
      value: '2495',
      label: 'Goradka',
      type: 'City'
    },
    {
      value: '2496',
      label: 'Gorakhpur',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '2497',
      label: 'Gorakhpur, MP',
      type: 'City'
    },
    {
      value: '2498',
      label: 'Gorakhpur, UP',
      type: 'City'
    },
    {
      value: '2499',
      label: 'Gorana',
      type: 'City'
    },
    {
      value: '2500',
      label: 'Gorane',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2501',
      label: 'Gorantla',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2502',
      label: 'Goraya',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '2503',
      label: 'GORBEA',
      type: 'City'
    },
    {
      value: '2504',
      label: 'Gorebal',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2505',
      label: 'Gorebal Camp',
      type: 'City'
    },
    {
      value: '2506',
      label: 'Gorihar',
      type: 'City'
    },
    {
      value: '2507',
      label: 'Goriwala',
      type: 'City'
    },
    {
      value: '2508',
      label: 'Gosainganj',
      type: 'City'
    },
    {
      value: '2509',
      label: 'Gosala',
      type: 'City'
    },
    {
      value: '2510',
      label: 'Gotan',
      type: 'City'
    },
    {
      value: '2511',
      label: 'Gotegaon',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '2512',
      label: 'Gottipadu',
      type: 'City'
    },
    {
      value: '2513',
      label: 'Gouripatnam',
      type: 'City'
    },
    {
      value: '2514',
      label: 'Gourjhamar',
      type: 'City'
    },
    {
      value: '2515',
      label: 'Govada',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2516',
      label: 'Govardhan',
      type: 'City'
    },
    {
      value: '2517',
      label: 'Govindgarh',
      type: 'City'
    },
    {
      value: '2518',
      label: 'Govindgarh, MP',
      type: 'City'
    },
    {
      value: '2519',
      label: 'Govindgarh, Rajasthan',
      type: 'City'
    },
    {
      value: '2520',
      label: 'Govindpali',
      type: 'City'
    },
    {
      value: '2521',
      label: 'Govindpur',
      type: 'City'
    },
    {
      value: '2522',
      label: 'Govindpura',
      type: 'City'
    },
    {
      value: '2523',
      label: 'Gowribidanur',
      type: 'City'
    },
    {
      value: '2524',
      label: 'Gowripatnam',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2525',
      label: 'Goya',
      type: 'City'
    },
    {
      value: '2526',
      label: 'Goyali',
      type: 'City'
    },
    {
      value: '2527',
      label: 'Gozaria',
      type: 'City'
    },
    {
      value: '2528',
      label: 'GRANEROS',
      type: 'City'
    },
    {
      value: '2529',
      label: 'Greater Noida',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '2530',
      label: 'Gubra',
      type: 'City'
    },
    {
      value: '2531',
      label: 'Guda',
      type: 'City'
    },
    {
      value: '2532',
      label: 'Guda Balotan',
      type: 'City'
    },
    {
      value: '2533',
      label: 'Gudalur',
      type: 'City'
    },
    {
      value: '2534',
      label: 'Gudalur  Cumbum',
      type: 'City'
    },
    {
      value: '2535',
      label: 'Gudalur (Cumbum)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '2536',
      label: 'Gudalur (Ooty)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '2537',
      label: 'Gudalur Cumbum',
      type: 'City'
    },
    {
      value: '2538',
      label: 'Gudalur(Cumbam)',
      type: 'City'
    },
    {
      value: '2539',
      label: 'Gudamalani',
      type: 'City'
    },
    {
      value: '2540',
      label: 'Gudavalli',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2541',
      label: 'Guddeangadi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2542',
      label: 'Guddeangadi  Kudi',
      type: 'City'
    },
    {
      value: '2543',
      label: 'Guddekeri',
      type: 'City'
    },
    {
      value: '2544',
      label: 'Gudem',
      type: 'City'
    },
    {
      value: '2545',
      label: 'Gudgaon',
      type: 'City'
    },
    {
      value: '2546',
      label: 'Gudha Gorji',
      type: 'City'
    },
    {
      value: '2547',
      label: 'Gudhshisha',
      type: 'City'
    },
    {
      value: '2548',
      label: 'Gudimangalam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '2549',
      label: 'Gudivada',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2550',
      label: 'Gudiwada',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2551',
      label: 'Gudlavalleru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2552',
      label: 'Gudlur',
      type: 'City'
    },
    {
      value: '2553',
      label: 'Gudluru',
      type: 'City'
    },
    {
      value: '2554',
      label: 'Gudluru (Andhra Pradesh)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2555',
      label: 'Gudur (Nellore)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2556',
      label: 'Gudur(Nellore)',
      type: 'City'
    },
    {
      value: '2557',
      label: 'Gudur, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '2558',
      label: 'Gudur, Karnataka',
      type: 'City'
    },
    {
      value: '2559',
      label: 'Guduru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2560',
      label: 'Guduru (By-Pass)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2561',
      label: 'Guhagar',
      type: 'City'
    },
    {
      value: '2562',
      label: 'Gulabganj',
      type: 'City'
    },
    {
      value: '2563',
      label: 'Gulabpura',
      type: 'City'
    },
    {
      value: '2564',
      label: 'Gulabpura (Rajasthan)',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '2565',
      label: 'Gulabpura(Gujarat)',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2566',
      label: 'Gulabpura, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '2567',
      label: 'Gulabpura, Rajasthan',
      type: 'City'
    },
    {
      value: '2568',
      label: 'Gulaothi',
      type: 'City'
    },
    {
      value: '2569',
      label: 'Gulapura',
      type: 'City'
    },
    {
      value: '2570',
      label: 'Gular',
      type: 'City'
    },
    {
      value: '2571',
      label: 'Gulbarga',
      type: 'City'
    },
    {
      value: '2572',
      label: 'Guledagudda',
      type: 'City'
    },
    {
      value: '2573',
      label: 'Guledgudda',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2574',
      label: 'Gullapur',
      type: 'City'
    },
    {
      value: '2575',
      label: 'Gullapura',
      type: 'City'
    },
    {
      value: '2576',
      label: 'Gulleda Gudda',
      type: 'City'
    },
    {
      value: '2577',
      label: 'Gulledgudda',
      type: 'City'
    },
    {
      value: '2578',
      label: 'Gumla',
      type: 'City'
    },
    {
      value: '2579',
      label: 'Gumma',
      type: 'City'
    },
    {
      value: '2580',
      label: 'Gummileru',
      type: 'City'
    },
    {
      value: '2581',
      label: 'Guna',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '2582',
      label: 'Gunavanthe',
      type: 'City'
    },
    {
      value: '2583',
      label: 'Gunda',
      type: 'City'
    },
    {
      value: '2584',
      label: 'Gundala, Gujarat',
      type: 'City'
    },
    {
      value: '2585',
      label: 'Gundala, Telangana',
      type: 'City'
    },
    {
      value: '2586',
      label: 'Gundarana',
      type: 'City'
    },
    {
      value: '2587',
      label: 'Gundlapalli',
      type: 'City'
    },
    {
      value: '2588',
      label: 'Gundlupet',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2589',
      label: 'Gundlupete',
      type: 'City'
    },
    {
      value: '2590',
      label: 'Gundmi Ambagilu',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2591',
      label: 'Gundoj',
      type: 'City'
    },
    {
      value: '2592',
      label: 'Gundugolanu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2593',
      label: 'Gundugulanu',
      type: 'City'
    },
    {
      value: '2594',
      label: 'Gundya',
      type: 'City'
    },
    {
      value: '2595',
      label: 'Gunga',
      type: 'City'
    },
    {
      value: '2596',
      label: 'Gunj',
      type: 'City'
    },
    {
      value: '2597',
      label: 'Gunour',
      type: 'City'
    },
    {
      value: '2598',
      label: 'Guntakal',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2599',
      label: 'Guntur',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2600',
      label: 'Guntur (Andhra Pradesh)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2601',
      label: 'Guram Konda',
      type: 'City'
    },
    {
      value: '2602',
      label: 'Guravayapalem',
      type: 'City'
    },
    {
      value: '2603',
      label: 'Guravayyapalem',
      type: 'City'
    },
    {
      value: '2604',
      label: 'Guravayyepalem',
      type: 'City'
    },
    {
      value: '2605',
      label: 'Gurdaspur',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '2606',
      label: 'Gurgaon',
      type: 'City',
      'state': 'Haryana'
    },
    {
      value: '2607',
      label: 'Gurlapur Cross',
      type: 'City'
    },
    {
      value: '2608',
      label: 'Gurram Konda',
      type: 'City'
    },
    {
      value: '2609',
      label: 'Gurramkonda',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2610',
      label: 'Gursahaiganj',
      type: 'City'
    },
    {
      value: '2611',
      label: 'Gurugram',
      type: 'City'
    },
    {
      value: '2612',
      label: 'Gurugram (Gurgaon)',
      type: 'City',
      'state': 'Haryana'
    },
    {
      value: '2613',
      label: 'Gurupura',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2614',
      label: 'Gurupura  Kaikamba',
      type: 'City'
    },
    {
      value: '2615',
      label: 'Guruvayana Kere',
      type: 'City'
    },
    {
      value: '2616',
      label: 'Guruvayanakere',
      type: 'City'
    },
    {
      value: '2617',
      label: 'Guruvayankere',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2618',
      label: 'Guruvayoor',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '2619',
      label: 'Guruvayur',
      type: 'City'
    },
    {
      value: '2620',
      label: 'Gusainsar',
      type: 'City'
    },
    {
      value: '2621',
      label: 'Gutti',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2622',
      label: 'Guwahati',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '2623',
      label: 'Gv Satram',
      type: 'City'
    },
    {
      value: '2624',
      label: 'Gwala',
      type: 'City'
    },
    {
      value: '2625',
      label: 'Gwalior',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '2626',
      label: 'Gyangarh',
      type: 'City'
    },
    {
      value: '2627',
      label: 'Gyanpur',
      type: 'City'
    },
    {
      value: '2628',
      label: 'Gyaraspur',
      type: 'City'
    },
    {
      value: '2629',
      label: 'Hadala',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2630',
      label: 'Hadgaon',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2631',
      label: 'Hadgaon, Maharashtra',
      type: 'City'
    },
    {
      value: '2632',
      label: 'Hadgaon, Telangana',
      type: 'City'
    },
    {
      value: '2633',
      label: 'Hadi',
      type: 'City'
    },
    {
      value: '2634',
      label: 'Hadida',
      type: 'City'
    },
    {
      value: '2635',
      label: 'Hadinbal',
      type: 'City'
    },
    {
      value: '2636',
      label: 'Hadmadiya',
      type: 'City'
    },
    {
      value: '2637',
      label: 'Hadmatiya',
      type: 'City'
    },
    {
      value: '2638',
      label: 'Hadobhangi',
      type: 'City'
    },
    {
      value: '2639',
      label: 'Hadolti',
      type: 'City'
    },
    {
      value: '2640',
      label: 'Hadpid',
      type: 'City'
    },
    {
      value: '2641',
      label: 'Hagaribommanahalli',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2642',
      label: 'Haidargarh',
      type: 'City'
    },
    {
      value: '2643',
      label: 'Hajipar',
      type: 'City'
    },
    {
      value: '2644',
      label: 'Hajipur',
      type: 'City'
    },
    {
      value: '2645',
      label: 'Hajipur (Bihar)',
      type: 'City'
    },
    {
      value: '2646',
      label: 'Hajipur, Bihar',
      type: 'City'
    },
    {
      value: '2647',
      label: 'Hajipur, Telangana',
      type: 'City'
    },
    {
      value: '2648',
      label: 'Hajiradhar',
      type: 'City'
    },
    {
      value: '2649',
      label: 'Haladi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2650',
      label: 'Halady',
      type: 'City'
    },
    {
      value: '2651',
      label: 'Haldi',
      type: 'City'
    },
    {
      value: '2652',
      label: 'Haldi Rampur',
      type: 'City'
    },
    {
      value: '2653',
      label: 'Haldia',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '2654',
      label: 'Haldipur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2655',
      label: 'Haldwani',
      type: 'City'
    },
    {
      value: '2656',
      label: 'Hale Angadi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '2657',
      label: 'Haleangadi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2658',
      label: 'Halekatte',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2659',
      label: 'Halena',
      type: 'City'
    },
    {
      value: '2660',
      label: 'Haleyangadi',
      type: 'City'
    },
    {
      value: '2661',
      label: 'Haleyangadi  Sasihithlu',
      type: 'City'
    },
    {
      value: '2662',
      label: 'Haliwara',
      type: 'City'
    },
    {
      value: '2663',
      label: 'Haliwaw',
      type: 'City'
    },
    {
      value: '2664',
      label: 'Haliyad',
      type: 'City'
    },
    {
      value: '2665',
      label: 'Haliyal',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2666',
      label: 'Halol',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2667',
      label: 'Halsi',
      type: 'City'
    },
    {
      value: '2668',
      label: 'Halugunda',
      type: 'City'
    },
    {
      value: '2669',
      label: 'Haluvalli',
      type: 'City'
    },
    {
      value: '2670',
      label: 'Halvad',
      type: 'City'
    },
    {
      value: '2671',
      label: 'Halwara',
      type: 'City'
    },
    {
      value: '2672',
      label: 'Hamapur',
      type: 'City'
    },
    {
      value: '2673',
      label: 'Hamirgarh',
      type: 'City'
    },
    {
      value: '2674',
      label: 'Hamirpur (Himachal Pradesh)',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '2675',
      label: 'Hamirpur, Himachal Pradesh',
      type: 'City'
    },
    {
      value: '2676',
      label: 'Hamirpur, UP',
      type: 'City'
    },
    {
      value: '2677',
      label: 'Hampi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2678',
      label: 'Hanagal',
      type: 'City'
    },
    {
      value: '2679',
      label: 'Hanamkonda',
      type: 'City'
    },
    {
      value: '2680',
      label: 'Hanchinal Camp',
      type: 'City'
    },
    {
      value: '2681',
      label: 'Handewadi',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2682',
      label: 'Handia',
      type: 'City'
    },
    {
      value: '2683',
      label: 'Hangal',
      type: 'City'
    },
    {
      value: '2684',
      label: 'Hanmatawdve',
      type: 'City'
    },
    {
      value: '2685',
      label: 'Hanmkonda',
      type: 'City'
    },
    {
      value: '2686',
      label: 'Hanol',
      type: 'City'
    },
    {
      value: '2687',
      label: 'Hansi',
      type: 'City'
    },
    {
      value: '2688',
      label: 'Hanuman Junction',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2689',
      label: 'Hanuman Khijadiya',
      type: 'City'
    },
    {
      value: '2690',
      label: 'Hanumana',
      type: 'City'
    },
    {
      value: '2691',
      label: 'Hanumangadh',
      type: 'City'
    },
    {
      value: '2692',
      label: 'Hanumangarh',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '2693',
      label: 'Hanumanthanpatty',
      type: 'City'
    },
    {
      value: '2694',
      label: 'Hanumantpura',
      type: 'City'
    },
    {
      value: '2695',
      label: 'Hanumasagara',
      type: 'City'
    },
    {
      value: '2696',
      label: 'Hapur',
      type: 'City'
    },
    {
      value: '2697',
      label: 'Harali',
      type: 'City'
    },
    {
      value: '2698',
      label: 'Harapanahalli',
      type: 'City'
    },
    {
      value: '2699',
      label: 'Harapanalli',
      type: 'City'
    },
    {
      value: '2700',
      label: 'Harare',
      type: 'City'
    },
    {
      value: '2701',
      label: 'Harda',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '2702',
      label: 'Hardoi',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '2703',
      label: 'Hariana',
      type: 'City'
    },
    {
      value: '2704',
      label: 'Haridwar',
      type: 'City'
    },
    {
      value: '2705',
      label: 'Haridwar Package Tour',
      type: 'City'
    },
    {
      value: '2706',
      label: 'Haridwar Rishikesh tour',
      type: 'City'
    },
    {
      value: '2707',
      label: 'Harihar',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2708',
      label: 'Harihar Bypass',
      type: 'City'
    },
    {
      value: '2709',
      label: 'Harihara',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2710',
      label: 'Hariharapura',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2711',
      label: 'Harihareshwar',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2712',
      label: 'Hariharganj',
      type: 'City'
    },
    {
      value: '2713',
      label: 'Harij',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2714',
      label: 'Harike',
      type: 'City'
    },
    {
      value: '2715',
      label: 'Haripad',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '2716',
      label: 'Haripar',
      type: 'City'
    },
    {
      value: '2717',
      label: 'Haripur',
      type: 'City'
    },
    {
      value: '2718',
      label: 'Harishankar Maniyari',
      type: 'City'
    },
    {
      value: '2719',
      label: 'Hariyad-Juni',
      type: 'City'
    },
    {
      value: '2720',
      label: 'Harji',
      type: 'City'
    },
    {
      value: '2721',
      label: 'Harmannu',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2722',
      label: 'Harnawa',
      type: 'City'
    },
    {
      value: '2723',
      label: 'Harogolige',
      type: 'City'
    },
    {
      value: '2724',
      label: 'Harpalpur',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '2725',
      label: 'Harpanahalli',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2726',
      label: 'Harrai',
      type: 'City'
    },
    {
      value: '2727',
      label: 'Harraiya',
      type: 'City'
    },
    {
      value: '2728',
      label: 'Harrakheda',
      type: 'City'
    },
    {
      value: '2729',
      label: 'Harrismith',
      type: 'City'
    },
    {
      value: '2730',
      label: 'Harrismith (Wimpy Bergview)',
      type: 'City'
    },
    {
      value: '2731',
      label: 'Harshad',
      type: 'City'
    },
    {
      value: '2732',
      label: 'Harsipattan',
      type: 'City'
    },
    {
      value: '2733',
      label: 'Harsol',
      type: 'City'
    },
    {
      value: '2734',
      label: 'Harsore',
      type: 'City'
    },
    {
      value: '2735',
      label: 'Harsurpur Devaliya',
      type: 'City'
    },
    {
      value: '2736',
      label: 'Harugeri',
      type: 'City'
    },
    {
      value: '2737',
      label: 'Harugeri Cross',
      type: 'City'
    },
    {
      value: '2738',
      label: 'Hassan',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2739',
      label: 'Hassan(Bypass)',
      type: 'City'
    },
    {
      value: '2740',
      label: 'Hastinapur',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '2741',
      label: 'Hata, MP',
      type: 'City'
    },
    {
      value: '2742',
      label: 'Hata, UP',
      type: 'City'
    },
    {
      value: '2743',
      label: 'Hath Kamba',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2744',
      label: 'Hatharva',
      type: 'City'
    },
    {
      value: '2745',
      label: 'Hathgaon',
      type: 'City'
    },
    {
      value: '2746',
      label: 'Hathgoan',
      type: 'City'
    },
    {
      value: '2747',
      label: 'Hathigadh',
      type: 'City'
    },
    {
      value: '2748',
      label: 'Hathinala',
      type: 'City'
    },
    {
      value: '2749',
      label: 'Hathkhamba',
      type: 'City'
    },
    {
      value: '2750',
      label: 'Hathras',
      type: 'City'
    },
    {
      value: '2751',
      label: 'Hathvale',
      type: 'City'
    },
    {
      value: '2752',
      label: 'Hativale',
      type: 'City'
    },
    {
      value: '2753',
      label: 'Hatkanangale',
      type: 'City'
    },
    {
      value: '2754',
      label: 'Hatkoti',
      type: 'City'
    },
    {
      value: '2755',
      label: 'Hatpipliya',
      type: 'City'
    },
    {
      value: '2756',
      label: 'Hatta (Hingoli)',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '2757',
      label: 'Hatta, MP',
      type: 'City'
    },
    {
      value: '2758',
      label: 'Hatta, Maharashtra',
      type: 'City'
    },
    {
      value: '2759',
      label: 'Hattargi',
      type: 'City'
    },
    {
      value: '2760',
      label: 'Hatti',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2761',
      label: 'Hattigudur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2762',
      label: 'Haunsbhavi',
      type: 'City'
    },
    {
      value: '2763',
      label: 'Haveri',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2764',
      label: 'Hazaribagh',
      type: 'City',
      'state': 'Jharkhand'
    },
    {
      value: '2765',
      label: 'Hazipur',
      type: 'City'
    },
    {
      value: '2766',
      label: 'Hebbal',
      type: 'City'
    },
    {
      value: '2767',
      label: 'Hebri',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2768',
      label: 'Hedvi',
      type: 'City'
    },
    {
      value: '2769',
      label: 'Heera Ki Dhani',
      type: 'City'
    },
    {
      value: '2770',
      label: 'Heerpura',
      type: 'City'
    },
    {
      value: '2771',
      label: 'Heidelberg',
      type: 'City'
    },
    {
      value: '2772',
      label: 'Hemal',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2773',
      label: 'Hemmadi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2774',
      label: 'Herbertpur',
      type: 'City'
    },
    {
      value: '2775',
      label: 'Herbertpur(Uttarakhand)',
      type: 'City'
    },
    {
      value: '2776',
      label: 'Herikudru',
      type: 'City'
    },
    {
      value: '2777',
      label: 'Herur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2778',
      label: 'Hidkal',
      type: 'City'
    },
    {
      value: '2779',
      label: 'Hili',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '2780',
      label: 'Himmatnagar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2781',
      label: 'Himmatnagar',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '2782',
      label: 'Himmatnagar Post Office',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2783',
      label: 'Hindaun City',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '2784',
      label: 'Hindhupur',
      type: 'City'
    },
    {
      value: '2785',
      label: 'Hindoli',
      type: 'City'
    },
    {
      value: '2786',
      label: 'Hindoriya',
      type: 'City'
    },
    {
      value: '2787',
      label: 'HIndupur',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2788',
      label: 'Hinganghat',
      type: 'City'
    },
    {
      value: '2789',
      label: 'Hingoli',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2790',
      label: 'Hinjewadi Chowk',
      type: 'City'
    },
    {
      value: '2791',
      label: 'Hipavadli',
      type: 'City'
    },
    {
      value: '2792',
      label: 'Hiramandalam',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2793',
      label: 'Hiranagar, Jammu',
      type: 'City'
    },
    {
      value: '2794',
      label: 'Hiranagar, Jammu And Kashmir',
      type: 'City'
    },
    {
      value: '2795',
      label: 'Hirapur, MP',
      type: 'City'
    },
    {
      value: '2796',
      label: 'Hirapur, Maharashtra',
      type: 'City'
    },
    {
      value: '2797',
      label: 'Hire Bagewadi',
      type: 'City'
    },
    {
      value: '2798',
      label: 'Hirekerur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2799',
      label: 'Hiriyadka',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2800',
      label: 'Hiriyadka  Hiriadka',
      type: 'City'
    },
    {
      value: '2801',
      label: 'Hiriyur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2802',
      label: 'Hirur',
      type: 'City'
    },
    {
      value: '2803',
      label: 'Hisar',
      type: 'City',
      'state': 'Haryana'
    },
    {
      value: '2804',
      label: 'Hiwar',
      type: 'City'
    },
    {
      value: '2805',
      label: 'Hiwara',
      type: 'City'
    },
    {
      value: '2806',
      label: 'Hiwarkhed',
      type: 'City'
    },
    {
      value: '2807',
      label: 'Hiwrashram',
      type: 'City'
    },
    {
      value: '2808',
      label: 'Hodal',
      type: 'City'
    },
    {
      value: '2809',
      label: 'Holalkere',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2810',
      label: 'Holehonnur',
      type: 'City'
    },
    {
      value: '2811',
      label: 'Honavar',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2812',
      label: 'Honavara',
      type: 'City'
    },
    {
      value: '2813',
      label: 'Hong Kong',
      type: 'City'
    },
    {
      value: '2814',
      label: 'Honnali',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2815',
      label: 'Honnali, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '2816',
      label: 'Honnali, Karnataka',
      type: 'City'
    },
    {
      value: '2817',
      label: 'Honnavar',
      type: 'City'
    },
    {
      value: '2818',
      label: 'Hoovina Hadagali',
      type: 'City'
    },
    {
      value: '2819',
      label: 'Horanadu',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2820',
      label: 'Hornadu',
      type: 'City'
    },
    {
      value: '2821',
      label: 'Horti',
      type: 'City'
    },
    {
      value: '2822',
      label: 'Hosabettu',
      type: 'City'
    },
    {
      value: '2823',
      label: 'Hosagadde',
      type: 'City'
    },
    {
      value: '2824',
      label: 'Hosahalli',
      type: 'City'
    },
    {
      value: '2825',
      label: 'Hosanagar',
      type: 'City'
    },
    {
      value: '2826',
      label: 'Hosanagara',
      type: 'City'
    },
    {
      value: '2827',
      label: 'Hosangadi',
      type: 'City'
    },
    {
      value: '2828',
      label: 'Hosangadi (Karnataka)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2829',
      label: 'Hosapete',
      type: 'City'
    },
    {
      value: '2830',
      label: 'Hoshangabad',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '2831',
      label: 'Hoshiarpur',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '2832',
      label: 'Hoskote',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2833',
      label: 'Hosmar',
      type: 'City'
    },
    {
      value: '2834',
      label: 'Hosnagar',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2835',
      label: 'Hospet',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2836',
      label: 'Hospet(Bypass)',
      type: 'City'
    },
    {
      value: '2837',
      label: 'Hosur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '2838',
      label: 'Hosur, Karnataka',
      type: 'City'
    },
    {
      value: '2839',
      label: 'Hosur, Tamil Nadu',
      type: 'City'
    },
    {
      value: '2840',
      label: 'Howly',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '2841',
      label: 'Howrah',
      type: 'City'
    },
    {
      value: '2842',
      label: 'HUALPIN',
      type: 'City'
    },
    {
      value: '2843',
      label: 'Hubballi',
      type: 'City'
    },
    {
      value: '2844',
      label: 'Hubli',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2845',
      label: 'Hubli Bypass',
      type: 'City'
    },
    {
      value: '2846',
      label: 'Hubli(Bypass)',
      type: 'City'
    },
    {
      value: '2847',
      label: 'Hukkeri',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2848',
      label: 'Hulikal',
      type: 'City'
    },
    {
      value: '2849',
      label: 'Humcha',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2850',
      label: 'Humnabad',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2851',
      label: 'Humpi',
      type: 'City'
    },
    {
      value: '2852',
      label: 'Hunasagi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2853',
      label: 'Hungund',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2854',
      label: 'Hungund By Pass',
      type: 'City'
    },
    {
      value: '2855',
      label: 'Hunnar',
      type: 'City'
    },
    {
      value: '2856',
      label: 'Hunsemakki',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2857',
      label: 'Hunsur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2858',
      label: 'Hunugunda',
      type: 'City'
    },
    {
      value: '2859',
      label: 'Hupari',
      type: 'City'
    },
    {
      value: '2860',
      label: 'Hutti',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2861',
      label: 'Huvin Hippargi',
      type: 'City'
    },
    {
      value: '2862',
      label: 'Huvinahadagali',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2863',
      label: 'Hyderabad',
      type: 'City',
      'state': 'Telangana'
    },
    {
      value: '2864',
      label: 'I.Pangidi',
      type: 'City'
    },
    {
      value: '2865',
      label: 'Ibadan',
      type: 'City'
    },
    {
      value: '2866',
      label: 'Ibrahimpatnam',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2867',
      label: 'Ibrahimpatnam, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '2868',
      label: 'Ibrahimpatnam, Telangana',
      type: 'City'
    },
    {
      value: '2869',
      label: 'Ichal karanji',
      type: 'City'
    },
    {
      value: '2870',
      label: 'Ichalkaranji',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2871',
      label: 'Ichapuram',
      type: 'City'
    },
    {
      value: '2872',
      label: 'Ichchapuram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2873',
      label: 'Ichhapur',
      type: 'City'
    },
    {
      value: '2874',
      label: 'Ichoda',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2875',
      label: 'Idaikal',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '2876',
      label: 'Idappadi',
      type: 'City'
    },
    {
      value: '2877',
      label: 'Idar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2878',
      label: 'Idayamelur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '2879',
      label: 'Idinthakarai',
      type: 'City'
    },
    {
      value: '2880',
      label: 'Idor',
      type: 'City'
    },
    {
      value: '2881',
      label: 'Idupulapaaya',
      type: 'City'
    },
    {
      value: '2882',
      label: 'Idupulapadu',
      type: 'City'
    },
    {
      value: '2883',
      label: 'Idupulapaya',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2884',
      label: 'Igatpuri',
      type: 'City'
    },
    {
      value: '2885',
      label: 'Ikauna',
      type: 'City'
    },
    {
      value: '2886',
      label: 'Ilayangudi, Puducherry',
      type: 'City'
    },
    {
      value: '2887',
      label: 'Ilayangudi, Tamil Nadu',
      type: 'City'
    },
    {
      value: '2888',
      label: 'Ilkal',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2889',
      label: 'Ilkal By Pass',
      type: 'City'
    },
    {
      value: '2890',
      label: 'Illayangudi',
      type: 'City'
    },
    {
      value: '2891',
      label: 'Imagica(mumbai)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2892',
      label: 'Imamganj',
      type: 'City'
    },
    {
      value: '2893',
      label: 'Imphal',
      type: 'City',
      'state': 'Manipur'
    },
    {
      value: '2894',
      label: 'Indapur',
      type: 'City'
    },
    {
      value: '2895',
      label: 'Indapur (pune)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2896',
      label: 'Indergarh',
      type: 'City'
    },
    {
      value: '2897',
      label: 'Index Medical College',
      type: 'City'
    },
    {
      value: '2898',
      label: 'Indi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2899',
      label: 'Indore',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '2900',
      label: 'Indragarh',
      type: 'City'
    },
    {
      value: '2901',
      label: 'Indravathi',
      type: 'City'
    },
    {
      value: '2902',
      label: 'Indravati',
      type: 'City'
    },
    {
      value: '2903',
      label: 'Indugunji',
      type: 'City'
    },
    {
      value: '2904',
      label: 'Ingorala',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2905',
      label: 'Ingorala-Dand',
      type: 'City'
    },
    {
      value: '2906',
      label: 'Inhauna',
      type: 'City'
    },
    {
      value: '2907',
      label: 'Inkollu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2908',
      label: 'International Airport Taxi on Hire Delhi',
      type: 'City',
      'state': 'Delhi'
    },
    {
      value: '2909',
      label: 'Ipurupalem',
      type: 'City'
    },
    {
      value: '2910',
      label: 'Iqbalgadh',
      type: 'City'
    },
    {
      value: '2911',
      label: 'Iquique',
      type: 'City'
    },
    {
      value: '2912',
      label: 'Irikkur',
      type: 'City'
    },
    {
      value: '2913',
      label: 'Irinjalakuda',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '2914',
      label: 'Iritty',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '2915',
      label: 'Irrikkur',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '2916',
      label: 'Isad',
      type: 'City'
    },
    {
      value: '2917',
      label: 'Isagarh',
      type: 'City'
    },
    {
      value: '2918',
      label: 'Ishvariya',
      type: 'City'
    },
    {
      value: '2919',
      label: 'Ishwariya',
      type: 'City'
    },
    {
      value: '2920',
      label: 'Islampur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2921',
      label: 'Islampur, Bihar',
      type: 'City'
    },
    {
      value: '2922',
      label: 'Islampur, West Bengal',
      type: 'City'
    },
    {
      value: '2923',
      label: 'Isnapur',
      type: 'City'
    },
    {
      value: '2924',
      label: 'Isnapur  Hyderabad',
      type: 'City'
    },
    {
      value: '2925',
      label: 'Ispurli',
      type: 'City'
    },
    {
      value: '2926',
      label: 'Iswal',
      type: 'City'
    },
    {
      value: '2927',
      label: 'Itagi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2928',
      label: 'Itanagar (Arunachal Pradesh)',
      type: 'City',
      'state': 'Arunachal Pradesh'
    },
    {
      value: '2929',
      label: 'Itarsi',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '2930',
      label: 'Itava',
      type: 'City'
    },
    {
      value: '2931',
      label: 'Itawa, MP',
      type: 'City'
    },
    {
      value: '2932',
      label: 'Itawa, Rajasthan',
      type: 'City'
    },
    {
      value: '2933',
      label: 'Itempudi',
      type: 'City'
    },
    {
      value: '2934',
      label: 'Itia Thok',
      type: 'City'
    },
    {
      value: '2935',
      label: 'Ittamozhi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '2936',
      label: 'Itvaya',
      type: 'City'
    },
    {
      value: '2937',
      label: 'Itwa, MP',
      type: 'City'
    },
    {
      value: '2938',
      label: 'Jabalpur',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '2939',
      label: 'Jabera',
      type: 'City'
    },
    {
      value: '2940',
      label: 'Jabli',
      type: 'City'
    },
    {
      value: '2941',
      label: 'Jadan',
      type: 'City'
    },
    {
      value: '2942',
      label: 'Jadcharla',
      type: 'City'
    },
    {
      value: '2943',
      label: 'Jade',
      type: 'City'
    },
    {
      value: '2944',
      label: 'Jadia',
      type: 'City'
    },
    {
      value: '2945',
      label: 'Jadiya',
      type: 'City'
    },
    {
      value: '2946',
      label: 'Jadkal',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2947',
      label: 'Jadupur',
      type: 'City'
    },
    {
      value: '2948',
      label: 'Jafarabad',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '2949',
      label: 'Jafrabad',
      type: 'City'
    },
    {
      value: '2950',
      label: 'JagadaPatnam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '2951',
      label: 'Jagadhri',
      type: 'City'
    },
    {
      value: '2952',
      label: 'Jagalur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2953',
      label: 'Jaganadhagiri',
      type: 'City'
    },
    {
      value: '2954',
      label: 'Jagannadhapuram',
      type: 'City'
    },
    {
      value: '2955',
      label: 'Jagannapeta',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2956',
      label: 'Jagarlamudi',
      type: 'City'
    },
    {
      value: '2957',
      label: 'Jagatpur',
      type: 'City'
    },
    {
      value: '2958',
      label: 'Jagdalpur',
      type: 'City'
    },
    {
      value: '2959',
      label: 'Jagdishpur',
      type: 'City'
    },
    {
      value: '2960',
      label: 'Jaggaiahpet',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2961',
      label: 'Jaggaiapet',
      type: 'City'
    },
    {
      value: '2962',
      label: 'Jaggampet',
      type: 'City'
    },
    {
      value: '2963',
      label: 'Jaggampeta',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2964',
      label: 'Jagganathagiri',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2965',
      label: 'Jaggannapeta',
      type: 'City'
    },
    {
      value: '2966',
      label: 'Jaggayyapet',
      type: 'City'
    },
    {
      value: '2967',
      label: 'Jagityal',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '2968',
      label: 'Jagraon',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '2969',
      label: 'Jagtial',
      type: 'City'
    },
    {
      value: '2970',
      label: 'Jagun',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '2971',
      label: 'Jahanabad',
      type: 'City'
    },
    {
      value: '2972',
      label: 'Jahanabad, Bihar',
      type: 'City'
    },
    {
      value: '2973',
      label: 'Jahanabad, UP',
      type: 'City'
    },
    {
      value: '2974',
      label: 'Jahazpur',
      type: 'City'
    },
    {
      value: '2975',
      label: 'Jahlma',
      type: 'City'
    },
    {
      value: '2976',
      label: 'Jahoo',
      type: 'City'
    },
    {
      value: '2977',
      label: 'Jahu',
      type: 'City'
    },
    {
      value: '2978',
      label: 'Jai Singhpur',
      type: 'City'
    },
    {
      value: '2979',
      label: 'Jaidevi',
      type: 'City'
    },
    {
      value: '2980',
      label: 'Jaikheda',
      type: 'City'
    },
    {
      value: '2981',
      label: 'Jaila',
      type: 'City'
    },
    {
      value: '2982',
      label: 'Jainath(Adilabad)',
      type: 'City'
    },
    {
      value: '2983',
      label: 'Jaintipur',
      type: 'City'
    },
    {
      value: '2984',
      label: 'Jaipur',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '2985',
      label: 'Jaipur (karnataka)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '2986',
      label: 'Jaipur Agra Mathura Tour',
      type: 'City'
    },
    {
      value: '2987',
      label: 'Jaipur Ajmer Agra Tour',
      type: 'City'
    },
    {
      value: '2988',
      label: 'Jaipur Ajmer Pushkar Tour',
      type: 'City'
    },
    {
      value: '2989',
      label: 'Jaipur Package Tour',
      type: 'City'
    },
    {
      value: '2990',
      label: 'Jaipur, Rajasthan',
      type: 'City'
    },
    {
      value: '2991',
      label: 'Jaipur, Telangana',
      type: 'City'
    },
    {
      value: '2992',
      label: 'Jairampur',
      type: 'City',
      'state': 'Arunachal Pradesh'
    },
    {
      value: '2993',
      label: 'Jais',
      type: 'City'
    },
    {
      value: '2994',
      label: 'Jaisalmer',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '2995',
      label: 'Jaisamand',
      type: 'City'
    },
    {
      value: '2996',
      label: 'Jaisinagar',
      type: 'City'
    },
    {
      value: '2997',
      label: 'Jaisinghpur',
      type: 'City'
    },
    {
      value: '2998',
      label: 'Jaisinghpur (Maharashtra)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '2999',
      label: 'Jaisinghpur(H.P)',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '3000',
      label: 'Jaisinghpura',
      type: 'City'
    },
    {
      value: '3001',
      label: 'Jaitane',
      type: 'City'
    },
    {
      value: '3002',
      label: 'Jaitaran',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '3003',
      label: 'Jaithara',
      type: 'City'
    },
    {
      value: '3004',
      label: 'Jaito',
      type: 'City'
    },
    {
      value: '3005',
      label: 'Jaitpur',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '3006',
      label: 'Jaitran',
      type: 'City'
    },
    {
      value: '3007',
      label: 'Jaitsar',
      type: 'City'
    },
    {
      value: '3008',
      label: 'Jajeli',
      type: 'City'
    },
    {
      value: '3009',
      label: 'Jakaram',
      type: 'City'
    },
    {
      value: '3010',
      label: 'Jakhora',
      type: 'City'
    },
    {
      value: '3011',
      label: 'Jakkaram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3012',
      label: 'Jalahalli',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3013',
      label: 'Jalahalli(Devadurga)',
      type: 'City'
    },
    {
      value: '3014',
      label: 'Jalakandapuram',
      type: 'City'
    },
    {
      value: '3015',
      label: 'Jalalabad, Punjab',
      type: 'City'
    },
    {
      value: '3016',
      label: 'Jalalabad, UP',
      type: 'City'
    },
    {
      value: '3017',
      label: 'Jalalpar',
      type: 'City'
    },
    {
      value: '3018',
      label: 'Jalandhar',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '3019',
      label: 'Jalansar',
      type: 'City'
    },
    {
      value: '3020',
      label: 'Jalaun',
      type: 'City'
    },
    {
      value: '3021',
      label: 'Jalesar',
      type: 'City'
    },
    {
      value: '3022',
      label: 'Jalgaon',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3023',
      label: 'Jalgaon Jamod',
      type: 'City'
    },
    {
      value: '3024',
      label: 'Jalila',
      type: 'City'
    },
    {
      value: '3025',
      label: 'Jalipa',
      type: 'City'
    },
    {
      value: '3026',
      label: 'jaliya',
      type: 'City'
    },
    {
      value: '3027',
      label: 'Jaljivadi',
      type: 'City'
    },
    {
      value: '3028',
      label: 'Jalna',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3029',
      label: 'Jalod',
      type: 'City'
    },
    {
      value: '3030',
      label: 'Jalor',
      type: 'City'
    },
    {
      value: '3031',
      label: 'Jalore',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '3032',
      label: 'Jalori Pass',
      type: 'City'
    },
    {
      value: '3033',
      label: 'Jalotra',
      type: 'City'
    },
    {
      value: '3034',
      label: 'Jalwara',
      type: 'City'
    },
    {
      value: '3035',
      label: 'Jam Kandona',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3036',
      label: 'Jam Raval',
      type: 'City'
    },
    {
      value: '3037',
      label: 'Jamai Road',
      type: 'City'
    },
    {
      value: '3038',
      label: 'Jamakhandi',
      type: 'City'
    },
    {
      value: '3039',
      label: 'Jamal',
      type: 'City'
    },
    {
      value: '3040',
      label: 'Jamalpur',
      type: 'City'
    },
    {
      value: '3041',
      label: 'Jamanvav',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3042',
      label: 'Jamb',
      type: 'City'
    },
    {
      value: '3043',
      label: 'Jamb (Nanded)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3044',
      label: 'Jambala',
      type: 'City'
    },
    {
      value: '3045',
      label: 'Jambhuldhaba',
      type: 'City'
    },
    {
      value: '3046',
      label: 'Jambuda',
      type: 'City'
    },
    {
      value: '3047',
      label: 'Jamdevliya',
      type: 'City'
    },
    {
      value: '3048',
      label: 'Jamjodhpur',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3049',
      label: 'Jamkandorana',
      type: 'City'
    },
    {
      value: '3050',
      label: 'Jamkhambhalia',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3051',
      label: 'Jamkhandi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3052',
      label: 'Jamkhed',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3053',
      label: 'Jamli',
      type: 'City'
    },
    {
      value: '3054',
      label: 'Jammalamadugu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3055',
      label: 'Jammu',
      type: 'City'
    },
    {
      value: '3056',
      label: 'Jammu (j and k)',
      type: 'City',
      'state': 'Jammu & Kashmir'
    },
    {
      value: '3057',
      label: 'Jammu sringr gulmrg tour',
      type: 'City'
    },
    {
      value: '3058',
      label: 'Jammulapalem',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3059',
      label: 'Jamnagar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3060',
      label: 'Jamner',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3061',
      label: 'Jampani',
      type: 'City'
    },
    {
      value: '3062',
      label: 'Jamrunda  Taraguda',
      type: 'City'
    },
    {
      value: '3063',
      label: 'Jamsande',
      type: 'City'
    },
    {
      value: '3064',
      label: 'Jamshedpur',
      type: 'City',
      'state': 'Jharkhand'
    },
    {
      value: '3065',
      label: 'Jamvali',
      type: 'City'
    },
    {
      value: '3066',
      label: 'Janal',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '3067',
      label: 'Janana',
      type: 'City'
    },
    {
      value: '3068',
      label: 'Jandrapeta',
      type: 'City'
    },
    {
      value: '3069',
      label: 'Jangal Beri',
      type: 'City'
    },
    {
      value: '3070',
      label: 'Jangalpatti',
      type: 'City'
    },
    {
      value: '3071',
      label: 'Jangaon',
      type: 'City'
    },
    {
      value: '3072',
      label: 'Jangar',
      type: 'City'
    },
    {
      value: '3073',
      label: 'Jangareddigudem',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3074',
      label: 'Jangareddy Gudem',
      type: 'City'
    },
    {
      value: '3075',
      label: 'Jangvad',
      type: 'City'
    },
    {
      value: '3076',
      label: 'Janjali',
      type: 'City'
    },
    {
      value: '3077',
      label: 'Janjariya Juna',
      type: 'City'
    },
    {
      value: '3078',
      label: 'Janjariya Nava',
      type: 'City'
    },
    {
      value: '3079',
      label: 'Janjeela',
      type: 'City'
    },
    {
      value: '3080',
      label: 'Janjehli',
      type: 'City'
    },
    {
      value: '3081',
      label: 'Jannadi',
      type: 'City'
    },
    {
      value: '3082',
      label: 'Janra',
      type: 'City'
    },
    {
      value: '3083',
      label: 'Jansui',
      type: 'City'
    },
    {
      value: '3084',
      label: 'Januda',
      type: 'City'
    },
    {
      value: '3085',
      label: 'Jaora',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '3086',
      label: 'Japan',
      type: 'City'
    },
    {
      value: '3087',
      label: 'Japthi',
      type: 'City'
    },
    {
      value: '3088',
      label: 'Jarhi',
      type: 'City'
    },
    {
      value: '3089',
      label: 'Jari',
      type: 'City'
    },
    {
      value: '3090',
      label: 'Jarol',
      type: 'City'
    },
    {
      value: '3091',
      label: 'Jarugumalli',
      type: 'City'
    },
    {
      value: '3092',
      label: 'Jaruwa Kheda',
      type: 'City'
    },
    {
      value: '3093',
      label: 'Jarwal Road',
      type: 'City'
    },
    {
      value: '3094',
      label: 'Jasapar',
      type: 'City'
    },
    {
      value: '3095',
      label: 'Jasdan',
      type: 'City'
    },
    {
      value: '3096',
      label: 'Jashipur',
      type: 'City'
    },
    {
      value: '3097',
      label: 'Jashpur',
      type: 'City'
    },
    {
      value: '3098',
      label: 'Jasnagar',
      type: 'City'
    },
    {
      value: '3099',
      label: 'Jasol',
      type: 'City'
    },
    {
      value: '3100',
      label: 'Jaspara',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3101',
      label: 'Jaspur',
      type: 'City'
    },
    {
      value: '3102',
      label: 'Jaspura',
      type: 'City'
    },
    {
      value: '3103',
      label: 'Jassur',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '3104',
      label: 'Jasvant Ghadh',
      type: 'City'
    },
    {
      value: '3105',
      label: 'Jaswanthgarh',
      type: 'City'
    },
    {
      value: '3106',
      label: 'Jaswantnagar',
      type: 'City'
    },
    {
      value: '3107',
      label: 'Jaswantpura',
      type: 'City'
    },
    {
      value: '3108',
      label: 'Jatara',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '3109',
      label: 'Jath',
      type: 'City'
    },
    {
      value: '3110',
      label: 'Jatroda',
      type: 'City'
    },
    {
      value: '3111',
      label: 'Jaunpur',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '3112',
      label: 'Javala',
      type: 'City'
    },
    {
      value: '3113',
      label: 'Javalaga',
      type: 'City'
    },
    {
      value: '3114',
      label: 'Javalga',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3115',
      label: 'Jawad',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '3116',
      label: 'Jawahar Nagar',
      type: 'City'
    },
    {
      value: '3117',
      label: 'Jawal',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '3118',
      label: 'Jawala',
      type: 'City'
    },
    {
      value: '3119',
      label: 'Jawala Bazar',
      type: 'City'
    },
    {
      value: '3120',
      label: 'Jawala Ji',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '3121',
      label: 'Jawalamukhi',
      type: 'City'
    },
    {
      value: '3122',
      label: 'Jawali',
      type: 'City'
    },
    {
      value: '3123',
      label: 'Jawar',
      type: 'City'
    },
    {
      value: '3124',
      label: 'Jayal',
      type: 'City'
    },
    {
      value: '3125',
      label: 'Jayamkondan',
      type: 'City'
    },
    {
      value: '3126',
      label: 'Jayankondam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3127',
      label: 'Jayapura',
      type: 'City'
    },
    {
      value: '3128',
      label: 'Jaynagar',
      type: 'City'
    },
    {
      value: '3129',
      label: 'Jaysingpur',
      type: 'City'
    },
    {
      value: '3130',
      label: 'Jaysingpur (Kolhapur)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3131',
      label: 'Jedcharla',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3132',
      label: 'Jeelakarragudem',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3133',
      label: 'Jeelola',
      type: 'City'
    },
    {
      value: '3134',
      label: 'Jeewana',
      type: 'City'
    },
    {
      value: '3135',
      label: 'Jegathapattinam(Pudukottai)',
      type: 'City'
    },
    {
      value: '3136',
      label: 'Jegathappattinam',
      type: 'City'
    },
    {
      value: '3137',
      label: 'Jehanabad',
      type: 'City'
    },
    {
      value: '3138',
      label: 'Jejuri',
      type: 'City'
    },
    {
      value: '3139',
      label: 'Jengraimukh',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '3140',
      label: 'Jeori',
      type: 'City'
    },
    {
      value: '3141',
      label: 'Jeran',
      type: 'City'
    },
    {
      value: '3142',
      label: 'Jesar',
      type: 'City'
    },
    {
      value: '3143',
      label: 'Jesingpara',
      type: 'City'
    },
    {
      value: '3144',
      label: 'Jetalsar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3145',
      label: 'Jetaran',
      type: 'City'
    },
    {
      value: '3146',
      label: 'Jetda',
      type: 'City'
    },
    {
      value: '3147',
      label: 'Jethiyavadar',
      type: 'City'
    },
    {
      value: '3148',
      label: 'Jethuwal',
      type: 'City'
    },
    {
      value: '3149',
      label: 'Jetpur',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3150',
      label: 'Jeur',
      type: 'City'
    },
    {
      value: '3151',
      label: 'Jevargi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3152',
      label: 'Jeypore',
      type: 'City'
    },
    {
      value: '3153',
      label: 'Jeypore Bypass',
      type: 'City'
    },
    {
      value: '3154',
      label: 'Jhab',
      type: 'City'
    },
    {
      value: '3155',
      label: 'Jhabua',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '3156',
      label: 'Jhajjar',
      type: 'City'
    },
    {
      value: '3157',
      label: 'Jhakri',
      type: 'City'
    },
    {
      value: '3158',
      label: 'Jhalawar',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '3159',
      label: 'Jhalki  Zalki',
      type: 'City'
    },
    {
      value: '3160',
      label: 'Jhalod',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3161',
      label: 'Jhalra',
      type: 'City'
    },
    {
      value: '3162',
      label: 'Jhalrapatan',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '3163',
      label: 'Jhambar',
      type: 'City'
    },
    {
      value: '3164',
      label: 'Jhanduta',
      type: 'City'
    },
    {
      value: '3165',
      label: 'Jhandutta',
      type: 'City'
    },
    {
      value: '3166',
      label: 'Jhanjharpur',
      type: 'City'
    },
    {
      value: '3167',
      label: 'Jhansi',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '3168',
      label: 'Jharol',
      type: 'City'
    },
    {
      value: '3169',
      label: 'Jharsuguda',
      type: 'City'
    },
    {
      value: '3170',
      label: 'Jherda',
      type: 'City'
    },
    {
      value: '3171',
      label: 'Jhodge',
      type: 'City'
    },
    {
      value: '3172',
      label: 'Jhonsberg',
      type: 'City'
    },
    {
      value: '3173',
      label: 'Jhunjhunu',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '3174',
      label: 'Jihan',
      type: 'City'
    },
    {
      value: '3175',
      label: 'Jikiyali',
      type: 'City'
    },
    {
      value: '3176',
      label: 'Jiliya',
      type: 'City'
    },
    {
      value: '3177',
      label: 'Jim Corbett National Park',
      type: 'City'
    },
    {
      value: '3178',
      label: 'Jind',
      type: 'City'
    },
    {
      value: '3179',
      label: 'Jindal',
      type: 'City'
    },
    {
      value: '3180',
      label: 'Jindal (Karnataka)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3181',
      label: 'Jindal (Mundra)',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3182',
      label: 'Jindal Power',
      type: 'City'
    },
    {
      value: '3183',
      label: 'Jindal Steel',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3184',
      label: 'Jindal Steel and Power Limited',
      type: 'City'
    },
    {
      value: '3185',
      label: 'Jintur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3186',
      label: 'Jira',
      type: 'City'
    },
    {
      value: '3187',
      label: 'Jiragadh',
      type: 'City'
    },
    {
      value: '3188',
      label: 'Jirapur',
      type: 'City'
    },
    {
      value: '3189',
      label: 'Jirawala',
      type: 'City'
    },
    {
      value: '3190',
      label: 'Jiribam',
      type: 'City',
      'state': 'Manipur'
    },
    {
      value: '3191',
      label: 'Jivapar',
      type: 'City'
    },
    {
      value: '3192',
      label: 'Jiwan Nagar',
      type: 'City'
    },
    {
      value: '3193',
      label: 'Jiyanpur',
      type: 'City'
    },
    {
      value: '3194',
      label: 'Joba',
      type: 'City'
    },
    {
      value: '3195',
      label: 'Jobat',
      type: 'City'
    },
    {
      value: '3196',
      label: 'Jobner',
      type: 'City'
    },
    {
      value: '3197',
      label: 'Jodhpur',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '3198',
      label: 'Jog Falls',
      type: 'City'
    },
    {
      value: '3199',
      label: 'Jogaldari',
      type: 'City'
    },
    {
      value: '3200',
      label: 'Jogbani',
      type: 'City'
    },
    {
      value: '3201',
      label: 'Jogfalls',
      type: 'City'
    },
    {
      value: '3202',
      label: 'Jogidas Ka Gaon',
      type: 'City'
    },
    {
      value: '3203',
      label: 'Joginder Nagar',
      type: 'City'
    },
    {
      value: '3204',
      label: 'Jogiwala Barani',
      type: 'City'
    },
    {
      value: '3205',
      label: 'Jogni',
      type: 'City'
    },
    {
      value: '3206',
      label: 'Jogpur Mod',
      type: 'City'
    },
    {
      value: '3207',
      label: 'Johannesberg',
      type: 'City'
    },
    {
      value: '3208',
      label: 'Johannesburg Park Station',
      type: 'City'
    },
    {
      value: '3209',
      label: 'Joida',
      type: 'City'
    },
    {
      value: '3210',
      label: 'Jojawar',
      type: 'City'
    },
    {
      value: '3211',
      label: 'Joniha',
      type: 'City'
    },
    {
      value: '3212',
      label: 'Jonnada',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3213',
      label: 'Jorhat',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '3214',
      label: 'Jos',
      type: 'City'
    },
    {
      value: '3215',
      label: 'Jotingada',
      type: 'City'
    },
    {
      value: '3216',
      label: 'Joya',
      type: 'City'
    },
    {
      value: '3217',
      label: 'Jubbal',
      type: 'City'
    },
    {
      value: '3218',
      label: 'Jui Khurd',
      type: 'City'
    },
    {
      value: '3219',
      label: 'Jukhala',
      type: 'City'
    },
    {
      value: '3220',
      label: 'Julurpadu',
      type: 'City'
    },
    {
      value: '3221',
      label: 'Julwania',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '3222',
      label: 'Juna Pipaliya',
      type: 'City'
    },
    {
      value: '3223',
      label: 'Juna Savar',
      type: 'City'
    },
    {
      value: '3224',
      label: 'Junagadh',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3225',
      label: 'Junjani',
      type: 'City'
    },
    {
      value: '3226',
      label: 'Junnardeo',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '3227',
      label: 'Jutogh',
      type: 'City'
    },
    {
      value: '3228',
      label: 'Juvvalapalem',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3229',
      label: 'K Padapudi',
      type: 'City'
    },
    {
      value: '3230',
      label: 'K.Paramathi',
      type: 'City'
    },
    {
      value: '3231',
      label: 'K.R. Nagar',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3232',
      label: 'K.r.pet',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3233',
      label: 'Kaalahasthi',
      type: 'City'
    },
    {
      value: '3234',
      label: 'Kaas Plateau',
      type: 'City'
    },
    {
      value: '3235',
      label: 'Kabrel',
      type: 'City'
    },
    {
      value: '3236',
      label: 'Kabuganj',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '3237',
      label: 'Kachnara',
      type: 'City'
    },
    {
      value: '3238',
      label: 'Kada',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3239',
      label: 'Kadaba',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3240',
      label: 'Kadaganchi',
      type: 'City'
    },
    {
      value: '3241',
      label: 'Kadaiyanallur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3242',
      label: 'Kadaladi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3243',
      label: 'Kadalas',
      type: 'City'
    },
    {
      value: '3244',
      label: 'Kadamanchali',
      type: 'City'
    },
    {
      value: '3245',
      label: 'Kadapa',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3246',
      label: 'Kadapa (by pass)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3247',
      label: 'Kadara',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3248',
      label: 'Kadatchapuram',
      type: 'City'
    },
    {
      value: '3249',
      label: 'Kadaura',
      type: 'City'
    },
    {
      value: '3250',
      label: 'Kadavanthra',
      type: 'City'
    },
    {
      value: '3251',
      label: 'Kadayalumoodu',
      type: 'City'
    },
    {
      value: '3252',
      label: 'Kadayalurutti',
      type: 'City'
    },
    {
      value: '3253',
      label: 'Kadayam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3254',
      label: 'Kadayanallur',
      type: 'City'
    },
    {
      value: '3255',
      label: 'Kadegaon',
      type: 'City'
    },
    {
      value: '3256',
      label: 'Kadepur',
      type: 'City'
    },
    {
      value: '3257',
      label: 'Kadera',
      type: 'City'
    },
    {
      value: '3258',
      label: 'Kadganchi',
      type: 'City'
    },
    {
      value: '3259',
      label: 'Kadhiri',
      type: 'City'
    },
    {
      value: '3260',
      label: 'Kadi',
      type: 'City'
    },
    {
      value: '3261',
      label: 'Kadia',
      type: 'City'
    },
    {
      value: '3262',
      label: 'Kadiam',
      type: 'City'
    },
    {
      value: '3263',
      label: 'Kadipur',
      type: 'City'
    },
    {
      value: '3264',
      label: 'Kadiri',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3265',
      label: 'Kadiyam',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3266',
      label: 'Kadodara',
      type: 'City'
    },
    {
      value: '3267',
      label: 'Kadodra',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3268',
      label: 'Kadra',
      type: 'City'
    },
    {
      value: '3269',
      label: 'Kadugli',
      type: 'City'
    },
    {
      value: '3270',
      label: 'Kadur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3271',
      label: 'Kadur, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '3272',
      label: 'Kadur, Karnataka',
      type: 'City'
    },
    {
      value: '3273',
      label: 'Kaduthuruthi',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '3274',
      label: 'Kaduthuruthy',
      type: 'City'
    },
    {
      value: '3275',
      label: 'Kagal',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3276',
      label: 'Kagdadi',
      type: 'City'
    },
    {
      value: '3277',
      label: 'Kagdana',
      type: 'City'
    },
    {
      value: '3278',
      label: 'Kaghaznagar',
      type: 'City'
    },
    {
      value: '3279',
      label: 'Kagwad',
      type: 'City'
    },
    {
      value: '3280',
      label: 'Kagwade',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3281',
      label: 'Kahoda',
      type: 'City'
    },
    {
      value: '3282',
      label: 'Kaiga',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3283',
      label: 'Kaij',
      type: 'City'
    },
    {
      value: '3284',
      label: 'Kaikaluru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3285',
      label: 'Kaikamba',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3286',
      label: 'Kaikaram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3287',
      label: 'Kaikatti',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3288',
      label: 'Kaikatty',
      type: 'City'
    },
    {
      value: '3289',
      label: 'Kailadevi',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '3290',
      label: 'Kailaras',
      type: 'City'
    },
    {
      value: '3291',
      label: 'Kailash Nagar',
      type: 'City'
    },
    {
      value: '3292',
      label: 'Kaimara',
      type: 'City'
    },
    {
      value: '3293',
      label: 'Kaimganj',
      type: 'City'
    },
    {
      value: '3294',
      label: 'Kaisarganj',
      type: 'City'
    },
    {
      value: '3295',
      label: 'Kaithal',
      type: 'City',
      'state': 'Haryana'
    },
    {
      value: '3296',
      label: 'Kajgaon',
      type: 'City'
    },
    {
      value: '3297',
      label: 'Kakani',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3298',
      label: 'Kakar',
      type: 'City'
    },
    {
      value: '3299',
      label: 'Kakinada',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3300',
      label: 'Kakira',
      type: 'City'
    },
    {
      value: '3301',
      label: 'Kakkanad',
      type: 'City'
    },
    {
      value: '3302',
      label: 'Kakkar',
      type: 'City'
    },
    {
      value: '3303',
      label: 'Kakkattil',
      type: 'City'
    },
    {
      value: '3304',
      label: 'Kakkavayal',
      type: 'City'
    },
    {
      value: '3305',
      label: 'Kakoshi',
      type: 'City'
    },
    {
      value: '3306',
      label: 'Kakroli',
      type: 'City',
      'state': 'Haryana'
    },
    {
      value: '3307',
      label: 'Kakumanu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3308',
      label: 'Kala Amb',
      type: 'City'
    },
    {
      value: '3309',
      label: 'Kalaburagi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3310',
      label: 'Kalachal',
      type: 'City'
    },
    {
      value: '3311',
      label: 'Kalady',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '3312',
      label: 'Kalahasthi',
      type: 'City'
    },
    {
      value: '3313',
      label: 'Kalakada',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3314',
      label: 'Kalakkad',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3315',
      label: 'Kalamassery',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '3316',
      label: 'Kalamassery  Kochi',
      type: 'City'
    },
    {
      value: '3317',
      label: 'Kalamb',
      type: 'City'
    },
    {
      value: '3318',
      label: 'Kalamboli',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3319',
      label: 'Kalamboli Navi Mumbai',
      type: 'City'
    },
    {
      value: '3320',
      label: 'Kalamnuri',
      type: 'City'
    },
    {
      value: '3321',
      label: 'Kalana',
      type: 'City'
    },
    {
      value: '3322',
      label: 'Kalanaur',
      type: 'City'
    },
    {
      value: '3323',
      label: 'Kalandri',
      type: 'City'
    },
    {
      value: '3324',
      label: 'Kalangar',
      type: 'City'
    },
    {
      value: '3325',
      label: 'Kalappanaickenpatti',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3326',
      label: 'Kalasa',
      type: 'City'
    },
    {
      value: '3327',
      label: 'Kalasapadu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3328',
      label: 'Kalath',
      type: 'City'
    },
    {
      value: '3329',
      label: 'Kalavad',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3330',
      label: 'Kalavapamula',
      type: 'City'
    },
    {
      value: '3331',
      label: 'Kalavara',
      type: 'City'
    },
    {
      value: '3332',
      label: 'Kalawa',
      type: 'City'
    },
    {
      value: '3333',
      label: 'Kalayarkoil',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3334',
      label: 'Kaleyakavelai',
      type: 'City'
    },
    {
      value: '3335',
      label: 'Kalghatgi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3336',
      label: 'Kaliaguda',
      type: 'City'
    },
    {
      value: '3337',
      label: 'Kaliakkavilai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3338',
      label: 'Kalidevi',
      type: 'City'
    },
    {
      value: '3339',
      label: 'Kalidindi',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3340',
      label: 'Kaligiri',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3341',
      label: 'Kalikiri',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3342',
      label: 'Kalikkadavu',
      type: 'City'
    },
    {
      value: '3343',
      label: 'Kalimela',
      type: 'City'
    },
    {
      value: '3344',
      label: 'Kalimpong',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '3345',
      label: 'Kalinda',
      type: 'City'
    },
    {
      value: '3346',
      label: 'Kalinjara',
      type: 'City'
    },
    {
      value: '3347',
      label: 'Kalinjer',
      type: 'City'
    },
    {
      value: '3348',
      label: 'Kaliyal',
      type: 'City'
    },
    {
      value: '3349',
      label: 'Kalka',
      type: 'City',
      'state': 'Haryana'
    },
    {
      value: '3350',
      label: 'Kalkurichi',
      type: 'City'
    },
    {
      value: '3351',
      label: 'Kalla',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3352',
      label: 'Kallachi',
      type: 'City'
    },
    {
      value: '3353',
      label: 'Kalladka',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3354',
      label: 'Kallakurichi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3355',
      label: 'Kallakuru',
      type: 'City'
    },
    {
      value: '3356',
      label: 'Kallal',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3357',
      label: 'Kallambalam',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '3358',
      label: 'Kallar',
      type: 'City'
    },
    {
      value: '3359',
      label: 'Kallidaikurichi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3360',
      label: 'Kallige',
      type: 'City'
    },
    {
      value: '3361',
      label: 'Kalligudi',
      type: 'City'
    },
    {
      value: '3362',
      label: 'Kallikandy',
      type: 'City'
    },
    {
      value: '3363',
      label: 'Kallikkandy',
      type: 'City'
    },
    {
      value: '3364',
      label: 'Kallikudi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3365',
      label: 'Kallimandayam',
      type: 'City'
    },
    {
      value: '3366',
      label: 'Kalloli',
      type: 'City'
    },
    {
      value: '3367',
      label: 'Kalloorani',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3368',
      label: 'Kallupatti',
      type: 'City'
    },
    {
      value: '3369',
      label: 'Kallur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3370',
      label: 'Kallurani',
      type: 'City'
    },
    {
      value: '3371',
      label: 'Kalluru',
      type: 'City'
    },
    {
      value: '3372',
      label: 'Kalluru(Chittor Dist)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3373',
      label: 'Kalluru, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '3374',
      label: 'Kalluru, Telangana',
      type: 'City'
    },
    {
      value: '3375',
      label: 'Kallurugudem',
      type: 'City'
    },
    {
      value: '3376',
      label: 'Kalmanda',
      type: 'City'
    },
    {
      value: '3377',
      label: 'Kalmane',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3378',
      label: 'Kaloda',
      type: 'City'
    },
    {
      value: '3379',
      label: 'Kaloha',
      type: 'City'
    },
    {
      value: '3380',
      label: 'Kalol',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3381',
      label: 'Kalol, Gujarat',
      type: 'City'
    },
    {
      value: '3382',
      label: 'Kalol, Himachal Pradesh',
      type: 'City'
    },
    {
      value: '3383',
      label: 'Kaloor',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '3384',
      label: 'Kaloor  Kochi',
      type: 'City'
    },
    {
      value: '3385',
      label: 'Kalpa',
      type: 'City'
    },
    {
      value: '3386',
      label: 'Kalpakam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3387',
      label: 'Kalpakkam Township',
      type: 'City'
    },
    {
      value: '3388',
      label: 'Kalpetta',
      type: 'City'
    },
    {
      value: '3389',
      label: 'Kalpi (UP)',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '3390',
      label: 'Kalpi, MP',
      type: 'City'
    },
    {
      value: '3391',
      label: 'Kalpi, UP',
      type: 'City'
    },
    {
      value: '3392',
      label: 'Kalsari',
      type: 'City'
    },
    {
      value: '3393',
      label: 'Kaludi',
      type: 'City'
    },
    {
      value: '3394',
      label: 'Kalugumalai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3395',
      label: 'Kaluneerkulam',
      type: 'City'
    },
    {
      value: '3396',
      label: 'Kaluvanthittai',
      type: 'City'
    },
    {
      value: '3397',
      label: 'Kalwa',
      type: 'City'
    },
    {
      value: '3398',
      label: 'Kalwan',
      type: 'City'
    },
    {
      value: '3399',
      label: 'Kalwari',
      type: 'City'
    },
    {
      value: '3400',
      label: 'Kalyan',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3401',
      label: 'Kalyandurg',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3402',
      label: 'Kalyanpur, Gujarat',
      type: 'City'
    },
    {
      value: '3403',
      label: 'Kalyanpur, Rajasthan',
      type: 'City'
    },
    {
      value: '3404',
      label: 'Kalyanpura',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '3405',
      label: 'Kamadhiya',
      type: 'City'
    },
    {
      value: '3406',
      label: 'Kamal Nagar',
      type: 'City'
    },
    {
      value: '3407',
      label: 'Kamalapur (hampi)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3408',
      label: 'Kamalapur, Karnataka',
      type: 'City'
    },
    {
      value: '3409',
      label: 'Kamalapur, Telangana',
      type: 'City'
    },
    {
      value: '3410',
      label: 'Kamalapuram',
      type: 'City'
    },
    {
      value: '3411',
      label: 'Kamalighat',
      type: 'City'
    },
    {
      value: '3412',
      label: 'Kamalnagar',
      type: 'City'
    },
    {
      value: '3413',
      label: 'Kamanayakkanpatti',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3414',
      label: 'Kamara',
      type: 'City'
    },
    {
      value: '3415',
      label: 'Kamareddy',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3416',
      label: 'Kamargaon',
      type: 'City'
    },
    {
      value: '3417',
      label: 'Kamatagi',
      type: 'City'
    },
    {
      value: '3418',
      label: 'Kamatchipuram',
      type: 'City'
    },
    {
      value: '3419',
      label: 'Kamavarapu Kota',
      type: 'City'
    },
    {
      value: '3420',
      label: 'Kamba',
      type: 'City'
    },
    {
      value: '3421',
      label: 'Kambadakone',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3422',
      label: 'Kambalakkad',
      type: 'City'
    },
    {
      value: '3423',
      label: 'Kamboi',
      type: 'City'
    },
    {
      value: '3424',
      label: 'Kamepalli',
      type: 'City'
    },
    {
      value: '3425',
      label: 'Kamepalli  Prakasam',
      type: 'City'
    },
    {
      value: '3426',
      label: 'Kamera Gadh',
      type: 'City'
    },
    {
      value: '3427',
      label: 'Kami',
      type: 'City'
    },
    {
      value: '3428',
      label: 'Kaminpura',
      type: 'City'
    },
    {
      value: '3429',
      label: 'Kamkheda (Maharashtra)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3430',
      label: 'Kamlapur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3431',
      label: 'Kamligadh',
      type: 'City'
    },
    {
      value: '3432',
      label: 'Kamlighat',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '3433',
      label: 'Kammaradi',
      type: 'City'
    },
    {
      value: '3434',
      label: 'Kammardi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3435',
      label: 'Kammarpally',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3436',
      label: 'Kamol',
      type: 'City'
    },
    {
      value: '3437',
      label: 'Kamothe',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3438',
      label: 'Kamothe Navi Mumbai',
      type: 'City'
    },
    {
      value: '3439',
      label: 'Kampli',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3440',
      label: 'Kamptee',
      type: 'City'
    },
    {
      value: '3441',
      label: 'Kamrej',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3442',
      label: 'Kamudi',
      type: 'City'
    },
    {
      value: '3443',
      label: 'Kamuthi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3444',
      label: 'Kamuthi Vilakku',
      type: 'City'
    },
    {
      value: '3445',
      label: 'Kanadukathan',
      type: 'City'
    },
    {
      value: '3446',
      label: 'Kanakagiri',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3447',
      label: 'Kanangad',
      type: 'City'
    },
    {
      value: '3448',
      label: 'Kanaparti',
      type: 'City'
    },
    {
      value: '3449',
      label: 'Kanasar',
      type: 'City'
    },
    {
      value: '3450',
      label: 'Kanavadla',
      type: 'City'
    },
    {
      value: '3451',
      label: 'Kanchikacherla',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3452',
      label: 'Kanchipura',
      type: 'City'
    },
    {
      value: '3453',
      label: 'Kanchipuram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3454',
      label: 'Kanchipuram',
      type: 'City'
    },
    {
      value: '3455',
      label: 'Kanchipuram, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '3456',
      label: 'Kanchiyar',
      type: 'City'
    },
    {
      value: '3457',
      label: 'Kanda',
      type: 'City'
    },
    {
      value: '3458',
      label: 'Kandaghat',
      type: 'City'
    },
    {
      value: '3459',
      label: 'Kandalloor',
      type: 'City'
    },
    {
      value: '3460',
      label: 'Kandalur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3461',
      label: 'Kandanur',
      type: 'City'
    },
    {
      value: '3462',
      label: 'Kandavalli',
      type: 'City'
    },
    {
      value: '3463',
      label: 'Kandavelli',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3464',
      label: 'Kandhar',
      type: 'City'
    },
    {
      value: '3465',
      label: 'Kandivalasa',
      type: 'City'
    },
    {
      value: '3466',
      label: 'Kandlur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3467',
      label: 'Kandola',
      type: 'City'
    },
    {
      value: '3468',
      label: 'Kandorna',
      type: 'City'
    },
    {
      value: '3469',
      label: 'Kandrour',
      type: 'City'
    },
    {
      value: '3470',
      label: 'Kandukur',
      type: 'City'
    },
    {
      value: '3471',
      label: 'Kandukuru',
      type: 'City'
    },
    {
      value: '3472',
      label: 'Kandukuru(Khammam dist.)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3473',
      label: 'Kandukuru(Prakasham dist)',
      type: 'City'
    },
    {
      value: '3474',
      label: 'Kandukuru(Prakasham dist.)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3475',
      label: 'Kangal',
      type: 'City'
    },
    {
      value: '3476',
      label: 'Kangayam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3477',
      label: 'Kangoo',
      type: 'City'
    },
    {
      value: '3478',
      label: 'Kangra',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '3479',
      label: 'Kanha',
      type: 'City'
    },
    {
      value: '3480',
      label: 'Kanhan',
      type: 'City'
    },
    {
      value: '3481',
      label: 'Kanhangad',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '3482',
      label: 'Kanhiwada',
      type: 'City'
    },
    {
      value: '3483',
      label: 'Kanigiri',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3484',
      label: 'Kanja',
      type: 'City'
    },
    {
      value: '3485',
      label: 'Kanjanagadu',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '3486',
      label: 'Kanjarda',
      type: 'City'
    },
    {
      value: '3487',
      label: 'Kanjikode',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '3488',
      label: 'Kanjirappally',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '3489',
      label: 'Kankaria  Ahmedabad',
      type: 'City'
    },
    {
      value: '3490',
      label: 'Kankatapalem',
      type: 'City'
    },
    {
      value: '3491',
      label: 'Kankavali',
      type: 'City'
    },
    {
      value: '3492',
      label: 'Kankavli',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3493',
      label: 'Kanker',
      type: 'City'
    },
    {
      value: '3494',
      label: 'Kankeri',
      type: 'City'
    },
    {
      value: '3495',
      label: 'Kankipadu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3496',
      label: 'Kankot',
      type: 'City'
    },
    {
      value: '3497',
      label: 'Kankroli',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '3498',
      label: 'Kankroli  Rajsamand',
      type: 'City'
    },
    {
      value: '3499',
      label: 'Kannad',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3500',
      label: 'Kannar',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3501',
      label: 'Kannauj',
      type: 'City'
    },
    {
      value: '3502',
      label: 'Kannauj UP',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '3503',
      label: 'Kannavam',
      type: 'City'
    },
    {
      value: '3504',
      label: 'Kannirajapuram',
      type: 'City'
    },
    {
      value: '3505',
      label: 'Kannirajpuram',
      type: 'City'
    },
    {
      value: '3506',
      label: 'Kanniyakumari',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3507',
      label: 'Kannod',
      type: 'City'
    },
    {
      value: '3508',
      label: 'Kannur',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '3509',
      label: 'Kanod',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '3510',
      label: 'Kanodar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3511',
      label: 'Kanoi',
      type: 'City'
    },
    {
      value: '3512',
      label: 'Kanoodar',
      type: 'City'
    },
    {
      value: '3513',
      label: 'Kanore',
      type: 'City'
    },
    {
      value: '3514',
      label: 'Kanota',
      type: 'City'
    },
    {
      value: '3515',
      label: 'Kanpar',
      type: 'City'
    },
    {
      value: '3516',
      label: 'Kanpur',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '3517',
      label: 'Kanpur Nagar',
      type: 'City'
    },
    {
      value: '3518',
      label: 'Kansa',
      type: 'City'
    },
    {
      value: '3519',
      label: 'Kansabel',
      type: 'City'
    },
    {
      value: '3520',
      label: 'Kansari',
      type: 'City'
    },
    {
      value: '3521',
      label: 'Kansur',
      type: 'City'
    },
    {
      value: '3522',
      label: 'Kansur(Sirsi)',
      type: 'City'
    },
    {
      value: '3523',
      label: 'Kantala',
      type: 'City'
    },
    {
      value: '3524',
      label: 'Kantrodi',
      type: 'City'
    },
    {
      value: '3525',
      label: 'Kanwa',
      type: 'City'
    },
    {
      value: '3526',
      label: 'Kanwad',
      type: 'City'
    },
    {
      value: '3527',
      label: 'Kanyakumari',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3528',
      label: 'Kapadvanj',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3529',
      label: 'Kapalya Khedi',
      type: 'City'
    },
    {
      value: '3530',
      label: 'Kapasan',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '3531',
      label: 'Kapavaram',
      type: 'City'
    },
    {
      value: '3532',
      label: 'Kapileswarapuram',
      type: 'City'
    },
    {
      value: '3533',
      label: 'Kaprada',
      type: 'City'
    },
    {
      value: '3534',
      label: 'Kaptanganj',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '3535',
      label: 'Kapu',
      type: 'City'
    },
    {
      value: '3536',
      label: 'Kapu (Karnataka)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3537',
      label: 'Kapurthala',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '3538',
      label: 'Karad',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3539',
      label: 'Karad By Pass',
      type: 'City'
    },
    {
      value: '3540',
      label: 'Karada',
      type: 'City'
    },
    {
      value: '3541',
      label: 'Karadi',
      type: 'City'
    },
    {
      value: '3542',
      label: 'Karadkhel',
      type: 'City'
    },
    {
      value: '3543',
      label: 'Karahal',
      type: 'City'
    },
    {
      value: '3544',
      label: 'Karaikal',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3545',
      label: 'Karaikudi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3546',
      label: 'Karamchedu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3547',
      label: 'Karampudi',
      type: 'City'
    },
    {
      value: '3548',
      label: 'Karamsad',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3549',
      label: 'Karanja',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3550',
      label: 'Karanja Ghadge',
      type: 'City'
    },
    {
      value: '3551',
      label: 'Karanja Lad',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3552',
      label: 'Karanjani',
      type: 'City'
    },
    {
      value: '3553',
      label: 'Karanji',
      type: 'City'
    },
    {
      value: '3554',
      label: 'Karanjia',
      type: 'City'
    },
    {
      value: '3555',
      label: 'Karanpur',
      type: 'City'
    },
    {
      value: '3556',
      label: 'Karanpur (Rajasthan)',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '3557',
      label: 'Karapa',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3558',
      label: 'Kararaghat',
      type: 'City'
    },
    {
      value: '3559',
      label: 'Karatagi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3560',
      label: 'Karauli',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '3561',
      label: 'Karcham',
      type: 'City'
    },
    {
      value: '3562',
      label: 'Karda',
      type: 'City'
    },
    {
      value: '3563',
      label: 'Kareda',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '3564',
      label: 'Kareli',
      type: 'City'
    },
    {
      value: '3565',
      label: 'Karempudi',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3566',
      label: 'Karera',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '3567',
      label: 'Karera, MP',
      type: 'City'
    },
    {
      value: '3568',
      label: 'Karera, Rajasthan',
      type: 'City'
    },
    {
      value: '3569',
      label: 'Kargal',
      type: 'City'
    },
    {
      value: '3570',
      label: 'Kargani',
      type: 'City'
    },
    {
      value: '3571',
      label: 'Kargedde',
      type: 'City'
    },
    {
      value: '3572',
      label: 'Karhal',
      type: 'City'
    },
    {
      value: '3573',
      label: 'Karhiya',
      type: 'City'
    },
    {
      value: '3574',
      label: 'Kariapatti',
      type: 'City'
    },
    {
      value: '3575',
      label: 'Karikal',
      type: 'City'
    },
    {
      value: '3576',
      label: 'Karikatte',
      type: 'City'
    },
    {
      value: '3577',
      label: 'Karimganj',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '3578',
      label: 'Karimnagar',
      type: 'City',
      'state': 'Telangana'
    },
    {
      value: '3579',
      label: 'Karivalam Vanda Nallur',
      type: 'City'
    },
    {
      value: '3580',
      label: 'Karivellur',
      type: 'City'
    },
    {
      value: '3581',
      label: 'Kariyani',
      type: 'City'
    },
    {
      value: '3582',
      label: 'Kariyapatti',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3583',
      label: 'Karjala',
      type: 'City'
    },
    {
      value: '3584',
      label: 'Karjan',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3585',
      label: 'Karjat (Ahmednagar)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3586',
      label: 'Karkala',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3587',
      label: 'Karkeri',
      type: 'City'
    },
    {
      value: '3588',
      label: 'Karki',
      type: 'City'
    },
    {
      value: '3589',
      label: 'Karlapalem',
      type: 'City'
    },
    {
      value: '3590',
      label: 'Karli',
      type: 'City'
    },
    {
      value: '3591',
      label: 'Karlyakoo',
      type: 'City'
    },
    {
      value: '3592',
      label: 'Karmad',
      type: 'City'
    },
    {
      value: '3593',
      label: 'Karmal',
      type: 'City'
    },
    {
      value: '3594',
      label: 'Karmala',
      type: 'City'
    },
    {
      value: '3595',
      label: 'Karmala (Solapur)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3596',
      label: 'Karnal',
      type: 'City',
      'state': 'Haryana'
    },
    {
      value: '3597',
      label: 'Karnal, HR',
      type: 'City'
    },
    {
      value: '3598',
      label: 'Karnal, Himachal Pradesh',
      type: 'City'
    },
    {
      value: '3599',
      label: 'Karnataka',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3600',
      label: 'Karnawad',
      type: 'City'
    },
    {
      value: '3601',
      label: 'Karnool',
      type: 'City'
    },
    {
      value: '3602',
      label: 'Karoi',
      type: 'City'
    },
    {
      value: '3603',
      label: 'Karoti',
      type: 'City'
    },
    {
      value: '3604',
      label: 'Karsog',
      type: 'City'
    },
    {
      value: '3605',
      label: 'Kartal',
      type: 'City'
    },
    {
      value: '3606',
      label: 'Kartarpur',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '3607',
      label: 'Karukachal',
      type: 'City'
    },
    {
      value: '3608',
      label: 'Karukutty',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '3609',
      label: 'Karumathampatti',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3610',
      label: 'Karunagapilly',
      type: 'City'
    },
    {
      value: '3611',
      label: 'Karunagappally',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '3612',
      label: 'Karungal',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3613',
      label: 'Karungalakudi',
      type: 'City'
    },
    {
      value: '3614',
      label: 'Karunkal',
      type: 'City'
    },
    {
      value: '3615',
      label: 'Karunya Nagar',
      type: 'City'
    },
    {
      value: '3616',
      label: 'Karur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3617',
      label: 'Karur Bypass',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3618',
      label: 'Karuvanchal',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '3619',
      label: 'Karwar',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3620',
      label: 'Karwara',
      type: 'City'
    },
    {
      value: '3621',
      label: 'Karwi',
      type: 'City'
    },
    {
      value: '3622',
      label: 'Karwi(Chitrakut Dham)',
      type: 'City'
    },
    {
      value: '3623',
      label: 'Kasal',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3624',
      label: 'Kasan',
      type: 'City'
    },
    {
      value: '3625',
      label: 'Kasar Sirsi',
      type: 'City'
    },
    {
      value: '3626',
      label: 'Kasaragod',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '3627',
      label: 'Kasarde',
      type: 'City'
    },
    {
      value: '3628',
      label: 'Kasbathana',
      type: 'City'
    },
    {
      value: '3629',
      label: 'Kasegaon',
      type: 'City'
    },
    {
      value: '3630',
      label: 'Kasegaon (Sangli)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3631',
      label: 'Kasganj',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '3632',
      label: 'Kashedi',
      type: 'City'
    },
    {
      value: '3633',
      label: 'Kashil',
      type: 'City'
    },
    {
      value: '3634',
      label: 'Kashimira',
      type: 'City'
    },
    {
      value: '3635',
      label: 'Kashimira (Thane)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3636',
      label: 'Kashipur',
      type: 'City'
    },
    {
      value: '3637',
      label: 'Kashti',
      type: 'City'
    },
    {
      value: '3638',
      label: 'Kasia Bazaar',
      type: 'City'
    },
    {
      value: '3639',
      label: 'Kasoda',
      type: 'City'
    },
    {
      value: '3640',
      label: 'Kasol',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '3641',
      label: 'Kasrawad',
      type: 'City'
    },
    {
      value: '3642',
      label: 'Kasya',
      type: 'City'
    },
    {
      value: '3643',
      label: 'Katameta',
      type: 'City'
    },
    {
      value: '3644',
      label: 'Katangi',
      type: 'City'
    },
    {
      value: '3645',
      label: 'Katapadi (KAR)',
      type: 'City'
    },
    {
      value: '3646',
      label: 'Katapady',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3647',
      label: 'Katargaon',
      type: 'City'
    },
    {
      value: '3648',
      label: 'Katchanavilai',
      type: 'City'
    },
    {
      value: '3649',
      label: 'Kateel',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3650',
      label: 'Katehri',
      type: 'City'
    },
    {
      value: '3651',
      label: 'Katghar  Bareilly',
      type: 'City'
    },
    {
      value: '3652',
      label: 'Katghora',
      type: 'City'
    },
    {
      value: '3653',
      label: 'Kathari',
      type: 'City'
    },
    {
      value: '3654',
      label: 'Kathgarh',
      type: 'City'
    },
    {
      value: '3655',
      label: 'Kathgodam',
      type: 'City'
    },
    {
      value: '3656',
      label: 'Kathgodam  Haldwani',
      type: 'City'
    },
    {
      value: '3657',
      label: 'Kathipudi',
      type: 'City'
    },
    {
      value: '3658',
      label: 'Kathlal',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3659',
      label: 'Kathmandu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3660',
      label: 'Kathu Nangal',
      type: 'City'
    },
    {
      value: '3661',
      label: 'Kathua',
      type: 'City'
    },
    {
      value: '3662',
      label: 'Katisour',
      type: 'City'
    },
    {
      value: '3663',
      label: 'Katneshwar',
      type: 'City'
    },
    {
      value: '3664',
      label: 'Katni',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '3665',
      label: 'Katol',
      type: 'City'
    },
    {
      value: '3666',
      label: 'Katori Bang',
      type: 'City'
    },
    {
      value: '3667',
      label: 'Katpadi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3668',
      label: 'Katpadi  Vellore',
      type: 'City'
    },
    {
      value: '3669',
      label: 'Katra',
      type: 'City'
    },
    {
      value: '3670',
      label: 'Katra (jammu and kashmir)',
      type: 'City',
      'state': 'Jammu & Kashmir'
    },
    {
      value: '3671',
      label: 'Katra, Jammu',
      type: 'City'
    },
    {
      value: '3672',
      label: 'Katra, Jammu And Kashmir',
      type: 'City'
    },
    {
      value: '3673',
      label: 'Katra, MP',
      type: 'City'
    },
    {
      value: '3674',
      label: 'Katra, UP',
      type: 'City'
    },
    {
      value: '3675',
      label: 'Katradevi',
      type: 'City'
    },
    {
      value: '3676',
      label: 'Katrenikona',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3677',
      label: 'Katta',
      type: 'City'
    },
    {
      value: '3678',
      label: 'Kattanguru',
      type: 'City'
    },
    {
      value: '3679',
      label: 'Kattankulathur',
      type: 'City'
    },
    {
      value: '3680',
      label: 'Kattappana',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '3681',
      label: 'Kattemakki',
      type: 'City'
    },
    {
      value: '3682',
      label: 'Kattikulam',
      type: 'City'
    },
    {
      value: '3683',
      label: 'Kattipudi',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3684',
      label: 'Kattu Mavidi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3685',
      label: 'Kattumavadi',
      type: 'City'
    },
    {
      value: '3686',
      label: 'Kattunaickenpatti',
      type: 'City'
    },
    {
      value: '3687',
      label: 'Kattuputhur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3688',
      label: 'Katunda',
      type: 'City'
    },
    {
      value: '3689',
      label: 'Kaunterpur',
      type: 'City'
    },
    {
      value: '3690',
      label: 'Kaup',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3691',
      label: 'Kaushambi',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '3692',
      label: 'Kaushambi  Ghaziabad',
      type: 'City'
    },
    {
      value: '3693',
      label: 'Kavalakki',
      type: 'City'
    },
    {
      value: '3694',
      label: 'Kavali',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3695',
      label: 'Kavali Bye Pass',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3696',
      label: 'Kavalkinaru',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3697',
      label: 'Kavalkinaru Bypass',
      type: 'City'
    },
    {
      value: '3698',
      label: 'Kavathe mahankal',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3699',
      label: 'Kaveripattinam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3700',
      label: 'Kaviti',
      type: 'City'
    },
    {
      value: '3701',
      label: 'Kavoor',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3702',
      label: 'Kavoor  Mangaluru',
      type: 'City'
    },
    {
      value: '3703',
      label: 'Kavuru',
      type: 'City'
    },
    {
      value: '3704',
      label: 'Kavutaram',
      type: 'City'
    },
    {
      value: '3705',
      label: 'Kawardha',
      type: 'City'
    },
    {
      value: '3706',
      label: 'Kawas',
      type: 'City'
    },
    {
      value: '3707',
      label: 'Kayal Pattinam',
      type: 'City'
    },
    {
      value: '3708',
      label: 'Kayalpatnam',
      type: 'City'
    },
    {
      value: '3709',
      label: 'Kayalpattinam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3710',
      label: 'Kayamkulam',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '3711',
      label: 'Kayamozhi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3712',
      label: 'Kayankulam',
      type: 'City'
    },
    {
      value: '3713',
      label: 'Kayathar',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3714',
      label: 'Kaza',
      type: 'City'
    },
    {
      value: '3715',
      label: 'Kazhakkoottam',
      type: 'City'
    },
    {
      value: '3716',
      label: 'Kazhakkottam',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '3717',
      label: 'Kazhakootam',
      type: 'City'
    },
    {
      value: '3718',
      label: 'Kazhakuttam',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '3719',
      label: 'Kazipet',
      type: 'City'
    },
    {
      value: '3720',
      label: 'Kazipet(Kadapa)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3721',
      label: 'Kaziranga',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '3722',
      label: 'Keela Eral',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3723',
      label: 'Keela Eral',
      type: 'City'
    },
    {
      value: '3724',
      label: 'Keelakam',
      type: 'City'
    },
    {
      value: '3725',
      label: 'Keelakarai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3726',
      label: 'Keelapavoor',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3727',
      label: 'Keelaselvanur',
      type: 'City'
    },
    {
      value: '3728',
      label: 'Keeranur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3729',
      label: 'Keezhapalur',
      type: 'City'
    },
    {
      value: '3730',
      label: 'Keilodhar',
      type: 'City'
    },
    {
      value: '3731',
      label: 'Kekdi',
      type: 'City'
    },
    {
      value: '3732',
      label: 'Kekri',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '3733',
      label: 'Keladevi',
      type: 'City'
    },
    {
      value: '3734',
      label: 'Kelambakkam',
      type: 'City'
    },
    {
      value: '3735',
      label: 'Kelwa',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3736',
      label: 'Kelwad',
      type: 'City'
    },
    {
      value: '3737',
      label: 'Kelwara',
      type: 'City'
    },
    {
      value: '3738',
      label: 'Kenawade Phata',
      type: 'City'
    },
    {
      value: '3739',
      label: 'Kenchiya',
      type: 'City'
    },
    {
      value: '3740',
      label: 'Kendrapara',
      type: 'City'
    },
    {
      value: '3741',
      label: 'Kenedipur',
      type: 'City'
    },
    {
      value: '3742',
      label: 'Kenjoor',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3743',
      label: 'Kenpura',
      type: 'City'
    },
    {
      value: '3744',
      label: 'Kenwad',
      type: 'City'
    },
    {
      value: '3745',
      label: 'Keolari',
      type: 'City'
    },
    {
      value: '3746',
      label: 'Keonjhar',
      type: 'City'
    },
    {
      value: '3747',
      label: 'Kera',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3748',
      label: 'Kerala',
      type: 'City'
    },
    {
      value: '3749',
      label: 'Kerala Potta',
      type: 'City'
    },
    {
      value: '3750',
      label: 'Kerbana',
      type: 'City'
    },
    {
      value: '3751',
      label: 'Kerlapal',
      type: 'City'
    },
    {
      value: '3752',
      label: 'Kerur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3753',
      label: 'Kesali',
      type: 'City'
    },
    {
      value: '3754',
      label: 'Kesanipalli',
      type: 'City'
    },
    {
      value: '3755',
      label: 'Kesargadde',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3756',
      label: 'Kesariya',
      type: 'City'
    },
    {
      value: '3757',
      label: 'Kesariya (Bihar)',
      type: 'City'
    },
    {
      value: '3758',
      label: 'Kesariyaji',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '3759',
      label: 'Kesariyaji Tirth',
      type: 'City'
    },
    {
      value: '3760',
      label: 'Kesavaram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3761',
      label: 'Keshloor',
      type: 'City'
    },
    {
      value: '3762',
      label: 'Keshod',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3763',
      label: 'Keshoraipatan',
      type: 'City'
    },
    {
      value: '3764',
      label: 'Keshori',
      type: 'City'
    },
    {
      value: '3765',
      label: 'Keshvala',
      type: 'City'
    },
    {
      value: '3766',
      label: 'Keshwana',
      type: 'City'
    },
    {
      value: '3767',
      label: 'Kesinga',
      type: 'City'
    },
    {
      value: '3768',
      label: 'Keskal',
      type: 'City'
    },
    {
      value: '3769',
      label: 'Kesrisinghpur',
      type: 'City'
    },
    {
      value: '3770',
      label: 'Kewariya',
      type: 'City'
    },
    {
      value: '3771',
      label: 'Keylong',
      type: 'City'
    },
    {
      value: '3772',
      label: 'Kg Chavadi',
      type: 'City'
    },
    {
      value: '3773',
      label: 'Khabha',
      type: 'City'
    },
    {
      value: '3774',
      label: 'Khachrod',
      type: 'City'
    },
    {
      value: '3775',
      label: 'KhadaDhar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3776',
      label: 'Khadar',
      type: 'City'
    },
    {
      value: '3777',
      label: 'Khadasali',
      type: 'City'
    },
    {
      value: '3778',
      label: 'Khadawada',
      type: 'City'
    },
    {
      value: '3779',
      label: 'Khadgawan',
      type: 'City'
    },
    {
      value: '3780',
      label: 'Khadiya',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3781',
      label: 'Khadka',
      type: 'City'
    },
    {
      value: '3782',
      label: 'Khaga',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '3783',
      label: 'Khagaria',
      type: 'City'
    },
    {
      value: '3784',
      label: 'Khagna',
      type: 'City'
    },
    {
      value: '3785',
      label: 'Khaira',
      type: 'City'
    },
    {
      value: '3786',
      label: 'Khairagarh',
      type: 'City'
    },
    {
      value: '3787',
      label: 'Khajipet',
      type: 'City'
    },
    {
      value: '3788',
      label: 'Khajipeta',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3789',
      label: 'Khajurada',
      type: 'City'
    },
    {
      value: '3790',
      label: 'Khajuraho',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '3791',
      label: 'Khajuri',
      type: 'City'
    },
    {
      value: '3792',
      label: 'Khajuria, Bihar',
      type: 'City'
    },
    {
      value: '3793',
      label: 'Khajuria, UP',
      type: 'City'
    },
    {
      value: '3794',
      label: 'Khajuwala',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '3795',
      label: 'Khakhar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3796',
      label: 'Khakhi Jalia',
      type: 'City'
    },
    {
      value: '3797',
      label: 'Khakhra',
      type: 'City'
    },
    {
      value: '3798',
      label: 'Khakhriya',
      type: 'City'
    },
    {
      value: '3799',
      label: 'Khaknar  Jamuniya',
      type: 'City'
    },
    {
      value: '3800',
      label: 'Khalapur (Imagica)',
      type: 'City'
    },
    {
      value: '3801',
      label: 'Khalghat',
      type: 'City'
    },
    {
      value: '3802',
      label: 'Khali',
      type: 'City'
    },
    {
      value: '3803',
      label: 'Khalilabad',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '3804',
      label: 'Khamadi',
      type: 'City'
    },
    {
      value: '3805',
      label: 'Khambadakone',
      type: 'City'
    },
    {
      value: '3806',
      label: 'Khambha',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3807',
      label: 'Khambha Gir',
      type: 'City'
    },
    {
      value: '3808',
      label: 'Khambhada',
      type: 'City'
    },
    {
      value: '3809',
      label: 'Khambhalia',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3810',
      label: 'Khambhat',
      type: 'City'
    },
    {
      value: '3811',
      label: 'Khamera',
      type: 'City'
    },
    {
      value: '3812',
      label: 'Khamgaon',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3813',
      label: 'Khammam',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3814',
      label: 'Khamnor',
      type: 'City'
    },
    {
      value: '3815',
      label: 'Khamnore',
      type: 'City'
    },
    {
      value: '3816',
      label: 'Khanag',
      type: 'City'
    },
    {
      value: '3817',
      label: 'Khanangad',
      type: 'City'
    },
    {
      value: '3818',
      label: 'Khanapur',
      type: 'City'
    },
    {
      value: '3819',
      label: 'Khanapur (Karnataka)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3820',
      label: 'Khanauri',
      type: 'City'
    },
    {
      value: '3821',
      label: 'Khandala',
      type: 'City'
    },
    {
      value: '3822',
      label: 'Khandala  Lonavala',
      type: 'City'
    },
    {
      value: '3823',
      label: 'Khandala (satara)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3824',
      label: 'Khandap',
      type: 'City'
    },
    {
      value: '3825',
      label: 'Khandela',
      type: 'City'
    },
    {
      value: '3826',
      label: 'Khandhera',
      type: 'City'
    },
    {
      value: '3827',
      label: 'Khandi',
      type: 'City'
    },
    {
      value: '3828',
      label: 'Khandvi',
      type: 'City'
    },
    {
      value: '3829',
      label: 'Khandwa',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '3830',
      label: 'Khaneti',
      type: 'City'
    },
    {
      value: '3831',
      label: 'Khangaon',
      type: 'City'
    },
    {
      value: '3832',
      label: 'Khaniadhana',
      type: 'City'
    },
    {
      value: '3833',
      label: 'Khanna',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '3834',
      label: 'Khanpur',
      type: 'City'
    },
    {
      value: '3835',
      label: 'Khapri',
      type: 'City'
    },
    {
      value: '3836',
      label: 'Khaptiha Kalan',
      type: 'City'
    },
    {
      value: '3837',
      label: 'Khara',
      type: 'City'
    },
    {
      value: '3838',
      label: 'Kharachia',
      type: 'City'
    },
    {
      value: '3839',
      label: 'Kharachiya',
      type: 'City'
    },
    {
      value: '3840',
      label: 'Kharagpur',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '3841',
      label: 'Kharal',
      type: 'City'
    },
    {
      value: '3842',
      label: 'Kharapathar',
      type: 'City'
    },
    {
      value: '3843',
      label: 'Kharar',
      type: 'City'
    },
    {
      value: '3844',
      label: 'Kharda',
      type: 'City'
    },
    {
      value: '3845',
      label: 'Kharedi',
      type: 'City'
    },
    {
      value: '3846',
      label: 'Kharepatan',
      type: 'City'
    },
    {
      value: '3847',
      label: 'Kharepaten',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3848',
      label: 'Khargapur',
      type: 'City'
    },
    {
      value: '3849',
      label: 'Kharghar',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3850',
      label: 'Khargone',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '3851',
      label: 'Kharnal',
      type: 'City'
    },
    {
      value: '3852',
      label: 'Kharod Chatra',
      type: 'City'
    },
    {
      value: '3853',
      label: 'Kharora',
      type: 'City'
    },
    {
      value: '3854',
      label: 'Kharsara',
      type: 'City'
    },
    {
      value: '3855',
      label: 'Kharsundi',
      type: 'City'
    },
    {
      value: '3856',
      label: 'Kharupetia',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '3857',
      label: 'Kharvada',
      type: 'City'
    },
    {
      value: '3858',
      label: 'Kharwandi',
      type: 'City'
    },
    {
      value: '3859',
      label: 'Kharwar',
      type: 'City'
    },
    {
      value: '3860',
      label: 'Khatauli',
      type: 'City'
    },
    {
      value: '3861',
      label: 'Khategaon',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '3862',
      label: 'Khatima',
      type: 'City'
    },
    {
      value: '3863',
      label: 'Khatipudi',
      type: 'City'
    },
    {
      value: '3864',
      label: 'Khatiya',
      type: 'City'
    },
    {
      value: '3865',
      label: 'Khatkiya  Kumbhraj',
      type: 'City'
    },
    {
      value: '3866',
      label: 'Khatoli, Rajasthan',
      type: 'City'
    },
    {
      value: '3867',
      label: 'Khatoli, UP',
      type: 'City'
    },
    {
      value: '3868',
      label: 'Khatraj',
      type: 'City'
    },
    {
      value: '3869',
      label: 'Khatu',
      type: 'City'
    },
    {
      value: '3870',
      label: 'Khatushyamji',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '3871',
      label: 'Khavdi',
      type: 'City'
    },
    {
      value: '3872',
      label: 'Khawasa',
      type: 'City'
    },
    {
      value: '3873',
      label: 'Khed',
      type: 'City'
    },
    {
      value: '3874',
      label: 'Khed (ratnagiri)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3875',
      label: 'Khed Shivapur',
      type: 'City'
    },
    {
      value: '3876',
      label: 'Kheda',
      type: 'City'
    },
    {
      value: '3877',
      label: 'Khedbrahma',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3878',
      label: 'Khejarla',
      type: 'City'
    },
    {
      value: '3879',
      label: 'Khemana',
      type: 'City'
    },
    {
      value: '3880',
      label: 'Khera',
      type: 'City'
    },
    {
      value: '3881',
      label: 'Khera Jassa',
      type: 'City'
    },
    {
      value: '3882',
      label: 'Kheralu',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3883',
      label: 'Kherapa',
      type: 'City'
    },
    {
      value: '3884',
      label: 'Kherdi',
      type: 'City'
    },
    {
      value: '3885',
      label: 'Khergam',
      type: 'City'
    },
    {
      value: '3886',
      label: 'Kheri',
      type: 'City'
    },
    {
      value: '3887',
      label: 'Kheroda',
      type: 'City'
    },
    {
      value: '3888',
      label: 'Kheroj',
      type: 'City'
    },
    {
      value: '3889',
      label: 'Kherva',
      type: 'City'
    },
    {
      value: '3890',
      label: 'Kherwada',
      type: 'City'
    },
    {
      value: '3891',
      label: 'Kherwara',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '3892',
      label: 'Kherwara',
      type: 'City'
    },
    {
      value: '3893',
      label: 'Khetia',
      type: 'City'
    },
    {
      value: '3894',
      label: 'Khetri',
      type: 'City'
    },
    {
      value: '3895',
      label: 'Khicha',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3896',
      label: 'Khijadiya',
      type: 'City'
    },
    {
      value: '3897',
      label: 'Khilavad',
      type: 'City'
    },
    {
      value: '3898',
      label: 'Khilchipur',
      type: 'City'
    },
    {
      value: '3899',
      label: 'Khiloda',
      type: 'City'
    },
    {
      value: '3900',
      label: 'Khimana',
      type: 'City'
    },
    {
      value: '3901',
      label: 'Khimat',
      type: 'City'
    },
    {
      value: '3902',
      label: 'Khimlasa',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '3903',
      label: 'Khimsar',
      type: 'City'
    },
    {
      value: '3904',
      label: 'Khinwara',
      type: 'City'
    },
    {
      value: '3905',
      label: 'Khirasara',
      type: 'City'
    },
    {
      value: '3906',
      label: 'Khirki',
      type: 'City'
    },
    {
      value: '3907',
      label: 'Khisa',
      type: 'City'
    },
    {
      value: '3908',
      label: 'Khisari',
      type: 'City'
    },
    {
      value: '3909',
      label: 'Khodvadari',
      type: 'City'
    },
    {
      value: '3910',
      label: 'Khoksar',
      type: 'City'
    },
    {
      value: '3911',
      label: 'Kholapur',
      type: 'City'
    },
    {
      value: '3912',
      label: 'Khombhadi',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3913',
      label: 'Khoohdi',
      type: 'City'
    },
    {
      value: '3914',
      label: 'Khoor',
      type: 'City'
    },
    {
      value: '3915',
      label: 'Khopa',
      type: 'City'
    },
    {
      value: '3916',
      label: 'Khopala',
      type: 'City'
    },
    {
      value: '3917',
      label: 'Khopoli',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '3918',
      label: 'Khud',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '3919',
      label: 'Khudel',
      type: 'City'
    },
    {
      value: '3920',
      label: 'Khuian Sarwar',
      type: 'City'
    },
    {
      value: '3921',
      label: 'Khuldabad',
      type: 'City'
    },
    {
      value: '3922',
      label: 'Khumanpura',
      type: 'City'
    },
    {
      value: '3923',
      label: 'Khundian',
      type: 'City'
    },
    {
      value: '3924',
      label: 'Khurai',
      type: 'City'
    },
    {
      value: '3925',
      label: 'Khuri',
      type: 'City'
    },
    {
      value: '3926',
      label: 'Khurja',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '3927',
      label: 'Khusal Nagar',
      type: 'City'
    },
    {
      value: '3928',
      label: 'Khutar',
      type: 'City'
    },
    {
      value: '3929',
      label: 'Khutauna',
      type: 'City'
    },
    {
      value: '3930',
      label: 'Kiari',
      type: 'City'
    },
    {
      value: '3931',
      label: 'Kichha',
      type: 'City'
    },
    {
      value: '3932',
      label: 'Kidangoor',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '3933',
      label: 'Kikariya',
      type: 'City'
    },
    {
      value: '3934',
      label: 'Kilakarai',
      type: 'City'
    },
    {
      value: '3935',
      label: 'Kilasevalpatti',
      type: 'City'
    },
    {
      value: '3936',
      label: 'Kilepar',
      type: 'City'
    },
    {
      value: '3937',
      label: 'Kilimanoor',
      type: 'City'
    },
    {
      value: '3938',
      label: 'Killa-Pardi',
      type: 'City'
    },
    {
      value: '3939',
      label: 'Killari',
      type: 'City'
    },
    {
      value: '3940',
      label: 'Kim',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3941',
      label: 'Kinathukadavu',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3942',
      label: 'Kingal',
      type: 'City'
    },
    {
      value: '3943',
      label: 'Kingaon',
      type: 'City'
    },
    {
      value: '3944',
      label: 'Kinnigoli',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3945',
      label: 'Kinwat',
      type: 'City'
    },
    {
      value: '3946',
      label: 'Kir Ki Choki',
      type: 'City'
    },
    {
      value: '3947',
      label: 'Kirara Chhota',
      type: 'City'
    },
    {
      value: '3948',
      label: 'Kiratpur',
      type: 'City'
    },
    {
      value: '3949',
      label: 'Kiratpur Sahib',
      type: 'City'
    },
    {
      value: '3950',
      label: 'Kirawali',
      type: 'City'
    },
    {
      value: '3951',
      label: 'Kirimanjeshwar',
      type: 'City'
    },
    {
      value: '3952',
      label: 'Kirimanjeswar',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '3953',
      label: 'Kirkakani',
      type: 'City'
    },
    {
      value: '3954',
      label: 'Kirnapur',
      type: 'City'
    },
    {
      value: '3955',
      label: 'Kisalpuri',
      type: 'City'
    },
    {
      value: '3956',
      label: 'Kishangadh',
      type: 'City'
    },
    {
      value: '3957',
      label: 'Kishanganj',
      type: 'City'
    },
    {
      value: '3958',
      label: 'Kishanganj',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '3959',
      label: 'Kishanganj, Bihar',
      type: 'City'
    },
    {
      value: '3960',
      label: 'Kishanganj, Rajasthan',
      type: 'City'
    },
    {
      value: '3961',
      label: 'Kishangarh',
      type: 'City'
    },
    {
      value: '3962',
      label: 'Kishangarh Bas',
      type: 'City'
    },
    {
      value: '3963',
      label: 'Kishanghar',
      type: 'City'
    },
    {
      value: '3964',
      label: 'Kishanpur',
      type: 'City'
    },
    {
      value: '3965',
      label: 'Kishanpura',
      type: 'City'
    },
    {
      value: '3966',
      label: 'Kishni',
      type: 'City'
    },
    {
      value: '3967',
      label: 'Kistaram, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '3968',
      label: 'Kistaram, Telangana',
      type: 'City'
    },
    {
      value: '3969',
      label: 'Kittadahal',
      type: 'City'
    },
    {
      value: '3970',
      label: 'Kittur',
      type: 'City'
    },
    {
      value: '3971',
      label: 'Kobadi',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3972',
      label: 'Kochi',
      type: 'City'
    },
    {
      value: '3973',
      label: 'Kodad',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3974',
      label: 'Kodagu',
      type: 'City'
    },
    {
      value: '3975',
      label: 'Kodai Road',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3976',
      label: 'Kodaikanal',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '3977',
      label: 'Kodaipul',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3978',
      label: 'Kodakara',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '3979',
      label: 'Kodali',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3980',
      label: 'Kodali, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '3981',
      label: 'Kodali, Maharashtra',
      type: 'City'
    },
    {
      value: '3982',
      label: 'Kodamanchali',
      type: 'City'
    },
    {
      value: '3983',
      label: 'Kodamanchili',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '3984',
      label: 'Kodamangalam',
      type: 'City'
    },
    {
      value: '3985',
      label: 'Kodangal',
      type: 'City'
    },
    {
      value: '3986',
      label: 'Koday',
      type: 'City'
    },
    {
      value: '3987',
      label: 'Kodenar',
      type: 'City'
    },
    {
      value: '3988',
      label: 'Kodimatha',
      type: 'City'
    },
    {
      value: '3989',
      label: 'Kodinar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '3990',
      label: 'Kodiyalam',
      type: 'City'
    },
    {
      value: '3991',
      label: 'Kodki',
      type: 'City'
    },
    {
      value: '3992',
      label: 'Kodungallur',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '3993',
      label: 'Kodungoor',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '3994',
      label: 'Koduru',
      type: 'City'
    },
    {
      value: '3995',
      label: 'Koduvally',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '3996',
      label: 'Koduvilarpatti',
      type: 'City'
    },
    {
      value: '3997',
      label: 'Koh M peybei',
      type: 'City'
    },
    {
      value: '3998',
      label: 'Koh M peybei (To any resort)',
      type: 'City'
    },
    {
      value: '3999',
      label: 'Koh Rong',
      type: 'City'
    },
    {
      value: '4000',
      label: 'Koh Rong (Any Port)',
      type: 'City'
    },
    {
      value: '4001',
      label: 'Koh Rong (Coconut Beach)',
      type: 'City'
    },
    {
      value: '4002',
      label: 'Koh Rong (Deum Tkov Village)',
      type: 'City'
    },
    {
      value: '4003',
      label: 'Koh Rong (Koh Toch Port)',
      type: 'City'
    },
    {
      value: '4004',
      label: 'Koh Rong (Long Set Beach)',
      type: 'City'
    },
    {
      value: '4005',
      label: 'Koh Rong (Required Port)',
      type: 'City'
    },
    {
      value: '4006',
      label: 'Koh Rong (Roum Dul Beach)',
      type: 'City'
    },
    {
      value: '4007',
      label: 'Koh Rong (Sok San Beach)',
      type: 'City'
    },
    {
      value: '4008',
      label: 'Koh Rong (To any resort)',
      type: 'City'
    },
    {
      value: '4009',
      label: 'Koh Rong (Villager Port)',
      type: 'City'
    },
    {
      value: '4010',
      label: 'Koh Rong (West Side of Island)',
      type: 'City'
    },
    {
      value: '4011',
      label: 'Koh Rong Samloem',
      type: 'City'
    },
    {
      value: '4012',
      label: 'Koh Rong Samloem (23 Port Village)',
      type: 'City'
    },
    {
      value: '4013',
      label: 'Koh Rong Samloem (Any Port)',
      type: 'City'
    },
    {
      value: '4014',
      label: 'Koh Rong Samloem (Driff Wood Port)',
      type: 'City'
    },
    {
      value: '4015',
      label: 'Koh Rong Samloem (Mad Monkey Port)',
      type: 'City'
    },
    {
      value: '4016',
      label: 'Koh Rong Samloem (Saracen Bay Beach Area)',
      type: 'City'
    },
    {
      value: '4017',
      label: 'Koh Rong Samloem (To any resort)',
      type: 'City'
    },
    {
      value: '4018',
      label: 'Koh Rong Samloem (West Side of Island)',
      type: 'City'
    },
    {
      value: '4019',
      label: 'Koh Rong Samloem (West Side of Island, Any Beach)',
      type: 'City'
    },
    {
      value: '4020',
      label: 'Koh Rong Sanloem (Sun Set Beach)',
      type: 'City'
    },
    {
      value: '4021',
      label: 'Koh Rong Sanloem(Required Port)',
      type: 'City'
    },
    {
      value: '4022',
      label: 'Koilkuntla',
      type: 'City'
    },
    {
      value: '4023',
      label: 'Koita',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4024',
      label: 'Kokkarne',
      type: 'City'
    },
    {
      value: '4025',
      label: 'Kokkarne  Kadur',
      type: 'City'
    },
    {
      value: '4026',
      label: 'Kokkarne - Neelavara Road',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4027',
      label: 'Kokodi',
      type: 'City'
    },
    {
      value: '4028',
      label: 'Kokrud',
      type: 'City'
    },
    {
      value: '4029',
      label: 'Kokunala',
      type: 'City'
    },
    {
      value: '4030',
      label: 'Kolachel',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4031',
      label: 'Kolar',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4032',
      label: 'Kolaras',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '4033',
      label: 'Kolathur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4034',
      label: 'Kolayad',
      type: 'City'
    },
    {
      value: '4035',
      label: 'Kolayat',
      type: 'City'
    },
    {
      value: '4036',
      label: 'Kolda',
      type: 'City'
    },
    {
      value: '4037',
      label: 'Kole',
      type: 'City'
    },
    {
      value: '4038',
      label: 'Kolenchery',
      type: 'City'
    },
    {
      value: '4039',
      label: 'Kolgaon',
      type: 'City'
    },
    {
      value: '4040',
      label: 'Kolhapur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4041',
      label: 'Kolhapur Maharashtra',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4042',
      label: 'Kolhapur(Karnataka)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4043',
      label: 'Kolhapur(Maharashtra)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4044',
      label: 'Kolhar',
      type: 'City'
    },
    {
      value: '4045',
      label: 'Kolhar (Ahmednagar)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4046',
      label: 'Kolidam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4047',
      label: 'Kolimigundla',
      type: 'City'
    },
    {
      value: '4048',
      label: 'Koliyadi',
      type: 'City'
    },
    {
      value: '4049',
      label: 'Kolkata',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '4050',
      label: 'Kolkata city tour',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '4051',
      label: 'Kolki',
      type: 'City'
    },
    {
      value: '4052',
      label: 'Kollam',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4053',
      label: 'Kollamkode',
      type: 'City'
    },
    {
      value: '4054',
      label: 'Kollangudi',
      type: 'City'
    },
    {
      value: '4055',
      label: 'Kollankodu',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4056',
      label: 'Kollidam',
      type: 'City'
    },
    {
      value: '4057',
      label: 'Kollipara',
      type: 'City'
    },
    {
      value: '4058',
      label: 'Kollipara (Andhra Pradesh)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4059',
      label: 'Kollumangudi',
      type: 'City'
    },
    {
      value: '4060',
      label: 'Kollur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4061',
      label: 'Kollur  Hyderabad',
      type: 'City'
    },
    {
      value: '4062',
      label: 'Kollur  Mookambika',
      type: 'City'
    },
    {
      value: '4063',
      label: 'Kollur (Mookambika)',
      type: 'City'
    },
    {
      value: '4064',
      label: 'Kollur Mokambike',
      type: 'City'
    },
    {
      value: '4065',
      label: 'Kollur Mookambika Temple',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4066',
      label: 'Kolluru',
      type: 'City'
    },
    {
      value: '4067',
      label: 'Kolluru (Andhra Pradesh)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4068',
      label: 'Koloshi',
      type: 'City'
    },
    {
      value: '4069',
      label: 'Kolwadi',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4070',
      label: 'Komaanapalli',
      type: 'City'
    },
    {
      value: '4071',
      label: 'Komaragiri',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4072',
      label: 'Komaragiripatnam',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4073',
      label: 'Komarolu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4074',
      label: 'Kombai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4075',
      label: 'Kommadikottai',
      type: 'City'
    },
    {
      value: '4076',
      label: 'Kommuru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4077',
      label: 'Konaje',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4078',
      label: 'Konandur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4079',
      label: 'Konanduru',
      type: 'City'
    },
    {
      value: '4080',
      label: 'Konanki',
      type: 'City'
    },
    {
      value: '4081',
      label: 'Konapattu',
      type: 'City'
    },
    {
      value: '4082',
      label: 'Kondagaon',
      type: 'City'
    },
    {
      value: '4083',
      label: 'Kondamanjuluru',
      type: 'City'
    },
    {
      value: '4084',
      label: 'Kondapi',
      type: 'City'
    },
    {
      value: '4085',
      label: 'Kondapuram',
      type: 'City'
    },
    {
      value: '4086',
      label: 'Kondapuram (prakasham dist)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4087',
      label: 'Kondepi',
      type: 'City'
    },
    {
      value: '4088',
      label: 'Konder',
      type: 'City'
    },
    {
      value: '4089',
      label: 'Kondhali',
      type: 'City'
    },
    {
      value: '4090',
      label: 'Kondotty',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4091',
      label: 'Kondye',
      type: 'City'
    },
    {
      value: '4092',
      label: 'Konni',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4093',
      label: 'Konnur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4094',
      label: 'Konnur, Karnataka',
      type: 'City'
    },
    {
      value: '4095',
      label: 'Konnur, Telangana',
      type: 'City'
    },
    {
      value: '4096',
      label: 'Konta',
      type: 'City'
    },
    {
      value: '4097',
      label: 'Koodali',
      type: 'City'
    },
    {
      value: '4098',
      label: 'Koodankulam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4099',
      label: 'Kootampuli',
      type: 'City'
    },
    {
      value: '4100',
      label: 'Koothanallur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4101',
      label: 'Koothattukulam',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4102',
      label: 'Koothatukulam',
      type: 'City'
    },
    {
      value: '4103',
      label: 'Koothuparamba',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4104',
      label: 'Koottanad',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4105',
      label: 'Koovappally',
      type: 'City'
    },
    {
      value: '4106',
      label: 'Kopam',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4107',
      label: 'Kopar Khairane',
      type: 'City'
    },
    {
      value: '4108',
      label: 'Kopargaon',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4109',
      label: 'Koppa',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4110',
      label: 'Koppal',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4111',
      label: 'Kora',
      type: 'City'
    },
    {
      value: '4112',
      label: 'Koradacheri',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4113',
      label: 'Koradi',
      type: 'City'
    },
    {
      value: '4114',
      label: 'Korampallam',
      type: 'City'
    },
    {
      value: '4115',
      label: 'Korampallam  Thoothukudi',
      type: 'City'
    },
    {
      value: '4116',
      label: 'Koraput',
      type: 'City'
    },
    {
      value: '4117',
      label: 'Koratty',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4118',
      label: 'Korba',
      type: 'City'
    },
    {
      value: '4119',
      label: 'Koregaon Bhima',
      type: 'City'
    },
    {
      value: '4120',
      label: 'Korogwe',
      type: 'City'
    },
    {
      value: '4121',
      label: 'Korukollu',
      type: 'City'
    },
    {
      value: '4122',
      label: 'Korukolu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4123',
      label: 'Korutla',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4124',
      label: 'Kosamba',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4125',
      label: 'Kosari',
      type: 'City'
    },
    {
      value: '4126',
      label: 'Koshital',
      type: 'City'
    },
    {
      value: '4127',
      label: 'Koshithal',
      type: 'City'
    },
    {
      value: '4128',
      label: 'Kosi Kalan',
      type: 'City'
    },
    {
      value: '4129',
      label: 'Kot Kapura',
      type: 'City'
    },
    {
      value: '4130',
      label: 'Kota',
      type: 'City'
    },
    {
      value: '4131',
      label: 'Kota(Karnataka)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4132',
      label: 'Kota(Rajasthan)',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '4133',
      label: 'Kota, Karnataka',
      type: 'City'
    },
    {
      value: '4134',
      label: 'Kota, Rajasthan',
      type: 'City'
    },
    {
      value: '4135',
      label: 'Kota, UP',
      type: 'City'
    },
    {
      value: '4136',
      label: 'Kotabommali',
      type: 'City'
    },
    {
      value: '4137',
      label: 'Kotada',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4138',
      label: 'Kotada Jadodar',
      type: 'City'
    },
    {
      value: '4139',
      label: 'Kotada Pitha',
      type: 'City'
    },
    {
      value: '4140',
      label: 'Kotagiri, Tamil Nadu',
      type: 'City'
    },
    {
      value: '4141',
      label: 'Kotagiri, Telangana',
      type: 'City'
    },
    {
      value: '4142',
      label: 'Kotananduru',
      type: 'City'
    },
    {
      value: '4143',
      label: 'Kotapad',
      type: 'City'
    },
    {
      value: '4144',
      label: 'Kotda',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4145',
      label: 'Kotdwar',
      type: 'City'
    },
    {
      value: '4146',
      label: 'Kotdwara',
      type: 'City'
    },
    {
      value: '4147',
      label: 'Koteshwar',
      type: 'City'
    },
    {
      value: '4148',
      label: 'Koteshwara',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4149',
      label: 'Kotgarh',
      type: 'City'
    },
    {
      value: '4150',
      label: 'Kothacheruvu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4151',
      label: 'Kothagudem',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4152',
      label: 'Kothagudem, Telangana',
      type: 'City'
    },
    {
      value: '4153',
      label: 'Kothamangalam',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4154',
      label: 'Kothanalloor',
      type: 'City'
    },
    {
      value: '4155',
      label: 'Kothapalli',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4156',
      label: 'Kothapeta',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4157',
      label: 'Kothapeta, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '4158',
      label: 'Kothapeta, Telangana',
      type: 'City'
    },
    {
      value: '4159',
      label: 'Kothara',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4160',
      label: 'Kothi, Bihar',
      type: 'City'
    },
    {
      value: '4161',
      label: 'Kothi, Himachal Pradesh',
      type: 'City'
    },
    {
      value: '4162',
      label: 'KothPutli',
      type: 'City'
    },
    {
      value: '4163',
      label: 'Kothuru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4164',
      label: 'Koti',
      type: 'City'
    },
    {
      value: '4165',
      label: 'Kotkapura',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '4166',
      label: 'Kotkhai',
      type: 'City'
    },
    {
      value: '4167',
      label: 'Kotla',
      type: 'City'
    },
    {
      value: '4168',
      label: 'Kotli, Himachal Pradesh',
      type: 'City'
    },
    {
      value: '4169',
      label: 'Kotli, Punjab',
      type: 'City'
    },
    {
      value: '4170',
      label: 'Kotlu',
      type: 'City'
    },
    {
      value: '4171',
      label: 'Kotputali',
      type: 'City'
    },
    {
      value: '4172',
      label: 'Kotputli',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '4173',
      label: 'Kotralam Bypass',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4174',
      label: 'Kottaipattinam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4175',
      label: 'Kottaippattinam',
      type: 'City'
    },
    {
      value: '4176',
      label: 'Kottakkal',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4177',
      label: 'Kottampatti',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4178',
      label: 'Kottampatty',
      type: 'City'
    },
    {
      value: '4179',
      label: 'Kottapattinam',
      type: 'City'
    },
    {
      value: '4180',
      label: 'Kottara Chowk  Derebail',
      type: 'City'
    },
    {
      value: '4181',
      label: 'Kottara Chowki',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4182',
      label: 'Kottarakara',
      type: 'City'
    },
    {
      value: '4183',
      label: 'Kottarakkara',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4184',
      label: 'Kottayam',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4185',
      label: 'Kottigehara',
      type: 'City'
    },
    {
      value: '4186',
      label: 'Kottiyoor',
      type: 'City'
    },
    {
      value: '4187',
      label: 'Kotturu',
      type: 'City'
    },
    {
      value: '4188',
      label: 'Kotturu (Andhra Pradesh)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4189',
      label: 'Kotturu, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '4190',
      label: 'Kotturu, Karnataka',
      type: 'City'
    },
    {
      value: '4191',
      label: 'Kotwa',
      type: 'City'
    },
    {
      value: '4192',
      label: 'Kovilangulam',
      type: 'City'
    },
    {
      value: '4193',
      label: 'Kovilpalayam',
      type: 'City'
    },
    {
      value: '4194',
      label: 'Kovilpatti',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4195',
      label: 'KovilPatti Bye Pass',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4196',
      label: 'Kovur',
      type: 'City'
    },
    {
      value: '4197',
      label: 'Kovvur',
      type: 'City'
    },
    {
      value: '4198',
      label: 'Kovvuru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4199',
      label: 'Kovvuru Toll Gate',
      type: 'City'
    },
    {
      value: '4200',
      label: 'Koyalana',
      type: 'City'
    },
    {
      value: '4201',
      label: 'Koyambedu',
      type: 'City'
    },
    {
      value: '4202',
      label: 'Koyembedu',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4203',
      label: 'Koyilandy',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4204',
      label: 'Koylandi',
      type: 'City'
    },
    {
      value: '4205',
      label: 'Koyyalagudem',
      type: 'City'
    },
    {
      value: '4206',
      label: 'Koyyalgudem',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4207',
      label: 'Koyylagudem',
      type: 'City'
    },
    {
      value: '4208',
      label: 'Kozhencherry',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4209',
      label: 'Kozhenchery',
      type: 'City'
    },
    {
      value: '4210',
      label: 'Kozhhikode',
      type: 'City'
    },
    {
      value: '4211',
      label: 'Kozhikode',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4212',
      label: 'Kozhuvanal',
      type: 'City'
    },
    {
      value: '4213',
      label: 'Kr Pete',
      type: 'City'
    },
    {
      value: '4214',
      label: 'Krankach',
      type: 'City'
    },
    {
      value: '4215',
      label: 'Krishna Nagar',
      type: 'City'
    },
    {
      value: '4216',
      label: 'Krishnagadh',
      type: 'City'
    },
    {
      value: '4217',
      label: 'Krishnagiri',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4218',
      label: 'Krishnagiri, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '4219',
      label: 'Krishnagiri, Tamil Nadu',
      type: 'City'
    },
    {
      value: '4220',
      label: 'Krishnagunj',
      type: 'City'
    },
    {
      value: '4221',
      label: 'krishnan Koil',
      type: 'City'
    },
    {
      value: '4222',
      label: 'Krishnan Kovil',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4223',
      label: 'Krishnanagar',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '4224',
      label: 'KrishnanKoil',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4225',
      label: 'Krishnapuram',
      type: 'City'
    },
    {
      value: '4226',
      label: 'Krishnapuram  Sundaranachiapuram',
      type: 'City'
    },
    {
      value: '4227',
      label: 'Krishnarajpete',
      type: 'City'
    },
    {
      value: '4228',
      label: 'Kruthivennu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4229',
      label: 'Kuanthal',
      type: 'City'
    },
    {
      value: '4230',
      label: 'Kuba',
      type: 'City'
    },
    {
      value: '4231',
      label: 'Kubda',
      type: 'City'
    },
    {
      value: '4232',
      label: 'Kuberpur',
      type: 'City'
    },
    {
      value: '4233',
      label: 'Kuchaikote',
      type: 'City'
    },
    {
      value: '4234',
      label: 'Kuchaman',
      type: 'City'
    },
    {
      value: '4235',
      label: 'Kuchaman City',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '4236',
      label: 'Kuchavada',
      type: 'City'
    },
    {
      value: '4237',
      label: 'Kuchera',
      type: 'City'
    },
    {
      value: '4238',
      label: 'Kuchinapudi',
      type: 'City'
    },
    {
      value: '4239',
      label: 'Kuchipudi',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4240',
      label: 'Kudal',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4241',
      label: 'Kudankulam',
      type: 'City'
    },
    {
      value: '4242',
      label: 'Kudatini',
      type: 'City'
    },
    {
      value: '4243',
      label: 'Kudchi',
      type: 'City'
    },
    {
      value: '4244',
      label: 'Kuddu',
      type: 'City'
    },
    {
      value: '4245',
      label: 'Kudra',
      type: 'City'
    },
    {
      value: '4246',
      label: 'Kudukaimatta',
      type: 'City'
    },
    {
      value: '4247',
      label: 'Kudukkimotta',
      type: 'City'
    },
    {
      value: '4248',
      label: 'Kuduremukha',
      type: 'City'
    },
    {
      value: '4249',
      label: 'Kudus',
      type: 'City'
    },
    {
      value: '4250',
      label: 'Kudush',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4251',
      label: 'Kuee',
      type: 'City'
    },
    {
      value: '4252',
      label: 'Kufri',
      type: 'City'
    },
    {
      value: '4253',
      label: 'Kuharwas',
      type: 'City'
    },
    {
      value: '4254',
      label: 'Kukanar',
      type: 'City'
    },
    {
      value: '4255',
      label: 'Kukdeshwar',
      type: 'City'
    },
    {
      value: '4256',
      label: 'Kukke Subramanya',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4257',
      label: 'Kukke Subramanya Rd  Subrahmanya',
      type: 'City'
    },
    {
      value: '4258',
      label: 'Kukma',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4259',
      label: 'Kuknoor',
      type: 'City'
    },
    {
      value: '4260',
      label: 'Kuknur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4261',
      label: 'Kukshi',
      type: 'City'
    },
    {
      value: '4262',
      label: 'Kulai',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4263',
      label: 'Kulai  Mangaluru',
      type: 'City'
    },
    {
      value: '4264',
      label: 'Kulanada',
      type: 'City'
    },
    {
      value: '4265',
      label: 'Kulasekaram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4266',
      label: 'Kulasekarapattinam',
      type: 'City'
    },
    {
      value: '4267',
      label: 'Kulasekharam',
      type: 'City'
    },
    {
      value: '4268',
      label: 'Kulasekharapatnam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4269',
      label: 'Kulathur',
      type: 'City'
    },
    {
      value: '4270',
      label: 'Kulgeri',
      type: 'City'
    },
    {
      value: '4271',
      label: 'Kulgeri Cross',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4272',
      label: 'Kulithalai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4273',
      label: 'Kullu',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '4274',
      label: 'Kulpahar',
      type: 'City'
    },
    {
      value: '4275',
      label: 'Kulur',
      type: 'City'
    },
    {
      value: '4276',
      label: 'Kulur  Panambur',
      type: 'City'
    },
    {
      value: '4277',
      label: 'Kulur(Karnataka)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4278',
      label: 'Kumarapalayam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4279',
      label: 'Kumarghat',
      type: 'City'
    },
    {
      value: '4280',
      label: 'Kumarhatti',
      type: 'City'
    },
    {
      value: '4281',
      label: 'Kumarsain',
      type: 'City'
    },
    {
      value: '4282',
      label: 'Kumbakonam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4283',
      label: 'Kumbala',
      type: 'City'
    },
    {
      value: '4284',
      label: 'Kumbale',
      type: 'City'
    },
    {
      value: '4285',
      label: 'Kumbanad',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4286',
      label: 'Kumbashi',
      type: 'City'
    },
    {
      value: '4287',
      label: 'Kumbashi Anegudde',
      type: 'City'
    },
    {
      value: '4288',
      label: 'Kumbhalmer',
      type: 'City'
    },
    {
      value: '4289',
      label: 'Kumbhariya',
      type: 'City'
    },
    {
      value: '4290',
      label: 'Kumbhasan',
      type: 'City'
    },
    {
      value: '4291',
      label: 'Kumbhashi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4292',
      label: 'Kumbla',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4293',
      label: 'Kumbla (Kumble)',
      type: 'City'
    },
    {
      value: '4294',
      label: 'Kumble',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4295',
      label: 'Kumhari',
      type: 'City'
    },
    {
      value: '4296',
      label: 'Kumher',
      type: 'City'
    },
    {
      value: '4297',
      label: 'Kumily',
      type: 'City'
    },
    {
      value: '4298',
      label: 'Kumily (Kerala)',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4299',
      label: 'Kumily (Tamil Nadu)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4300',
      label: 'Kumragod',
      type: 'City'
    },
    {
      value: '4301',
      label: 'Kumta',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4302',
      label: 'Kumuli  Sirunagar',
      type: 'City'
    },
    {
      value: '4303',
      label: 'Kumuly',
      type: 'City'
    },
    {
      value: '4304',
      label: 'Kumuly / Thekkady',
      type: 'City'
    },
    {
      value: '4305',
      label: 'Kunda',
      type: 'City'
    },
    {
      value: '4306',
      label: 'Kundal Rd',
      type: 'City'
    },
    {
      value: '4307',
      label: 'Kundal, Gujarat',
      type: 'City'
    },
    {
      value: '4308',
      label: 'Kundal, Rajasthan',
      type: 'City'
    },
    {
      value: '4309',
      label: 'Kundaldham',
      type: 'City'
    },
    {
      value: '4310',
      label: 'Kundalpur',
      type: 'City'
    },
    {
      value: '4311',
      label: 'Kundapur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4312',
      label: 'Kundapura',
      type: 'City'
    },
    {
      value: '4313',
      label: 'Kundara',
      type: 'City'
    },
    {
      value: '4314',
      label: 'Kundheli',
      type: 'City'
    },
    {
      value: '4315',
      label: 'Kundrakudi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4316',
      label: 'Kunigal',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4317',
      label: 'Kunihar',
      type: 'City'
    },
    {
      value: '4318',
      label: 'Kunjalu',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4319',
      label: 'Kunjwani',
      type: 'City'
    },
    {
      value: '4320',
      label: 'Kunkavav',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4321',
      label: 'Kunkeshwar',
      type: 'City'
    },
    {
      value: '4322',
      label: 'Kunkuri',
      type: 'City'
    },
    {
      value: '4323',
      label: 'Kunnakudi',
      type: 'City'
    },
    {
      value: '4324',
      label: 'Kunnam',
      type: 'City'
    },
    {
      value: '4325',
      label: 'Kunnamangalam',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4326',
      label: 'KunnamKulam',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4327',
      label: 'Kunnivalue',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4328',
      label: 'Kunvara',
      type: 'City'
    },
    {
      value: '4329',
      label: 'Kunwariya',
      type: 'City'
    },
    {
      value: '4330',
      label: 'Kunwariya (Gujarat)',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4331',
      label: 'Kuppali',
      type: 'City'
    },
    {
      value: '4332',
      label: 'Kuppam',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4333',
      label: 'Kupvi',
      type: 'City'
    },
    {
      value: '4334',
      label: 'Kurai',
      type: 'City'
    },
    {
      value: '4335',
      label: 'Kuraj',
      type: 'City'
    },
    {
      value: '4336',
      label: 'Kurali, HR',
      type: 'City'
    },
    {
      value: '4337',
      label: 'Kurali, Punjab',
      type: 'City'
    },
    {
      value: '4338',
      label: 'Kurara',
      type: 'City'
    },
    {
      value: '4339',
      label: 'Kuravalangad',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4340',
      label: 'Kuravilagad',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4341',
      label: 'Kuravilangad',
      type: 'City'
    },
    {
      value: '4342',
      label: 'Kurawad',
      type: 'City'
    },
    {
      value: '4343',
      label: 'Kurduwadi',
      type: 'City'
    },
    {
      value: '4344',
      label: 'Kurellagudem',
      type: 'City'
    },
    {
      value: '4345',
      label: 'Kurgaon',
      type: 'City'
    },
    {
      value: '4346',
      label: 'Kurha Panache',
      type: 'City'
    },
    {
      value: '4347',
      label: 'Kurichedu',
      type: 'City'
    },
    {
      value: '4348',
      label: 'Kurkumbh',
      type: 'City'
    },
    {
      value: '4349',
      label: 'Kurla (Raigad)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4350',
      label: 'Kurnool',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4351',
      label: 'Kurnool Byepass',
      type: 'City'
    },
    {
      value: '4352',
      label: 'Kurud',
      type: 'City'
    },
    {
      value: '4353',
      label: 'Kurugodu',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4354',
      label: 'Kurukkal patti',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4355',
      label: 'Kurukku Salai',
      type: 'City'
    },
    {
      value: '4356',
      label: 'Kurukkuchalai',
      type: 'City'
    },
    {
      value: '4357',
      label: 'Kurukshetra',
      type: 'City',
      'state': 'Haryana'
    },
    {
      value: '4358',
      label: 'Kurumbur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4359',
      label: 'Kurundwad',
      type: 'City'
    },
    {
      value: '4360',
      label: 'Kuruppampady',
      type: 'City'
    },
    {
      value: '4361',
      label: 'Kuruppanthara',
      type: 'City'
    },
    {
      value: '4362',
      label: 'Kurupumthara',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4363',
      label: 'Kuruvilangad',
      type: 'City'
    },
    {
      value: '4364',
      label: 'Kuruvilangadu',
      type: 'City'
    },
    {
      value: '4365',
      label: 'Kurwai',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '4366',
      label: 'Kuseep',
      type: 'City'
    },
    {
      value: '4367',
      label: 'Kushal Nagar',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4368',
      label: 'Kushalgarh',
      type: 'City'
    },
    {
      value: '4369',
      label: 'Kushalnagar',
      type: 'City'
    },
    {
      value: '4370',
      label: 'Kushinagar',
      type: 'City'
    },
    {
      value: '4371',
      label: 'Kushinagar (UP)',
      type: 'City'
    },
    {
      value: '4372',
      label: 'Kushtagi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4373',
      label: 'Kushtagi (Bypass)',
      type: 'City'
    },
    {
      value: '4374',
      label: 'Kushtagi Bypass',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4375',
      label: 'Kusmara',
      type: 'City'
    },
    {
      value: '4376',
      label: 'Kusmi',
      type: 'City'
    },
    {
      value: '4377',
      label: 'Kusumbe',
      type: 'City'
    },
    {
      value: '4378',
      label: 'Kutangan',
      type: 'City'
    },
    {
      value: '4379',
      label: 'Kuthenkuly',
      type: 'City'
    },
    {
      value: '4380',
      label: 'Kuthera',
      type: 'City'
    },
    {
      value: '4381',
      label: 'Kuthuparamba',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4382',
      label: 'Kutiyana',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4383',
      label: 'Kutiyana Bypass',
      type: 'City'
    },
    {
      value: '4384',
      label: 'Kutta',
      type: 'City'
    },
    {
      value: '4385',
      label: 'Kuttalam',
      type: 'City'
    },
    {
      value: '4386',
      label: 'Kuttanad',
      type: 'City'
    },
    {
      value: '4387',
      label: 'Kuttattukulam',
      type: 'City'
    },
    {
      value: '4388',
      label: 'Kuttiady',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4389',
      label: 'Kuttikkanam',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4390',
      label: 'Kuttippuram',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4391',
      label: 'Kutuparamba',
      type: 'City'
    },
    {
      value: '4392',
      label: 'Kuvadva',
      type: 'City'
    },
    {
      value: '4393',
      label: 'Kuwaria',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '4394',
      label: 'Kuzhithurai',
      type: 'City'
    },
    {
      value: '4395',
      label: 'L.N. Puram',
      type: 'City'
    },
    {
      value: '4396',
      label: 'La Calera',
      type: 'City'
    },
    {
      value: '4397',
      label: 'La Cruz',
      type: 'City'
    },
    {
      value: '4398',
      label: 'LA ESTRELLA',
      type: 'City'
    },
    {
      value: '4399',
      label: 'La Paz',
      type: 'City'
    },
    {
      value: '4400',
      label: 'La Plata',
      type: 'City'
    },
    {
      value: '4401',
      label: 'La Rioja',
      type: 'City'
    },
    {
      value: '4402',
      label: 'La Serena',
      type: 'City'
    },
    {
      value: '4403',
      label: 'Laboulaye',
      type: 'City'
    },
    {
      value: '4404',
      label: 'LABRANZA',
      type: 'City'
    },
    {
      value: '4405',
      label: 'Lad Karanja',
      type: 'City'
    },
    {
      value: '4406',
      label: 'Ladnu',
      type: 'City'
    },
    {
      value: '4407',
      label: 'Ladnun',
      type: 'City'
    },
    {
      value: '4408',
      label: 'Ladpura',
      type: 'City'
    },
    {
      value: '4409',
      label: 'Ladraur',
      type: 'City'
    },
    {
      value: '4410',
      label: 'Ladugaon',
      type: 'City'
    },
    {
      value: '4411',
      label: 'Lagos',
      type: 'City'
    },
    {
      value: '4412',
      label: 'Lahar',
      type: 'City'
    },
    {
      value: '4413',
      label: 'Lahru',
      type: 'City'
    },
    {
      value: '4414',
      label: 'Lailunga',
      type: 'City'
    },
    {
      value: '4415',
      label: 'Lakadia',
      type: 'City'
    },
    {
      value: '4416',
      label: 'Lakhan Pur',
      type: 'City'
    },
    {
      value: '4417',
      label: 'Lakhandur',
      type: 'City'
    },
    {
      value: '4418',
      label: 'Lakhani',
      type: 'City'
    },
    {
      value: '4419',
      label: 'Lakhani Bypass',
      type: 'City'
    },
    {
      value: '4420',
      label: 'Lakhanka',
      type: 'City'
    },
    {
      value: '4421',
      label: 'Lakhanpur, Chhattisgarh',
      type: 'City'
    },
    {
      value: '4422',
      label: 'Lakhanpur, Jammu And Kashmir',
      type: 'City'
    },
    {
      value: '4423',
      label: 'Lakhanpur, Punjab',
      type: 'City'
    },
    {
      value: '4424',
      label: 'Lakhanpuri',
      type: 'City'
    },
    {
      value: '4425',
      label: 'Lakhapadar',
      type: 'City'
    },
    {
      value: '4426',
      label: 'Lakheri',
      type: 'City'
    },
    {
      value: '4427',
      label: 'Lakhimpur',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '4428',
      label: 'Lakhiyani',
      type: 'City'
    },
    {
      value: '4429',
      label: 'Lakhmapur',
      type: 'City'
    },
    {
      value: '4430',
      label: 'Lakhnadon',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '4431',
      label: 'Lakhni',
      type: 'City'
    },
    {
      value: '4432',
      label: 'Lakhoosar',
      type: 'City'
    },
    {
      value: '4433',
      label: 'Lakkar Bazar  Shimla',
      type: 'City'
    },
    {
      value: '4434',
      label: 'Lakkavaram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4435',
      label: 'Lakkidi  Kunnathidavaka',
      type: 'City'
    },
    {
      value: '4436',
      label: 'Lakkireddipalli',
      type: 'City'
    },
    {
      value: '4437',
      label: 'Lakkireddypalli',
      type: 'City'
    },
    {
      value: '4438',
      label: 'Lakshettipet',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4439',
      label: 'Lakshmangudi',
      type: 'City'
    },
    {
      value: '4440',
      label: 'Lakshmangudi  Koothanallur',
      type: 'City'
    },
    {
      value: '4441',
      label: 'Lakshmankudi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4442',
      label: 'Lakshmipuram',
      type: 'City'
    },
    {
      value: '4443',
      label: 'Lalapur',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '4444',
      label: 'Lalauli',
      type: 'City'
    },
    {
      value: '4445',
      label: 'Lalavadar',
      type: 'City'
    },
    {
      value: '4446',
      label: 'Lalbarra',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '4447',
      label: 'Lalganj, Bihar',
      type: 'City'
    },
    {
      value: '4448',
      label: 'Lalganj, UP',
      type: 'City'
    },
    {
      value: '4449',
      label: 'Lalgarh',
      type: 'City'
    },
    {
      value: '4450',
      label: 'Lalgudi',
      type: 'City'
    },
    {
      value: '4451',
      label: 'Lalitpur',
      type: 'City'
    },
    {
      value: '4452',
      label: 'Lalitpur(UP)',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '4453',
      label: 'Lalkuan',
      type: 'City'
    },
    {
      value: '4454',
      label: 'Lalpur Jamnagar',
      type: 'City'
    },
    {
      value: '4455',
      label: 'Lalpur Junagadh',
      type: 'City'
    },
    {
      value: '4456',
      label: 'Lalpur(Gujarat)',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4457',
      label: 'Lalru',
      type: 'City'
    },
    {
      value: '4458',
      label: 'Lalsot',
      type: 'City'
    },
    {
      value: '4459',
      label: 'Laluk',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '4460',
      label: 'Lam',
      type: 'City'
    },
    {
      value: '4461',
      label: 'Lamahi',
      type: 'City'
    },
    {
      value: '4462',
      label: 'Lamba',
      type: 'City'
    },
    {
      value: '4463',
      label: 'Lamba Dabra',
      type: 'City'
    },
    {
      value: '4464',
      label: 'Lambagaon',
      type: 'City'
    },
    {
      value: '4465',
      label: 'Lambhua',
      type: 'City'
    },
    {
      value: '4466',
      label: 'Lambiya',
      type: 'City'
    },
    {
      value: '4467',
      label: 'Lamblu',
      type: 'City'
    },
    {
      value: '4468',
      label: 'Lamjana',
      type: 'City'
    },
    {
      value: '4469',
      label: 'Lamjana (Latur)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4470',
      label: 'Lamta',
      type: 'City'
    },
    {
      value: '4471',
      label: 'LANCO',
      type: 'City'
    },
    {
      value: '4472',
      label: 'Landgewadi',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4473',
      label: 'Langhanaj',
      type: 'City'
    },
    {
      value: '4474',
      label: 'Langna',
      type: 'City'
    },
    {
      value: '4475',
      label: 'Lanja',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4476',
      label: 'Lanja, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '4477',
      label: 'Lanja, Maharashtra',
      type: 'City'
    },
    {
      value: '4478',
      label: 'Lanjhi',
      type: 'City'
    },
    {
      value: '4479',
      label: 'Lanjoda',
      type: 'City'
    },
    {
      value: '4480',
      label: 'Lankala Koderu',
      type: 'City'
    },
    {
      value: '4481',
      label: 'Lankalakoderu',
      type: 'City'
    },
    {
      value: '4482',
      label: 'Lankapalli, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '4483',
      label: 'Lankapalli, Telangana',
      type: 'City'
    },
    {
      value: '4484',
      label: 'Lanva',
      type: 'City'
    },
    {
      value: '4485',
      label: 'Lapaliya',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4486',
      label: 'Lapania',
      type: 'City'
    },
    {
      value: '4487',
      label: 'Lapsya',
      type: 'City'
    },
    {
      value: '4488',
      label: 'Largi',
      type: 'City'
    },
    {
      value: '4489',
      label: 'LAS DAMAS',
      type: 'City'
    },
    {
      value: '4490',
      label: 'Lasadiya',
      type: 'City'
    },
    {
      value: '4491',
      label: 'Lasalgaon',
      type: 'City'
    },
    {
      value: '4492',
      label: 'Lasani',
      type: 'City'
    },
    {
      value: '4493',
      label: 'Lasur',
      type: 'City'
    },
    {
      value: '4494',
      label: 'Lateri',
      type: 'City'
    },
    {
      value: '4495',
      label: 'Latghat',
      type: 'City'
    },
    {
      value: '4496',
      label: 'Lath',
      type: 'City'
    },
    {
      value: '4497',
      label: 'Lathi(Gujarat)',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4498',
      label: 'Lathi, Gujarat',
      type: 'City'
    },
    {
      value: '4499',
      label: 'Lathi, Rajasthan',
      type: 'City'
    },
    {
      value: '4500',
      label: 'Lathiani',
      type: 'City'
    },
    {
      value: '4501',
      label: 'Lathidad',
      type: 'City'
    },
    {
      value: '4502',
      label: 'Latur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4503',
      label: 'Laukaha',
      type: 'City'
    },
    {
      value: '4504',
      label: 'Laungani',
      type: 'City'
    },
    {
      value: '4505',
      label: 'LAUTARO',
      type: 'City'
    },
    {
      value: '4506',
      label: 'Lavale Phata',
      type: 'City'
    },
    {
      value: '4507',
      label: 'Lavasa',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4508',
      label: 'Lavhala',
      type: 'City'
    },
    {
      value: '4509',
      label: 'Lavkush Nagar',
      type: 'City'
    },
    {
      value: '4510',
      label: 'Laxmangarh',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '4511',
      label: 'Laxmanpur',
      type: 'City'
    },
    {
      value: '4512',
      label: 'Laxmeshwar',
      type: 'City'
    },
    {
      value: '4513',
      label: 'Laxmeswar',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4514',
      label: 'Laxminarsupeta',
      type: 'City'
    },
    {
      value: '4515',
      label: 'Layja Nana',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4516',
      label: 'Lca (Lca Peru)',
      type: 'City'
    },
    {
      value: '4517',
      label: 'Lebad',
      type: 'City'
    },
    {
      value: '4518',
      label: 'Leh',
      type: 'City'
    },
    {
      value: '4519',
      label: 'Leta',
      type: 'City'
    },
    {
      value: '4520',
      label: 'LICANRAY',
      type: 'City'
    },
    {
      value: '4521',
      label: 'Lilakha',
      type: 'City'
    },
    {
      value: '4522',
      label: 'Lilapur',
      type: 'City'
    },
    {
      value: '4523',
      label: 'Liliya',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4524',
      label: 'Liliya Mota',
      type: 'City'
    },
    {
      value: '4525',
      label: 'Lima La Victoria',
      type: 'City'
    },
    {
      value: '4526',
      label: 'Lima Lince',
      type: 'City'
    },
    {
      value: '4527',
      label: 'Lima Plaza Norte',
      type: 'City'
    },
    {
      value: '4528',
      label: 'Limabde',
      type: 'City'
    },
    {
      value: '4529',
      label: 'Limadiya',
      type: 'City'
    },
    {
      value: '4530',
      label: 'Limba Ganesh',
      type: 'City'
    },
    {
      value: '4531',
      label: 'Limbada',
      type: 'City'
    },
    {
      value: '4532',
      label: 'Limbadi',
      type: 'City'
    },
    {
      value: '4533',
      label: 'Limbadi to Hadala road',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4534',
      label: 'Limbala',
      type: 'City'
    },
    {
      value: '4535',
      label: 'Limbdi',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4536',
      label: 'Limda',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4537',
      label: 'Limda  Hanubhana',
      type: 'City'
    },
    {
      value: '4538',
      label: 'Limdi',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4539',
      label: 'Limkheda',
      type: 'City'
    },
    {
      value: '4540',
      label: 'Linares',
      type: 'City'
    },
    {
      value: '4541',
      label: 'Lincoln',
      type: 'City'
    },
    {
      value: '4542',
      label: 'Lingasoor',
      type: 'City'
    },
    {
      value: '4543',
      label: 'Lingasugur',
      type: 'City'
    },
    {
      value: '4544',
      label: 'Lingsugur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4545',
      label: 'LITUECHE',
      type: 'City'
    },
    {
      value: '4546',
      label: 'LLIFEN',
      type: 'City'
    },
    {
      value: '4547',
      label: 'Loaj',
      type: 'City'
    },
    {
      value: '4548',
      label: 'Local City Tour',
      type: 'City'
    },
    {
      value: '4549',
      label: 'Lodam',
      type: 'City'
    },
    {
      value: '4550',
      label: 'Lodga',
      type: 'City'
    },
    {
      value: '4551',
      label: 'Lodha Palava',
      type: 'City'
    },
    {
      value: '4552',
      label: 'Lodhikheda',
      type: 'City'
    },
    {
      value: '4553',
      label: 'Lodhwa',
      type: 'City'
    },
    {
      value: '4554',
      label: 'Loej',
      type: 'City'
    },
    {
      value: '4555',
      label: 'Loha',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4556',
      label: 'Lohandiguda',
      type: 'City'
    },
    {
      value: '4557',
      label: 'Lohara',
      type: 'City'
    },
    {
      value: '4558',
      label: 'Lohari',
      type: 'City'
    },
    {
      value: '4559',
      label: 'Lohariya',
      type: 'City'
    },
    {
      value: '4560',
      label: 'Loharu',
      type: 'City'
    },
    {
      value: '4561',
      label: 'Lohawat',
      type: 'City'
    },
    {
      value: '4562',
      label: 'Lohraiya',
      type: 'City'
    },
    {
      value: '4563',
      label: 'Lokapur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4564',
      label: 'Lokhpur',
      type: 'City'
    },
    {
      value: '4565',
      label: 'Lolasur',
      type: 'City'
    },
    {
      value: '4566',
      label: 'Lolla',
      type: 'City'
    },
    {
      value: '4567',
      label: 'LOLOL',
      type: 'City'
    },
    {
      value: '4568',
      label: 'Lonagatla',
      type: 'City'
    },
    {
      value: '4569',
      label: 'Lonand',
      type: 'City'
    },
    {
      value: '4570',
      label: 'Lonar',
      type: 'City'
    },
    {
      value: '4571',
      label: 'Lonavala',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4572',
      label: 'Lonavla',
      type: 'City'
    },
    {
      value: '4573',
      label: 'LONCOCHE',
      type: 'City'
    },
    {
      value: '4574',
      label: 'Longadi',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4575',
      label: 'LONGAVI',
      type: 'City'
    },
    {
      value: '4576',
      label: 'Loni (Ahmednagar)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4577',
      label: 'Loni, MP',
      type: 'City'
    },
    {
      value: '4578',
      label: 'Loni, Maharashtra',
      type: 'City'
    },
    {
      value: '4579',
      label: 'LONQUIMAY',
      type: 'City'
    },
    {
      value: '4580',
      label: 'Loor',
      type: 'City'
    },
    {
      value: '4581',
      label: 'Los Andes',
      type: 'City'
    },
    {
      value: '4582',
      label: 'LOS ANGELES',
      type: 'City'
    },
    {
      value: '4583',
      label: 'Losal',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '4584',
      label: 'Losing',
      type: 'City'
    },
    {
      value: '4585',
      label: 'Lote',
      type: 'City'
    },
    {
      value: '4586',
      label: 'Loyanga',
      type: 'City'
    },
    {
      value: '4587',
      label: 'Lucknow',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '4588',
      label: 'Ludeg',
      type: 'City'
    },
    {
      value: '4589',
      label: 'Ludhiana',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '4590',
      label: 'Ludrada',
      type: 'City'
    },
    {
      value: '4591',
      label: 'Luhari',
      type: 'City'
    },
    {
      value: '4592',
      label: 'Luhariya',
      type: 'City'
    },
    {
      value: '4593',
      label: 'Lukwasa',
      type: 'City'
    },
    {
      value: '4594',
      label: 'Lunawada',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4595',
      label: 'Lunghia',
      type: 'City'
    },
    {
      value: '4596',
      label: 'Lunidhar',
      type: 'City'
    },
    {
      value: '4597',
      label: 'Lunkaransar',
      type: 'City'
    },
    {
      value: '4598',
      label: 'Lunki',
      type: 'City'
    },
    {
      value: '4599',
      label: 'Lunsapur',
      type: 'City'
    },
    {
      value: '4600',
      label: 'Luvara',
      type: 'City'
    },
    {
      value: '4601',
      label: 'Luvariya',
      type: 'City'
    },
    {
      value: '4602',
      label: 'Luxettipet',
      type: 'City'
    },
    {
      value: '4603',
      label: 'M V79 Malkangiri',
      type: 'City'
    },
    {
      value: '4604',
      label: 'M.Cheruvu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4605',
      label: 'M.Rediapatti',
      type: 'City'
    },
    {
      value: '4606',
      label: 'Maanamadurai',
      type: 'City'
    },
    {
      value: '4607',
      label: 'Maanikonda',
      type: 'City'
    },
    {
      value: '4608',
      label: 'Mabukala',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4609',
      label: 'Mabukala  Hungarcutta',
      type: 'City'
    },
    {
      value: '4610',
      label: 'Machagai',
      type: 'City'
    },
    {
      value: '4611',
      label: 'Machalpur',
      type: 'City'
    },
    {
      value: '4612',
      label: 'Machavaram',
      type: 'City'
    },
    {
      value: '4613',
      label: 'Machavaram (andhra pradesh)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4614',
      label: 'Machavaram, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '4615',
      label: 'Machavaram, Telangana',
      type: 'City'
    },
    {
      value: '4616',
      label: 'Macherla',
      type: 'City'
    },
    {
      value: '4617',
      label: 'Macherla (andhra pradesh)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4618',
      label: 'Machhali Shahar',
      type: 'City'
    },
    {
      value: '4619',
      label: 'Machhaliya',
      type: 'City'
    },
    {
      value: '4620',
      label: 'Machial',
      type: 'City'
    },
    {
      value: '4621',
      label: 'Machilipatnam',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4622',
      label: 'Machiyala',
      type: 'City'
    },
    {
      value: '4623',
      label: 'Mada',
      type: 'City'
    },
    {
      value: '4624',
      label: 'Madagupatti',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4625',
      label: 'Madalmohi',
      type: 'City'
    },
    {
      value: '4626',
      label: 'Madana',
      type: 'City'
    },
    {
      value: '4627',
      label: 'Madanapalle',
      type: 'City'
    },
    {
      value: '4628',
      label: 'Madanapalli',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4629',
      label: 'Madangeri',
      type: 'City'
    },
    {
      value: '4630',
      label: 'Madariya',
      type: 'City'
    },
    {
      value: '4631',
      label: 'Madathukulam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4632',
      label: 'Madawara',
      type: 'City'
    },
    {
      value: '4633',
      label: 'Maddulur',
      type: 'City'
    },
    {
      value: '4634',
      label: 'Madduru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4635',
      label: 'Madgaon',
      type: 'City'
    },
    {
      value: '4636',
      label: 'Madha',
      type: 'City'
    },
    {
      value: '4637',
      label: 'Madhapar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4638',
      label: 'Madhapar',
      type: 'City'
    },
    {
      value: '4639',
      label: 'Madhav Nagar  Manipal',
      type: 'City'
    },
    {
      value: '4640',
      label: 'Madhavapatnam',
      type: 'City'
    },
    {
      value: '4641',
      label: 'Madhavaram',
      type: 'City'
    },
    {
      value: '4642',
      label: 'Madhavpur',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4643',
      label: 'Madhavpur(Gad)',
      type: 'City'
    },
    {
      value: '4644',
      label: 'Madhepura',
      type: 'City'
    },
    {
      value: '4645',
      label: 'Madhi',
      type: 'City'
    },
    {
      value: '4646',
      label: 'Madhogarh',
      type: 'City'
    },
    {
      value: '4647',
      label: 'Madhopur',
      type: 'City'
    },
    {
      value: '4648',
      label: 'Madhuban',
      type: 'City'
    },
    {
      value: '4649',
      label: 'Madhubani',
      type: 'City'
    },
    {
      value: '4650',
      label: 'Madhupur',
      type: 'City'
    },
    {
      value: '4651',
      label: 'Madhuvana',
      type: 'City'
    },
    {
      value: '4652',
      label: 'Madia',
      type: 'City'
    },
    {
      value: '4653',
      label: 'Madigubba',
      type: 'City'
    },
    {
      value: '4654',
      label: 'Madikeri',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4655',
      label: 'Madikeri',
      type: 'City'
    },
    {
      value: '4656',
      label: 'Madilage',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4657',
      label: 'Madras',
      type: 'City'
    },
    {
      value: '4658',
      label: 'Madri',
      type: 'City'
    },
    {
      value: '4659',
      label: 'Madukkur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4660',
      label: 'Madurai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4661',
      label: 'Madurai Bye pass',
      type: 'City'
    },
    {
      value: '4662',
      label: 'MAFIL',
      type: 'City'
    },
    {
      value: '4663',
      label: 'Magaon',
      type: 'City'
    },
    {
      value: '4664',
      label: 'Magriwada',
      type: 'City'
    },
    {
      value: '4665',
      label: 'Magron',
      type: 'City'
    },
    {
      value: '4666',
      label: 'Magroni',
      type: 'City'
    },
    {
      value: '4667',
      label: 'Mahabaleshwar',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4668',
      label: 'Mahabalipuram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4669',
      label: 'Mahabubnagar',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4670',
      label: 'Mahad',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4671',
      label: 'Mahagaon',
      type: 'City'
    },
    {
      value: '4672',
      label: 'Mahagaon, Maharashtra',
      type: 'City'
    },
    {
      value: '4673',
      label: 'Mahagaon, Telangana',
      type: 'City'
    },
    {
      value: '4674',
      label: 'Mahajan',
      type: 'City'
    },
    {
      value: '4675',
      label: 'Mahakaal',
      type: 'City'
    },
    {
      value: '4676',
      label: 'Mahal',
      type: 'City'
    },
    {
      value: '4677',
      label: 'Mahalingapur',
      type: 'City'
    },
    {
      value: '4678',
      label: 'Mahalingpur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4679',
      label: 'Maharajapuram',
      type: 'City'
    },
    {
      value: '4680',
      label: 'Maharajganj',
      type: 'City'
    },
    {
      value: '4681',
      label: 'Maharajpur',
      type: 'City'
    },
    {
      value: '4682',
      label: 'Maharana',
      type: 'City'
    },
    {
      value: '4683',
      label: 'Mahbubnagar',
      type: 'City'
    },
    {
      value: '4684',
      label: 'Mahdeiya Bazar',
      type: 'City'
    },
    {
      value: '4685',
      label: 'Mahe',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4686',
      label: 'Mahendra',
      type: 'City'
    },
    {
      value: '4687',
      label: 'Mahendragarh',
      type: 'City'
    },
    {
      value: '4688',
      label: 'Mahendranagar(Nepal)',
      type: 'City'
    },
    {
      value: '4689',
      label: 'Mahesana',
      type: 'City'
    },
    {
      value: '4690',
      label: 'Maheshwar',
      type: 'City'
    },
    {
      value: '4691',
      label: 'Mahidpur',
      type: 'City'
    },
    {
      value: '4692',
      label: 'Mahilpur',
      type: 'City'
    },
    {
      value: '4693',
      label: 'Mahipala Cheruvu',
      type: 'City'
    },
    {
      value: '4694',
      label: 'Mahipalacheruvu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4695',
      label: 'Mahlan',
      type: 'City'
    },
    {
      value: '4696',
      label: 'Mahnar',
      type: 'City'
    },
    {
      value: '4697',
      label: 'Mahoba',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '4698',
      label: 'Mahora',
      type: 'City'
    },
    {
      value: '4699',
      label: 'Mahrauni',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '4700',
      label: 'Mahud',
      type: 'City'
    },
    {
      value: '4701',
      label: 'Mahudha',
      type: 'City'
    },
    {
      value: '4702',
      label: 'Mahudi',
      type: 'City'
    },
    {
      value: '4703',
      label: 'Mahurgad',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '4704',
      label: 'Mahuva',
      type: 'City'
    },
    {
      value: '4705',
      label: 'Mahuva Rj',
      type: 'City'
    },
    {
      value: '4706',
      label: 'Mahuva(Gujarat)',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4707',
      label: 'Mahwa',
      type: 'City'
    },
    {
      value: '4708',
      label: 'Mahwa (RJ)',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '4709',
      label: 'Maidalpur',
      type: 'City'
    },
    {
      value: '4710',
      label: 'Maihar',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '4711',
      label: 'Mailani',
      type: 'City'
    },
    {
      value: '4712',
      label: 'Mailapur',
      type: 'City'
    },
    {
      value: '4713',
      label: 'Maina',
      type: 'City'
    },
    {
      value: '4714',
      label: 'Mainpuri',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '4715',
      label: 'Majalgaon',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4716',
      label: 'Majera',
      type: 'City'
    },
    {
      value: '4717',
      label: 'Majethi',
      type: 'City'
    },
    {
      value: '4718',
      label: 'Majevadi',
      type: 'City'
    },
    {
      value: '4719',
      label: 'Majhari',
      type: 'City'
    },
    {
      value: '4720',
      label: 'Majhera',
      type: 'City'
    },
    {
      value: '4721',
      label: 'Majiwada',
      type: 'City'
    },
    {
      value: '4722',
      label: 'Majri',
      type: 'City'
    },
    {
      value: '4723',
      label: 'Makani',
      type: 'City'
    },
    {
      value: '4724',
      label: 'Makhiyala',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4725',
      label: 'Makhu',
      type: 'City'
    },
    {
      value: '4726',
      label: 'Makrana',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '4727',
      label: 'Maksi',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '4728',
      label: 'Maksudangarh',
      type: 'City'
    },
    {
      value: '4729',
      label: 'Maktupur',
      type: 'City'
    },
    {
      value: '4730',
      label: 'Malad',
      type: 'City'
    },
    {
      value: '4731',
      label: 'Malaikovilur',
      type: 'City'
    },
    {
      value: '4732',
      label: 'Malakoli',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4733',
      label: 'MALALHUE',
      type: 'City'
    },
    {
      value: '4734',
      label: 'Malangaon',
      type: 'City'
    },
    {
      value: '4735',
      label: 'Malanjkhand',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '4736',
      label: 'Malanka',
      type: 'City'
    },
    {
      value: '4737',
      label: 'Malaparajagudem',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4738',
      label: 'Malappuram',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4739',
      label: 'Malapuram',
      type: 'City'
    },
    {
      value: '4740',
      label: 'MalasaPatia',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4741',
      label: 'Malda',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '4742',
      label: 'Malda, UP',
      type: 'City'
    },
    {
      value: '4743',
      label: 'Malda, West Bengal',
      type: 'City'
    },
    {
      value: '4744',
      label: 'Maldabhadi',
      type: 'City'
    },
    {
      value: '4745',
      label: 'Malebennur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4746',
      label: 'Malegaon',
      type: 'City'
    },
    {
      value: '4747',
      label: 'Malegaon  Mehkar',
      type: 'City'
    },
    {
      value: '4748',
      label: 'Malegaon  Washim',
      type: 'City'
    },
    {
      value: '4749',
      label: 'Malegaon (Dhule)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4750',
      label: 'Malegaon (nashik)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4751',
      label: 'Malegaon (Washim)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4752',
      label: 'Malegaon Jahangir',
      type: 'City'
    },
    {
      value: '4753',
      label: 'Malerkotla',
      type: 'City'
    },
    {
      value: '4754',
      label: 'Malesia',
      type: 'City'
    },
    {
      value: '4755',
      label: 'Malghar',
      type: 'City'
    },
    {
      value: '4756',
      label: 'Malhargarh',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '4757',
      label: 'Malia',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4758',
      label: 'Malikipuram',
      type: 'City'
    },
    {
      value: '4759',
      label: 'Malila',
      type: 'City'
    },
    {
      value: '4760',
      label: 'Maliya',
      type: 'City'
    },
    {
      value: '4761',
      label: 'Maliya Hatina',
      type: 'City'
    },
    {
      value: '4762',
      label: 'Malkangiri',
      type: 'City'
    },
    {
      value: '4763',
      label: 'Malkangiri, Odisha',
      type: 'City'
    },
    {
      value: '4764',
      label: 'Malkangiri, Telangana',
      type: 'City'
    },
    {
      value: '4765',
      label: 'Malkapur',
      type: 'City'
    },
    {
      value: '4766',
      label: 'Malkapur (Buldhana)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4767',
      label: 'Malkapur, Maharashtra',
      type: 'City'
    },
    {
      value: '4768',
      label: 'Malkapur, Telangana',
      type: 'City'
    },
    {
      value: '4769',
      label: 'Malkipuram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4770',
      label: 'Malkpur',
      type: 'City'
    },
    {
      value: '4771',
      label: 'Mallappally',
      type: 'City'
    },
    {
      value: '4772',
      label: 'Mallapura',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4773',
      label: 'Mallapuram',
      type: 'City'
    },
    {
      value: '4774',
      label: 'Mallepalle',
      type: 'City'
    },
    {
      value: '4775',
      label: 'Mallipattinam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4776',
      label: 'Malog',
      type: 'City'
    },
    {
      value: '4777',
      label: 'Malokhar',
      type: 'City'
    },
    {
      value: '4778',
      label: 'Maloli',
      type: 'City'
    },
    {
      value: '4779',
      label: 'Malot',
      type: 'City'
    },
    {
      value: '4780',
      label: 'Malout',
      type: 'City'
    },
    {
      value: '4781',
      label: 'Malpara',
      type: 'City'
    },
    {
      value: '4782',
      label: 'Malpur',
      type: 'City'
    },
    {
      value: '4783',
      label: 'Malshika',
      type: 'City'
    },
    {
      value: '4784',
      label: 'Malshiras',
      type: 'City'
    },
    {
      value: '4785',
      label: 'Malsika',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4786',
      label: 'Malsisar',
      type: 'City'
    },
    {
      value: '4787',
      label: 'Malthone',
      type: 'City'
    },
    {
      value: '4788',
      label: 'Malvadi',
      type: 'City'
    },
    {
      value: '4789',
      label: 'Malvan',
      type: 'City'
    },
    {
      value: '4790',
      label: 'Malvan (maharashtra)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4791',
      label: 'Malvan, Gujarat',
      type: 'City'
    },
    {
      value: '4792',
      label: 'Malvan, Maharashtra',
      type: 'City'
    },
    {
      value: '4793',
      label: 'Malwara',
      type: 'City'
    },
    {
      value: '4794',
      label: 'Mamidikududru',
      type: 'City'
    },
    {
      value: '4795',
      label: 'Mamidikuduru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4796',
      label: 'Mamurdi  Dehu Road',
      type: 'City'
    },
    {
      value: '4797',
      label: 'Manakala',
      type: 'City'
    },
    {
      value: '4798',
      label: 'Manali',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '4799',
      label: 'Manali Dhrmshla Vaishno D',
      type: 'City'
    },
    {
      value: '4800',
      label: 'Manamadurai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4801',
      label: 'Malabellkudi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4802',
      label: 'Manandadi',
      type: 'City'
    },
    {
      value: '4803',
      label: 'Mananthavaadi',
      type: 'City'
    },
    {
      value: '4804',
      label: 'Mananthavady',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4805',
      label: 'Manapad',
      type: 'City'
    },
    {
      value: '4806',
      label: 'Manapparai',
      type: 'City'
    },
    {
      value: '4807',
      label: 'Manasa',
      type: 'City'
    },
    {
      value: '4808',
      label: 'Manavadar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4809',
      label: 'Manavalakurichi',
      type: 'City'
    },
    {
      value: '4810',
      label: 'Manawar',
      type: 'City'
    },
    {
      value: '4811',
      label: 'Manchakal',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4812',
      label: 'Manchar',
      type: 'City'
    },
    {
      value: '4813',
      label: 'Mancheri',
      type: 'City'
    },
    {
      value: '4814',
      label: 'Mancherial',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4815',
      label: 'Manchikerl',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4816',
      label: 'Manchili',
      type: 'City'
    },
    {
      value: '4817',
      label: 'Mandagada',
      type: 'City'
    },
    {
      value: '4818',
      label: 'Mandal(Gujrat)',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '4819',
      label: 'Mandal, Gujarat',
      type: 'City'
    },
    {
      value: '4820',
      label: 'Mandal, Rajasthan',
      type: 'City'
    },
    {
      value: '4821',
      label: 'Mandalapalli',
      type: 'City'
    },
    {
      value: '4822',
      label: 'Mandalgarh, MP',
      type: 'City'
    },
    {
      value: '4823',
      label: 'Mandalgarh, Rajasthan',
      type: 'City'
    },
    {
      value: '4824',
      label: 'Mandan Kundla',
      type: 'City'
    },
    {
      value: '4825',
      label: 'Mandangad',
      type: 'City'
    },
    {
      value: '4826',
      label: 'Mandapalli',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4827',
      label: 'Mandapam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4828',
      label: 'Mandapasalai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4829',
      label: 'Mandapet',
      type: 'City'
    },
    {
      value: '4830',
      label: 'Mandapeta',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4831',
      label: 'Mandar',
      type: 'City'
    },
    {
      value: '4832',
      label: 'Mandar (Jharkhand)',
      type: 'City',
      'state': 'Jharkhand'
    },
    {
      value: '4833',
      label: 'Mandarakuppam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4834',
      label: 'Mandariya',
      type: 'City'
    },
    {
      value: '4835',
      label: 'Mandarmani',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '4836',
      label: 'Mandarthi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4837',
      label: 'Mandarti',
      type: 'City'
    },
    {
      value: '4838',
      label: 'Mandavad',
      type: 'City'
    },
    {
      value: '4839',
      label: 'Mandavalli',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4840',
      label: 'Mandavda',
      type: 'City'
    },
    {
      value: '4841',
      label: 'Mandawa',
      type: 'City'
    },
    {
      value: '4842',
      label: 'Mandawala',
      type: 'City'
    },
    {
      value: '4843',
      label: 'Mandawar',
      type: 'City'
    },
    {
      value: '4844',
      label: 'Mandhol',
      type: 'City'
    },
    {
      value: '4845',
      label: 'Mandi',
      type: 'City'
    },
    {
      value: '4846',
      label: 'Mandi (Himachal Pradesh)',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '4847',
      label: 'Mandi (Punjab)',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '4848',
      label: 'Mandi Bamora',
      type: 'City'
    },
    {
      value: '4849',
      label: 'Mandi Dabwali',
      type: 'City'
    },
    {
      value: '4850',
      label: 'Mandi Gobindgarh',
      type: 'City'
    },
    {
      value: '4851',
      label: 'Mandideep',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '4852',
      label: 'Mandideep  Bhopal',
      type: 'City'
    },
    {
      value: '4853',
      label: 'Mandla',
      type: 'City'
    },
    {
      value: '4854',
      label: 'Mandla (MP)',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '4855',
      label: 'Mandleshwar',
      type: 'City'
    },
    {
      value: '4856',
      label: 'Mandlikpur',
      type: 'City'
    },
    {
      value: '4857',
      label: 'Mandoli',
      type: 'City'
    },
    {
      value: '4858',
      label: 'Mandorana',
      type: 'City'
    },
    {
      value: '4859',
      label: 'Mandore  Jodhpur',
      type: 'City'
    },
    {
      value: '4860',
      label: 'Mandrayal',
      type: 'City'
    },
    {
      value: '4861',
      label: 'Mandsaur',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '4862',
      label: 'Mandva',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4863',
      label: 'Mandvada',
      type: 'City'
    },
    {
      value: '4864',
      label: 'Mandvi',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4865',
      label: 'Mandvi Tapi',
      type: 'City'
    },
    {
      value: '4866',
      label: 'Mandya',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4867',
      label: 'Manegaon, MP',
      type: 'City'
    },
    {
      value: '4868',
      label: 'Manegaon, Maharashtra',
      type: 'City'
    },
    {
      value: '4869',
      label: 'Manekvada',
      type: 'City'
    },
    {
      value: '4870',
      label: 'Manekwada',
      type: 'City'
    },
    {
      value: '4871',
      label: 'Manendragarh',
      type: 'City'
    },
    {
      value: '4872',
      label: 'Manesar',
      type: 'City'
    },
    {
      value: '4873',
      label: 'Manewadi',
      type: 'City'
    },
    {
      value: '4874',
      label: 'Mangadh',
      type: 'City'
    },
    {
      value: '4875',
      label: 'Mangal Giri By Pass',
      type: 'City'
    },
    {
      value: '4876',
      label: 'Mangalagiri',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4877',
      label: 'Mangalagiri Bypass',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4878',
      label: 'Mangalapuram',
      type: 'City'
    },
    {
      value: '4879',
      label: 'Mangaldai',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '4880',
      label: 'MANGALDASROAD',
      type: 'City'
    },
    {
      value: '4881',
      label: 'Mangalore',
      type: 'City'
    },
    {
      value: '4882',
      label: 'Mangalore Bypass',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4883',
      label: 'Mangalore(Pumpwell)',
      type: 'City'
    },
    {
      value: '4884',
      label: 'Mangaluru',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4885',
      label: 'Mangalwar',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '4886',
      label: 'Mangalwedha',
      type: 'City'
    },
    {
      value: '4887',
      label: 'Manganallur',
      type: 'City'
    },
    {
      value: '4888',
      label: 'Mangaon',
      type: 'City'
    },
    {
      value: '4889',
      label: 'Mangapur',
      type: 'City'
    },
    {
      value: '4890',
      label: 'Mangarh',
      type: 'City'
    },
    {
      value: '4891',
      label: 'Mangasuli',
      type: 'City'
    },
    {
      value: '4892',
      label: 'Mangawan',
      type: 'City'
    },
    {
      value: '4893',
      label: 'Mangi Tungi',
      type: 'City'
    },
    {
      value: '4894',
      label: 'Manglana',
      type: 'City'
    },
    {
      value: '4895',
      label: 'Mangliyawas',
      type: 'City'
    },
    {
      value: '4896',
      label: 'Mangod',
      type: 'City'
    },
    {
      value: '4897',
      label: 'Mangrol',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4898',
      label: 'Mangrol, Gujarat',
      type: 'City'
    },
    {
      value: '4899',
      label: 'Mangrol, Rajasthan',
      type: 'City'
    },
    {
      value: '4900',
      label: 'Mangrul',
      type: 'City'
    },
    {
      value: '4901',
      label: 'Mangrul Pir',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4902',
      label: 'Mangrulpir',
      type: 'City'
    },
    {
      value: '4903',
      label: 'Mangvapal',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4904',
      label: 'Mangwana',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4905',
      label: 'Manikaran',
      type: 'City'
    },
    {
      value: '4906',
      label: 'Manikonda',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4907',
      label: 'Manimajra',
      type: 'City'
    },
    {
      value: '4908',
      label: 'Maninagar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4909',
      label: 'Maninagar  Pallakuruchi',
      type: 'City'
    },
    {
      value: '4910',
      label: 'Manipal',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4911',
      label: 'Maniyara',
      type: 'City'
    },
    {
      value: '4912',
      label: 'Maniyor',
      type: 'City'
    },
    {
      value: '4913',
      label: 'Manjarapalke',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4914',
      label: 'Manjari',
      type: 'City'
    },
    {
      value: '4915',
      label: 'Manjari (Karnataka)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4916',
      label: 'Manjarpalke',
      type: 'City'
    },
    {
      value: '4917',
      label: 'Manjarsumbha',
      type: 'City'
    },
    {
      value: '4918',
      label: 'Manjeri',
      type: 'City'
    },
    {
      value: '4919',
      label: 'Manjeri (Kerala)',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4920',
      label: 'Manjeshwar',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4921',
      label: 'Manjhanpur',
      type: 'City'
    },
    {
      value: '4922',
      label: 'Manjhatoli',
      type: 'City'
    },
    {
      value: '4923',
      label: 'Mankhurd  Mumbai',
      type: 'City'
    },
    {
      value: '4924',
      label: 'Manki',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4925',
      label: 'Manki Mavinakatte',
      type: 'City'
    },
    {
      value: '4926',
      label: 'Mankuwa',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '4927',
      label: 'Manmad',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4928',
      label: 'Manmad, Maharashtra',
      type: 'City'
    },
    {
      value: '4929',
      label: 'Manmad, Telangana',
      type: 'City'
    },
    {
      value: '4930',
      label: 'Mannaekhelli',
      type: 'City'
    },
    {
      value: '4931',
      label: 'Mannakalli',
      type: 'City'
    },
    {
      value: '4932',
      label: 'Mannar',
      type: 'City'
    },
    {
      value: '4933',
      label: 'Mannargudi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4934',
      label: 'Mannarkkad',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4935',
      label: 'Mannarpuram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4936',
      label: 'Mannur',
      type: 'City'
    },
    {
      value: '4937',
      label: 'Mannuthy',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4938',
      label: 'Mannuthy  Thrissur',
      type: 'City'
    },
    {
      value: '4939',
      label: 'Manohar Thana',
      type: 'City'
    },
    {
      value: '4940',
      label: 'Manolli',
      type: 'City'
    },
    {
      value: '4941',
      label: 'Manoor (Tamil Nadu)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4942',
      label: 'Manoor, Karnataka',
      type: 'City'
    },
    {
      value: '4943',
      label: 'Manoor, Telangana',
      type: 'City'
    },
    {
      value: '4944',
      label: 'Manor',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4945',
      label: 'Manora',
      type: 'City'
    },
    {
      value: '4946',
      label: 'Manpur, Chhattisgarh',
      type: 'City'
    },
    {
      value: '4947',
      label: 'Manpur, Gujarat',
      type: 'City'
    },
    {
      value: '4948',
      label: 'Manpur, MP',
      type: 'City'
    },
    {
      value: '4949',
      label: 'Manpur, Rajasthan',
      type: 'City'
    },
    {
      value: '4950',
      label: 'Mansa',
      type: 'City'
    },
    {
      value: '4951',
      label: 'Mansar',
      type: 'City'
    },
    {
      value: '4952',
      label: 'Mansoorie',
      type: 'City'
    },
    {
      value: '4953',
      label: 'Mansore',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '4954',
      label: 'Mantada',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4955',
      label: 'Mantha',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4956',
      label: 'Mantralaya',
      type: 'City'
    },
    {
      value: '4957',
      label: 'Mantralayam',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4958',
      label: 'Manuguru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4959',
      label: 'Manur',
      type: 'City'
    },
    {
      value: '4960',
      label: 'Manur (Tamil Nadu)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4961',
      label: 'Manvi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4962',
      label: 'Manwat Road',
      type: 'City'
    },
    {
      value: '4963',
      label: 'Manwath',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '4964',
      label: 'Mapsa',
      type: 'City'
    },
    {
      value: '4965',
      label: 'Mapusa',
      type: 'City',
      'state': 'Goa'
    },
    {
      value: '4966',
      label: 'Mar Del Plata',
      type: 'City'
    },
    {
      value: '4967',
      label: 'Maragundi Lake',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4968',
      label: 'Maranda',
      type: 'City'
    },
    {
      value: '4969',
      label: 'Maravamangalam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4970',
      label: 'Maravanthe',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4971',
      label: 'Marayoor',
      type: 'City'
    },
    {
      value: '4972',
      label: 'Marayur',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '4973',
      label: 'Marcel',
      type: 'City',
      'state': 'Goa'
    },
    {
      value: '4974',
      label: 'MARCHIGUE',
      type: 'City'
    },
    {
      value: '4975',
      label: 'Mardasgaon',
      type: 'City'
    },
    {
      value: '4976',
      label: 'Maredumilli',
      type: 'City'
    },
    {
      value: '4977',
      label: 'Marg Tamhane',
      type: 'City'
    },
    {
      value: '4978',
      label: 'Margao',
      type: 'City'
    },
    {
      value: '4979',
      label: 'Margerita',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '4980',
      label: 'Margoa',
      type: 'City',
      'state': 'Goa'
    },
    {
      value: '4981',
      label: 'Marhi',
      type: 'City'
    },
    {
      value: '4982',
      label: 'Markapuram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4983',
      label: 'Marlapadu',
      type: 'City'
    },
    {
      value: '4984',
      label: 'Marotan',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '4985',
      label: 'Maroth',
      type: 'City'
    },
    {
      value: '4986',
      label: 'Marteru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4987',
      label: 'Marthandam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '4988',
      label: 'Martur',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4989',
      label: 'Marturu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '4990',
      label: 'Maruteru',
      type: 'City'
    },
    {
      value: '4991',
      label: 'Maruthamalai',
      type: 'City'
    },
    {
      value: '4992',
      label: 'Marwar Junction',
      type: 'City'
    },
    {
      value: '4993',
      label: 'Marwar Khara',
      type: 'City'
    },
    {
      value: '4994',
      label: 'Mashikatte',
      type: 'City'
    },
    {
      value: '4995',
      label: 'Mashrakh',
      type: 'City'
    },
    {
      value: '4996',
      label: 'Masitawali Head',
      type: 'City'
    },
    {
      value: '4997',
      label: 'Maski',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '4998',
      label: 'Masod',
      type: 'City'
    },
    {
      value: '4999',
      label: 'Masoor',
      type: 'City'
    },
    {
      value: '5000',
      label: 'Masthikatte',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5001',
      label: 'Masur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5002',
      label: 'Masura',
      type: 'City'
    },
    {
      value: '5003',
      label: 'Masyana',
      type: 'City'
    },
    {
      value: '5004',
      label: 'Mata No Madh',
      type: 'City'
    },
    {
      value: '5005',
      label: 'Mata Vaishno Devi Yatra',
      type: 'City'
    },
    {
      value: '5006',
      label: 'Matanomadh',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5007',
      label: 'Mataundh',
      type: 'City'
    },
    {
      value: '5008',
      label: 'Matel',
      type: 'City'
    },
    {
      value: '5009',
      label: 'Mathal',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5010',
      label: 'Mathania',
      type: 'City'
    },
    {
      value: '5011',
      label: 'Mathili',
      type: 'City'
    },
    {
      value: '5012',
      label: 'Mathura',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '5013',
      label: 'Matiana',
      type: 'City'
    },
    {
      value: '5014',
      label: 'Matiyana',
      type: 'City'
    },
    {
      value: '5015',
      label: 'Matkuli',
      type: 'City'
    },
    {
      value: '5016',
      label: 'Matooniya',
      type: 'City'
    },
    {
      value: '5017',
      label: 'Mattancheri',
      type: 'City'
    },
    {
      value: '5018',
      label: 'Mattancherry',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '5019',
      label: 'Mattancherry',
      type: 'City'
    },
    {
      value: '5020',
      label: 'Mattanur',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '5021',
      label: 'Matwada',
      type: 'City'
    },
    {
      value: '5022',
      label: 'Mau',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '5023',
      label: 'Mau Ranipur',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '5024',
      label: 'Mauda',
      type: 'City'
    },
    {
      value: '5025',
      label: 'Maudaha',
      type: 'City'
    },
    {
      value: '5026',
      label: 'Maulasar',
      type: 'City'
    },
    {
      value: '5027',
      label: 'Maunganj',
      type: 'City'
    },
    {
      value: '5028',
      label: 'Mauranipur',
      type: 'City'
    },
    {
      value: '5029',
      label: 'Mavadi',
      type: 'City'
    },
    {
      value: '5030',
      label: 'Mavalli',
      type: 'City'
    },
    {
      value: '5031',
      label: 'Mavelikkara',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '5032',
      label: 'Mavinagundi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5033',
      label: 'Mavingundi',
      type: 'City'
    },
    {
      value: '5034',
      label: 'Mavjinjava',
      type: 'City'
    },
    {
      value: '5035',
      label: 'Mavli',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '5036',
      label: 'Mavungal',
      type: 'City'
    },
    {
      value: '5037',
      label: 'Maya Bazar',
      type: 'City'
    },
    {
      value: '5038',
      label: 'Mayapadar',
      type: 'City'
    },
    {
      value: '5039',
      label: 'Mayavaram',
      type: 'City'
    },
    {
      value: '5040',
      label: 'Mayiladuthurai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5041',
      label: 'Mayur Nagar  Kamrej',
      type: 'City'
    },
    {
      value: '5042',
      label: 'Mbagala',
      type: 'City'
    },
    {
      value: '5043',
      label: 'McLeod Ganj',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '5044',
      label: 'Mcleod Ganj  Dharamshala',
      type: 'City'
    },
    {
      value: '5045',
      label: 'Mecheri',
      type: 'City'
    },
    {
      value: '5046',
      label: 'Mecleod Ganj',
      type: 'City'
    },
    {
      value: '5047',
      label: 'Medapadu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5048',
      label: 'Medarametla',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5049',
      label: 'Medi',
      type: 'City'
    },
    {
      value: '5050',
      label: 'Medikonduru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5051',
      label: 'Medshi',
      type: 'City'
    },
    {
      value: '5052',
      label: 'Medta',
      type: 'City'
    },
    {
      value: '5053',
      label: 'Meenagadi',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '5054',
      label: 'Meenangadi',
      type: 'City'
    },
    {
      value: '5055',
      label: 'Meerut',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '5056',
      label: 'Meethri',
      type: 'City'
    },
    {
      value: '5057',
      label: 'Megaravalli',
      type: 'City'
    },
    {
      value: '5058',
      label: 'Megh Nagar',
      type: 'City'
    },
    {
      value: '5059',
      label: 'Meghapipaliya',
      type: 'City'
    },
    {
      value: '5060',
      label: 'Meghpar',
      type: 'City'
    },
    {
      value: '5061',
      label: 'Meghpar  Jamnaagar',
      type: 'City'
    },
    {
      value: '5062',
      label: 'Meghpar(Bhuj)',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5063',
      label: 'Meghper',
      type: 'City'
    },
    {
      value: '5064',
      label: 'Meghraj',
      type: 'City'
    },
    {
      value: '5065',
      label: 'Megnanapuram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5066',
      label: 'Mehakar',
      type: 'City'
    },
    {
      value: '5067',
      label: 'Mehal Kalan',
      type: 'City'
    },
    {
      value: '5068',
      label: 'Meham',
      type: 'City'
    },
    {
      value: '5069',
      label: 'Mehandipur',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '5070',
      label: 'Mehandipur Balaji',
      type: 'City'
    },
    {
      value: '5071',
      label: 'Mehandipur Balaji Temple',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '5072',
      label: 'Mehatpur, Himachal Pradesh',
      type: 'City'
    },
    {
      value: '5073',
      label: 'Mehatpur, Punjab',
      type: 'City'
    },
    {
      value: '5074',
      label: 'Mehgaon',
      type: 'City'
    },
    {
      value: '5075',
      label: 'Mehkar',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5076',
      label: 'Mehluwa',
      type: 'City'
    },
    {
      value: '5077',
      label: 'Mehra',
      type: 'City'
    },
    {
      value: '5078',
      label: 'Mehsana',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5079',
      label: 'Mehta Chowk',
      type: 'City'
    },
    {
      value: '5080',
      label: 'Melapalayam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5081',
      label: 'Melapalayam  Tirunelveli',
      type: 'City'
    },
    {
      value: '5082',
      label: 'Melaseval',
      type: 'City'
    },
    {
      value: '5083',
      label: 'melborne',
      type: 'City'
    },
    {
      value: '5084',
      label: 'Melkar',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5085',
      label: 'Melmaruvathur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5086',
      label: 'Melpuram',
      type: 'City'
    },
    {
      value: '5087',
      label: 'Melthi',
      type: 'City'
    },
    {
      value: '5088',
      label: 'Melua Chowraha',
      type: 'City'
    },
    {
      value: '5089',
      label: 'Melukavu',
      type: 'City'
    },
    {
      value: '5090',
      label: 'Melur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5091',
      label: 'Menar',
      type: 'City'
    },
    {
      value: '5092',
      label: 'Mendarda',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5093',
      label: 'Mendoza',
      type: 'City'
    },
    {
      value: '5094',
      label: 'Mengalwa',
      type: 'City'
    },
    {
      value: '5095',
      label: 'Mengaon',
      type: 'City'
    },
    {
      value: '5096',
      label: 'Mera Kh',
      type: 'City'
    },
    {
      value: '5097',
      label: 'Meravadar',
      type: 'City'
    },
    {
      value: '5098',
      label: 'Mercedes',
      type: 'City'
    },
    {
      value: '5099',
      label: 'Meriyana',
      type: 'City'
    },
    {
      value: '5100',
      label: 'Merta',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '5101',
      label: 'Meta Khambhaliya',
      type: 'City'
    },
    {
      value: '5102',
      label: 'Metkarwadi',
      type: 'City'
    },
    {
      value: '5103',
      label: 'Metpally',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5104',
      label: 'METRENCO',
      type: 'City'
    },
    {
      value: '5105',
      label: 'Mettupalayam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5106',
      label: 'Mettur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5107',
      label: 'Metwada',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '5108',
      label: 'Mevada',
      type: 'City'
    },
    {
      value: '5109',
      label: 'Mhasala (Raigad)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5110',
      label: 'Mhasdi',
      type: 'City'
    },
    {
      value: '5111',
      label: 'Mhow',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '5112',
      label: 'Miani',
      type: 'City'
    },
    {
      value: '5113',
      label: 'Mihinpurwa',
      type: 'City'
    },
    {
      value: '5114',
      label: 'Mihona',
      type: 'City'
    },
    {
      value: '5115',
      label: 'Mijar',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5116',
      label: 'Mimisal',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5117',
      label: 'Mini Bypass Road',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5118',
      label: 'Miraj',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5119',
      label: 'Mirajgaon',
      type: 'City'
    },
    {
      value: '5120',
      label: 'Mirganj',
      type: 'City'
    },
    {
      value: '5121',
      label: 'Mirjan',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5122',
      label: 'Mirjoli',
      type: 'City'
    },
    {
      value: '5123',
      label: 'Mirthal',
      type: 'City'
    },
    {
      value: '5124',
      label: 'Miryalaguda',
      type: 'City'
    },
    {
      value: '5125',
      label: 'Miryalguda',
      type: 'City'
    },
    {
      value: '5126',
      label: 'Mirzapur',
      type: 'City'
    },
    {
      value: '5127',
      label: 'Mirzapur (UP)',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '5128',
      label: 'Mirzewala  3C Chhoti',
      type: 'City'
    },
    {
      value: '5129',
      label: 'Mithapur',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5130',
      label: 'Mithbav',
      type: 'City'
    },
    {
      value: '5131',
      label: 'Mittapalem',
      type: 'City'
    },
    {
      value: '5132',
      label: 'Modasa',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5133',
      label: 'Moddulagudem',
      type: 'City'
    },
    {
      value: '5134',
      label: 'Modekurru',
      type: 'City'
    },
    {
      value: '5135',
      label: 'Modha',
      type: 'City'
    },
    {
      value: '5136',
      label: 'Modhera',
      type: 'City'
    },
    {
      value: '5137',
      label: 'Modi',
      type: 'City'
    },
    {
      value: '5138',
      label: 'Modinagar',
      type: 'City'
    },
    {
      value: '5139',
      label: 'Modpar',
      type: 'City'
    },
    {
      value: '5140',
      label: 'Modran',
      type: 'City'
    },
    {
      value: '5141',
      label: 'Moga',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '5142',
      label: 'Mogalturu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5143',
      label: 'Mogha',
      type: 'City'
    },
    {
      value: '5144',
      label: 'Mohabbat Nagar',
      type: 'City'
    },
    {
      value: '5145',
      label: 'Mohala, Chhattisgarh',
      type: 'City'
    },
    {
      value: '5146',
      label: 'Mohala, Maharashtra',
      type: 'City'
    },
    {
      value: '5147',
      label: 'Mohali',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '5148',
      label: 'Mohammadabad',
      type: 'City'
    },
    {
      value: '5149',
      label: 'Mohammadi',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '5150',
      label: 'Mohammadpur',
      type: 'City'
    },
    {
      value: '5151',
      label: 'Mohammadpur (Bihar)',
      type: 'City'
    },
    {
      value: '5152',
      label: 'Mohan Nagar  Ghaziabad',
      type: 'City'
    },
    {
      value: '5153',
      label: 'Mohana',
      type: 'City'
    },
    {
      value: '5154',
      label: 'Mohangarh',
      type: 'City'
    },
    {
      value: '5155',
      label: 'Mohangarh, MP',
      type: 'City'
    },
    {
      value: '5156',
      label: 'Mohangarh, Rajasthan',
      type: 'City'
    },
    {
      value: '5157',
      label: 'Mohania',
      type: 'City'
    },
    {
      value: '5158',
      label: 'Mohankheda',
      type: 'City'
    },
    {
      value: '5159',
      label: 'Mohanlalganj',
      type: 'City'
    },
    {
      value: '5160',
      label: 'Mohanur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5161',
      label: 'Mohgaon',
      type: 'City'
    },
    {
      value: '5162',
      label: 'Mohol',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5163',
      label: 'Moi Kalan',
      type: 'City'
    },
    {
      value: '5164',
      label: 'Mokalsar',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '5165',
      label: 'Mokeri',
      type: 'City'
    },
    {
      value: '5166',
      label: 'Mokhada',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5167',
      label: 'Mokhadka',
      type: 'City'
    },
    {
      value: '5168',
      label: 'Mokhampura',
      type: 'City'
    },
    {
      value: '5169',
      label: 'Mokhunda',
      type: 'City'
    },
    {
      value: '5170',
      label: 'Mokkam',
      type: 'City'
    },
    {
      value: '5171',
      label: 'Mokshagundam',
      type: 'City'
    },
    {
      value: '5172',
      label: 'Moladi',
      type: 'City'
    },
    {
      value: '5173',
      label: 'Molasar',
      type: 'City'
    },
    {
      value: '5174',
      label: 'Molela',
      type: 'City'
    },
    {
      value: '5175',
      label: 'Monday market',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5176',
      label: 'Monduru',
      type: 'City'
    },
    {
      value: '5177',
      label: 'Mongal',
      type: 'City'
    },
    {
      value: '5178',
      label: 'Monipally',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '5179',
      label: 'Monippally',
      type: 'City'
    },
    {
      value: '5180',
      label: 'Moniya',
      type: 'City'
    },
    {
      value: '5181',
      label: 'Monpar',
      type: 'City'
    },
    {
      value: '5182',
      label: 'Montecarlo',
      type: 'City'
    },
    {
      value: '5183',
      label: 'Monteros',
      type: 'City'
    },
    {
      value: '5184',
      label: 'Montevideo',
      type: 'City'
    },
    {
      value: '5185',
      label: 'Monvel',
      type: 'City'
    },
    {
      value: '5186',
      label: 'Moodabidri',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5187',
      label: 'Moodbidri',
      type: 'City'
    },
    {
      value: '5188',
      label: 'Moodubelle',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5189',
      label: 'Mooiriver Plaza',
      type: 'City'
    },
    {
      value: '5190',
      label: 'Mooka',
      type: 'City'
    },
    {
      value: '5191',
      label: 'Mookambika',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '5192',
      label: 'Moolaikaraipatti',
      type: 'City'
    },
    {
      value: '5193',
      label: 'Moolakaraippatti',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5194',
      label: 'Moonak',
      type: 'City'
    },
    {
      value: '5195',
      label: 'Moondradaippu',
      type: 'City'
    },
    {
      value: '5196',
      label: 'Moonnupeedika',
      type: 'City'
    },
    {
      value: '5197',
      label: 'Moonupeedika',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '5198',
      label: 'Moorang',
      type: 'City'
    },
    {
      value: '5199',
      label: 'Moovattupuzha',
      type: 'City'
    },
    {
      value: '5200',
      label: 'Mopidevi',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5201',
      label: 'Moradabad',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '5202',
      label: 'Moran',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '5203',
      label: 'Morayur',
      type: 'City'
    },
    {
      value: '5204',
      label: 'Morba (Raigad)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5205',
      label: 'Morba, Gujarat',
      type: 'City'
    },
    {
      value: '5206',
      label: 'Morba, Maharashtra',
      type: 'City'
    },
    {
      value: '5207',
      label: 'Morbi',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5208',
      label: 'Morena',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '5209',
      label: 'Morga',
      type: 'City'
    },
    {
      value: '5210',
      label: 'Morinda',
      type: 'City'
    },
    {
      value: '5211',
      label: 'Morjar',
      type: 'City'
    },
    {
      value: '5212',
      label: 'Morkha',
      type: 'City'
    },
    {
      value: '5213',
      label: 'Morshi',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5214',
      label: 'Mortad',
      type: 'City'
    },
    {
      value: '5215',
      label: 'Mortakka',
      type: 'City'
    },
    {
      value: '5216',
      label: 'Morthad',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5217',
      label: 'Morvada',
      type: 'City'
    },
    {
      value: '5218',
      label: 'Morvadi',
      type: 'City'
    },
    {
      value: '5219',
      label: 'Morvan',
      type: 'City'
    },
    {
      value: '5220',
      label: 'Morwada',
      type: 'City'
    },
    {
      value: '5221',
      label: 'Moshi',
      type: 'City'
    },
    {
      value: '5222',
      label: 'Mota Asrana',
      type: 'City'
    },
    {
      value: '5223',
      label: 'Mota Charodiya',
      type: 'City'
    },
    {
      value: '5224',
      label: 'Mota Dadva',
      type: 'City'
    },
    {
      value: '5225',
      label: 'Mota Devaliya',
      type: 'City'
    },
    {
      value: '5226',
      label: 'Mota Gundala',
      type: 'City'
    },
    {
      value: '5227',
      label: 'Mota Jadra Road',
      type: 'City'
    },
    {
      value: '5228',
      label: 'Mota Khutavada',
      type: 'City'
    },
    {
      value: '5229',
      label: 'Mota Kotda',
      type: 'City'
    },
    {
      value: '5230',
      label: 'Mota Machiyala',
      type: 'City'
    },
    {
      value: '5231',
      label: 'Mota Munjiasar  Munjiasar Mota',
      type: 'City'
    },
    {
      value: '5232',
      label: 'Mota Surka',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5233',
      label: 'Motala',
      type: 'City'
    },
    {
      value: '5234',
      label: 'Motanwadi',
      type: 'City'
    },
    {
      value: '5235',
      label: 'Motap',
      type: 'City'
    },
    {
      value: '5236',
      label: 'Mothadaka',
      type: 'City'
    },
    {
      value: '5237',
      label: 'Mothala',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5238',
      label: 'Mothara',
      type: 'City'
    },
    {
      value: '5239',
      label: 'Moti Bhagedi',
      type: 'City'
    },
    {
      value: '5240',
      label: 'Moti Jagadhar',
      type: 'City'
    },
    {
      value: '5241',
      label: 'Moti Khakhar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5242',
      label: 'Moti Khavadi',
      type: 'City'
    },
    {
      value: '5243',
      label: 'Moti Khavdi',
      type: 'City'
    },
    {
      value: '5244',
      label: 'Moti Khilori',
      type: 'City'
    },
    {
      value: '5245',
      label: 'Moti Khodiyar',
      type: 'City'
    },
    {
      value: '5246',
      label: 'Moti Matali',
      type: 'City'
    },
    {
      value: '5247',
      label: 'Moti Moli',
      type: 'City'
    },
    {
      value: '5248',
      label: 'Moti Monpari',
      type: 'City'
    },
    {
      value: '5249',
      label: 'Moti Vadal',
      type: 'City'
    },
    {
      value: '5250',
      label: 'Moti vavdi',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5251',
      label: 'Motigarh',
      type: 'City'
    },
    {
      value: '5252',
      label: 'Motihari',
      type: 'City'
    },
    {
      value: '5253',
      label: 'Motikhavdi',
      type: 'City'
    },
    {
      value: '5254',
      label: 'Motinala',
      type: 'City'
    },
    {
      value: '5255',
      label: 'Motipur',
      type: 'City'
    },
    {
      value: '5256',
      label: 'Motori',
      type: 'City'
    },
    {
      value: '5257',
      label: 'Moulasar',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '5258',
      label: 'Mount Abu',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '5259',
      label: 'MountAbu',
      type: 'City'
    },
    {
      value: '5260',
      label: 'Movva',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5261',
      label: 'Mozari',
      type: 'City'
    },
    {
      value: '5262',
      label: 'Mt. Abu',
      type: 'City'
    },
    {
      value: '5263',
      label: 'Mubarakpur',
      type: 'City'
    },
    {
      value: '5264',
      label: 'Mubarikpur',
      type: 'City'
    },
    {
      value: '5265',
      label: 'Muchipara',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '5266',
      label: 'Mudabidre',
      type: 'City'
    },
    {
      value: '5267',
      label: 'Mudabidri',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5268',
      label: 'Mudalagi',
      type: 'City'
    },
    {
      value: '5269',
      label: 'Mudalur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5270',
      label: 'Mudarangadi',
      type: 'City'
    },
    {
      value: '5271',
      label: 'Muddanur',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5272',
      label: 'Muddanuru Road',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5273',
      label: 'Muddebihal',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5274',
      label: 'Mudeti Patia',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5275',
      label: 'Mudgal',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5276',
      label: 'Mudgal, Karnataka',
      type: 'City'
    },
    {
      value: '5277',
      label: 'Mudgal, Telangana',
      type: 'City'
    },
    {
      value: '5278',
      label: 'Mudhol',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5279',
      label: 'Mudigere',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5280',
      label: 'Mudigubba',
      type: 'City'
    },
    {
      value: '5281',
      label: 'Mudikondan',
      type: 'City'
    },
    {
      value: '5282',
      label: 'Mudinepalli',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5283',
      label: 'Mudinepally',
      type: 'City'
    },
    {
      value: '5284',
      label: 'Mudipu',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '5285',
      label: 'Mudipu  Kurnad',
      type: 'City'
    },
    {
      value: '5286',
      label: 'Mudradi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5287',
      label: 'Mudrady',
      type: 'City'
    },
    {
      value: '5288',
      label: 'Mudrangandi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5289',
      label: 'Mudukulathur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5290',
      label: 'Mugalkhod',
      type: 'City'
    },
    {
      value: '5291',
      label: 'Mugalsaray',
      type: 'City'
    },
    {
      value: '5292',
      label: 'Mughal Sarai',
      type: 'City'
    },
    {
      value: '5293',
      label: 'Mugij',
      type: 'City'
    },
    {
      value: '5294',
      label: 'Mujafernagar',
      type: 'City'
    },
    {
      value: '5295',
      label: 'Mukam',
      type: 'City'
    },
    {
      value: '5296',
      label: 'Mukandgarh',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '5297',
      label: 'Mukeria',
      type: 'City'
    },
    {
      value: '5298',
      label: 'Mukerian',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '5299',
      label: 'Mukhed',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5300',
      label: 'Mukka',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5301',
      label: 'Mukka  Sasihithlu',
      type: 'City'
    },
    {
      value: '5302',
      label: 'Mukkamala',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5303',
      label: 'Mukkani',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5304',
      label: 'Muklawa',
      type: 'City'
    },
    {
      value: '5305',
      label: 'Mukramabad',
      type: 'City'
    },
    {
      value: '5306',
      label: 'Muktainagar',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5307',
      label: 'Muktheswaram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5308',
      label: 'Mukti',
      type: 'City'
    },
    {
      value: '5309',
      label: 'Muktsar',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '5310',
      label: 'Mukundgarh',
      type: 'City'
    },
    {
      value: '5311',
      label: 'Mul',
      type: 'City'
    },
    {
      value: '5312',
      label: 'Mulakalacheruvu',
      type: 'City'
    },
    {
      value: '5313',
      label: 'Mulamthurthy',
      type: 'City'
    },
    {
      value: '5314',
      label: 'Mulamthuruthy',
      type: 'City'
    },
    {
      value: '5315',
      label: 'Mulanur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5316',
      label: 'Mulbagal',
      type: 'City'
    },
    {
      value: '5317',
      label: 'MULCHEN',
      type: 'City'
    },
    {
      value: '5318',
      label: 'Muldharai',
      type: 'City'
    },
    {
      value: '5319',
      label: 'Muliya',
      type: 'City'
    },
    {
      value: '5320',
      label: 'Mulki',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5321',
      label: 'Mulki  Kilpady',
      type: 'City'
    },
    {
      value: '5322',
      label: 'Mulky',
      type: 'City'
    },
    {
      value: '5323',
      label: 'Mullakadu',
      type: 'City'
    },
    {
      value: '5324',
      label: 'Mullakadu  Thoothukudi',
      type: 'City'
    },
    {
      value: '5325',
      label: 'Mullanpur',
      type: 'City'
    },
    {
      value: '5326',
      label: 'Mullanpur Dakha',
      type: 'City'
    },
    {
      value: '5327',
      label: 'Mulleria',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5328',
      label: 'Mullikatte',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5329',
      label: 'Mullikatte  Hosadu',
      type: 'City'
    },
    {
      value: '5330',
      label: 'Muloor',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5331',
      label: 'Mulshi',
      type: 'City'
    },
    {
      value: '5332',
      label: 'Multai',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '5333',
      label: 'Mulund',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5334',
      label: 'Mulur',
      type: 'City'
    },
    {
      value: '5335',
      label: 'Mumanvas',
      type: 'City'
    },
    {
      value: '5336',
      label: 'Mumbai',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5337',
      label: 'Mumbai - Sion',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5338',
      label: 'Mumbai Borivali',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5339',
      label: 'Mumbai Darshan',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5340',
      label: 'Mumbai Naka',
      type: 'City'
    },
    {
      value: '5341',
      label: 'Mumbai(Dadar)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5342',
      label: 'Mumbai(Thane)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5343',
      label: 'Mumbai(Vikhroli)',
      type: 'City'
    },
    {
      value: '5344',
      label: 'Mumindivaaram',
      type: 'City'
    },
    {
      value: '5345',
      label: 'Mummidivaram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5346',
      label: 'Munanjipatti',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5347',
      label: 'Munavalli',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5348',
      label: 'Munavalli  Manolli',
      type: 'City'
    },
    {
      value: '5349',
      label: 'Mundakayam',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '5350',
      label: 'Mundara',
      type: 'City'
    },
    {
      value: '5351',
      label: 'Mundargi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5352',
      label: 'Mundgod',
      type: 'City'
    },
    {
      value: '5353',
      label: 'Mundhi',
      type: 'City'
    },
    {
      value: '5354',
      label: 'Mundi',
      type: 'City'
    },
    {
      value: '5355',
      label: 'Mundkur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5356',
      label: 'Mundra',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5357',
      label: 'Mundrigi',
      type: 'City'
    },
    {
      value: '5358',
      label: 'Mundur',
      type: 'City'
    },
    {
      value: '5359',
      label: 'Munganda',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5360',
      label: 'Mungaoli',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '5361',
      label: 'Munged',
      type: 'City'
    },
    {
      value: '5362',
      label: 'Mungisapur',
      type: 'City'
    },
    {
      value: '5363',
      label: 'Mungling',
      type: 'City'
    },
    {
      value: '5364',
      label: 'Mungra Badshahpur',
      type: 'City'
    },
    {
      value: '5365',
      label: 'Mungwani',
      type: 'City'
    },
    {
      value: '5366',
      label: 'Munirabad',
      type: 'City'
    },
    {
      value: '5367',
      label: 'Muniyal',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5368',
      label: 'Munjiasar Nana',
      type: 'City'
    },
    {
      value: '5369',
      label: 'Munjiyasar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5370',
      label: 'Munna Doongar',
      type: 'City'
    },
    {
      value: '5371',
      label: 'Munnar',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '5372',
      label: 'Munshiganj',
      type: 'City'
    },
    {
      value: '5373',
      label: 'Mupkal',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5374',
      label: 'Muppavaram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5375',
      label: 'Muradabad',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '5376',
      label: 'Muradganj',
      type: 'City'
    },
    {
      value: '5377',
      label: 'Muradnagar',
      type: 'City'
    },
    {
      value: '5378',
      label: 'Muramalla',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5379',
      label: 'Murambu',
      type: 'City'
    },
    {
      value: '5380',
      label: 'Murari',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5381',
      label: 'Murathangadi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5382',
      label: 'Murdeshwar',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5383',
      label: 'Murdeshwara',
      type: 'City'
    },
    {
      value: '5384',
      label: 'Murickassery',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '5385',
      label: 'Muringoor',
      type: 'City'
    },
    {
      value: '5386',
      label: 'Murinjapuzha',
      type: 'City'
    },
    {
      value: '5387',
      label: 'Murliganj',
      type: 'City'
    },
    {
      value: '5388',
      label: 'Murnad',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5389',
      label: 'Murshidabad',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '5390',
      label: 'Murtajapur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5391',
      label: 'Murthal',
      type: 'City',
      'state': 'Haryana'
    },
    {
      value: '5392',
      label: 'Murtizapur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5393',
      label: 'Murud',
      type: 'City'
    },
    {
      value: '5394',
      label: 'Murud (Latur)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5395',
      label: 'Murud (raigad)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5396',
      label: 'Murudeshwar',
      type: 'City'
    },
    {
      value: '5397',
      label: 'Musafirkhana',
      type: 'City'
    },
    {
      value: '5398',
      label: 'Musakhedi Square Indore',
      type: 'City'
    },
    {
      value: '5399',
      label: 'Mushrigharari',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '5400',
      label: 'Musiri',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5401',
      label: 'Musiri, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '5402',
      label: 'Musiri, Tamil Nadu',
      type: 'City'
    },
    {
      value: '5403',
      label: 'Musorie Rishiksh Haridwar',
      type: 'City'
    },
    {
      value: '5404',
      label: 'Mussoorie',
      type: 'City'
    },
    {
      value: '5405',
      label: 'Mussorie',
      type: 'City'
    },
    {
      value: '5406',
      label: 'Muthanoor(Tuticorin)',
      type: 'City'
    },
    {
      value: '5407',
      label: 'Muthli',
      type: 'City'
    },
    {
      value: '5408',
      label: 'Muthukulathur',
      type: 'City'
    },
    {
      value: '5409',
      label: 'Muthupet',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5410',
      label: 'Muthupettai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5411',
      label: 'Muthuramalingapuram',
      type: 'City'
    },
    {
      value: '5412',
      label: 'Mutthupettai',
      type: 'City'
    },
    {
      value: '5413',
      label: 'Muttom',
      type: 'City'
    },
    {
      value: '5414',
      label: 'Muttuchira',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '5415',
      label: 'Muvattupuzha',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '5416',
      label: 'Muzaffarnagar',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '5417',
      label: 'Muzaffarpur',
      type: 'City'
    },
    {
      value: '5418',
      label: 'Muzaffarpur (Bihar)',
      type: 'City'
    },
    {
      value: '5419',
      label: 'Muzaffarpur, UP',
      type: 'City'
    },
    {
      value: '5420',
      label: 'Muzhappilangad',
      type: 'City'
    },
    {
      value: '5421',
      label: 'Mydukur',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5422',
      label: 'Mydukuru',
      type: 'City'
    },
    {
      value: '5423',
      label: 'Mylavaram',
      type: 'City'
    },
    {
      value: '5424',
      label: 'Mysore',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5425',
      label: 'Mysore Ooty 1n 2d Itdc',
      type: 'City'
    },
    {
      value: '5426',
      label: 'Mysore Ooty 1n 2d Itdc (Dlx)',
      type: 'City'
    },
    {
      value: '5427',
      label: 'Mysore Ooty 1n 2d Itdc (Lxy)',
      type: 'City'
    },
    {
      value: '5428',
      label: 'Mysore Ooty 1n 2d Itdc (Star)',
      type: 'City'
    },
    {
      value: '5429',
      label: 'Mysore Ooty 2n 3d',
      type: 'City'
    },
    {
      value: '5430',
      label: 'Mysore Ooty 2n 3d Itdc',
      type: 'City'
    },
    {
      value: '5431',
      label: 'Mysore Ooty 2n 3d Itdc (Dlx)',
      type: 'City'
    },
    {
      value: '5432',
      label: 'Mysore Ooty 2n 3d Itdc (Lxy)',
      type: 'City'
    },
    {
      value: '5433',
      label: 'Mysore Ooty 2n 3d Itdc (Star)',
      type: 'City'
    },
    {
      value: '5434',
      label: 'Mysore Ooty Coonur Kodai (Dlx)',
      type: 'City'
    },
    {
      value: '5435',
      label: 'Mysore Ooty Coonur Kodai (Lxy)',
      type: 'City'
    },
    {
      value: '5436',
      label: 'Mysore Ooty Coonur Kodai (Str)',
      type: 'City'
    },
    {
      value: '5437',
      label: 'Mysore Ooty Kodai 3n 4d (Dlx)',
      type: 'City'
    },
    {
      value: '5438',
      label: 'Mysore Ooty Kodai 3n 4d (Lxy)',
      type: 'City'
    },
    {
      value: '5439',
      label: 'Mysore Ooty Kodai 3n 4d (Star)',
      type: 'City'
    },
    {
      value: '5440',
      label: 'Mysore Ooty Kodai 3n 4d Itdc',
      type: 'City'
    },
    {
      value: '5441',
      label: 'Mysore Sightseeing Itdc',
      type: 'City'
    },
    {
      value: '5442',
      label: 'Mysore Site Seeing',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5443',
      label: 'Mysuru',
      type: 'City'
    },
    {
      value: '5444',
      label: 'N I T K (Mangalore)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5445',
      label: 'N R Pura',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5446',
      label: 'N.G.O Quarters Clt',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5447',
      label: 'Nabarangpur',
      type: 'City'
    },
    {
      value: '5448',
      label: 'Nabinagar',
      type: 'City'
    },
    {
      value: '5449',
      label: 'Nabipur',
      type: 'City'
    },
    {
      value: '5450',
      label: 'Nachna',
      type: 'City'
    },
    {
      value: '5451',
      label: 'Nadagudde Angadi',
      type: 'City'
    },
    {
      value: '5452',
      label: 'Nadakuduru',
      type: 'City'
    },
    {
      value: '5453',
      label: 'Nadapuram',
      type: 'City'
    },
    {
      value: '5454',
      label: 'Nadaun',
      type: 'City'
    },
    {
      value: '5455',
      label: 'Nadiad',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5456',
      label: 'Nadiya',
      type: 'City'
    },
    {
      value: '5457',
      label: 'Nadiyad',
      type: 'City'
    },
    {
      value: '5458',
      label: 'Nadol',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '5459',
      label: 'Naduan',
      type: 'City'
    },
    {
      value: '5460',
      label: 'Naduvakurichi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5461',
      label: 'Naduvannur',
      type: 'City'
    },
    {
      value: '5462',
      label: 'Naduvil',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '5463',
      label: 'Nagaj',
      type: 'City'
    },
    {
      value: '5464',
      label: 'Nagaj (Sangali)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5465',
      label: 'Nagalapuram',
      type: 'City'
    },
    {
      value: '5466',
      label: 'Nagalapuram (Andhra Pradesh)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5467',
      label: 'Nagalapuram, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '5468',
      label: 'Nagalapuram, Tamil Nadu',
      type: 'City'
    },
    {
      value: '5469',
      label: 'Nagalpar',
      type: 'City'
    },
    {
      value: '5470',
      label: 'Naganur',
      type: 'City'
    },
    {
      value: '5471',
      label: 'Naganwadi',
      type: 'City'
    },
    {
      value: '5472',
      label: 'Nagaon',
      type: 'City'
    },
    {
      value: '5473',
      label: 'Nagapatnam',
      type: 'City'
    },
    {
      value: '5474',
      label: 'Nagapattinam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5475',
      label: 'Nagar',
      type: 'City'
    },
    {
      value: '5476',
      label: 'Nagar (Gujarat)',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5477',
      label: 'Nagar, Jharkhand',
      type: 'City'
    },
    {
      value: '5478',
      label: 'Nagar, Rajasthan',
      type: 'City'
    },
    {
      value: '5479',
      label: 'Nagaram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5480',
      label: 'Nagarcoil',
      type: 'City'
    },
    {
      value: '5481',
      label: 'Nagardeola',
      type: 'City'
    },
    {
      value: '5482',
      label: 'Nagari(Andhra Pradesh)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5483',
      label: 'Nagari, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '5484',
      label: 'Nagari, Chhattisgarh',
      type: 'City'
    },
    {
      value: '5485',
      label: 'Nagarjunsagar',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5486',
      label: 'Nagarkovil',
      type: 'City'
    },
    {
      value: '5487',
      label: 'Nagarnar',
      type: 'City'
    },
    {
      value: '5488',
      label: 'Nagas Phata',
      type: 'City'
    },
    {
      value: '5489',
      label: 'Nagaur',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '5490',
      label: 'Nagayalanka',
      type: 'City'
    },
    {
      value: '5491',
      label: 'Nagda',
      type: 'City'
    },
    {
      value: '5492',
      label: 'Nagercoil',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5493',
      label: 'Nagercoil',
      type: 'City'
    },
    {
      value: '5494',
      label: 'Nageshree',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5495',
      label: 'Nageshwar',
      type: 'City'
    },
    {
      value: '5496',
      label: 'Naggar',
      type: 'City'
    },
    {
      value: '5497',
      label: 'Nagina',
      type: 'City'
    },
    {
      value: '5498',
      label: 'Nagnesh',
      type: 'City'
    },
    {
      value: '5499',
      label: 'Nagni',
      type: 'City'
    },
    {
      value: '5500',
      label: 'Nagod',
      type: 'City'
    },
    {
      value: '5501',
      label: 'Nagoor (Andhra Pradesh)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5502',
      label: 'Nagoor(Karnataka)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5503',
      label: 'Nagoor, Karnataka',
      type: 'City'
    },
    {
      value: '5504',
      label: 'Nagoor, Tamil Nadu',
      type: 'City'
    },
    {
      value: '5505',
      label: 'Nagore',
      type: 'City'
    },
    {
      value: '5506',
      label: 'Nagore  Nagapattinam',
      type: 'City'
    },
    {
      value: '5507',
      label: 'Nagore (Tamil Nadu)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5508',
      label: 'Nagpur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5509',
      label: 'Nagpur, Maharashtra',
      type: 'City'
    },
    {
      value: '5510',
      label: 'Nagpur, Telangana',
      type: 'City'
    },
    {
      value: '5511',
      label: 'Nagrota Bagwan',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '5512',
      label: 'Nagrota Surian',
      type: 'City'
    },
    {
      value: '5513',
      label: 'Nagrota, Himachal Pradesh',
      type: 'City'
    },
    {
      value: '5514',
      label: 'Nagrota, Jammu And Kashmir',
      type: 'City'
    },
    {
      value: '5515',
      label: 'Nagthane',
      type: 'City'
    },
    {
      value: '5516',
      label: 'Nagullanka',
      type: 'City'
    },
    {
      value: '5517',
      label: 'Naguluppalapadu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5518',
      label: 'Nagur',
      type: 'City'
    },
    {
      value: '5519',
      label: 'Naguru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5520',
      label: 'Nagzari  Amravati',
      type: 'City'
    },
    {
      value: '5521',
      label: 'Nahan',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '5522',
      label: 'Naharkatia',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '5523',
      label: 'Naharlagun',
      type: 'City',
      'state': 'Arunachal Pradesh'
    },
    {
      value: '5524',
      label: 'Naidupet',
      type: 'City'
    },
    {
      value: '5525',
      label: 'Naidupeta',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5526',
      label: 'Naidupeta (By-Pass)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5527',
      label: 'Naigaon',
      type: 'City'
    },
    {
      value: '5528',
      label: 'Naikanakatte  Nandanavana',
      type: 'City'
    },
    {
      value: '5529',
      label: 'Naikguda',
      type: 'City'
    },
    {
      value: '5530',
      label: 'Naina Tikker',
      type: 'City'
    },
    {
      value: '5531',
      label: 'Nainagir',
      type: 'City'
    },
    {
      value: '5532',
      label: 'Naini',
      type: 'City'
    },
    {
      value: '5533',
      label: 'Nainikhad',
      type: 'City'
    },
    {
      value: '5534',
      label: 'Nainital',
      type: 'City'
    },
    {
      value: '5535',
      label: 'Nainpur',
      type: 'City'
    },
    {
      value: '5536',
      label: 'Naitale',
      type: 'City'
    },
    {
      value: '5537',
      label: 'Najapur',
      type: 'City'
    },
    {
      value: '5538',
      label: 'Najibabad',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '5539',
      label: 'Nakerakal',
      type: 'City'
    },
    {
      value: '5540',
      label: 'Nakhare',
      type: 'City'
    },
    {
      value: '5541',
      label: 'Nakhatrana',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5542',
      label: 'Nakkapalli',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5543',
      label: 'Nakoda',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '5544',
      label: 'Nakodar',
      type: 'City'
    },
    {
      value: '5545',
      label: 'Nakrekal',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5546',
      label: 'Nal',
      type: 'City'
    },
    {
      value: '5547',
      label: 'Nalagarh',
      type: 'City'
    },
    {
      value: '5548',
      label: 'Nalajerlla',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5549',
      label: 'Nalanda',
      type: 'City'
    },
    {
      value: '5550',
      label: 'Nalasopara',
      type: 'City'
    },
    {
      value: '5551',
      label: 'Nalbari',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '5552',
      label: 'Naldehra',
      type: 'City'
    },
    {
      value: '5553',
      label: 'Naldurg',
      type: 'City'
    },
    {
      value: '5554',
      label: 'Naldurg (Osmanabad)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5555',
      label: 'Nalegaon',
      type: 'City'
    },
    {
      value: '5556',
      label: 'Nalegaon, Maharashtra',
      type: 'City'
    },
    {
      value: '5557',
      label: 'Nalegaon, Telangana',
      type: 'City'
    },
    {
      value: '5558',
      label: 'Nalgonda',
      type: 'City',
      'state': 'Telangana'
    },
    {
      value: '5559',
      label: 'Naliya',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5560',
      label: 'Nallaguntla',
      type: 'City'
    },
    {
      value: '5561',
      label: 'Nallajerla',
      type: 'City'
    },
    {
      value: '5562',
      label: 'Nallapadu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5563',
      label: 'Nalti  Hamirpur',
      type: 'City'
    },
    {
      value: '5564',
      label: 'Nalumavadi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5565',
      label: 'Nalur',
      type: 'City'
    },
    {
      value: '5566',
      label: 'Namagiripettai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5567',
      label: 'Namakal',
      type: 'City'
    },
    {
      value: '5568',
      label: 'Namakkal',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5569',
      label: 'Nambuthalai',
      type: 'City'
    },
    {
      value: '5570',
      label: 'Nambuthalai (Ramanathapuram)',
      type: 'City'
    },
    {
      value: '5571',
      label: 'Nambuthalai Bypass',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5572',
      label: 'Namhol',
      type: 'City'
    },
    {
      value: '5573',
      label: 'Namli',
      type: 'City'
    },
    {
      value: '5574',
      label: 'Nampur',
      type: 'City'
    },
    {
      value: '5575',
      label: 'Namrup',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '5576',
      label: 'Namsai',
      type: 'City',
      'state': 'Arunachal Pradesh'
    },
    {
      value: '5577',
      label: 'Namtola',
      type: 'City'
    },
    {
      value: '5578',
      label: 'Nan Dishma',
      type: 'City'
    },
    {
      value: '5579',
      label: 'Nana',
      type: 'City'
    },
    {
      value: '5580',
      label: 'Nana Asarana',
      type: 'City'
    },
    {
      value: '5581',
      label: 'Nana Barman',
      type: 'City'
    },
    {
      value: '5582',
      label: 'Nana Bhandariya',
      type: 'City'
    },
    {
      value: '5583',
      label: 'Nana Chiloda',
      type: 'City'
    },
    {
      value: '5584',
      label: 'Nana Khutavada',
      type: 'City'
    },
    {
      value: '5585',
      label: 'Nana Panch Devda',
      type: 'City'
    },
    {
      value: '5586',
      label: 'Nanakmatta',
      type: 'City'
    },
    {
      value: '5587',
      label: 'NANCAGUA',
      type: 'City'
    },
    {
      value: '5588',
      label: 'Nandalur',
      type: 'City'
    },
    {
      value: '5589',
      label: 'Nandaluru',
      type: 'City'
    },
    {
      value: '5590',
      label: 'Nandamuru',
      type: 'City'
    },
    {
      value: '5591',
      label: 'Nandasan',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5592',
      label: 'Nanded',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5593',
      label: 'Nandeshma',
      type: 'City'
    },
    {
      value: '5594',
      label: 'Nandeshwar',
      type: 'City'
    },
    {
      value: '5595',
      label: 'Nandgaon',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5596',
      label: 'Nandgaon (nasik)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5597',
      label: 'Nandgaon Titha  Nandgaon',
      type: 'City'
    },
    {
      value: '5598',
      label: 'Nandghat',
      type: 'City'
    },
    {
      value: '5599',
      label: 'Nandigama',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5600',
      label: 'Nandigama, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '5601',
      label: 'Nandigama, Telangana',
      type: 'City'
    },
    {
      value: '5602',
      label: 'Nandikur',
      type: 'City'
    },
    {
      value: '5603',
      label: 'Nandivada',
      type: 'City'
    },
    {
      value: '5604',
      label: 'Nandivelugu',
      type: 'City'
    },
    {
      value: '5605',
      label: 'Nandivelugu (Andhra Pradesh)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5606',
      label: 'Nandsa',
      type: 'City'
    },
    {
      value: '5607',
      label: 'Nandur',
      type: 'City'
    },
    {
      value: '5608',
      label: 'Nandur Ghat',
      type: 'City'
    },
    {
      value: '5609',
      label: 'Nandur Shingote',
      type: 'City'
    },
    {
      value: '5610',
      label: 'Nandura',
      type: 'City'
    },
    {
      value: '5611',
      label: 'Nandura (Buldhana)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5612',
      label: 'Nandurbar',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5613',
      label: 'Nanduri',
      type: 'City'
    },
    {
      value: '5614',
      label: 'Nandyal',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5615',
      label: 'Nandyal',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5616',
      label: 'Nangal',
      type: 'City'
    },
    {
      value: '5617',
      label: 'Nangal Chaudhary',
      type: 'City'
    },
    {
      value: '5618',
      label: 'Nanguneri',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5619',
      label: 'Nani Bhagedi',
      type: 'City'
    },
    {
      value: '5620',
      label: 'Nani Khakhar',
      type: 'City'
    },
    {
      value: '5621',
      label: 'Nani Khavdi',
      type: 'City'
    },
    {
      value: '5622',
      label: 'Nani Kunkavav',
      type: 'City'
    },
    {
      value: '5623',
      label: 'Nani Molpari',
      type: 'City'
    },
    {
      value: '5624',
      label: 'Nani Monpari',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5625',
      label: 'Nani Rajasthali',
      type: 'City'
    },
    {
      value: '5626',
      label: 'Nanjanagudu',
      type: 'City'
    },
    {
      value: '5627',
      label: 'Nanjangood',
      type: 'City'
    },
    {
      value: '5628',
      label: 'Nanjangudu',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5629',
      label: 'Nankhari',
      type: 'City'
    },
    {
      value: '5630',
      label: 'Nanpara',
      type: 'City'
    },
    {
      value: '5631',
      label: 'Nanpur',
      type: 'City'
    },
    {
      value: '5632',
      label: 'Nanrol',
      type: 'City'
    },
    {
      value: '5633',
      label: 'Nanudi',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5634',
      label: 'Napasar',
      type: 'City'
    },
    {
      value: '5635',
      label: 'Napoklu',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5636',
      label: 'Naragund',
      type: 'City'
    },
    {
      value: '5637',
      label: 'Narahi',
      type: 'City'
    },
    {
      value: '5638',
      label: 'Narahia',
      type: 'City'
    },
    {
      value: '5639',
      label: 'Naraingarh',
      type: 'City'
    },
    {
      value: '5640',
      label: 'Naraini',
      type: 'City'
    },
    {
      value: '5641',
      label: 'Narakoduru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5642',
      label: 'Narakulapadu',
      type: 'City'
    },
    {
      value: '5643',
      label: 'Narangwadi',
      type: 'City'
    },
    {
      value: '5644',
      label: 'NARANPAR',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5645',
      label: 'Narasannapeta',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5646',
      label: 'Narasaraopet',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5647',
      label: 'Narasaraopeta',
      type: 'City'
    },
    {
      value: '5648',
      label: 'Narasimharajapura',
      type: 'City'
    },
    {
      value: '5649',
      label: 'Narasingapadu',
      type: 'City'
    },
    {
      value: '5650',
      label: 'Narasingapur',
      type: 'City'
    },
    {
      value: '5651',
      label: 'Naravi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5652',
      label: 'Narayan Ghat',
      type: 'City'
    },
    {
      value: '5653',
      label: 'Narayanapuram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5654',
      label: 'Narayanganj',
      type: 'City'
    },
    {
      value: '5655',
      label: 'Narayangaon',
      type: 'City'
    },
    {
      value: '5656',
      label: 'Narayangarh, MP',
      type: 'City'
    },
    {
      value: '5657',
      label: 'Narayangarh, Nepal',
      type: 'City'
    },
    {
      value: '5658',
      label: 'Narayanpur (Maharashtra)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5659',
      label: 'Narayanpur, Chhattisgarh',
      type: 'City'
    },
    {
      value: '5660',
      label: 'Narayanpur, Telangana',
      type: 'City'
    },
    {
      value: '5661',
      label: 'Narayanpura',
      type: 'City'
    },
    {
      value: '5662',
      label: 'Nardana',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5663',
      label: 'Nardipur',
      type: 'City'
    },
    {
      value: '5664',
      label: 'Naredi',
      type: 'City'
    },
    {
      value: '5665',
      label: 'Naregal',
      type: 'City'
    },
    {
      value: '5666',
      label: 'Narela',
      type: 'City'
    },
    {
      value: '5667',
      label: 'Nargund',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5668',
      label: 'Nari',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5669',
      label: 'Narippaiyur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5670',
      label: 'Nariyawal',
      type: 'City'
    },
    {
      value: '5671',
      label: 'Narkand',
      type: 'City'
    },
    {
      value: '5672',
      label: 'Narketpalli',
      type: 'City'
    },
    {
      value: '5673',
      label: 'Narkhoria',
      type: 'City'
    },
    {
      value: '5674',
      label: 'Narnaul',
      type: 'City'
    },
    {
      value: '5675',
      label: 'Narol',
      type: 'City'
    },
    {
      value: '5676',
      label: 'Narpatganj',
      type: 'City'
    },
    {
      value: '5677',
      label: 'Narrawada',
      type: 'City'
    },
    {
      value: '5678',
      label: 'Narsana',
      type: 'City'
    },
    {
      value: '5679',
      label: 'Narsapur',
      type: 'City'
    },
    {
      value: '5680',
      label: 'Narsapuram',
      type: 'City'
    },
    {
      value: '5681',
      label: 'Narsapuram (Andhra Pradesh)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5682',
      label: 'Narsaraopet',
      type: 'City'
    },
    {
      value: '5683',
      label: 'Narsayapalem',
      type: 'City'
    },
    {
      value: '5684',
      label: 'Narsi',
      type: 'City'
    },
    {
      value: '5685',
      label: 'Narsinghgarh',
      type: 'City'
    },
    {
      value: '5686',
      label: 'Narsinghpur',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '5687',
      label: 'Narsinhwadi',
      type: 'City'
    },
    {
      value: '5688',
      label: 'Narsipatnam',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5689',
      label: 'NARVAI',
      type: 'City'
    },
    {
      value: '5690',
      label: 'Narvan',
      type: 'City'
    },
    {
      value: '5691',
      label: 'Narwali',
      type: 'City'
    },
    {
      value: '5692',
      label: 'Narwana',
      type: 'City'
    },
    {
      value: '5693',
      label: 'Narwar',
      type: 'City'
    },
    {
      value: '5694',
      label: 'Naseerabad',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5695',
      label: 'Naseerabagh',
      type: 'City'
    },
    {
      value: '5696',
      label: 'Nashik',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5697',
      label: 'Nashirabad',
      type: 'City'
    },
    {
      value: '5698',
      label: 'Nasik',
      type: 'City'
    },
    {
      value: '5699',
      label: 'Nasirabad',
      type: 'City'
    },
    {
      value: '5700',
      label: 'Nasirabad (Maharashtra)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5701',
      label: 'Nasirabad (rajasthan)',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '5702',
      label: 'Nasirabad Maharashtra',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5703',
      label: 'Nasirabad Rajasthan',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '5704',
      label: 'Nasirabad, Maharashtra',
      type: 'City'
    },
    {
      value: '5705',
      label: 'Nasirabad, Rajasthan',
      type: 'City'
    },
    {
      value: '5706',
      label: 'Nasirabad, UP',
      type: 'City'
    },
    {
      value: '5707',
      label: 'Nasrullaganj',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '5708',
      label: 'Nasvadi',
      type: 'City'
    },
    {
      value: '5709',
      label: 'Nate',
      type: 'City'
    },
    {
      value: '5710',
      label: 'Natepute',
      type: 'City'
    },
    {
      value: '5711',
      label: 'Nathdwara',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '5712',
      label: 'Nathpa',
      type: 'City'
    },
    {
      value: '5713',
      label: 'Nathusari Chopta',
      type: 'City'
    },
    {
      value: '5714',
      label: 'Natta Raameshwaram',
      type: 'City'
    },
    {
      value: '5715',
      label: 'Natta Rameswaram',
      type: 'City'
    },
    {
      value: '5716',
      label: 'Nattarasankottai',
      type: 'City'
    },
    {
      value: '5717',
      label: 'Natunde',
      type: 'City'
    },
    {
      value: '5718',
      label: 'Naubatpur',
      type: 'City'
    },
    {
      value: '5719',
      label: 'Naugaon, MP',
      type: 'City'
    },
    {
      value: '5720',
      label: 'Naugaon, Odisha',
      type: 'City'
    },
    {
      value: '5721',
      label: 'Naugarh',
      type: 'City'
    },
    {
      value: '5722',
      label: 'Naukha',
      type: 'City'
    },
    {
      value: '5723',
      label: 'Nauni',
      type: 'City'
    },
    {
      value: '5724',
      label: 'Nautanwa',
      type: 'City'
    },
    {
      value: '5725',
      label: 'Nava Ujala',
      type: 'City'
    },
    {
      value: '5726',
      label: 'Navagadh',
      type: 'City'
    },
    {
      value: '5727',
      label: 'Navagadh  Jetpur',
      type: 'City'
    },
    {
      value: '5728',
      label: 'Navagadh Railway Station Road',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5729',
      label: 'Navagam',
      type: 'City'
    },
    {
      value: '5730',
      label: 'Navaghadh',
      type: 'City'
    },
    {
      value: '5731',
      label: 'Navaladi',
      type: 'City'
    },
    {
      value: '5732',
      label: 'Navalagund',
      type: 'City'
    },
    {
      value: '5733',
      label: 'Navalgund',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5734',
      label: 'Navalpur',
      type: 'City'
    },
    {
      value: '5735',
      label: 'Navaniya',
      type: 'City'
    },
    {
      value: '5736',
      label: 'Navapur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5737',
      label: 'Navarasapuram',
      type: 'City'
    },
    {
      value: '5738',
      label: 'Navavaghaniya',
      type: 'City'
    },
    {
      value: '5739',
      label: 'Navgaon',
      type: 'City'
    },
    {
      value: '5740',
      label: 'Navi Haliyad',
      type: 'City'
    },
    {
      value: '5741',
      label: 'Navi Mumbai',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5742',
      label: 'Navsari',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5743',
      label: 'Navuduru',
      type: 'City'
    },
    {
      value: '5744',
      label: 'Navunda',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5745',
      label: 'Nawa',
      type: 'City'
    },
    {
      value: '5746',
      label: 'Nawabganj',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '5747',
      label: 'Nawada',
      type: 'City'
    },
    {
      value: '5748',
      label: 'Nawalgarh',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '5749',
      label: 'Nawanshahr',
      type: 'City'
    },
    {
      value: '5750',
      label: 'Nawpedwa Road',
      type: 'City'
    },
    {
      value: '5751',
      label: 'Nayagaon',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '5752',
      label: 'Nayagaon, MP',
      type: 'City'
    },
    {
      value: '5753',
      label: 'Nayagaon, Rajasthan',
      type: 'City'
    },
    {
      value: '5754',
      label: 'Nayagarh',
      type: 'City'
    },
    {
      value: '5755',
      label: 'Nayakanakatte',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5756',
      label: 'Naydongri',
      type: 'City'
    },
    {
      value: '5757',
      label: 'Nazareth',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5758',
      label: 'Nazca (Lca Peru)',
      type: 'City'
    },
    {
      value: '5759',
      label: 'Nazira',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '5760',
      label: 'Necochea',
      type: 'City'
    },
    {
      value: '5761',
      label: 'Nedra',
      type: 'City'
    },
    {
      value: '5762',
      label: 'Nedumboil',
      type: 'City'
    },
    {
      value: '5763',
      label: 'Nedumkandam',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '5764',
      label: 'Nedumpoil',
      type: 'City'
    },
    {
      value: '5765',
      label: 'Nedumpoyil',
      type: 'City'
    },
    {
      value: '5766',
      label: 'Nedumudy',
      type: 'City'
    },
    {
      value: '5767',
      label: 'Nedunggandam',
      type: 'City'
    },
    {
      value: '5768',
      label: 'Needamangalam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5769',
      label: 'Neeleeswaram',
      type: 'City'
    },
    {
      value: '5770',
      label: 'Neelkanth',
      type: 'City'
    },
    {
      value: '5771',
      label: 'Neem ka thana',
      type: 'City'
    },
    {
      value: '5772',
      label: 'Neembla',
      type: 'City'
    },
    {
      value: '5773',
      label: 'Neemrana',
      type: 'City'
    },
    {
      value: '5774',
      label: 'Neemuch',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '5775',
      label: 'Neemuch',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '5776',
      label: 'Nehiriana',
      type: 'City'
    },
    {
      value: '5777',
      label: 'Nehran Pukhar',
      type: 'City'
    },
    {
      value: '5778',
      label: 'Nekarikallu',
      type: 'City'
    },
    {
      value: '5779',
      label: 'Neknoor',
      type: 'City'
    },
    {
      value: '5780',
      label: 'Nelamangala',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5781',
      label: 'Nelkaranji',
      type: 'City'
    },
    {
      value: '5782',
      label: 'Nellai',
      type: 'City'
    },
    {
      value: '5783',
      label: 'Nellikar',
      type: 'City'
    },
    {
      value: '5784',
      label: 'Nellimarla',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5785',
      label: 'Nellore',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5786',
      label: 'Nellore (Bypass)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5787',
      label: 'Nellore Palem',
      type: 'City'
    },
    {
      value: '5788',
      label: 'Nelyady',
      type: 'City'
    },
    {
      value: '5789',
      label: 'Nemathanpatti',
      type: 'City'
    },
    {
      value: '5790',
      label: 'Nemawar',
      type: 'City'
    },
    {
      value: '5791',
      label: 'Nenava',
      type: 'City'
    },
    {
      value: '5792',
      label: 'Nepanagar',
      type: 'City'
    },
    {
      value: '5793',
      label: 'Ner',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5794',
      label: 'Ner (Dhule)',
      type: 'City'
    },
    {
      value: '5795',
      label: 'Ner Chowk',
      type: 'City'
    },
    {
      value: '5796',
      label: 'Neralakatte',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5797',
      label: 'Neri Bk.',
      type: 'City'
    },
    {
      value: '5798',
      label: 'Neri, Himachal Pradesh',
      type: 'City'
    },
    {
      value: '5799',
      label: 'Neri, Maharashtra',
      type: 'City'
    },
    {
      value: '5800',
      label: 'Neriamangalam',
      type: 'City'
    },
    {
      value: '5801',
      label: 'Nerul',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5802',
      label: 'Nerwa',
      type: 'City'
    },
    {
      value: '5803',
      label: 'Nesadi',
      type: 'City'
    },
    {
      value: '5804',
      label: 'Nesari',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5805',
      label: 'Nesdi',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5806',
      label: 'Neser pet',
      type: 'City'
    },
    {
      value: '5807',
      label: 'Neswad',
      type: 'City'
    },
    {
      value: '5808',
      label: 'Nethaur',
      type: 'City'
    },
    {
      value: '5809',
      label: 'Nethivaripalem',
      type: 'City'
    },
    {
      value: '5810',
      label: 'Netra',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5811',
      label: 'Netramali',
      type: 'City'
    },
    {
      value: '5812',
      label: 'Netramli',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5813',
      label: 'Netrang',
      type: 'City'
    },
    {
      value: '5814',
      label: 'Nette',
      type: 'City'
    },
    {
      value: '5815',
      label: 'Nevasaphata',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5816',
      label: 'New Delhi',
      type: 'City'
    },
    {
      value: '5817',
      label: 'new york',
      type: 'City'
    },
    {
      value: '5818',
      label: 'Newasa',
      type: 'City'
    },
    {
      value: '5819',
      label: 'Newasa Fata',
      type: 'City'
    },
    {
      value: '5820',
      label: 'Newton',
      type: 'City'
    },
    {
      value: '5821',
      label: 'newyork',
      type: 'City'
    },
    {
      value: '5822',
      label: 'Neyveli',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5823',
      label: 'Neyyattinkara',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '5824',
      label: 'Nibaiheda',
      type: 'City'
    },
    {
      value: '5825',
      label: 'Nidadavolu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5826',
      label: 'Nidagundi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5827',
      label: 'Nidamangalam',
      type: 'City'
    },
    {
      value: '5828',
      label: 'Nidamanuru  Vijayawada',
      type: 'City'
    },
    {
      value: '5829',
      label: 'Nidamarru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5830',
      label: 'Nidamolu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5831',
      label: 'Nidgundi',
      type: 'City'
    },
    {
      value: '5832',
      label: 'Nidhori',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5833',
      label: 'Nidimukala',
      type: 'City'
    },
    {
      value: '5834',
      label: 'Nidugundi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5835',
      label: 'Nidumolu',
      type: 'City'
    },
    {
      value: '5836',
      label: 'Nidumukkala',
      type: 'City'
    },
    {
      value: '5837',
      label: 'Nigari',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5838',
      label: 'Nigdi (Pune)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5839',
      label: 'Nighasan',
      type: 'City'
    },
    {
      value: '5840',
      label: 'Nigul Sari',
      type: 'City'
    },
    {
      value: '5841',
      label: 'Nihari',
      type: 'City'
    },
    {
      value: '5842',
      label: 'Nikava',
      type: 'City'
    },
    {
      value: '5843',
      label: 'Nikker',
      type: 'City'
    },
    {
      value: '5844',
      label: 'Nikumbh',
      type: 'City'
    },
    {
      value: '5845',
      label: 'NILAHUE',
      type: 'City'
    },
    {
      value: '5846',
      label: 'Nilakottai',
      type: 'City'
    },
    {
      value: '5847',
      label: 'Nilambur',
      type: 'City'
    },
    {
      value: '5848',
      label: 'Nilamel',
      type: 'City'
    },
    {
      value: '5849',
      label: 'Nilanga',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5850',
      label: 'Nilanggaaurad',
      type: 'City'
    },
    {
      value: '5851',
      label: 'Nileshwar',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '5852',
      label: 'Nilokheri',
      type: 'City'
    },
    {
      value: '5853',
      label: 'Nimaaj',
      type: 'City'
    },
    {
      value: '5854',
      label: 'Nimach',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '5855',
      label: 'Nimaheda',
      type: 'City'
    },
    {
      value: '5856',
      label: 'Nimba',
      type: 'City'
    },
    {
      value: '5857',
      label: 'Nimbada',
      type: 'City'
    },
    {
      value: '5858',
      label: 'Nimbahera',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '5859',
      label: 'Nimbahera Jatan',
      type: 'City'
    },
    {
      value: '5860',
      label: 'Nimbaj',
      type: 'City'
    },
    {
      value: '5861',
      label: 'Nimbi Jodhan',
      type: 'City'
    },
    {
      value: '5862',
      label: 'Nimblana',
      type: 'City'
    },
    {
      value: '5863',
      label: 'Nimbola',
      type: 'City'
    },
    {
      value: '5864',
      label: 'Nimed',
      type: 'City'
    },
    {
      value: '5865',
      label: 'Nimgaon',
      type: 'City'
    },
    {
      value: '5866',
      label: 'Nimgaon Jali',
      type: 'City'
    },
    {
      value: '5867',
      label: 'Nimgul',
      type: 'City'
    },
    {
      value: '5868',
      label: 'Nimla',
      type: 'City'
    },
    {
      value: '5869',
      label: 'Ninan',
      type: 'City'
    },
    {
      value: '5870',
      label: 'Ningala',
      type: 'City'
    },
    {
      value: '5871',
      label: 'Nipani',
      type: 'City'
    },
    {
      value: '5872',
      label: 'Nipanni By Pass',
      type: 'City'
    },
    {
      value: '5873',
      label: 'Niphad',
      type: 'City'
    },
    {
      value: '5874',
      label: 'Nippani',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5875',
      label: 'Nirath',
      type: 'City'
    },
    {
      value: '5876',
      label: 'Nirmal',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5877',
      label: 'Nirmali',
      type: 'City'
    },
    {
      value: '5878',
      label: 'Nirwal',
      type: 'City'
    },
    {
      value: '5879',
      label: 'Nithiravilai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5880',
      label: 'Nitk Beach',
      type: 'City'
    },
    {
      value: '5881',
      label: 'NITK Surathkal',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5882',
      label: 'Nitte',
      type: 'City'
    },
    {
      value: '5883',
      label: 'Nitte (Karkala)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5884',
      label: 'Nitte(Mangalore)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5885',
      label: 'Nittur',
      type: 'City'
    },
    {
      value: '5886',
      label: 'Nittur  Shimoga',
      type: 'City'
    },
    {
      value: '5887',
      label: 'Nitur',
      type: 'City'
    },
    {
      value: '5888',
      label: 'Nivali',
      type: 'City'
    },
    {
      value: '5889',
      label: 'Nivli',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '5890',
      label: 'Nivliphata',
      type: 'City'
    },
    {
      value: '5891',
      label: 'Niwai',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '5892',
      label: 'Niwari',
      type: 'City'
    },
    {
      value: '5893',
      label: 'Niwas',
      type: 'City'
    },
    {
      value: '5894',
      label: 'Niwgha',
      type: 'City'
    },
    {
      value: '5895',
      label: 'Nizamabad',
      type: 'City',
      'state': 'Telangana'
    },
    {
      value: '5896',
      label: 'Nizamabad, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '5897',
      label: 'Nizamabad, Telangana',
      type: 'City'
    },
    {
      value: '5898',
      label: 'Nizambad',
      type: 'City'
    },
    {
      value: '5899',
      label: 'Nizampur',
      type: 'City'
    },
    {
      value: '5900',
      label: 'Nizar',
      type: 'City'
    },
    {
      value: '5901',
      label: 'Noghanvadar',
      type: 'City'
    },
    {
      value: '5902',
      label: 'Nogli',
      type: 'City'
    },
    {
      value: '5903',
      label: 'Nohar',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '5904',
      label: 'Nohradhar',
      type: 'City'
    },
    {
      value: '5905',
      label: 'Noida',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '5906',
      label: 'Noida',
      type: 'City',
      'state': 'Delhi'
    },
    {
      value: '5907',
      label: 'Nokha',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '5908',
      label: 'Nokhra',
      type: 'City'
    },
    {
      value: '5909',
      label: 'Noojadi Road',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5910',
      label: 'Noon',
      type: 'City'
    },
    {
      value: '5911',
      label: 'Noorpur',
      type: 'City'
    },
    {
      value: '5912',
      label: 'North Goa',
      type: 'City'
    },
    {
      value: '5913',
      label: 'North Lakhimpur',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '5914',
      label: 'Nosra',
      type: 'City'
    },
    {
      value: '5915',
      label: 'Nova',
      type: 'City'
    },
    {
      value: '5916',
      label: 'Nowgong',
      type: 'City'
    },
    {
      value: '5917',
      label: 'Nowrozabad',
      type: 'City'
    },
    {
      value: '5918',
      label: 'NR-Peta',
      type: 'City'
    },
    {
      value: '5919',
      label: 'Nuagam',
      type: 'City'
    },
    {
      value: '5920',
      label: 'NUEVA IMPERIAL',
      type: 'City'
    },
    {
      value: '5921',
      label: 'Nujadi',
      type: 'City'
    },
    {
      value: '5922',
      label: 'Nujari',
      type: 'City'
    },
    {
      value: '5923',
      label: 'Numaligarh',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '5924',
      label: 'Nunna',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5925',
      label: 'Nurpur',
      type: 'City'
    },
    {
      value: '5926',
      label: 'Nuthalapadu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5927',
      label: 'Nuzendla',
      type: 'City'
    },
    {
      value: '5928',
      label: 'Nuziveedu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5929',
      label: 'Nyamathi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5930',
      label: 'Oachira',
      type: 'City'
    },
    {
      value: '5931',
      label: 'Obaidullaganj',
      type: 'City'
    },
    {
      value: '5932',
      label: 'Ochira',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '5933',
      label: 'Odaipatti',
      type: 'City'
    },
    {
      value: '5934',
      label: 'Odakkali',
      type: 'City'
    },
    {
      value: '5935',
      label: 'Oddanchataram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5936',
      label: 'Oddanchatram',
      type: 'City'
    },
    {
      value: '5937',
      label: 'Oddi',
      type: 'City'
    },
    {
      value: '5938',
      label: 'Odumalai',
      type: 'City'
    },
    {
      value: '5939',
      label: 'Ogalewadi',
      type: 'City'
    },
    {
      value: '5940',
      label: 'Ojhara',
      type: 'City'
    },
    {
      value: '5941',
      label: 'Okha',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5942',
      label: 'Okkur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5943',
      label: 'Olavapadu',
      type: 'City'
    },
    {
      value: '5944',
      label: 'Oliya',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '5945',
      label: 'Ollur  Thrissur',
      type: 'City'
    },
    {
      value: '5946',
      label: 'Omerga',
      type: 'City'
    },
    {
      value: '5947',
      label: 'Omkareshwar',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '5948',
      label: 'Ongole',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5949',
      label: 'Ongole Byepass',
      type: 'City'
    },
    {
      value: '5950',
      label: 'Ongole By-pass',
      type: 'City'
    },
    {
      value: '5951',
      label: 'Oni',
      type: 'City'
    },
    {
      value: '5952',
      label: 'Onitsha',
      type: 'City'
    },
    {
      value: '5953',
      label: 'Onthibettu',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '5954',
      label: 'Oonnukal',
      type: 'City'
    },
    {
      value: '5955',
      label: 'Oorambu',
      type: 'City'
    },
    {
      value: '5956',
      label: 'Ootacamund',
      type: 'City'
    },
    {
      value: '5957',
      label: 'Ootanchathiram',
      type: 'City'
    },
    {
      value: '5958',
      label: 'Ooty',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5959',
      label: 'Ooty S S',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5960',
      label: 'Opilan',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5961',
      label: 'Oppilan',
      type: 'City'
    },
    {
      value: '5962',
      label: 'Orai',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '5963',
      label: 'Orathanadu',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5964',
      label: 'Oriya',
      type: 'City'
    },
    {
      value: '5965',
      label: 'Oros',
      type: 'City'
    },
    {
      value: '5966',
      label: 'Orthanad',
      type: 'City'
    },
    {
      value: '5967',
      label: 'Osian',
      type: 'City'
    },
    {
      value: '5968',
      label: 'Osiyan',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '5969',
      label: 'Osmanabad',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5970',
      label: 'Osorno',
      type: 'City'
    },
    {
      value: '5971',
      label: 'Otha',
      type: 'City'
    },
    {
      value: '5972',
      label: 'Ottancatram',
      type: 'City'
    },
    {
      value: '5973',
      label: 'Ottanchathiram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5974',
      label: 'Ottanchattram',
      type: 'City'
    },
    {
      value: '5975',
      label: 'Ottapalam',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '5976',
      label: 'Ottapidaram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '5977',
      label: 'Otwala',
      type: 'City'
    },
    {
      value: '5978',
      label: 'Oupada',
      type: 'City'
    },
    {
      value: '5979',
      label: 'Owk',
      type: 'City'
    },
    {
      value: '5980',
      label: 'Ozar',
      type: 'City'
    },
    {
      value: '5981',
      label: 'P.Gannavaram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5982',
      label: 'P.LAS CASAS',
      type: 'City'
    },
    {
      value: '5983',
      label: 'P.O. Hatwar  Dehra',
      type: 'City'
    },
    {
      value: '5984',
      label: 'Paakkad By Pass',
      type: 'City'
    },
    {
      value: '5985',
      label: 'Paarl',
      type: 'City'
    },
    {
      value: '5986',
      label: 'Paarl Centre Town',
      type: 'City'
    },
    {
      value: '5987',
      label: 'Paarl Klapmuts',
      type: 'City'
    },
    {
      value: '5988',
      label: 'Pach Khora',
      type: 'City'
    },
    {
      value: '5989',
      label: 'Pachal',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5990',
      label: 'Pachapachiya',
      type: 'City'
    },
    {
      value: '5991',
      label: 'Pachmarhi',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '5992',
      label: 'Pachmarhi(MP)',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '5993',
      label: 'Pachod',
      type: 'City'
    },
    {
      value: '5994',
      label: 'Pachora',
      type: 'City'
    },
    {
      value: '5995',
      label: 'Pachora (Maharashtra)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '5996',
      label: 'Pachore',
      type: 'City'
    },
    {
      value: '5997',
      label: 'Pachpadra',
      type: 'City'
    },
    {
      value: '5998',
      label: 'Pachperwa',
      type: 'City'
    },
    {
      value: '5999',
      label: 'Pachrukhia',
      type: 'City'
    },
    {
      value: '6000',
      label: 'Pachwad',
      type: 'City'
    },
    {
      value: '6001',
      label: 'Padadhari',
      type: 'City'
    },
    {
      value: '6002',
      label: 'Padadhri',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6003',
      label: 'Padalsingi',
      type: 'City'
    },
    {
      value: '6004',
      label: 'Padamata Palem',
      type: 'City'
    },
    {
      value: '6005',
      label: 'Padampur',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6006',
      label: 'Padardi',
      type: 'City'
    },
    {
      value: '6007',
      label: 'Paddar',
      type: 'City'
    },
    {
      value: '6008',
      label: 'Padel  Pural',
      type: 'City'
    },
    {
      value: '6009',
      label: 'Padhar',
      type: 'City'
    },
    {
      value: '6010',
      label: 'Padmapur',
      type: 'City'
    },
    {
      value: '6011',
      label: 'Padoli',
      type: 'City'
    },
    {
      value: '6012',
      label: 'Padra',
      type: 'City'
    },
    {
      value: '6013',
      label: 'Padrauna',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '6014',
      label: 'Padru',
      type: 'City'
    },
    {
      value: '6015',
      label: 'Padubidri',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '6016',
      label: 'Padukallan',
      type: 'City'
    },
    {
      value: '6017',
      label: 'Padukkapathu',
      type: 'City'
    },
    {
      value: '6018',
      label: 'Padukkapathu(tuticorin)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6019',
      label: 'Padukone',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '6020',
      label: 'Padupanambur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '6021',
      label: 'Padupanambur  Mulki',
      type: 'City'
    },
    {
      value: '6022',
      label: 'Padwa',
      type: 'City'
    },
    {
      value: '6023',
      label: 'Padyarabettu',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '6024',
      label: 'Pagaria',
      type: 'City'
    },
    {
      value: '6025',
      label: 'Pahadi Kheda',
      type: 'City'
    },
    {
      value: '6026',
      label: 'Pahalgam',
      type: 'City',
      'state': 'Jammu & Kashmir'
    },
    {
      value: '6027',
      label: 'Pahra',
      type: 'City'
    },
    {
      value: '6028',
      label: 'Pahur',
      type: 'City'
    },
    {
      value: '6029',
      label: 'Pahur (Jalgaon)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6030',
      label: 'Pailani',
      type: 'City'
    },
    {
      value: '6031',
      label: 'Pailapool',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '6032',
      label: 'PAILLACO',
      type: 'City'
    },
    {
      value: '6033',
      label: 'Paingottoor',
      type: 'City'
    },
    {
      value: '6034',
      label: 'Paithan',
      type: 'City'
    },
    {
      value: '6035',
      label: 'Pakela',
      type: 'City'
    },
    {
      value: '6036',
      label: 'Pakka Saharana',
      type: 'City'
    },
    {
      value: '6037',
      label: 'Pala',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6038',
      label: 'Palavalue',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6039',
      label: 'Palakkad',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6040',
      label: 'Palakkad By Pass',
      type: 'City'
    },
    {
      value: '6041',
      label: 'Palakkad Bypass',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6042',
      label: 'Palakollu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6043',
      label: 'Palakonda',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6044',
      label: 'Palakunnu',
      type: 'City'
    },
    {
      value: '6045',
      label: 'Palam',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6046',
      label: 'Palamaner',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6047',
      label: 'Palamaneru',
      type: 'City'
    },
    {
      value: '6048',
      label: 'Palampur',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '6049',
      label: 'Palana',
      type: 'City'
    },
    {
      value: '6050',
      label: 'Palani',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6051',
      label: 'Palanpur',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6052',
      label: 'Palari',
      type: 'City'
    },
    {
      value: '6053',
      label: 'Palarivattam',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6054',
      label: 'Palarivattom',
      type: 'City'
    },
    {
      value: '6055',
      label: 'Palarivattom  Kochi',
      type: 'City'
    },
    {
      value: '6056',
      label: 'Palasa',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6057',
      label: 'Palasava',
      type: 'City'
    },
    {
      value: '6058',
      label: 'Palasner',
      type: 'City'
    },
    {
      value: '6059',
      label: 'Palavancha',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6060',
      label: 'Palayakayal',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6061',
      label: 'Palayakkayal',
      type: 'City'
    },
    {
      value: '6062',
      label: 'Palayam',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6063',
      label: 'Palcot',
      type: 'City'
    },
    {
      value: '6064',
      label: 'Palda Naka Indore',
      type: 'City'
    },
    {
      value: '6065',
      label: 'Paldhi',
      type: 'City'
    },
    {
      value: '6066',
      label: 'Paldi',
      type: 'City'
    },
    {
      value: '6067',
      label: 'Paldi-Ahmedabad',
      type: 'City'
    },
    {
      value: '6068',
      label: 'Palej',
      type: 'City'
    },
    {
      value: '6069',
      label: 'Palera',
      type: 'City'
    },
    {
      value: '6070',
      label: 'Palgad',
      type: 'City'
    },
    {
      value: '6071',
      label: 'Palghar (Thane)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6072',
      label: 'Palghat',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6073',
      label: 'Pali',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6074',
      label: 'Pali  Ratnagiri',
      type: 'City'
    },
    {
      value: '6075',
      label: 'Pali (Gujarat)',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6076',
      label: 'Pali Birsinghpur',
      type: 'City'
    },
    {
      value: '6077',
      label: 'Pali, Chhattisgarh',
      type: 'City'
    },
    {
      value: '6078',
      label: 'Pali, Gujarat',
      type: 'City'
    },
    {
      value: '6079',
      label: 'Pali, Maharashtra',
      type: 'City'
    },
    {
      value: '6080',
      label: 'Pali, Rajasthan',
      type: 'City'
    },
    {
      value: '6081',
      label: 'Pali, UP',
      type: 'City'
    },
    {
      value: '6082',
      label: 'Palia',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '6083',
      label: 'Palia Kalan',
      type: 'City'
    },
    {
      value: '6084',
      label: 'Paliganj',
      type: 'City'
    },
    {
      value: '6085',
      label: 'Palitana',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6086',
      label: 'Palivela',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6087',
      label: 'Paliya',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '6088',
      label: 'Paliyad',
      type: 'City'
    },
    {
      value: '6089',
      label: 'Palkulam  Thoothukudi',
      type: 'City'
    },
    {
      value: '6090',
      label: 'Palladam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6091',
      label: 'Pallamkuru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6092',
      label: 'Pallapatti',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6093',
      label: 'Pallathur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6094',
      label: 'Pallickathodu',
      type: 'City'
    },
    {
      value: '6095',
      label: 'Palliedi',
      type: 'City'
    },
    {
      value: '6096',
      label: 'Pallikere',
      type: 'City'
    },
    {
      value: '6097',
      label: 'Pallikunnu',
      type: 'City'
    },
    {
      value: '6098',
      label: 'Pallivasal',
      type: 'City'
    },
    {
      value: '6099',
      label: 'Pallivela',
      type: 'City'
    },
    {
      value: '6100',
      label: 'Palloor',
      type: 'City'
    },
    {
      value: '6101',
      label: 'Pallu',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6102',
      label: 'PALMILLA',
      type: 'City'
    },
    {
      value: '6103',
      label: 'Paloda',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6104',
      label: 'Palsam',
      type: 'City'
    },
    {
      value: '6105',
      label: 'Palsana',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6106',
      label: 'Palsana, Gujarat',
      type: 'City'
    },
    {
      value: '6107',
      label: 'Palsana, Rajasthan',
      type: 'City'
    },
    {
      value: '6108',
      label: 'Palus',
      type: 'City'
    },
    {
      value: '6109',
      label: 'Palvancha',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6110',
      label: 'Palwal',
      type: 'City'
    },
    {
      value: '6111',
      label: 'Palwancha',
      type: 'City'
    },
    {
      value: '6112',
      label: 'Palwas',
      type: 'City'
    },
    {
      value: '6113',
      label: 'Pamarru',
      type: 'City'
    },
    {
      value: '6114',
      label: 'Pamarru (Krishna District)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6115',
      label: 'Pamba',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6116',
      label: 'Pamban',
      type: 'City'
    },
    {
      value: '6117',
      label: 'Pambanar',
      type: 'City'
    },
    {
      value: '6118',
      label: 'Pamidi',
      type: 'City'
    },
    {
      value: '6119',
      label: 'Pampady',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6120',
      label: 'Pamuru',
      type: 'City'
    },
    {
      value: '6121',
      label: 'Pamuru (Prakasham District)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6122',
      label: 'Panagar',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '6123',
      label: 'Panagarh',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '6124',
      label: 'Panaikudi',
      type: 'City'
    },
    {
      value: '6125',
      label: 'Panaikulam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6126',
      label: 'Panaiyur',
      type: 'City'
    },
    {
      value: '6127',
      label: 'Panaji',
      type: 'City',
      'state': 'Goa'
    },
    {
      value: '6128',
      label: 'Panakudi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6129',
      label: 'Panamaram',
      type: 'City'
    },
    {
      value: '6130',
      label: 'Panambur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '6131',
      label: 'Panambur  Mangaluru',
      type: 'City'
    },
    {
      value: '6132',
      label: 'Panathur',
      type: 'City'
    },
    {
      value: '6133',
      label: 'Panavadali Chatram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6134',
      label: 'Panchgani',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6135',
      label: 'Panchgaon',
      type: 'City'
    },
    {
      value: '6136',
      label: 'Panchkula',
      type: 'City',
      'state': 'Haryana'
    },
    {
      value: '6137',
      label: 'Panchori',
      type: 'City'
    },
    {
      value: '6138',
      label: 'Panchot',
      type: 'City'
    },
    {
      value: '6139',
      label: 'Panchpipla',
      type: 'City'
    },
    {
      value: '6140',
      label: 'Panchrukhi',
      type: 'City'
    },
    {
      value: '6141',
      label: 'Panchvada',
      type: 'City'
    },
    {
      value: '6142',
      label: 'Panchvamal',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6143',
      label: 'Panchwad',
      type: 'City'
    },
    {
      value: '6144',
      label: 'Pandaaravilai',
      type: 'City'
    },
    {
      value: '6145',
      label: 'Pandalam',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6146',
      label: 'Pandalkudi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6147',
      label: 'Pandaravilai',
      type: 'City'
    },
    {
      value: '6148',
      label: 'Pandarkavda',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6149',
      label: 'Pandavapura',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '6150',
      label: 'Pandesra',
      type: 'City'
    },
    {
      value: '6151',
      label: 'Pandhargaon',
      type: 'City'
    },
    {
      value: '6152',
      label: 'Pandharkawada',
      type: 'City'
    },
    {
      value: '6153',
      label: 'Pandharpur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6154',
      label: 'Pandhro',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6155',
      label: 'Pandhurna',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '6156',
      label: 'Pandicherry',
      type: 'City'
    },
    {
      value: '6157',
      label: 'Pandiripani',
      type: 'City'
    },
    {
      value: '6158',
      label: 'Pandithavalluru',
      type: 'City'
    },
    {
      value: '6159',
      label: 'Pandoh',
      type: 'City'
    },
    {
      value: '6160',
      label: 'Pandopara',
      type: 'City'
    },
    {
      value: '6161',
      label: 'Pandranu',
      type: 'City'
    },
    {
      value: '6162',
      label: 'Pandwa Mod',
      type: 'City'
    },
    {
      value: '6163',
      label: 'Paneli',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6164',
      label: 'Paneli Moti',
      type: 'City'
    },
    {
      value: '6165',
      label: 'Panemangalore',
      type: 'City'
    },
    {
      value: '6166',
      label: 'Pangala',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '6167',
      label: 'Pangam',
      type: 'City'
    },
    {
      value: '6168',
      label: 'Pangaon',
      type: 'City'
    },
    {
      value: '6169',
      label: 'Pangidi',
      type: 'City'
    },
    {
      value: '6170',
      label: 'Pangidi Cheruvu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6171',
      label: 'Pangidi, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '6172',
      label: 'Pangidi, Telangana',
      type: 'City'
    },
    {
      value: '6173',
      label: 'Pangidigudem',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6174',
      label: 'Pangire',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '6175',
      label: 'Pangri',
      type: 'City'
    },
    {
      value: '6176',
      label: 'PANGUIPULLI',
      type: 'City'
    },
    {
      value: '6177',
      label: 'Paniar',
      type: 'City'
    },
    {
      value: '6178',
      label: 'Panidhra',
      type: 'City'
    },
    {
      value: '6179',
      label: 'Panipat',
      type: 'City',
      'state': 'Haryana'
    },
    {
      value: '6180',
      label: 'Paniya',
      type: 'City'
    },
    {
      value: '6181',
      label: 'Panjehra',
      type: 'City'
    },
    {
      value: '6182',
      label: 'Panjim',
      type: 'City',
      'state': 'Goa'
    },
    {
      value: '6183',
      label: 'Panjot',
      type: 'City'
    },
    {
      value: '6184',
      label: 'Panjuana',
      type: 'City'
    },
    {
      value: '6185',
      label: 'Panna',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '6186',
      label: 'Pannaivillai',
      type: 'City'
    },
    {
      value: '6187',
      label: 'Panoli',
      type: 'City'
    },
    {
      value: '6188',
      label: 'Panoor',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6189',
      label: 'Panotiya',
      type: 'City'
    },
    {
      value: '6190',
      label: 'Panruti',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6191',
      label: 'Panrutty',
      type: 'City'
    },
    {
      value: '6192',
      label: 'Pansada',
      type: 'City'
    },
    {
      value: '6193',
      label: 'Pansemal',
      type: 'City'
    },
    {
      value: '6194',
      label: 'Panthawada',
      type: 'City'
    },
    {
      value: '6195',
      label: 'Pantheri',
      type: 'City'
    },
    {
      value: '6196',
      label: 'Panvel',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6197',
      label: 'Panvel  Navi Mumbai',
      type: 'City'
    },
    {
      value: '6198',
      label: 'Panvi',
      type: 'City'
    },
    {
      value: '6199',
      label: 'Panwa',
      type: 'City'
    },
    {
      value: '6200',
      label: 'Panwari',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '6201',
      label: 'Panwel',
      type: 'City'
    },
    {
      value: '6202',
      label: 'Paonta',
      type: 'City'
    },
    {
      value: '6203',
      label: 'Paonta Sahib',
      type: 'City'
    },
    {
      value: '6204',
      label: 'Paonta Sahib (Himachal Pradesh)',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '6205',
      label: 'Paota',
      type: 'City'
    },
    {
      value: '6206',
      label: 'Papanasam(Tirunelveli)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6207',
      label: 'Pappadahandi',
      type: 'City'
    },
    {
      value: '6208',
      label: 'Pappanadu',
      type: 'City'
    },
    {
      value: '6209',
      label: 'Pappireddipatti',
      type: 'City'
    },
    {
      value: '6210',
      label: 'Paprenda',
      type: 'City'
    },
    {
      value: '6211',
      label: 'Paprola',
      type: 'City'
    },
    {
      value: '6212',
      label: 'Parab',
      type: 'City'
    },
    {
      value: '6213',
      label: 'Parad',
      type: 'City'
    },
    {
      value: '6214',
      label: 'Paradeep',
      type: 'City'
    },
    {
      value: '6215',
      label: 'Paradsinga',
      type: 'City'
    },
    {
      value: '6216',
      label: 'Parakkadavu',
      type: 'City'
    },
    {
      value: '6217',
      label: 'Paralachi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6218',
      label: 'Paralakhemundi',
      type: 'City'
    },
    {
      value: '6219',
      label: 'Parali',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6220',
      label: 'Paramakudi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6221',
      label: 'Paramankurichi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6222',
      label: 'Paramathi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6223',
      label: 'Paramathivellore',
      type: 'City'
    },
    {
      value: '6224',
      label: 'Paramathivelur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6225',
      label: 'Paranda',
      type: 'City'
    },
    {
      value: '6226',
      label: 'Parappadi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6227',
      label: 'Parappu',
      type: 'City'
    },
    {
      value: '6228',
      label: 'Parasia',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '6229',
      label: 'Parasoli',
      type: 'City'
    },
    {
      value: '6230',
      label: 'Paraspur',
      type: 'City'
    },
    {
      value: '6231',
      label: 'Parassala',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6232',
      label: 'Paraswada',
      type: 'City'
    },
    {
      value: '6233',
      label: 'Parat',
      type: 'City'
    },
    {
      value: '6234',
      label: 'Paratwada',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6235',
      label: 'Paraur',
      type: 'City'
    },
    {
      value: '6236',
      label: 'Paravadi',
      type: 'City'
    },
    {
      value: '6237',
      label: 'Paravoor',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6238',
      label: 'Paravur',
      type: 'City'
    },
    {
      value: '6239',
      label: 'Parbatsar (Maharashtra)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6240',
      label: 'Parbhani',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6241',
      label: 'Parchoor',
      type: 'City'
    },
    {
      value: '6242',
      label: 'Parchur',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6243',
      label: 'Pardi',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6244',
      label: 'Pare',
      type: 'City'
    },
    {
      value: '6245',
      label: 'PAREDONES',
      type: 'City'
    },
    {
      value: '6246',
      label: 'Pareu',
      type: 'City'
    },
    {
      value: '6247',
      label: 'Pargaon',
      type: 'City'
    },
    {
      value: '6248',
      label: 'Pargaon-Khandala',
      type: 'City'
    },
    {
      value: '6249',
      label: 'Parihara',
      type: 'City'
    },
    {
      value: '6250',
      label: 'Paripally',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6251',
      label: 'Parippally',
      type: 'City'
    },
    {
      value: '6252',
      label: 'Paritala',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6253',
      label: 'Pariyaram',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6254',
      label: 'Parkala',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '6255',
      label: 'Parla',
      type: 'City'
    },
    {
      value: '6256',
      label: 'Parli',
      type: 'City'
    },
    {
      value: '6257',
      label: 'Parmanand',
      type: 'City'
    },
    {
      value: '6258',
      label: 'Parmanu',
      type: 'City'
    },
    {
      value: '6259',
      label: 'Parola (Jalgaon)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6260',
      label: 'Parour',
      type: 'City'
    },
    {
      value: '6261',
      label: 'PARRAL',
      type: 'City'
    },
    {
      value: '6262',
      label: 'Parsa',
      type: 'City'
    },
    {
      value: '6263',
      label: 'Parsad',
      type: 'City'
    },
    {
      value: '6264',
      label: 'Parsadepur',
      type: 'City'
    },
    {
      value: '6265',
      label: 'Parshuram  Chiplun',
      type: 'City'
    },
    {
      value: '6266',
      label: 'Parsoli',
      type: 'City'
    },
    {
      value: '6267',
      label: 'Partapur',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6268',
      label: 'Parthibanur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6269',
      label: 'Partur',
      type: 'City'
    },
    {
      value: '6270',
      label: 'Parvadi',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6271',
      label: 'Parvala',
      type: 'City'
    },
    {
      value: '6272',
      label: 'Parvathipuram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6273',
      label: 'Parwanoo',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '6274',
      label: 'Pasalapudi',
      type: 'City'
    },
    {
      value: '6275',
      label: 'Pasarlapudi',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6276',
      label: 'Pasipattinam',
      type: 'City'
    },
    {
      value: '6277',
      label: 'Pasipattinam(Ramanathapuram)',
      type: 'City'
    },
    {
      value: '6278',
      label: 'Paso De Los Libres',
      type: 'City'
    },
    {
      value: '6279',
      label: 'Pasumarru',
      type: 'City'
    },
    {
      value: '6280',
      label: 'Pasumarthi',
      type: 'City'
    },
    {
      value: '6281',
      label: 'Pasuvanthanai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6282',
      label: 'Patan',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6283',
      label: 'Patan Vav',
      type: 'City'
    },
    {
      value: '6284',
      label: 'Patan(Gujarat)',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6285',
      label: 'Patan, MP',
      type: 'City'
    },
    {
      value: '6286',
      label: 'Patana Bhal',
      type: 'City'
    },
    {
      value: '6287',
      label: 'Patana, Gujarat',
      type: 'City'
    },
    {
      value: '6288',
      label: 'Patana, UP',
      type: 'City'
    },
    {
      value: '6289',
      label: 'Patanvav',
      type: 'City'
    },
    {
      value: '6290',
      label: 'Patas',
      type: 'City'
    },
    {
      value: '6291',
      label: 'Patera',
      type: 'City'
    },
    {
      value: '6292',
      label: 'Pathalgaon',
      type: 'City'
    },
    {
      value: '6293',
      label: 'Pathanamthitta',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6294',
      label: 'Pathanapuram',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6295',
      label: 'Pathankot',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '6296',
      label: 'Pathanthitta',
      type: 'City'
    },
    {
      value: '6297',
      label: 'Pathapatnam',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6298',
      label: 'Pathardi',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6299',
      label: 'Pathari',
      type: 'City'
    },
    {
      value: '6300',
      label: 'Patharia',
      type: 'City'
    },
    {
      value: '6301',
      label: 'Pathariya',
      type: 'City'
    },
    {
      value: '6302',
      label: 'Patharkandi',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '6303',
      label: 'Pathri',
      type: 'City'
    },
    {
      value: '6304',
      label: 'Pathri (Parbhani)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6305',
      label: 'Pathrot',
      type: 'City'
    },
    {
      value: '6306',
      label: 'Pathrud',
      type: 'City'
    },
    {
      value: '6307',
      label: 'Pathsala',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '6308',
      label: 'Pathur',
      type: 'City'
    },
    {
      value: '6309',
      label: 'Patiala',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '6310',
      label: 'Patiram',
      type: 'City'
    },
    {
      value: '6311',
      label: 'Patkhilori',
      type: 'City'
    },
    {
      value: '6312',
      label: 'Patlikuhal',
      type: 'City'
    },
    {
      value: '6313',
      label: 'Patna',
      type: 'City'
    },
    {
      value: '6314',
      label: 'Patna (Bihar)',
      type: 'City'
    },
    {
      value: '6315',
      label: 'Patnagarh',
      type: 'City'
    },
    {
      value: '6316',
      label: 'Patnitop',
      type: 'City'
    },
    {
      value: '6317',
      label: 'Patoda',
      type: 'City'
    },
    {
      value: '6318',
      label: 'Patoda (beed)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6319',
      label: 'Patodi',
      type: 'City'
    },
    {
      value: '6320',
      label: 'Patran',
      type: 'City'
    },
    {
      value: '6321',
      label: 'Patratoli',
      type: 'City'
    },
    {
      value: '6322',
      label: 'Patrud',
      type: 'City'
    },
    {
      value: '6323',
      label: 'Patsangvi',
      type: 'City'
    },
    {
      value: '6324',
      label: 'Patta',
      type: 'City'
    },
    {
      value: '6325',
      label: 'Pattamadai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6326',
      label: 'Pattanamthitta',
      type: 'City'
    },
    {
      value: '6327',
      label: 'Patti',
      type: 'City'
    },
    {
      value: '6328',
      label: 'Patti, Punjab',
      type: 'City'
    },
    {
      value: '6329',
      label: 'Patti, UP',
      type: 'City'
    },
    {
      value: '6330',
      label: 'Pattikkad',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6331',
      label: 'Pattukkottai',
      type: 'City'
    },
    {
      value: '6332',
      label: 'Pattukotai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6333',
      label: 'Patur (Akola)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6334',
      label: 'Paturu',
      type: 'City'
    },
    {
      value: '6335',
      label: 'Patwa',
      type: 'City'
    },
    {
      value: '6336',
      label: 'Pauli',
      type: 'City'
    },
    {
      value: '6337',
      label: 'Pauni',
      type: 'City'
    },
    {
      value: '6338',
      label: 'Pavagad',
      type: 'City'
    },
    {
      value: '6339',
      label: 'Pavagadh',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6340',
      label: 'Pavithram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6341',
      label: 'Pavoorchatram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6342',
      label: 'Pawai',
      type: 'City'
    },
    {
      value: '6343',
      label: 'Pawapuri',
      type: 'City'
    },
    {
      value: '6344',
      label: 'Pawas',
      type: 'City'
    },
    {
      value: '6345',
      label: 'Pawta',
      type: 'City'
    },
    {
      value: '6346',
      label: 'Pawti',
      type: 'City'
    },
    {
      value: '6347',
      label: 'Payala Kalan',
      type: 'City'
    },
    {
      value: '6348',
      label: 'Payangadi',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6349',
      label: 'Payyanur',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6350',
      label: 'Payyavoor',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6351',
      label: 'Payyoli',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6352',
      label: 'Pazhaiyakayal',
      type: 'City'
    },
    {
      value: '6353',
      label: 'Pazhayangadi',
      type: 'City'
    },
    {
      value: '6354',
      label: 'Pdpl',
      type: 'City'
    },
    {
      value: '6355',
      label: 'Pe Airport',
      type: 'City'
    },
    {
      value: '6356',
      label: 'Pedabramadevam',
      type: 'City'
    },
    {
      value: '6357',
      label: 'Pedana',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6358',
      label: 'Pedanandipadu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6359',
      label: 'Pedaparupudi',
      type: 'City'
    },
    {
      value: '6360',
      label: 'Pedaprolu',
      type: 'City'
    },
    {
      value: '6361',
      label: 'Pedapudi',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6362',
      label: 'Pedaravuru',
      type: 'City'
    },
    {
      value: '6363',
      label: 'Pedaravuru  Tenali',
      type: 'City'
    },
    {
      value: '6364',
      label: 'Pedavadlapudi',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6365',
      label: 'Peddapalli',
      type: 'City',
      'state': 'Telangana'
    },
    {
      value: '6366',
      label: 'Peddapuram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6367',
      label: 'Pedhla',
      type: 'City'
    },
    {
      value: '6368',
      label: 'Peermade',
      type: 'City'
    },
    {
      value: '6369',
      label: 'Peeth',
      type: 'City'
    },
    {
      value: '6370',
      label: 'Pehowa',
      type: 'City'
    },
    {
      value: '6371',
      label: 'Peikulam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6372',
      label: 'PELEQUEN',
      type: 'City'
    },
    {
      value: '6373',
      label: 'Peleru',
      type: 'City'
    },
    {
      value: '6374',
      label: 'Pen (Maharashtra)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6375',
      label: 'Penamaluru',
      type: 'City'
    },
    {
      value: '6376',
      label: 'Pendra',
      type: 'City'
    },
    {
      value: '6377',
      label: 'Pendraroad',
      type: 'City'
    },
    {
      value: '6378',
      label: 'Penduru',
      type: 'City'
    },
    {
      value: '6379',
      label: 'Penugonda (Andhra Pradesh)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6380',
      label: 'Penuguduru',
      type: 'City'
    },
    {
      value: '6381',
      label: 'Penukonda',
      type: 'City'
    },
    {
      value: '6382',
      label: 'Penumandra',
      type: 'City'
    },
    {
      value: '6383',
      label: 'Penumantra',
      type: 'City'
    },
    {
      value: '6384',
      label: 'Penumudi',
      type: 'City'
    },
    {
      value: '6385',
      label: 'Peppeganj',
      type: 'City'
    },
    {
      value: '6386',
      label: 'Peraiyur',
      type: 'City'
    },
    {
      value: '6387',
      label: 'Peralam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6388',
      label: 'PERALILLO',
      type: 'City'
    },
    {
      value: '6389',
      label: 'Perambalur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6390',
      label: 'Perambra',
      type: 'City'
    },
    {
      value: '6391',
      label: 'Peravali',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6392',
      label: 'Peravalli',
      type: 'City'
    },
    {
      value: '6393',
      label: 'Peravoor',
      type: 'City'
    },
    {
      value: '6394',
      label: 'Peravurani',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6395',
      label: 'Percherla',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6396',
      label: 'Perdoor',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '6397',
      label: 'Perecherla',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6398',
      label: 'Pergamino',
      type: 'City'
    },
    {
      value: '6399',
      label: 'Peria',
      type: 'City'
    },
    {
      value: '6400',
      label: 'Peringathur',
      type: 'City'
    },
    {
      value: '6401',
      label: 'Perinthalmanna',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6402',
      label: 'Periyakulam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6403',
      label: 'Periyamedu',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6404',
      label: 'Periyar',
      type: 'City'
    },
    {
      value: '6405',
      label: 'Perla',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6406',
      label: 'Pernem',
      type: 'City'
    },
    {
      value: '6407',
      label: 'Perrundurai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6408',
      label: 'Perugulathur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6409',
      label: 'Perumbavoor',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6410',
      label: 'Perunali',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6411',
      label: 'Perundhurai',
      type: 'City'
    },
    {
      value: '6412',
      label: 'Perundurai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6413',
      label: 'Perungalathur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6414',
      label: 'Perungulam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6415',
      label: 'Perunkulam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6416',
      label: 'Peruru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6417',
      label: 'Perurupeta',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6418',
      label: 'Peruvamthanam',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6419',
      label: 'Peth',
      type: 'City'
    },
    {
      value: '6420',
      label: 'Peth Naka',
      type: 'City'
    },
    {
      value: '6421',
      label: 'Peth Naka (Satara)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6422',
      label: 'Peth Shivani',
      type: 'City'
    },
    {
      value: '6423',
      label: 'Pethapur',
      type: 'City'
    },
    {
      value: '6424',
      label: 'Pethri',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '6425',
      label: 'Petlawad',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '6426',
      label: 'Petnaka',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6427',
      label: 'Phagwara',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '6428',
      label: 'Phalodi',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6429',
      label: 'Phalsund',
      type: 'City'
    },
    {
      value: '6430',
      label: 'Phaltan',
      type: 'City'
    },
    {
      value: '6431',
      label: 'Phansu',
      type: 'City'
    },
    {
      value: '6432',
      label: 'Pharasgaon',
      type: 'City'
    },
    {
      value: '6433',
      label: 'Pharenda',
      type: 'City'
    },
    {
      value: '6434',
      label: 'Phenhara',
      type: 'City'
    },
    {
      value: '6435',
      label: 'Phephna',
      type: 'City'
    },
    {
      value: '6436',
      label: 'Phillaur',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '6437',
      label: 'Philoor',
      type: 'City'
    },
    {
      value: '6438',
      label: 'Phoop',
      type: 'City'
    },
    {
      value: '6439',
      label: 'Phul Sagar',
      type: 'City'
    },
    {
      value: '6440',
      label: 'Phulambri',
      type: 'City'
    },
    {
      value: '6441',
      label: 'Phulgaon',
      type: 'City'
    },
    {
      value: '6442',
      label: 'Phulparas',
      type: 'City'
    },
    {
      value: '6443',
      label: 'Phulpur',
      type: 'City'
    },
    {
      value: '6444',
      label: 'Phulwari',
      type: 'City'
    },
    {
      value: '6445',
      label: 'Pichhore',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '6446',
      label: 'Piduguralla',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6447',
      label: 'Pilani',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6448',
      label: 'Pilarkhana',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '6449',
      label: 'Pilathara',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6450',
      label: 'Pileru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6451',
      label: 'Pili Bhanga',
      type: 'City'
    },
    {
      value: '6452',
      label: 'Pilibanga',
      type: 'City'
    },
    {
      value: '6453',
      label: 'Pilibhit',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '6454',
      label: 'Pilkhod',
      type: 'City'
    },
    {
      value: '6455',
      label: 'Pillayarpatti',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6456',
      label: 'Pillayarpatti',
      type: 'City'
    },
    {
      value: '6457',
      label: 'Pimpal',
      type: 'City'
    },
    {
      value: '6458',
      label: 'Pimpalgaon',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6459',
      label: 'Pimpalner',
      type: 'City'
    },
    {
      value: '6460',
      label: 'Pimpari',
      type: 'City'
    },
    {
      value: '6461',
      label: 'Pimparkhed',
      type: 'City'
    },
    {
      value: '6462',
      label: 'Pimpri (Hingoli)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6463',
      label: 'Pindakhai Moti',
      type: 'City'
    },
    {
      value: '6464',
      label: 'Pindawal',
      type: 'City'
    },
    {
      value: '6465',
      label: 'Pindrai',
      type: 'City'
    },
    {
      value: '6466',
      label: 'Pindwara',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6467',
      label: 'Pinetown',
      type: 'City'
    },
    {
      value: '6468',
      label: 'Pinjore',
      type: 'City'
    },
    {
      value: '6469',
      label: 'Pipali',
      type: 'City'
    },
    {
      value: '6470',
      label: 'Pipaliya Dhundhiy',
      type: 'City'
    },
    {
      value: '6471',
      label: 'Pipaliya Hajani',
      type: 'City'
    },
    {
      value: '6472',
      label: 'Pipaliya, Gujarat',
      type: 'City'
    },
    {
      value: '6473',
      label: 'Pipaliya, Rajasthan',
      type: 'City'
    },
    {
      value: '6474',
      label: 'Pipalkhunt',
      type: 'City'
    },
    {
      value: '6475',
      label: 'Pipara',
      type: 'City'
    },
    {
      value: '6476',
      label: 'Pipariya(MP)',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '6477',
      label: 'Pipartoda',
      type: 'City'
    },
    {
      value: '6478',
      label: 'Pipavav Port',
      type: 'City'
    },
    {
      value: '6479',
      label: 'Pipli',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6480',
      label: 'Piplia Mandi',
      type: 'City'
    },
    {
      value: '6481',
      label: 'Piplod',
      type: 'City'
    },
    {
      value: '6482',
      label: 'Piploda',
      type: 'City'
    },
    {
      value: '6483',
      label: 'Piplya Mandi',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '6484',
      label: 'Piplyahana Square  Indore',
      type: 'City'
    },
    {
      value: '6485',
      label: 'Pippara (Andhra Pradesh)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6486',
      label: 'Pipra',
      type: 'City'
    },
    {
      value: '6487',
      label: 'Pipra Kothi',
      type: 'City'
    },
    {
      value: '6488',
      label: 'Piravam',
      type: 'City'
    },
    {
      value: '6489',
      label: 'Pirawa',
      type: 'City'
    },
    {
      value: '6490',
      label: 'Piro',
      type: 'City'
    },
    {
      value: '6491',
      label: 'Pisai',
      type: 'City'
    },
    {
      value: '6492',
      label: 'Pitapuram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6493',
      label: 'Pithadiya',
      type: 'City'
    },
    {
      value: '6494',
      label: 'Pithampur',
      type: 'City'
    },
    {
      value: '6495',
      label: 'Pithampur Bypass',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6496',
      label: 'Pithavadi',
      type: 'City'
    },
    {
      value: '6497',
      label: 'Pithora',
      type: 'City'
    },
    {
      value: '6498',
      label: 'Pitol',
      type: 'City'
    },
    {
      value: '6499',
      label: 'PITRUFQUEN',
      type: 'City'
    },
    {
      value: '6500',
      label: 'Piyava Gir',
      type: 'City'
    },
    {
      value: '6501',
      label: 'PLACILLA',
      type: 'City'
    },
    {
      value: '6502',
      label: 'Plasi',
      type: 'City'
    },
    {
      value: '6503',
      label: 'Plettenberg Bay',
      type: 'City'
    },
    {
      value: '6504',
      label: 'Plottier',
      type: 'City'
    },
    {
      value: '6505',
      label: 'Pocito',
      type: 'City'
    },
    {
      value: '6506',
      label: 'Podakkudi',
      type: 'City'
    },
    {
      value: '6507',
      label: 'Podili',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6508',
      label: 'Podimattom',
      type: 'City'
    },
    {
      value: '6509',
      label: 'Pohari',
      type: 'City'
    },
    {
      value: '6510',
      label: 'Pokaran',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6511',
      label: 'Pokhara',
      type: 'City'
    },
    {
      value: '6512',
      label: 'Pokhran',
      type: 'City'
    },
    {
      value: '6513',
      label: 'Poladpur',
      type: 'City'
    },
    {
      value: '6514',
      label: 'Polarpur',
      type: 'City'
    },
    {
      value: '6515',
      label: 'Pollachi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6516',
      label: 'Polur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6517',
      label: 'Ponamaravathi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6518',
      label: 'Ponda',
      type: 'City',
      'state': 'Goa'
    },
    {
      value: '6519',
      label: 'Pondi',
      type: 'City'
    },
    {
      value: '6520',
      label: 'Pondicherry',
      type: 'City',
      'state': 'Pondicherry'
    },
    {
      value: '6521',
      label: 'Ponduru',
      type: 'City'
    },
    {
      value: '6522',
      label: 'Ponkunnam',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6523',
      label: 'Ponnaluru',
      type: 'City'
    },
    {
      value: '6524',
      label: 'Ponnamaravathi',
      type: 'City'
    },
    {
      value: '6525',
      label: 'Ponnani',
      type: 'City'
    },
    {
      value: '6526',
      label: 'Ponnur',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6527',
      label: 'Ponnuru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6528',
      label: 'Pooh',
      type: 'City'
    },
    {
      value: '6529',
      label: 'Pookode',
      type: 'City'
    },
    {
      value: '6530',
      label: 'Poolangal',
      type: 'City'
    },
    {
      value: '6531',
      label: 'Poonamallee',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6532',
      label: 'Poonamallee  Chennai',
      type: 'City'
    },
    {
      value: '6533',
      label: 'Poonthottam',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6534',
      label: 'Poranki  Vijayawada',
      type: 'City'
    },
    {
      value: '6535',
      label: 'Porbandar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6536',
      label: 'Porbunder',
      type: 'City'
    },
    {
      value: '6537',
      label: 'Porsa',
      type: 'City'
    },
    {
      value: '6538',
      label: 'Port Blair',
      type: 'City',
      'state': 'Andaman & Nicobar Islands'
    },
    {
      value: '6539',
      label: 'Porumamilla',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6540',
      label: 'Porurchatram',
      type: 'City'
    },
    {
      value: '6541',
      label: 'Porvorim',
      type: 'City'
    },
    {
      value: '6542',
      label: 'Posadas',
      type: 'City'
    },
    {
      value: '6543',
      label: 'Posalia',
      type: 'City'
    },
    {
      value: '6544',
      label: 'Posana',
      type: 'City'
    },
    {
      value: '6545',
      label: 'Pota',
      type: 'City'
    },
    {
      value: '6546',
      label: 'Pothakalanvilai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6547',
      label: 'Pothakudi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6548',
      label: 'Pothukatla',
      type: 'City'
    },
    {
      value: '6549',
      label: 'Potlan',
      type: 'City'
    },
    {
      value: '6550',
      label: 'Potta',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6551',
      label: 'Pottalpudur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6552',
      label: 'Poundi',
      type: 'City'
    },
    {
      value: '6553',
      label: 'Powari',
      type: 'City'
    },
    {
      value: '6554',
      label: 'Powayan',
      type: 'City'
    },
    {
      value: '6555',
      label: 'Prabhat Pattan',
      type: 'City'
    },
    {
      value: '6556',
      label: 'Prabhu Toll Kanta',
      type: 'City'
    },
    {
      value: '6557',
      label: 'Prachi',
      type: 'City'
    },
    {
      value: '6558',
      label: 'Pragpar',
      type: 'City'
    },
    {
      value: '6559',
      label: 'Pragpur',
      type: 'City'
    },
    {
      value: '6560',
      label: 'Prahalad Gadh',
      type: 'City'
    },
    {
      value: '6561',
      label: 'Prakasha',
      type: 'City'
    },
    {
      value: '6562',
      label: 'Prantij',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6563',
      label: 'Pratapgadh',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6564',
      label: 'Pratapgadh (Rajasthan)',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6565',
      label: 'Pratapganj',
      type: 'City'
    },
    {
      value: '6566',
      label: 'Pratapgarh, Rajasthan',
      type: 'City'
    },
    {
      value: '6567',
      label: 'Pratapgarh, UP',
      type: 'City'
    },
    {
      value: '6568',
      label: 'Pratappur, Chhattisgarh',
      type: 'City'
    },
    {
      value: '6569',
      label: 'Pratappur, Gujarat',
      type: 'City'
    },
    {
      value: '6570',
      label: 'Pratappur, Rajasthan',
      type: 'City'
    },
    {
      value: '6571',
      label: 'Pratha',
      type: 'City'
    },
    {
      value: '6572',
      label: 'Prathipadu(East Godavari)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6573',
      label: 'Prathipadu(Guntur)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6574',
      label: 'Pregnapur',
      type: 'City'
    },
    {
      value: '6575',
      label: 'Prem Nagar  Dehradun',
      type: 'City'
    },
    {
      value: '6576',
      label: 'Prempara',
      type: 'City'
    },
    {
      value: '6577',
      label: 'Prithvipur',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '6578',
      label: 'Proddutur',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6579',
      label: 'Pucon',
      type: 'City'
    },
    {
      value: '6580',
      label: 'Pudhur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6581',
      label: 'Puducherry',
      type: 'City'
    },
    {
      value: '6582',
      label: 'Pudukadai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6583',
      label: 'Pudukottai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6584',
      label: 'Pudukottai(Tuticorin)',
      type: 'City'
    },
    {
      value: '6585',
      label: 'Pudukudi',
      type: 'City'
    },
    {
      value: '6586',
      label: 'Pudupatti',
      type: 'City'
    },
    {
      value: '6587',
      label: 'Pudur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6588',
      label: 'Puduvalasai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6589',
      label: 'Puduvayal',
      type: 'City'
    },
    {
      value: '6590',
      label: 'Puduwayal',
      type: 'City'
    },
    {
      value: '6591',
      label: 'Puerto Montt',
      type: 'City'
    },
    {
      value: '6592',
      label: 'Puerto Rico',
      type: 'City'
    },
    {
      value: '6593',
      label: 'Puerto Varas',
      type: 'City'
    },
    {
      value: '6594',
      label: 'Pugal',
      type: 'City'
    },
    {
      value: '6595',
      label: 'Pukhrayan',
      type: 'City'
    },
    {
      value: '6596',
      label: 'Pulgaon',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6597',
      label: 'Pulial',
      type: 'City'
    },
    {
      value: '6598',
      label: 'Puliampatti',
      type: 'City'
    },
    {
      value: '6599',
      label: 'pulikkal',
      type: 'City'
    },
    {
      value: '6600',
      label: 'Pulingudi',
      type: 'City'
    },
    {
      value: '6601',
      label: 'Pulivendula',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6602',
      label: 'Puliyal Mosque',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6603',
      label: 'Puliyampatti',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6604',
      label: 'Puliyangudi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6605',
      label: 'Pulla',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6606',
      label: 'Pullampet',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6607',
      label: 'Pulletikurru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6608',
      label: 'Pullupara',
      type: 'City'
    },
    {
      value: '6609',
      label: 'Pulpally',
      type: 'City'
    },
    {
      value: '6610',
      label: 'Pulugurtha',
      type: 'City'
    },
    {
      value: '6611',
      label: 'Pumpwell',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '6612',
      label: 'Pumpwell Circle  Maroli',
      type: 'City'
    },
    {
      value: '6613',
      label: 'Punadi',
      type: 'City'
    },
    {
      value: '6614',
      label: 'Punadipadu',
      type: 'City'
    },
    {
      value: '6615',
      label: 'Punali',
      type: 'City'
    },
    {
      value: '6616',
      label: 'Punalur',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6617',
      label: 'Punasa',
      type: 'City'
    },
    {
      value: '6618',
      label: 'Punawale Bazar',
      type: 'City'
    },
    {
      value: '6619',
      label: 'Pune',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6620',
      label: 'Pune Airport',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6621',
      label: 'Pune Darshan',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6622',
      label: 'Punganur',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6623',
      label: 'Punjapadar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6624',
      label: 'Punjpur',
      type: 'City'
    },
    {
      value: '6625',
      label: 'Punnapra',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6626',
      label: 'Punta Alta',
      type: 'City'
    },
    {
      value: '6627',
      label: 'Punta Arenas',
      type: 'City'
    },
    {
      value: '6628',
      label: 'Pupri',
      type: 'City'
    },
    {
      value: '6629',
      label: 'Pura Bazar',
      type: 'City'
    },
    {
      value: '6630',
      label: 'Puranpur',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '6631',
      label: 'Purba',
      type: 'City'
    },
    {
      value: '6632',
      label: 'Puri',
      type: 'City'
    },
    {
      value: '6633',
      label: 'Purnagad',
      type: 'City'
    },
    {
      value: '6634',
      label: 'Purnea',
      type: 'City'
    },
    {
      value: '6635',
      label: 'Purnia',
      type: 'City'
    },
    {
      value: '6636',
      label: 'Purulia',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '6637',
      label: 'Purur',
      type: 'City'
    },
    {
      value: '6638',
      label: 'Pusad',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6639',
      label: 'Pusauli',
      type: 'City'
    },
    {
      value: '6640',
      label: 'Pushkar',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6641',
      label: 'Pushpanagar A',
      type: 'City'
    },
    {
      value: '6642',
      label: 'Putalapattu',
      type: 'City'
    },
    {
      value: '6643',
      label: 'Puthanathani',
      type: 'City'
    },
    {
      value: '6644',
      label: 'Puthiamputhur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6645',
      label: 'Puthuchery',
      type: 'City',
      'state': 'Pondicherry'
    },
    {
      value: '6646',
      label: 'Puttaparthi',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6647',
      label: 'Puttur (Karnataka)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '6648',
      label: 'Puttur, Andhra Pradesh',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6649',
      label: 'Pydibimavaram',
      type: 'City'
    },
    {
      value: '6650',
      label: 'Quilandy',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6651',
      label: 'Quilon',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6652',
      label: 'R S Mangalam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6653',
      label: 'Raapaka',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6654',
      label: 'Rabakavi',
      type: 'City'
    },
    {
      value: '6655',
      label: 'Rabarika',
      type: 'City'
    },
    {
      value: '6656',
      label: 'Rabkavi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '6657',
      label: 'Racharla',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6658',
      label: 'Rachuru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6659',
      label: 'Radhanpur(Gujrat)',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6660',
      label: 'Raebareli',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '6661',
      label: 'Rafaela',
      type: 'City'
    },
    {
      value: '6662',
      label: 'Ragarganj',
      type: 'City'
    },
    {
      value: '6663',
      label: 'Raghogarh',
      type: 'City'
    },
    {
      value: '6664',
      label: 'Rahata',
      type: 'City'
    },
    {
      value: '6665',
      label: 'Rahatgarh',
      type: 'City'
    },
    {
      value: '6666',
      label: 'Rahij',
      type: 'City'
    },
    {
      value: '6667',
      label: 'Rahuri',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6668',
      label: 'Raichur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '6669',
      label: 'Raigad',
      type: 'City'
    },
    {
      value: '6670',
      label: 'Raiganj',
      type: 'City'
    },
    {
      value: '6671',
      label: 'Raigarh',
      type: 'City'
    },
    {
      value: '6672',
      label: 'Raighar',
      type: 'City'
    },
    {
      value: '6673',
      label: 'Raikot',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '6674',
      label: 'Raikote',
      type: 'City'
    },
    {
      value: '6675',
      label: 'Raila',
      type: 'City'
    },
    {
      value: '6676',
      label: 'Railmagra',
      type: 'City'
    },
    {
      value: '6677',
      label: 'Railway Koduru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6678',
      label: 'Raimoha',
      type: 'City'
    },
    {
      value: '6679',
      label: 'Raipatan',
      type: 'City'
    },
    {
      value: '6680',
      label: 'Raipur (Chhattisgarh)',
      type: 'City'
    },
    {
      value: '6681',
      label: 'Raipur (Rajasthan)',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6682',
      label: 'Raipur, Punjab',
      type: 'City'
    },
    {
      value: '6683',
      label: 'Raipur, Rajasthan',
      type: 'City'
    },
    {
      value: '6684',
      label: 'Raipura',
      type: 'City'
    },
    {
      value: '6685',
      label: 'Raipura Muhsam',
      type: 'City'
    },
    {
      value: '6686',
      label: 'Raipuriya',
      type: 'City'
    },
    {
      value: '6687',
      label: 'Rairangpur',
      type: 'City'
    },
    {
      value: '6688',
      label: 'Raisen',
      type: 'City'
    },
    {
      value: '6689',
      label: 'Raisingh Nagar',
      type: 'City'
    },
    {
      value: '6690',
      label: 'Raisinghnagar',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6691',
      label: 'Raison',
      type: 'City'
    },
    {
      value: '6692',
      label: 'Rait',
      type: 'City'
    },
    {
      value: '6693',
      label: 'Raiwala',
      type: 'City'
    },
    {
      value: '6694',
      label: 'Raja Ka Talab',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '6695',
      label: 'Rajahmundry',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6696',
      label: 'Rajaldesar',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6697',
      label: 'Rajaldesher',
      type: 'City'
    },
    {
      value: '6698',
      label: 'Rajam',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6699',
      label: 'Rajampet',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6700',
      label: 'Rajanagaram (Andhra Pradesh)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6701',
      label: 'Rajapalayam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6702',
      label: 'Rajapur (Ratnagiri)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6703',
      label: 'Rajapur, Maharashtra',
      type: 'City'
    },
    {
      value: '6704',
      label: 'Rajasingamangalam',
      type: 'City'
    },
    {
      value: '6705',
      label: 'Rajbera',
      type: 'City'
    },
    {
      value: '6706',
      label: 'Rajegaon',
      type: 'City'
    },
    {
      value: '6707',
      label: 'Rajendragram',
      type: 'City'
    },
    {
      value: '6708',
      label: 'Rajepur',
      type: 'City'
    },
    {
      value: '6709',
      label: 'Rajgad',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6710',
      label: 'Rajgarh (Delhi)',
      type: 'City',
      'state': 'Delhi'
    },
    {
      value: '6711',
      label: 'Rajgir',
      type: 'City'
    },
    {
      value: '6712',
      label: 'Rajgurunagar',
      type: 'City'
    },
    {
      value: '6713',
      label: 'Rajhara',
      type: 'City'
    },
    {
      value: '6714',
      label: 'Rajim',
      type: 'City'
    },
    {
      value: '6715',
      label: 'Rajiyasar',
      type: 'City'
    },
    {
      value: '6716',
      label: 'Rajkot',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6717',
      label: 'Rajmarg',
      type: 'City'
    },
    {
      value: '6718',
      label: 'Rajnagar (Gujarat)',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6719',
      label: 'Rajnagar(Rajasthan)',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6720',
      label: 'Rajnandgaon',
      type: 'City'
    },
    {
      value: '6721',
      label: 'Rajnandgaon Court',
      type: 'City'
    },
    {
      value: '6722',
      label: 'Rajole',
      type: 'City'
    },
    {
      value: '6723',
      label: 'Rajpara (Khodiyar)',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6724',
      label: 'Rajpipala',
      type: 'City'
    },
    {
      value: '6725',
      label: 'Rajpipla',
      type: 'City'
    },
    {
      value: '6726',
      label: 'Rajpur, Chhattisgarh',
      type: 'City'
    },
    {
      value: '6727',
      label: 'Rajpur, Gujarat',
      type: 'City'
    },
    {
      value: '6728',
      label: 'Rajpur, MP',
      type: 'City'
    },
    {
      value: '6729',
      label: 'Rajpur, UP',
      type: 'City'
    },
    {
      value: '6730',
      label: 'Rajpura',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '6731',
      label: 'Rajpuriya',
      type: 'City'
    },
    {
      value: '6732',
      label: 'Rajsamand',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6733',
      label: 'Rajsitapur',
      type: 'City'
    },
    {
      value: '6734',
      label: 'Rajula',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6735',
      label: 'Rajupalem',
      type: 'City'
    },
    {
      value: '6736',
      label: 'Rajupet',
      type: 'City'
    },
    {
      value: '6737',
      label: 'Rajur (Yavatmal)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6738',
      label: 'Rajura (Chandrapur)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6739',
      label: 'Rakhi',
      type: 'City'
    },
    {
      value: '6740',
      label: 'Rakhiyal',
      type: 'City'
    },
    {
      value: '6741',
      label: 'Rakkar',
      type: 'City'
    },
    {
      value: '6742',
      label: 'Rama',
      type: 'City'
    },
    {
      value: '6743',
      label: 'Rama Mandi',
      type: 'City'
    },
    {
      value: '6744',
      label: 'Ramabhadrapuram',
      type: 'City'
    },
    {
      value: '6745',
      label: 'Ramachandrapuram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6746',
      label: 'Ramagundam',
      type: 'City',
      'state': 'Telangana'
    },
    {
      value: '6747',
      label: 'Ramakona',
      type: 'City'
    },
    {
      value: '6748',
      label: 'Ramanagar',
      type: 'City'
    },
    {
      value: '6749',
      label: 'Ramanagara',
      type: 'City'
    },
    {
      value: '6750',
      label: 'Ramanagaram',
      type: 'City'
    },
    {
      value: '6751',
      label: 'Ramanathapuram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6752',
      label: 'Ramanattukara',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6753',
      label: 'Ramanayapalem',
      type: 'City'
    },
    {
      value: '6754',
      label: 'Ramaniya',
      type: 'City'
    },
    {
      value: '6755',
      label: 'Ramankary',
      type: 'City'
    },
    {
      value: '6756',
      label: 'Ramanuj Ganj',
      type: 'City'
    },
    {
      value: '6757',
      label: 'Ramapuram',
      type: 'City'
    },
    {
      value: '6758',
      label: 'Ramaswamy Raja Nagar',
      type: 'City'
    },
    {
      value: '6759',
      label: 'Ramaswamy Raja Nagar Thammanayakkanpatti',
      type: 'City'
    },
    {
      value: '6760',
      label: 'Ramayampet',
      type: 'City'
    },
    {
      value: '6761',
      label: 'Ramban',
      type: 'City'
    },
    {
      value: '6762',
      label: 'Rambhari',
      type: 'City'
    },
    {
      value: '6763',
      label: 'Rambotlavaripalem',
      type: 'City'
    },
    {
      value: '6764',
      label: 'Ramdevra',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6765',
      label: 'Ramdhari',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6766',
      label: 'Ramdurg',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '6767',
      label: 'Rameshwara',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '6768',
      label: 'Rameshwaram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6769',
      label: 'Rameswaram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6770',
      label: 'Ramgarh',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6771',
      label: 'Ramgarh Dantaramgarh',
      type: 'City'
    },
    {
      value: '6772',
      label: 'Ramgarh, Jharkhand',
      type: 'City'
    },
    {
      value: '6773',
      label: 'Ramgarh, Rajasthan',
      type: 'City'
    },
    {
      value: '6774',
      label: 'Ramji Ka Gol',
      type: 'City'
    },
    {
      value: '6775',
      label: 'Ramna',
      type: 'City'
    },
    {
      value: '6776',
      label: 'Ramnagar (Uttrakhand)',
      type: 'City'
    },
    {
      value: '6777',
      label: 'Ramnagara (Karnataka)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '6778',
      label: 'Ramodadi',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6779',
      label: 'Ramoji Film City',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6780',
      label: 'Rampara-2',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6781',
      label: 'Rampur',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '6782',
      label: 'Rampura',
      type: 'City'
    },
    {
      value: '6783',
      label: 'Ramsar',
      type: 'City'
    },
    {
      value: '6784',
      label: 'Ramsara',
      type: 'City'
    },
    {
      value: '6785',
      label: 'Ramsin',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6786',
      label: 'Ramsinghpur',
      type: 'City'
    },
    {
      value: '6787',
      label: 'Ramtek',
      type: 'City'
    },
    {
      value: '6788',
      label: 'Ranakandorna',
      type: 'City'
    },
    {
      value: '6789',
      label: 'Ranakpur',
      type: 'City'
    },
    {
      value: '6790',
      label: 'Ranapur',
      type: 'City'
    },
    {
      value: '6791',
      label: 'Ranasthalam',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6792',
      label: 'Ranavav',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6793',
      label: 'Ranawas',
      type: 'City'
    },
    {
      value: '6794',
      label: 'RANCAGUA',
      type: 'City'
    },
    {
      value: '6795',
      label: 'Ranchi',
      type: 'City',
      'state': 'Jharkhand'
    },
    {
      value: '6796',
      label: 'Ranebennur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '6797',
      label: 'Rangampet',
      type: 'City'
    },
    {
      value: '6798',
      label: 'Rangampeta',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6799',
      label: 'Ranganpeta',
      type: 'City'
    },
    {
      value: '6800',
      label: 'Rangas',
      type: 'City'
    },
    {
      value: '6801',
      label: 'Ranghola',
      type: 'City'
    },
    {
      value: '6802',
      label: 'Rangilpur',
      type: 'City'
    },
    {
      value: '6803',
      label: 'Rangpar',
      type: 'City'
    },
    {
      value: '6804',
      label: 'Rani',
      type: 'City'
    },
    {
      value: '6805',
      label: 'Rani Ki Sarai',
      type: 'City'
    },
    {
      value: '6806',
      label: 'Rania, HR',
      type: 'City'
    },
    {
      value: '6807',
      label: 'Rania, UP',
      type: 'City'
    },
    {
      value: '6808',
      label: 'Ranibennur',
      type: 'City'
    },
    {
      value: '6809',
      label: 'Raniganj',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '6810',
      label: 'Ranigunj',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6811',
      label: 'Ranikhet',
      type: 'City'
    },
    {
      value: '6812',
      label: 'Ranipet',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6813',
      label: 'Ranisawargaon',
      type: 'City'
    },
    {
      value: '6814',
      label: 'Ranital',
      type: 'City'
    },
    {
      value: '6815',
      label: 'Raniwara',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6816',
      label: 'Ranjangaon',
      type: 'City'
    },
    {
      value: '6817',
      label: 'Ranjit Bag',
      type: 'City'
    },
    {
      value: '6818',
      label: 'Ranka',
      type: 'City'
    },
    {
      value: '6819',
      label: 'Ranni',
      type: 'City'
    },
    {
      value: '6820',
      label: 'Rannod',
      type: 'City'
    },
    {
      value: '6821',
      label: 'Ranny',
      type: 'City'
    },
    {
      value: '6822',
      label: 'Ranny Perunad',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6823',
      label: 'Ranoli',
      type: 'City'
    },
    {
      value: '6824',
      label: 'Ranpur',
      type: 'City'
    },
    {
      value: '6825',
      label: 'Ransiki',
      type: 'City'
    },
    {
      value: '6826',
      label: 'Ranuja',
      type: 'City'
    },
    {
      value: '6827',
      label: 'Ranvi',
      type: 'City'
    },
    {
      value: '6828',
      label: 'Rapar',
      type: 'City'
    },
    {
      value: '6829',
      label: 'Rasaliya',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6830',
      label: 'Rasingapuram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6831',
      label: 'Rasipuram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6832',
      label: 'Rasra',
      type: 'City'
    },
    {
      value: '6833',
      label: 'Rast',
      type: 'City'
    },
    {
      value: '6834',
      label: 'Rasulabad',
      type: 'City'
    },
    {
      value: '6835',
      label: 'Ratangadh',
      type: 'City'
    },
    {
      value: '6836',
      label: 'Ratangarh',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6837',
      label: 'Ratangarh, MP',
      type: 'City'
    },
    {
      value: '6838',
      label: 'Ratangarh, Rajasthan',
      type: 'City'
    },
    {
      value: '6839',
      label: 'Ratannagar',
      type: 'City'
    },
    {
      value: '6840',
      label: 'Ratanpar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6841',
      label: 'Ratanpur, Chhattisgarh',
      type: 'City'
    },
    {
      value: '6842',
      label: 'Ratdi',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6843',
      label: 'Rath',
      type: 'City'
    },
    {
      value: '6844',
      label: 'Rathnagiri',
      type: 'City'
    },
    {
      value: '6845',
      label: 'Ratia',
      type: 'City'
    },
    {
      value: '6846',
      label: 'Ratidhar',
      type: 'City'
    },
    {
      value: '6847',
      label: 'Ratipar',
      type: 'City'
    },
    {
      value: '6848',
      label: 'Ratlam',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '6849',
      label: 'Ratnagiri',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6850',
      label: 'Ratnal',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6851',
      label: 'Ratpura',
      type: 'City'
    },
    {
      value: '6852',
      label: 'Ratri',
      type: 'City'
    },
    {
      value: '6853',
      label: 'Rattalli',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '6854',
      label: 'Rattihalli',
      type: 'City'
    },
    {
      value: '6855',
      label: 'Rau',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '6856',
      label: 'Raulasgaon',
      type: 'City'
    },
    {
      value: '6857',
      label: 'Raval',
      type: 'City'
    },
    {
      value: '6858',
      label: 'Ravapar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6859',
      label: 'Ravapar Morbi',
      type: 'City'
    },
    {
      value: '6860',
      label: 'Raver',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6861',
      label: 'Ravet',
      type: 'City'
    },
    {
      value: '6862',
      label: 'Ravna',
      type: 'City'
    },
    {
      value: '6863',
      label: 'Ravulapalem',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6864',
      label: 'Rawala',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6865',
      label: 'Rawapar',
      type: 'City'
    },
    {
      value: '6866',
      label: 'RawatBhata',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6867',
      label: 'Rawatpur',
      type: 'City'
    },
    {
      value: '6868',
      label: 'Rawatsar',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6869',
      label: 'Rawla',
      type: 'City'
    },
    {
      value: '6870',
      label: 'Rawson',
      type: 'City'
    },
    {
      value: '6871',
      label: 'Raxaul',
      type: 'City'
    },
    {
      value: '6872',
      label: 'Raya',
      type: 'City'
    },
    {
      value: '6873',
      label: 'Rayachoti',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6874',
      label: 'Rayachoty',
      type: 'City'
    },
    {
      value: '6875',
      label: 'Rayadurg',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6876',
      label: 'Rayan',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6877',
      label: 'Raydi',
      type: 'City'
    },
    {
      value: '6878',
      label: 'Rayla',
      type: 'City'
    },
    {
      value: '6879',
      label: 'Rayudupalem, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '6880',
      label: 'Rayudupalem, Telangana',
      type: 'City'
    },
    {
      value: '6881',
      label: 'Rayya',
      type: 'City'
    },
    {
      value: '6882',
      label: 'Razam',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6883',
      label: 'Razole',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6884',
      label: 'RC Puram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6885',
      label: 'Rebbana',
      type: 'City'
    },
    {
      value: '6886',
      label: 'Reckong Peo',
      type: 'City'
    },
    {
      value: '6887',
      label: 'Reconquista',
      type: 'City'
    },
    {
      value: '6888',
      label: 'Reddiapatti',
      type: 'City'
    },
    {
      value: '6889',
      label: 'Reddiarpatti',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6890',
      label: 'Reddypalem',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6891',
      label: 'Redhakhol',
      type: 'City'
    },
    {
      value: '6892',
      label: 'Reengus',
      type: 'City'
    },
    {
      value: '6893',
      label: 'Rehan',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '6894',
      label: 'Rehli',
      type: 'City'
    },
    {
      value: '6895',
      label: 'Rehra',
      type: 'City'
    },
    {
      value: '6896',
      label: 'Rehti',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '6897',
      label: 'Rejerla',
      type: 'City'
    },
    {
      value: '6898',
      label: 'Reliance',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6899',
      label: 'Relmangra',
      type: 'City'
    },
    {
      value: '6900',
      label: 'Renapur',
      type: 'City'
    },
    {
      value: '6901',
      label: 'Renavi',
      type: 'City'
    },
    {
      value: '6902',
      label: 'RENGO',
      type: 'City'
    },
    {
      value: '6903',
      label: 'Renigunta',
      type: 'City'
    },
    {
      value: '6904',
      label: 'Renukoot',
      type: 'City'
    },
    {
      value: '6905',
      label: 'Reoti',
      type: 'City'
    },
    {
      value: '6906',
      label: 'Repalle',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6907',
      label: 'REQUINOA',
      type: 'City'
    },
    {
      value: '6908',
      label: 'Resistencia',
      type: 'City'
    },
    {
      value: '6909',
      label: 'RETIRO',
      type: 'City'
    },
    {
      value: '6910',
      label: 'Retur',
      type: 'City'
    },
    {
      value: '6911',
      label: 'Retur Village',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6912',
      label: 'Revas',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '6913',
      label: 'Revdanda',
      type: 'City'
    },
    {
      value: '6914',
      label: 'Revdar',
      type: 'City'
    },
    {
      value: '6915',
      label: 'Revendrapadu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6916',
      label: 'Rewa',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '6917',
      label: 'Rewalsar',
      type: 'City'
    },
    {
      value: '6918',
      label: 'Rewari',
      type: 'City'
    },
    {
      value: '6919',
      label: 'Rewatra',
      type: 'City'
    },
    {
      value: '6920',
      label: 'Ribda',
      type: 'City'
    },
    {
      value: '6921',
      label: 'Richhed',
      type: 'City'
    },
    {
      value: '6922',
      label: 'Richhwa',
      type: 'City'
    },
    {
      value: '6923',
      label: 'Ridmalsar',
      type: 'City'
    },
    {
      value: '6924',
      label: 'Ringas',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6925',
      label: 'Ripponpete',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '6926',
      label: 'Rishabhdev',
      type: 'City'
    },
    {
      value: '6927',
      label: 'Rishikesh',
      type: 'City'
    },
    {
      value: '6928',
      label: 'Risod',
      type: 'City'
    },
    {
      value: '6929',
      label: 'Rithad',
      type: 'City'
    },
    {
      value: '6930',
      label: 'Rly. Konduru',
      type: 'City'
    },
    {
      value: '6931',
      label: 'Robertsganj',
      type: 'City'
    },
    {
      value: '6932',
      label: 'Rohana',
      type: 'City'
    },
    {
      value: '6933',
      label: 'Rohat',
      type: 'City'
    },
    {
      value: '6934',
      label: 'Rohinkhed',
      type: 'City'
    },
    {
      value: '6935',
      label: 'Rohisala',
      type: 'City'
    },
    {
      value: '6936',
      label: 'Rohisha',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6937',
      label: 'Rohit',
      type: 'City'
    },
    {
      value: '6938',
      label: 'Rohru',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '6939',
      label: 'Rohtak',
      type: 'City',
      'state': 'Haryana'
    },
    {
      value: '6940',
      label: 'Rohtang Pass',
      type: 'City'
    },
    {
      value: '6941',
      label: 'Rojhad',
      type: 'City'
    },
    {
      value: '6942',
      label: 'Rojhri',
      type: 'City'
    },
    {
      value: '6943',
      label: 'Rojid',
      type: 'City'
    },
    {
      value: '6944',
      label: 'Rol',
      type: 'City'
    },
    {
      value: '6945',
      label: 'Ron',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '6946',
      label: 'Rona',
      type: 'City'
    },
    {
      value: '6947',
      label: 'Rondapali',
      type: 'City'
    },
    {
      value: '6948',
      label: 'Roopangarh',
      type: 'City'
    },
    {
      value: '6949',
      label: 'Roopwas',
      type: 'City'
    },
    {
      value: '6950',
      label: 'Roorkee (Uttarakhand)',
      type: 'City'
    },
    {
      value: '6951',
      label: 'Ropar, Punjab',
      type: 'City'
    },
    {
      value: '6952',
      label: 'Ropari',
      type: 'City'
    },
    {
      value: '6953',
      label: 'Ropsi',
      type: 'City'
    },
    {
      value: '6954',
      label: 'Rosala',
      type: 'City'
    },
    {
      value: '6955',
      label: 'Rosera',
      type: 'City'
    },
    {
      value: '6956',
      label: 'Rourkela',
      type: 'City'
    },
    {
      value: '6957',
      label: 'Rowta',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '6958',
      label: 'Rudki',
      type: 'City'
    },
    {
      value: '6959',
      label: 'Rudrakota',
      type: 'City'
    },
    {
      value: '6960',
      label: 'Rudrapur',
      type: 'City'
    },
    {
      value: '6961',
      label: 'Rufino',
      type: 'City'
    },
    {
      value: '6962',
      label: 'Ruhil Dhar',
      type: 'City'
    },
    {
      value: '6963',
      label: 'Rukhran',
      type: 'City'
    },
    {
      value: '6964',
      label: 'Rupaidiha',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '6965',
      label: 'Rupal',
      type: 'City'
    },
    {
      value: '6966',
      label: 'Rupana',
      type: 'City'
    },
    {
      value: '6967',
      label: 'Rupangadh',
      type: 'City'
    },
    {
      value: '6968',
      label: 'Rupnagar',
      type: 'City'
    },
    {
      value: '6969',
      label: 'Rura',
      type: 'City'
    },
    {
      value: '6970',
      label: 'Rurki, HR',
      type: 'City'
    },
    {
      value: '6971',
      label: 'Rurki, Punjab',
      type: 'City'
    },
    {
      value: '6972',
      label: 'Rurki, UP',
      type: 'City'
    },
    {
      value: '6973',
      label: 'Rustampur',
      type: 'City'
    },
    {
      value: '6974',
      label: 'Ruthiyai',
      type: 'City'
    },
    {
      value: '6975',
      label: 'S.K. Varmanagar',
      type: 'City'
    },
    {
      value: '6976',
      label: 'S.Konda By-Pass',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6977',
      label: 'S.P. Pattinam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '6978',
      label: 'Sabalgarh',
      type: 'City'
    },
    {
      value: '6979',
      label: 'Sabarimala',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '6980',
      label: 'Sabla',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6981',
      label: 'Sabu',
      type: 'City'
    },
    {
      value: '6982',
      label: 'Sachha Khera',
      type: 'City'
    },
    {
      value: '6983',
      label: 'Sachin',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '6984',
      label: 'Sadabad',
      type: 'City'
    },
    {
      value: '6985',
      label: 'Sadalga',
      type: 'City'
    },
    {
      value: '6986',
      label: 'Sadashivgad',
      type: 'City'
    },
    {
      value: '6987',
      label: 'Sadashivpet',
      type: 'City'
    },
    {
      value: '6988',
      label: 'Sadewala',
      type: 'City'
    },
    {
      value: '6989',
      label: 'Sadodar',
      type: 'City'
    },
    {
      value: '6990',
      label: 'Sadri',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6991',
      label: 'Sadulpur',
      type: 'City'
    },
    {
      value: '6992',
      label: 'Sagar',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '6993',
      label: 'Sagara',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '6994',
      label: 'Sagari',
      type: 'City'
    },
    {
      value: '6995',
      label: 'Sagarpali',
      type: 'City'
    },
    {
      value: '6996',
      label: 'Sagrasundarpur',
      type: 'City'
    },
    {
      value: '6997',
      label: 'Sagrun',
      type: 'City'
    },
    {
      value: '6998',
      label: 'Sagwara',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '6999',
      label: 'Saha',
      type: 'City'
    },
    {
      value: '7000',
      label: 'Sahara',
      type: 'City'
    },
    {
      value: '7001',
      label: 'Saharanpur',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '7002',
      label: 'Saharsa',
      type: 'City'
    },
    {
      value: '7003',
      label: 'Saharsamanu',
      type: 'City'
    },
    {
      value: '7004',
      label: 'Sahaspur',
      type: 'City'
    },
    {
      value: '7005',
      label: 'Sahatwar',
      type: 'City'
    },
    {
      value: '7006',
      label: 'Sahauran',
      type: 'City'
    },
    {
      value: '7007',
      label: 'Sahawa',
      type: 'City'
    },
    {
      value: '7008',
      label: 'Sahebganj',
      type: 'City'
    },
    {
      value: '7009',
      label: 'Sahjanpur',
      type: 'City'
    },
    {
      value: '7010',
      label: 'Sahnewali',
      type: 'City'
    },
    {
      value: '7011',
      label: 'Sahuwala',
      type: 'City'
    },
    {
      value: '7012',
      label: 'Saibarakatte',
      type: 'City'
    },
    {
      value: '7013',
      label: 'Saibrakatte',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7014',
      label: 'Saidapur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7015',
      label: 'Saifai',
      type: 'City'
    },
    {
      value: '7016',
      label: 'Sailana',
      type: 'City'
    },
    {
      value: '7017',
      label: 'Sailani',
      type: 'City'
    },
    {
      value: '7018',
      label: 'Saini',
      type: 'City'
    },
    {
      value: '7019',
      label: 'Sainj',
      type: 'City'
    },
    {
      value: '7020',
      label: 'Sainj Kullu',
      type: 'City'
    },
    {
      value: '7021',
      label: 'Saipau',
      type: 'City'
    },
    {
      value: '7022',
      label: 'Sajiyavadar',
      type: 'City'
    },
    {
      value: '7023',
      label: 'Sakari',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7024',
      label: 'Sakharkherda',
      type: 'City'
    },
    {
      value: '7025',
      label: 'Sakka Mal.',
      type: 'City'
    },
    {
      value: '7026',
      label: 'Sakkamalpuram',
      type: 'City'
    },
    {
      value: '7027',
      label: 'Sakleshpur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7028',
      label: 'Sakleshpura',
      type: 'City'
    },
    {
      value: '7029',
      label: 'Sakol',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7030',
      label: 'Sakri, Bihar',
      type: 'City'
    },
    {
      value: '7031',
      label: 'Sakri, Maharashtra',
      type: 'City'
    },
    {
      value: '7032',
      label: 'Sakthinagar',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7033',
      label: 'Salad',
      type: 'City'
    },
    {
      value: '7034',
      label: 'Salaigramam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7035',
      label: 'Salal',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7036',
      label: 'Salangpur',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7037',
      label: 'Salaper',
      type: 'City'
    },
    {
      value: '7038',
      label: 'Salasar',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7039',
      label: 'Salava',
      type: 'City'
    },
    {
      value: '7040',
      label: 'Salaya',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7041',
      label: 'Saldi',
      type: 'City'
    },
    {
      value: '7042',
      label: 'Saleha',
      type: 'City'
    },
    {
      value: '7043',
      label: 'Salekasa',
      type: 'City'
    },
    {
      value: '7044',
      label: 'Salem',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7045',
      label: 'Salem Bypass',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7046',
      label: 'Salemabad',
      type: 'City'
    },
    {
      value: '7047',
      label: 'Salempur',
      type: 'City'
    },
    {
      value: '7048',
      label: 'Salgara',
      type: 'City'
    },
    {
      value: '7049',
      label: 'Salgare',
      type: 'City'
    },
    {
      value: '7050',
      label: 'Saligrama',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7051',
      label: 'Salkanpur',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '7052',
      label: 'Sallopat',
      type: 'City'
    },
    {
      value: '7053',
      label: 'Saloda',
      type: 'City'
    },
    {
      value: '7054',
      label: 'Salodha',
      type: 'City'
    },
    {
      value: '7055',
      label: 'Salogra',
      type: 'City'
    },
    {
      value: '7056',
      label: 'Salon',
      type: 'City'
    },
    {
      value: '7057',
      label: 'Salouni',
      type: 'City'
    },
    {
      value: '7058',
      label: 'Salta',
      type: 'City'
    },
    {
      value: '7059',
      label: 'Saltauwa',
      type: 'City'
    },
    {
      value: '7060',
      label: 'Salumbar',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7061',
      label: 'Salur',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7062',
      label: 'Salvan',
      type: 'City'
    },
    {
      value: '7063',
      label: 'Sam',
      type: 'City'
    },
    {
      value: '7064',
      label: 'Samadhiyala',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7065',
      label: 'Samagoga',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7066',
      label: 'Samalaji',
      type: 'City'
    },
    {
      value: '7067',
      label: 'Samalkha',
      type: 'City'
    },
    {
      value: '7068',
      label: 'Samana, Gujarat',
      type: 'City'
    },
    {
      value: '7069',
      label: 'Samana, Punjab',
      type: 'City'
    },
    {
      value: '7070',
      label: 'Samarlakota',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7071',
      label: 'Samastipur',
      type: 'City'
    },
    {
      value: '7072',
      label: 'Samatra',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7073',
      label: 'Samayapuram',
      type: 'City'
    },
    {
      value: '7074',
      label: 'Samba, Jammu And Kashmir',
      type: 'City'
    },
    {
      value: '7075',
      label: 'Sambalpur',
      type: 'City'
    },
    {
      value: '7076',
      label: 'Sambavarvadakarai',
      type: 'City'
    },
    {
      value: '7077',
      label: 'Sambogarh',
      type: 'City'
    },
    {
      value: '7078',
      label: 'Samdari',
      type: 'City'
    },
    {
      value: '7079',
      label: 'Sami',
      type: 'City'
    },
    {
      value: '7080',
      label: 'Samkhayali',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7081',
      label: 'Samkhiyali',
      type: 'City'
    },
    {
      value: '7082',
      label: 'Samnapur',
      type: 'City'
    },
    {
      value: '7083',
      label: 'Samode',
      type: 'City'
    },
    {
      value: '7084',
      label: 'Samoh',
      type: 'City'
    },
    {
      value: '7085',
      label: 'Sampaje (Karnataka)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7086',
      label: 'Sampekatte',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7087',
      label: 'Sampekatte(Nittur)',
      type: 'City'
    },
    {
      value: '7088',
      label: 'Samrala, Himachal Pradesh',
      type: 'City'
    },
    {
      value: '7089',
      label: 'Samrala, Punjab',
      type: 'City'
    },
    {
      value: '7090',
      label: 'Samter',
      type: 'City'
    },
    {
      value: '7091',
      label: 'Samundra',
      type: 'City'
    },
    {
      value: '7092',
      label: 'Sanada',
      type: 'City'
    },
    {
      value: '7093',
      label: 'Sanala',
      type: 'City'
    },
    {
      value: '7094',
      label: 'Sanaliya',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7095',
      label: 'Sanand',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7096',
      label: 'Sanathali',
      type: 'City'
    },
    {
      value: '7097',
      label: 'Sanawad',
      type: 'City'
    },
    {
      value: '7098',
      label: 'Sanchi',
      type: 'City'
    },
    {
      value: '7099',
      label: 'Sanchor',
      type: 'City'
    },
    {
      value: '7100',
      label: 'Sanchore',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7101',
      label: 'Sandalpur',
      type: 'City'
    },
    {
      value: '7102',
      label: 'Sanderao',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7103',
      label: 'Sanderav',
      type: 'City'
    },
    {
      value: '7104',
      label: 'Sanderaw',
      type: 'City'
    },
    {
      value: '7105',
      label: 'Sandhida',
      type: 'City'
    },
    {
      value: '7106',
      label: 'Sandhikuliari',
      type: 'City'
    },
    {
      value: '7107',
      label: 'Sandhol',
      type: 'City'
    },
    {
      value: '7108',
      label: 'Sandla',
      type: 'City'
    },
    {
      value: '7109',
      label: 'Sandolu',
      type: 'City'
    },
    {
      value: '7110',
      label: 'Sandur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7111',
      label: 'Sandwa',
      type: 'City'
    },
    {
      value: '7112',
      label: 'Sangagiri',
      type: 'City'
    },
    {
      value: '7113',
      label: 'Sangam Jagarlamudi',
      type: 'City'
    },
    {
      value: '7114',
      label: 'Sangameshwar',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7115',
      label: 'Sangamner',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7116',
      label: 'Sanganer',
      type: 'City'
    },
    {
      value: '7117',
      label: 'Sangareddy',
      type: 'City',
      'state': 'Telangana'
    },
    {
      value: '7118',
      label: 'Sangarh',
      type: 'City'
    },
    {
      value: '7119',
      label: 'Sangaria',
      type: 'City'
    },
    {
      value: '7120',
      label: 'Sangariya',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7121',
      label: 'Sangat',
      type: 'City'
    },
    {
      value: '7122',
      label: 'Sangavadar',
      type: 'City'
    },
    {
      value: '7123',
      label: 'Sangawas',
      type: 'City'
    },
    {
      value: '7124',
      label: 'Sanghipuram',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7125',
      label: 'Sanghipuram',
      type: 'City'
    },
    {
      value: '7126',
      label: 'Sangipur',
      type: 'City'
    },
    {
      value: '7127',
      label: 'Sangla',
      type: 'City'
    },
    {
      value: '7128',
      label: 'Sangli',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7129',
      label: 'Sangod',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7130',
      label: 'Sangola (Solapur)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7131',
      label: 'Sangram',
      type: 'City'
    },
    {
      value: '7132',
      label: 'Sangrampur',
      type: 'City'
    },
    {
      value: '7133',
      label: 'Sangrur',
      type: 'City'
    },
    {
      value: '7134',
      label: 'Sanjan',
      type: 'City'
    },
    {
      value: '7135',
      label: 'Sankagiri',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7136',
      label: 'Sankaran Koil',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7137',
      label: 'Sankari',
      type: 'City'
    },
    {
      value: '7138',
      label: 'Sankarna',
      type: 'City'
    },
    {
      value: '7139',
      label: 'Sankeshwar',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7140',
      label: 'Sankeshwara',
      type: 'City'
    },
    {
      value: '7141',
      label: 'Sanna',
      type: 'City'
    },
    {
      value: '7142',
      label: 'Sannanallur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7143',
      label: 'Sanoli',
      type: 'City'
    },
    {
      value: '7144',
      label: 'Sanoor',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7145',
      label: 'Sanoor Karkala',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7146',
      label: 'Sanosara',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7147',
      label: 'Sanpur',
      type: 'City'
    },
    {
      value: '7148',
      label: 'Sansai Kurang',
      type: 'City'
    },
    {
      value: '7149',
      label: 'Sant Kabir Nagar',
      type: 'City'
    },
    {
      value: '7150',
      label: 'SANTA CRUZ',
      type: 'City'
    },
    {
      value: '7151',
      label: 'Santa Rosa',
      type: 'City'
    },
    {
      value: '7152',
      label: 'Santakatte',
      type: 'City'
    },
    {
      value: '7153',
      label: 'Santalpur',
      type: 'City'
    },
    {
      value: '7154',
      label: 'Santhamaguluru',
      type: 'City'
    },
    {
      value: '7155',
      label: 'Santhebachahalli',
      type: 'City'
    },
    {
      value: '7156',
      label: 'Santhekatte',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7157',
      label: 'Santhu',
      type: 'City'
    },
    {
      value: '7158',
      label: 'Santiago',
      type: 'City'
    },
    {
      value: '7159',
      label: 'Santiago De Chile',
      type: 'City'
    },
    {
      value: '7160',
      label: 'Sanval',
      type: 'City'
    },
    {
      value: '7161',
      label: 'Sanwaliya',
      type: 'City'
    },
    {
      value: '7162',
      label: 'Saoli',
      type: 'City'
    },
    {
      value: '7163',
      label: 'Saoner',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7164',
      label: 'Sapar',
      type: 'City'
    },
    {
      value: '7165',
      label: 'Sapeda',
      type: 'City'
    },
    {
      value: '7166',
      label: 'Sapotra',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7167',
      label: 'Saptashurngi',
      type: 'City'
    },
    {
      value: '7168',
      label: 'Saputara',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7169',
      label: 'Saquelim',
      type: 'City',
      'state': 'Goa'
    },
    {
      value: '7170',
      label: 'Sarada',
      type: 'City'
    },
    {
      value: '7171',
      label: 'Sarahan',
      type: 'City'
    },
    {
      value: '7172',
      label: 'Sarai Kale Khan New Delhi',
      type: 'City'
    },
    {
      value: '7173',
      label: 'Sarai Mir',
      type: 'City'
    },
    {
      value: '7174',
      label: 'Sarai Naga',
      type: 'City'
    },
    {
      value: '7175',
      label: 'Saraigarh',
      type: 'City'
    },
    {
      value: '7176',
      label: 'Saraipali',
      type: 'City'
    },
    {
      value: '7177',
      label: 'Sarambhada',
      type: 'City'
    },
    {
      value: '7178',
      label: 'Sarangarh',
      type: 'City'
    },
    {
      value: '7179',
      label: 'Sarangi',
      type: 'City'
    },
    {
      value: '7180',
      label: 'Sarangkheda',
      type: 'City'
    },
    {
      value: '7181',
      label: 'Sarangpur',
      type: 'City'
    },
    {
      value: '7182',
      label: 'Sarangpur (MP)',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '7183',
      label: 'Sarangpur, Gujarat',
      type: 'City'
    },
    {
      value: '7184',
      label: 'Sarangpur, MP',
      type: 'City'
    },
    {
      value: '7185',
      label: 'Sarasiya',
      type: 'City'
    },
    {
      value: '7186',
      label: 'Sarat',
      type: 'City'
    },
    {
      value: '7187',
      label: 'Saravakota',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7188',
      label: 'Saravanampatty Coimbatore',
      type: 'City'
    },
    {
      value: '7189',
      label: 'Sardargadh',
      type: 'City'
    },
    {
      value: '7190',
      label: 'Sardargarh',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7191',
      label: 'Sardarshahar',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7192',
      label: 'Sardharpur',
      type: 'City'
    },
    {
      value: '7193',
      label: 'Sardulgarh',
      type: 'City'
    },
    {
      value: '7194',
      label: 'Sareri',
      type: 'City'
    },
    {
      value: '7195',
      label: 'Sargaon',
      type: 'City'
    },
    {
      value: '7196',
      label: 'Sargiguda',
      type: 'City'
    },
    {
      value: '7197',
      label: 'Sarkadiya',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7198',
      label: 'Sarkaghat',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '7199',
      label: 'Sarmathura',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7200',
      label: 'Sarna',
      type: 'City'
    },
    {
      value: '7201',
      label: 'Sarni',
      type: 'City'
    },
    {
      value: '7202',
      label: 'Sarni (MP)',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '7203',
      label: 'Saroda',
      type: 'City'
    },
    {
      value: '7204',
      label: 'Saroli',
      type: 'City'
    },
    {
      value: '7205',
      label: 'Sarora',
      type: 'City'
    },
    {
      value: '7206',
      label: 'Sarsai',
      type: 'City'
    },
    {
      value: '7207',
      label: 'Sarubujjili',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7208',
      label: 'Sarwai',
      type: 'City'
    },
    {
      value: '7209',
      label: 'Sarwan',
      type: 'City'
    },
    {
      value: '7210',
      label: 'Sarwaniya',
      type: 'City'
    },
    {
      value: '7211',
      label: 'Sarwar',
      type: 'City'
    },
    {
      value: '7212',
      label: 'Sasan Gir',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7213',
      label: 'Sasaram',
      type: 'City'
    },
    {
      value: '7214',
      label: 'Sasihithlu',
      type: 'City'
    },
    {
      value: '7215',
      label: 'Sasni',
      type: 'City'
    },
    {
      value: '7216',
      label: 'Sastana',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7217',
      label: 'Sasthama',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '7218',
      label: 'Sasthan Airody',
      type: 'City'
    },
    {
      value: '7219',
      label: 'Sasthapur Bangla',
      type: 'City'
    },
    {
      value: '7220',
      label: 'Sastur',
      type: 'City'
    },
    {
      value: '7221',
      label: 'Sasundra',
      type: 'City'
    },
    {
      value: '7222',
      label: 'Sata',
      type: 'City'
    },
    {
      value: '7223',
      label: 'Satana',
      type: 'City'
    },
    {
      value: '7224',
      label: 'Satara',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7225',
      label: 'Satara-karad',
      type: 'City'
    },
    {
      value: '7226',
      label: 'Satari',
      type: 'City'
    },
    {
      value: '7227',
      label: 'Satawane',
      type: 'City'
    },
    {
      value: '7228',
      label: 'Satellite Ahmedabad',
      type: 'City'
    },
    {
      value: '7229',
      label: 'Sathankulam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7230',
      label: 'Sathenpalli',
      type: 'City'
    },
    {
      value: '7231',
      label: 'Sathupalli',
      type: 'City'
    },
    {
      value: '7232',
      label: 'Sathyamangalam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7233',
      label: 'Satlasana',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7234',
      label: 'Satna',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '7235',
      label: 'Satnali',
      type: 'City'
    },
    {
      value: '7236',
      label: 'Satner',
      type: 'City'
    },
    {
      value: '7237',
      label: 'Satodad',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7238',
      label: 'Sattenapalle',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7239',
      label: 'Sattur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7240',
      label: 'Satu',
      type: 'City'
    },
    {
      value: '7241',
      label: 'Satudad',
      type: 'City'
    },
    {
      value: '7242',
      label: 'Satwari',
      type: 'City'
    },
    {
      value: '7243',
      label: 'Satyavedu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7244',
      label: 'Saundal',
      type: 'City'
    },
    {
      value: '7245',
      label: 'Saundatti',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7246',
      label: 'Sausar',
      type: 'City'
    },
    {
      value: '7247',
      label: 'Savadatti',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7248',
      label: 'Savalanga',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7249',
      label: 'Savanur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7250',
      label: 'Savar Kundla',
      type: 'City'
    },
    {
      value: '7251',
      label: 'Savarda',
      type: 'City'
    },
    {
      value: '7252',
      label: 'Savarde',
      type: 'City'
    },
    {
      value: '7253',
      label: 'Savarkundla',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7254',
      label: 'Savda',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7255',
      label: 'Savlaj',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7256',
      label: 'Savner',
      type: 'City'
    },
    {
      value: '7257',
      label: 'Sawada',
      type: 'City'
    },
    {
      value: '7258',
      label: 'Sawai Madhopur',
      type: 'City'
    },
    {
      value: '7259',
      label: 'Sawaipur',
      type: 'City'
    },
    {
      value: '7260',
      label: 'Sawala',
      type: 'City'
    },
    {
      value: '7261',
      label: 'Sawantsar',
      type: 'City'
    },
    {
      value: '7262',
      label: 'Sawantwadi (Sindhudurg)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7263',
      label: 'Sawarde (Maharashtra)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7264',
      label: 'Sawyerpuram',
      type: 'City'
    },
    {
      value: '7265',
      label: 'Sayala',
      type: 'City'
    },
    {
      value: '7266',
      label: 'Sayalgudi',
      type: 'City'
    },
    {
      value: '7267',
      label: 'Sayalkudi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7268',
      label: 'Sayarpuram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7269',
      label: 'Sayla',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7270',
      label: 'Sayra (Maharashtra)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7271',
      label: 'Searmau',
      type: 'City'
    },
    {
      value: '7272',
      label: 'Secunderabad',
      type: 'City'
    },
    {
      value: '7273',
      label: 'Sedam',
      type: 'City'
    },
    {
      value: '7274',
      label: 'Seepalakkottai',
      type: 'City'
    },
    {
      value: '7275',
      label: 'Seerapalli',
      type: 'City'
    },
    {
      value: '7276',
      label: 'Seerkazhi',
      type: 'City'
    },
    {
      value: '7277',
      label: 'Seethanagaram',
      type: 'City'
    },
    {
      value: '7278',
      label: 'Seetharamapuram',
      type: 'City'
    },
    {
      value: '7279',
      label: 'Sehore(M.P)',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '7280',
      label: 'Seithur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7281',
      label: 'Selakui',
      type: 'City'
    },
    {
      value: '7282',
      label: 'Selamba',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7283',
      label: 'Selaqui',
      type: 'City'
    },
    {
      value: '7284',
      label: 'Selu (Parbhani)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7285',
      label: 'Selvas',
      type: 'City'
    },
    {
      value: '7286',
      label: 'Sema',
      type: 'City'
    },
    {
      value: '7287',
      label: 'Semari',
      type: 'City'
    },
    {
      value: '7288',
      label: 'Sembanarkoil',
      type: 'City'
    },
    {
      value: '7289',
      label: 'SeminarKoil',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7290',
      label: 'Semla',
      type: 'City'
    },
    {
      value: '7291',
      label: 'Semliya',
      type: 'City'
    },
    {
      value: '7292',
      label: 'Sempatti',
      type: 'City'
    },
    {
      value: '7293',
      label: 'Semra Jagadalpur',
      type: 'City'
    },
    {
      value: '7294',
      label: 'Semri',
      type: 'City'
    },
    {
      value: '7295',
      label: 'Senawasa',
      type: 'City'
    },
    {
      value: '7296',
      label: 'Sendhwa',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '7297',
      label: 'Sendva',
      type: 'City'
    },
    {
      value: '7298',
      label: 'Senjal',
      type: 'City'
    },
    {
      value: '7299',
      label: 'Senkottai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7300',
      label: 'Senthamangalam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7301',
      label: 'Senthamaram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7302',
      label: 'Seoh',
      type: 'City'
    },
    {
      value: '7303',
      label: 'Seondha',
      type: 'City'
    },
    {
      value: '7304',
      label: 'Seoni',
      type: 'City'
    },
    {
      value: '7305',
      label: 'Seoni (MP)',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '7306',
      label: 'Seoul',
      type: 'City'
    },
    {
      value: '7307',
      label: 'Serkali',
      type: 'City'
    },
    {
      value: '7308',
      label: 'Serna',
      type: 'City'
    },
    {
      value: '7309',
      label: 'Serndamangalam',
      type: 'City'
    },
    {
      value: '7310',
      label: 'Seruguppa',
      type: 'City'
    },
    {
      value: '7311',
      label: 'Seruna',
      type: 'City'
    },
    {
      value: '7312',
      label: 'Servaikaranmadam',
      type: 'City'
    },
    {
      value: '7313',
      label: 'Serwa',
      type: 'City'
    },
    {
      value: '7314',
      label: 'Seth Vadala',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7315',
      label: 'Sethubhavachatram',
      type: 'City'
    },
    {
      value: '7316',
      label: 'Sethur',
      type: 'City'
    },
    {
      value: '7317',
      label: 'Setrawa',
      type: 'City'
    },
    {
      value: '7318',
      label: 'Sevagram',
      type: 'City'
    },
    {
      value: '7319',
      label: 'Sewari',
      type: 'City'
    },
    {
      value: '7320',
      label: 'Seydunganallur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7321',
      label: 'Shadnagar',
      type: 'City'
    },
    {
      value: '7322',
      label: 'Shadora',
      type: 'City'
    },
    {
      value: '7323',
      label: 'Shahada',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7324',
      label: 'Shahapur (Karnataka)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7325',
      label: 'Shahbaad',
      type: 'City'
    },
    {
      value: '7326',
      label: 'Shahdol',
      type: 'City'
    },
    {
      value: '7327',
      label: 'Shaheed Bhagat Singh Nagar',
      type: 'City'
    },
    {
      value: '7328',
      label: 'Shahgadh',
      type: 'City'
    },
    {
      value: '7329',
      label: 'Shahgarh',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '7330',
      label: 'Shahjahanpur (UP)',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '7331',
      label: 'Shahkot',
      type: 'City'
    },
    {
      value: '7332',
      label: 'Shahpura (Rajasthan)',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7333',
      label: 'Shahuwadi',
      type: 'City'
    },
    {
      value: '7334',
      label: 'Shahzadpur',
      type: 'City'
    },
    {
      value: '7335',
      label: 'Shaitrawa',
      type: 'City'
    },
    {
      value: '7336',
      label: 'Shajapur',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '7337',
      label: 'Shaktinagar (MP)',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '7338',
      label: 'Shalaghat',
      type: 'City'
    },
    {
      value: '7339',
      label: 'Shambal Pimpri',
      type: 'City'
    },
    {
      value: '7340',
      label: 'Shambhupura',
      type: 'City'
    },
    {
      value: '7341',
      label: 'Shambu Kalan',
      type: 'City'
    },
    {
      value: '7342',
      label: 'Shamgarh',
      type: 'City'
    },
    {
      value: '7343',
      label: 'Shamkhyari',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7344',
      label: 'Shamlaji',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7345',
      label: 'Shamli',
      type: 'City'
    },
    {
      value: '7346',
      label: 'Shamshabad',
      type: 'City'
    },
    {
      value: '7347',
      label: 'Shani Shignapur',
      type: 'City'
    },
    {
      value: '7348',
      label: 'Shanichara',
      type: 'City'
    },
    {
      value: '7349',
      label: 'Shanishingnapur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7350',
      label: 'Shankaranarayana',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7351',
      label: 'Shankarganj',
      type: 'City'
    },
    {
      value: '7352',
      label: 'Shankargarh',
      type: 'City'
    },
    {
      value: '7353',
      label: 'Shankarpura',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7354',
      label: 'Shankheshwar',
      type: 'City'
    },
    {
      value: '7355',
      label: 'Shankhwali',
      type: 'City'
    },
    {
      value: '7356',
      label: 'Shantiniketan',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7357',
      label: 'Shapar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7358',
      label: 'Sharontha',
      type: 'City'
    },
    {
      value: '7359',
      label: 'Shedubhar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7360',
      label: 'Shegaon (Buldhana)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7361',
      label: 'Sheikhpura',
      type: 'City'
    },
    {
      value: '7362',
      label: 'Shekhpir',
      type: 'City'
    },
    {
      value: '7363',
      label: 'Shelana',
      type: 'City'
    },
    {
      value: '7364',
      label: 'Shelapur (Buldhana)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7365',
      label: 'Shelu Bazar',
      type: 'City'
    },
    {
      value: '7366',
      label: 'Shemali',
      type: 'City'
    },
    {
      value: '7367',
      label: 'Shemba',
      type: 'City'
    },
    {
      value: '7368',
      label: 'Shendurni',
      type: 'City'
    },
    {
      value: '7369',
      label: 'Shenkottai',
      type: 'City'
    },
    {
      value: '7370',
      label: 'Sheo',
      type: 'City'
    },
    {
      value: '7371',
      label: 'Sheoganj',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7372',
      label: 'Sheohar',
      type: 'City'
    },
    {
      value: '7373',
      label: 'Sherani Abad',
      type: 'City'
    },
    {
      value: '7374',
      label: 'Shergadh',
      type: 'City'
    },
    {
      value: '7375',
      label: 'Shergarh',
      type: 'City'
    },
    {
      value: '7376',
      label: 'Shevgaon',
      type: 'City'
    },
    {
      value: '7377',
      label: 'Shewali',
      type: 'City'
    },
    {
      value: '7378',
      label: 'Shihor',
      type: 'City'
    },
    {
      value: '7379',
      label: 'Shikaripur',
      type: 'City'
    },
    {
      value: '7380',
      label: 'Shikaripura',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7381',
      label: 'Shikohabad',
      type: 'City'
    },
    {
      value: '7382',
      label: 'Shikrapur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7383',
      label: 'Shil',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7384',
      label: 'Shillong',
      type: 'City',
      'state': 'Meghalaya'
    },
    {
      value: '7385',
      label: 'Shilphata Navi Mumbai',
      type: 'City'
    },
    {
      value: '7386',
      label: 'Shimla',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '7387',
      label: 'Shipur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7388',
      label: 'Shiradhon',
      type: 'City'
    },
    {
      value: '7389',
      label: 'Shiraguppi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7390',
      label: 'Shiraguppi (Sirsi)',
      type: 'City'
    },
    {
      value: '7391',
      label: 'Shirala',
      type: 'City'
    },
    {
      value: '7392',
      label: 'Shirali',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7393',
      label: 'Shiralkoppa',
      type: 'City'
    },
    {
      value: '7394',
      label: 'Shirdhon',
      type: 'City'
    },
    {
      value: '7395',
      label: 'Shirdi',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7396',
      label: 'Shirdun',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7397',
      label: 'Shirgaon',
      type: 'City'
    },
    {
      value: '7398',
      label: 'Shirguppi',
      type: 'City'
    },
    {
      value: '7399',
      label: 'Shirkhal',
      type: 'City'
    },
    {
      value: '7400',
      label: 'Shiroda(Goa)',
      type: 'City',
      'state': 'Goa'
    },
    {
      value: '7401',
      label: 'Shiroor',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7402',
      label: 'Shiror',
      type: 'City'
    },
    {
      value: '7403',
      label: 'Shirpur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7404',
      label: 'Shirpur Bypass',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7405',
      label: 'Shirur Anantpal',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7406',
      label: 'Shirur Kasar',
      type: 'City'
    },
    {
      value: '7407',
      label: 'Shirva',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7408',
      label: 'Shirwal',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7409',
      label: 'Shiv',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7410',
      label: 'Shiv Khori',
      type: 'City',
      'state': 'Jammu & Kashmir'
    },
    {
      value: '7411',
      label: 'Shivajinagar',
      type: 'City'
    },
    {
      value: '7412',
      label: 'Shivajinagar (Ratnagiri)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7413',
      label: 'Shivakodu',
      type: 'City'
    },
    {
      value: '7414',
      label: 'Shivali',
      type: 'City'
    },
    {
      value: '7415',
      label: 'Shivamogga',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7416',
      label: 'Shivana',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7417',
      label: 'Shivganj',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7418',
      label: 'Shivkhori',
      type: 'City',
      'state': 'Delhi'
    },
    {
      value: '7419',
      label: 'Shivpuri',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '7420',
      label: 'Shivrajgadh',
      type: 'City'
    },
    {
      value: '7421',
      label: 'Shiyawat',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7422',
      label: 'Shobhapur',
      type: 'City'
    },
    {
      value: '7423',
      label: 'Shobhavadla',
      type: 'City'
    },
    {
      value: '7424',
      label: 'Shoghi',
      type: 'City'
    },
    {
      value: '7425',
      label: 'Shohratgarh',
      type: 'City'
    },
    {
      value: '7426',
      label: 'Sholapur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7427',
      label: 'Shorapur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7428',
      label: 'Shornur',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '7429',
      label: 'Shravan',
      type: 'City'
    },
    {
      value: '7430',
      label: 'Shravanabelagola',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7431',
      label: 'Shravasti',
      type: 'City'
    },
    {
      value: '7432',
      label: 'Shri Anandpur',
      type: 'City'
    },
    {
      value: '7433',
      label: 'Shri Dungargarh',
      type: 'City'
    },
    {
      value: '7434',
      label: 'Shri Ganganagar',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7435',
      label: 'Shrigonda',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7436',
      label: 'Shrimadhopur',
      type: 'City'
    },
    {
      value: '7437',
      label: 'Shrinathgadh',
      type: 'City'
    },
    {
      value: '7438',
      label: 'Shrinathji',
      type: 'City'
    },
    {
      value: '7439',
      label: 'Shriramnagar',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7440',
      label: 'Shrirampur',
      type: 'City'
    },
    {
      value: '7441',
      label: 'Shyamgarh',
      type: 'City'
    },
    {
      value: '7442',
      label: 'Shyampur',
      type: 'City'
    },
    {
      value: '7443',
      label: 'Sibsagar',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '7444',
      label: 'Siddantam',
      type: 'City'
    },
    {
      value: '7445',
      label: 'Siddapur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7446',
      label: 'Siddapura (KPR)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7447',
      label: 'Siddapura (Sirsi)',
      type: 'City'
    },
    {
      value: '7448',
      label: 'Siddapura(Udupi)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7449',
      label: 'Siddapur-Sirsi Road',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7450',
      label: 'Siddhapur',
      type: 'City'
    },
    {
      value: '7451',
      label: 'Siddharthnagar',
      type: 'City'
    },
    {
      value: '7452',
      label: 'Siddipet',
      type: 'City',
      'state': 'Telangana'
    },
    {
      value: '7453',
      label: 'Sidhantham',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7454',
      label: 'Sidhauli',
      type: 'City'
    },
    {
      value: '7455',
      label: 'Sidhi',
      type: 'City'
    },
    {
      value: '7456',
      label: 'Sidhmukh',
      type: 'City'
    },
    {
      value: '7457',
      label: 'Sidhpur',
      type: 'City'
    },
    {
      value: '7458',
      label: 'Sidhpur(Gujarat)',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7459',
      label: 'Sidsar',
      type: 'City'
    },
    {
      value: '7460',
      label: 'Sigandur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7461',
      label: 'Sihanok Ville',
      type: 'City'
    },
    {
      value: '7462',
      label: 'Sihanouk Ville',
      type: 'City'
    },
    {
      value: '7463',
      label: 'Sihar',
      type: 'City'
    },
    {
      value: '7464',
      label: 'Sihor',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7465',
      label: 'Sihora',
      type: 'City'
    },
    {
      value: '7466',
      label: 'Sijna Kheda',
      type: 'City'
    },
    {
      value: '7467',
      label: 'Sikandarpur',
      type: 'City'
    },
    {
      value: '7468',
      label: 'Sikanderpur',
      type: 'City'
    },
    {
      value: '7469',
      label: 'Sikandra',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7470',
      label: 'Sikandrabad',
      type: 'City'
    },
    {
      value: '7471',
      label: 'Sikar',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7472',
      label: 'Sikariganj',
      type: 'City'
    },
    {
      value: '7473',
      label: 'Sikhohabad',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '7474',
      label: 'Sikka',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7475',
      label: 'Sikkal',
      type: 'City'
    },
    {
      value: '7476',
      label: 'Sikrori Barani',
      type: 'City'
    },
    {
      value: '7477',
      label: 'Sikti',
      type: 'City'
    },
    {
      value: '7478',
      label: 'Silamalai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7479',
      label: 'Silapathar',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '7480',
      label: 'Silchar',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '7481',
      label: 'Sildar',
      type: 'City'
    },
    {
      value: '7482',
      label: 'Silehgarh',
      type: 'City'
    },
    {
      value: '7483',
      label: 'Siliguri',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '7484',
      label: 'Sillod',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7485',
      label: 'Silvassa, Dadra And Nagar Haveli',
      type: 'City'
    },
    {
      value: '7486',
      label: 'Silvassa, Gujarat',
      type: 'City'
    },
    {
      value: '7487',
      label: 'Silwani',
      type: 'City'
    },
    {
      value: '7488',
      label: 'Simalwara',
      type: 'City'
    },
    {
      value: '7489',
      label: 'Simariya',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '7490',
      label: 'Simga',
      type: 'City'
    },
    {
      value: '7491',
      label: 'Simhadri Puram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7492',
      label: 'Similiguda',
      type: 'City'
    },
    {
      value: '7493',
      label: 'Simla',
      type: 'City'
    },
    {
      value: '7494',
      label: 'Simla manali Chndgrh tour',
      type: 'City'
    },
    {
      value: '7495',
      label: 'Simrahi',
      type: 'City'
    },
    {
      value: '7496',
      label: 'Simran',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7497',
      label: 'Simrol',
      type: 'City'
    },
    {
      value: '7498',
      label: 'Sinapali',
      type: 'City'
    },
    {
      value: '7499',
      label: 'Sindagi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7500',
      label: 'Sindari',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7501',
      label: 'Sindhkhed Raja',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7502',
      label: 'Sindhnur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7503',
      label: 'Sindhudurg',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7504',
      label: 'Sindkhed',
      type: 'City'
    },
    {
      value: '7505',
      label: 'Singampuneri',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7506',
      label: 'Singanallur',
      type: 'City'
    },
    {
      value: '7507',
      label: 'Singanpur',
      type: 'City'
    },
    {
      value: '7508',
      label: 'Singarayakonda',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7509',
      label: 'Singarayapalem',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7510',
      label: 'Singh',
      type: 'City'
    },
    {
      value: '7511',
      label: 'Singhana',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7512',
      label: 'Singheshwar',
      type: 'City'
    },
    {
      value: '7513',
      label: 'Singhpur',
      type: 'City'
    },
    {
      value: '7514',
      label: 'Singoli',
      type: 'City'
    },
    {
      value: '7515',
      label: 'Singpur',
      type: 'City'
    },
    {
      value: '7516',
      label: 'Singramau',
      type: 'City'
    },
    {
      value: '7517',
      label: 'Singrauli',
      type: 'City'
    },
    {
      value: '7518',
      label: 'Singrauli(Baidhan)',
      type: 'City'
    },
    {
      value: '7519',
      label: 'Sinnar',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7520',
      label: 'Sinthalakarai',
      type: 'City'
    },
    {
      value: '7521',
      label: 'Sipor',
      type: 'City'
    },
    {
      value: '7522',
      label: 'Sira',
      type: 'City'
    },
    {
      value: '7523',
      label: 'Siracha',
      type: 'City'
    },
    {
      value: '7524',
      label: 'Sirali',
      type: 'City'
    },
    {
      value: '7525',
      label: 'Siralkoppa',
      type: 'City'
    },
    {
      value: '7526',
      label: 'Sirasdevi',
      type: 'City'
    },
    {
      value: '7527',
      label: 'Sirathu',
      type: 'City'
    },
    {
      value: '7528',
      label: 'Sirguppa',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7529',
      label: 'Sirhind',
      type: 'City'
    },
    {
      value: '7530',
      label: 'Sirikali',
      type: 'City'
    },
    {
      value: '7531',
      label: 'Siripalle',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7532',
      label: 'Siripuram',
      type: 'City'
    },
    {
      value: '7533',
      label: 'Siriyari',
      type: 'City'
    },
    {
      value: '7534',
      label: 'Sirkali',
      type: 'City'
    },
    {
      value: '7535',
      label: 'Sirkali (Sirkazhi)',
      type: 'City'
    },
    {
      value: '7536',
      label: 'Sirkazhi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7537',
      label: 'Sirmaur',
      type: 'City'
    },
    {
      value: '7538',
      label: 'Sirohi',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7539',
      label: 'Sirohi Road',
      type: 'City'
    },
    {
      value: '7540',
      label: 'Sironj',
      type: 'City'
    },
    {
      value: '7541',
      label: 'Sirsa',
      type: 'City',
      'state': 'Haryana'
    },
    {
      value: '7542',
      label: 'Sirsaganj',
      type: 'City'
    },
    {
      value: '7543',
      label: 'Sirsala',
      type: 'City'
    },
    {
      value: '7544',
      label: 'Sirsi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7545',
      label: 'Siruguppa',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7546',
      label: 'Sirumugai',
      type: 'City'
    },
    {
      value: '7547',
      label: 'Sirur Tajband',
      type: 'City'
    },
    {
      value: '7548',
      label: 'Sirvar',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7549',
      label: 'Sirwar',
      type: 'City'
    },
    {
      value: '7550',
      label: 'Sisai',
      type: 'City'
    },
    {
      value: '7551',
      label: 'Sissu',
      type: 'City'
    },
    {
      value: '7552',
      label: 'Sitamarhi',
      type: 'City'
    },
    {
      value: '7553',
      label: 'Sitamau',
      type: 'City'
    },
    {
      value: '7554',
      label: 'Sitapur',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '7555',
      label: 'Sitarganj (Uttarakhand)',
      type: 'City'
    },
    {
      value: '7556',
      label: 'Sito Gunno',
      type: 'City'
    },
    {
      value: '7557',
      label: 'Sivaganga',
      type: 'City'
    },
    {
      value: '7558',
      label: 'Sivagangai(Tamil Nadu)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7559',
      label: 'Sivagiri (tirunelveli)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7560',
      label: 'Sivagnanapuram',
      type: 'City'
    },
    {
      value: '7561',
      label: 'Sivakasi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7562',
      label: 'Sivakodu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7563',
      label: 'Sivana',
      type: 'City'
    },
    {
      value: '7564',
      label: 'Sivanthipuram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7565',
      label: 'Sivasagar',
      type: 'City'
    },
    {
      value: '7566',
      label: 'Sivathiapuram',
      type: 'City'
    },
    {
      value: '7567',
      label: 'Siwan',
      type: 'City'
    },
    {
      value: '7568',
      label: 'Siwana',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7569',
      label: 'Siwani',
      type: 'City'
    },
    {
      value: '7570',
      label: 'Siwara',
      type: 'City'
    },
    {
      value: '7571',
      label: 'Siyana',
      type: 'City'
    },
    {
      value: '7572',
      label: 'Siyavat',
      type: 'City'
    },
    {
      value: '7573',
      label: 'Snow Point',
      type: 'City'
    },
    {
      value: '7574',
      label: 'Sodalpur',
      type: 'City'
    },
    {
      value: '7575',
      label: 'Sohagpur',
      type: 'City'
    },
    {
      value: '7576',
      label: 'Sohaon',
      type: 'City'
    },
    {
      value: '7577',
      label: 'Sohela',
      type: 'City'
    },
    {
      value: '7578',
      label: 'Sojat',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7579',
      label: 'Sokkanathapuram',
      type: 'City'
    },
    {
      value: '7580',
      label: 'Solan',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '7581',
      label: 'Solang',
      type: 'City'
    },
    {
      value: '7582',
      label: 'Solapur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7583',
      label: 'Somala',
      type: 'City'
    },
    {
      value: '7584',
      label: 'Somatane',
      type: 'City'
    },
    {
      value: '7585',
      label: 'Somesar',
      type: 'City'
    },
    {
      value: '7586',
      label: 'Somnath',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7587',
      label: 'Sompeta',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7588',
      label: 'Sonaganvilai',
      type: 'City'
    },
    {
      value: '7589',
      label: 'Sonai',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '7590',
      label: 'Sonari',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '7591',
      label: 'Sonarpal',
      type: 'City'
    },
    {
      value: '7592',
      label: 'Sonauli',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '7593',
      label: 'Sonda',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7594',
      label: 'Sondarda',
      type: 'City'
    },
    {
      value: '7595',
      label: 'Sondeghar',
      type: 'City'
    },
    {
      value: '7596',
      label: 'Sondwa',
      type: 'City'
    },
    {
      value: '7597',
      label: 'Sonepur',
      type: 'City'
    },
    {
      value: '7598',
      label: 'Soneripura',
      type: 'City'
    },
    {
      value: '7599',
      label: 'Songadh',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7600',
      label: 'Songir',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7601',
      label: 'Sonha',
      type: 'City'
    },
    {
      value: '7602',
      label: 'Sonipat',
      type: 'City',
      'state': 'Haryana'
    },
    {
      value: '7603',
      label: 'Sonkatch',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '7604',
      label: 'Sonkhed (Nanded)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7605',
      label: 'Sorab',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7606',
      label: 'Soraba',
      type: 'City'
    },
    {
      value: '7607',
      label: 'Sorandai',
      type: 'City'
    },
    {
      value: '7608',
      label: 'Soron',
      type: 'City'
    },
    {
      value: '7609',
      label: 'South Authoor',
      type: 'City'
    },
    {
      value: '7610',
      label: 'South Goa',
      type: 'City'
    },
    {
      value: '7611',
      label: 'Soyat Kalan',
      type: 'City'
    },
    {
      value: '7612',
      label: 'Soygaon',
      type: 'City'
    },
    {
      value: '7613',
      label: 'Soyla',
      type: 'City'
    },
    {
      value: '7614',
      label: 'SP Pattinam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7615',
      label: 'Spic Nagar',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7616',
      label: 'Sreekandapuram',
      type: 'City'
    },
    {
      value: '7617',
      label: 'Sri Ganganagar',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7618',
      label: 'Sri Ramanagara',
      type: 'City'
    },
    {
      value: '7619',
      label: 'Sri Vijaynagar',
      type: 'City'
    },
    {
      value: '7620',
      label: 'Srikakulam',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7621',
      label: 'SriKalahasthi',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7622',
      label: 'Srikandapuram',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '7623',
      label: 'Srikaranpur',
      type: 'City'
    },
    {
      value: '7624',
      label: 'Srinagar',
      type: 'City',
      'state': 'Jammu & Kashmir'
    },
    {
      value: '7625',
      label: 'Sringar Tadi',
      type: 'City'
    },
    {
      value: '7626',
      label: 'Sringeri',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7627',
      label: 'Sriperumbudur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7628',
      label: 'Sriramanagara',
      type: 'City'
    },
    {
      value: '7629',
      label: 'Srirangam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7630',
      label: 'Srirangapatna',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7631',
      label: 'Srirangapattana',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7632',
      label: 'Srisailam',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7633',
      label: 'Srivaikundam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7634',
      label: 'SriviliPuthur',
      type: 'City'
    },
    {
      value: '7635',
      label: 'Srivilliputhur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7636',
      label: 'Srungavruksham',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7637',
      label: 'Subathu Solan',
      type: 'City'
    },
    {
      value: '7638',
      label: 'Subhariya',
      type: 'City'
    },
    {
      value: '7639',
      label: 'Subhash Nagar',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7640',
      label: 'Subhashbridge Ahmedabad',
      type: 'City'
    },
    {
      value: '7641',
      label: 'Subrahmanya',
      type: 'City'
    },
    {
      value: '7642',
      label: 'Subramaniapuram',
      type: 'City'
    },
    {
      value: '7643',
      label: 'Suchi',
      type: 'City'
    },
    {
      value: '7644',
      label: 'Sudavad',
      type: 'City'
    },
    {
      value: '7645',
      label: 'Sudhar',
      type: 'City'
    },
    {
      value: '7646',
      label: 'Suigam',
      type: 'City'
    },
    {
      value: '7647',
      label: 'Sujangadh',
      type: 'City'
    },
    {
      value: '7648',
      label: 'SujanGarh',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7649',
      label: 'Sujanpur (himachal pradesh)',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '7650',
      label: 'Sukari',
      type: 'City'
    },
    {
      value: '7651',
      label: 'Suket',
      type: 'City'
    },
    {
      value: '7652',
      label: 'Sukhpar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7653',
      label: 'Sukma',
      type: 'City'
    },
    {
      value: '7654',
      label: 'Sulakkarai',
      type: 'City'
    },
    {
      value: '7655',
      label: 'Sullah',
      type: 'City'
    },
    {
      value: '7656',
      label: 'Sullia',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7657',
      label: 'Sullurpet',
      type: 'City'
    },
    {
      value: '7658',
      label: 'Sullurupeta',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7659',
      label: 'Sultan Bathery',
      type: 'City'
    },
    {
      value: '7660',
      label: 'Sultangade',
      type: 'City'
    },
    {
      value: '7661',
      label: 'Sultanganj',
      type: 'City'
    },
    {
      value: '7662',
      label: 'Sultanpur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7663',
      label: 'Sultanpur (UP)',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '7664',
      label: 'Sulthan Bathery',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '7665',
      label: 'Sumar',
      type: 'City'
    },
    {
      value: '7666',
      label: 'Sumerpur',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7667',
      label: 'Sunabeda',
      type: 'City'
    },
    {
      value: '7668',
      label: 'Sunam',
      type: 'City'
    },
    {
      value: '7669',
      label: 'Sunchales',
      type: 'City'
    },
    {
      value: '7670',
      label: 'Sundargarh',
      type: 'City'
    },
    {
      value: '7671',
      label: 'Sundariyana',
      type: 'City'
    },
    {
      value: '7672',
      label: 'Sundarpur',
      type: 'City'
    },
    {
      value: '7673',
      label: 'Sunder Nagar (Himachal Pradesh)',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '7674',
      label: 'Sundha Mata',
      type: 'City'
    },
    {
      value: '7675',
      label: 'Sundhia',
      type: 'City'
    },
    {
      value: '7676',
      label: 'Sunel',
      type: 'City'
    },
    {
      value: '7677',
      label: 'Sungra',
      type: 'City'
    },
    {
      value: '7678',
      label: 'Suni',
      type: 'City'
    },
    {
      value: '7679',
      label: 'Sunki',
      type: 'City'
    },
    {
      value: '7680',
      label: 'Suntikoppa',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7681',
      label: 'Supa',
      type: 'City'
    },
    {
      value: '7682',
      label: 'Supasi',
      type: 'City'
    },
    {
      value: '7683',
      label: 'Supaul',
      type: 'City'
    },
    {
      value: '7684',
      label: 'Supedi',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7685',
      label: 'Surajpar',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '7686',
      label: 'Sural',
      type: 'City'
    },
    {
      value: '7687',
      label: 'Surana',
      type: 'City'
    },
    {
      value: '7688',
      label: 'Surandai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7689',
      label: 'Surangudi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7690',
      label: 'Surat',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7691',
      label: 'Surat Garh',
      type: 'City'
    },
    {
      value: '7692',
      label: 'Suratgarh',
      type: 'City'
    },
    {
      value: '7693',
      label: 'Suratgarh Jn',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7694',
      label: 'Surathkal',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7695',
      label: 'Surendranagar',
      type: 'City'
    },
    {
      value: '7696',
      label: 'Surera',
      type: 'City'
    },
    {
      value: '7697',
      label: 'Suri',
      type: 'City',
      'state': 'West Bengal'
    },
    {
      value: '7698',
      label: 'Surkhi',
      type: 'City'
    },
    {
      value: '7699',
      label: 'Surli',
      type: 'City'
    },
    {
      value: '7700',
      label: 'Surnagar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7701',
      label: 'Surpur',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7702',
      label: 'Surva',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7703',
      label: 'Suryapet',
      type: 'City'
    },
    {
      value: '7704',
      label: 'Susner',
      type: 'City'
    },
    {
      value: '7705',
      label: 'Suthaliya',
      type: 'City'
    },
    {
      value: '7706',
      label: 'Sutharpada',
      type: 'City'
    },
    {
      value: '7707',
      label: 'Sutrapada',
      type: 'City'
    },
    {
      value: '7708',
      label: 'Sutrapara',
      type: 'City'
    },
    {
      value: '7709',
      label: 'Suwasra',
      type: 'City'
    },
    {
      value: '7710',
      label: 'Swamimalai Kumbakonam',
      type: 'City'
    },
    {
      value: '7711',
      label: 'Swaraj',
      type: 'City'
    },
    {
      value: '7712',
      label: 'Swarghat',
      type: 'City'
    },
    {
      value: '7713',
      label: 'Swarofganj',
      type: 'City'
    },
    {
      value: '7714',
      label: 'Swaroopganj',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7715',
      label: 'sydney',
      type: 'City'
    },
    {
      value: '7716',
      label: 'T Kallupatti',
      type: 'City'
    },
    {
      value: '7717',
      label: 'T Nagar Chennai',
      type: 'City'
    },
    {
      value: '7718',
      label: 'T P Gudem Byepass',
      type: 'City'
    },
    {
      value: '7719',
      label: 'T.B.Dam',
      type: 'City'
    },
    {
      value: '7720',
      label: 'T.Kallupatti',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7721',
      label: 'T.Mariyur',
      type: 'City'
    },
    {
      value: '7722',
      label: 'T.P Gudem',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7723',
      label: 'Tacna (Tacna Peru)',
      type: 'City'
    },
    {
      value: '7724',
      label: 'Tada',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7725',
      label: 'Tadawale',
      type: 'City'
    },
    {
      value: '7726',
      label: 'Tadepalligudem',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7727',
      label: 'Tadikalapudi',
      type: 'City'
    },
    {
      value: '7728',
      label: 'Tadikonda X Road',
      type: 'City'
    },
    {
      value: '7729',
      label: 'Tadipatri',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7730',
      label: 'Tadoba',
      type: 'City'
    },
    {
      value: '7731',
      label: 'Tagadi',
      type: 'City'
    },
    {
      value: '7732',
      label: 'Tagdi',
      type: 'City'
    },
    {
      value: '7733',
      label: 'Taharabad',
      type: 'City'
    },
    {
      value: '7734',
      label: 'Tajpur',
      type: 'City'
    },
    {
      value: '7735',
      label: 'Tajpur, Bihar',
      type: 'City'
    },
    {
      value: '7736',
      label: 'Tajpur, Gujarat',
      type: 'City'
    },
    {
      value: '7737',
      label: 'Takari',
      type: 'City'
    },
    {
      value: '7738',
      label: 'Takari (Sangli)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7739',
      label: 'Takhatgarh',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '7740',
      label: 'Takiya',
      type: 'City'
    },
    {
      value: '7741',
      label: 'Tal',
      type: 'City'
    },
    {
      value: '7742',
      label: 'Talada',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7743',
      label: 'Talagana',
      type: 'City'
    },
    {
      value: '7744',
      label: 'Talaguppa',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7745',
      label: 'Talaja',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7746',
      label: 'Talala',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7747',
      label: 'Talari',
      type: 'City'
    },
    {
      value: '7748',
      label: 'Talatady',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7749',
      label: 'Talbahat',
      type: 'City'
    },
    {
      value: '7750',
      label: 'Talca',
      type: 'City'
    },
    {
      value: '7751',
      label: 'Talcher',
      type: 'City'
    },
    {
      value: '7752',
      label: 'Talegaon (Wardha)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7753',
      label: 'Talegav',
      type: 'City'
    },
    {
      value: '7754',
      label: 'Talere',
      type: 'City'
    },
    {
      value: '7755',
      label: 'Talere Naka',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7756',
      label: 'Talikote',
      type: 'City'
    },
    {
      value: '7757',
      label: 'Talikoti',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7758',
      label: 'Taliparamba',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '7759',
      label: 'Talkhed',
      type: 'City'
    },
    {
      value: '7760',
      label: 'Tallada',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7761',
      label: 'Tallapudi',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7762',
      label: 'Tallur, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '7763',
      label: 'Tallur, Karnataka',
      type: 'City'
    },
    {
      value: '7764',
      label: 'Talluru (Andhra Pradesh)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7765',
      label: 'Talni',
      type: 'City'
    },
    {
      value: '7766',
      label: 'Talod',
      type: 'City'
    },
    {
      value: '7767',
      label: 'Taloda',
      type: 'City'
    },
    {
      value: '7768',
      label: 'Talwana',
      type: 'City'
    },
    {
      value: '7769',
      label: 'Talwandi',
      type: 'City'
    },
    {
      value: '7770',
      label: 'Talwara Jheel',
      type: 'City'
    },
    {
      value: '7771',
      label: 'Talwara, Punjab',
      type: 'City'
    },
    {
      value: '7772',
      label: 'Talwara, Rajasthan',
      type: 'City'
    },
    {
      value: '7773',
      label: 'Tambaldeg',
      type: 'City'
    },
    {
      value: '7774',
      label: 'Tambaram Chennai',
      type: 'City'
    },
    {
      value: '7775',
      label: 'Tambi',
      type: 'City'
    },
    {
      value: '7776',
      label: 'Tamia',
      type: 'City'
    },
    {
      value: '7777',
      label: 'Tamkhadi',
      type: 'City'
    },
    {
      value: '7778',
      label: 'Tamkuhi Road',
      type: 'City'
    },
    {
      value: '7779',
      label: 'Tamsa',
      type: 'City'
    },
    {
      value: '7780',
      label: 'Tanakal',
      type: 'City'
    },
    {
      value: '7781',
      label: 'Tanakpur',
      type: 'City'
    },
    {
      value: '7782',
      label: 'Tanchi',
      type: 'City'
    },
    {
      value: '7783',
      label: 'Tanda',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '7784',
      label: 'Tandil',
      type: 'City'
    },
    {
      value: '7785',
      label: 'Tandulja',
      type: 'City'
    },
    {
      value: '7786',
      label: 'Tanginiguda',
      type: 'City'
    },
    {
      value: '7787',
      label: 'Tanguturu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7788',
      label: 'Tanjore',
      type: 'City'
    },
    {
      value: '7789',
      label: 'Tankara',
      type: 'City'
    },
    {
      value: '7790',
      label: 'Tansa',
      type: 'City'
    },
    {
      value: '7791',
      label: 'Tantaniya',
      type: 'City'
    },
    {
      value: '7792',
      label: 'Tanuku',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7793',
      label: 'Tapkara',
      type: 'City'
    },
    {
      value: '7794',
      label: 'Tapra',
      type: 'City'
    },
    {
      value: '7795',
      label: 'Tapri',
      type: 'City'
    },
    {
      value: '7796',
      label: 'Tapukara',
      type: 'City'
    },
    {
      value: '7797',
      label: 'Tara',
      type: 'City'
    },
    {
      value: '7798',
      label: 'Tarabh',
      type: 'City'
    },
    {
      value: '7799',
      label: 'Taradevi',
      type: 'City'
    },
    {
      value: '7800',
      label: 'Taragam',
      type: 'City'
    },
    {
      value: '7801',
      label: 'Taragampadi',
      type: 'City'
    },
    {
      value: '7802',
      label: 'Taral',
      type: 'City'
    },
    {
      value: '7803',
      label: 'Tarala',
      type: 'City'
    },
    {
      value: '7804',
      label: 'Tarale',
      type: 'City'
    },
    {
      value: '7805',
      label: 'Taranagar (Delhi)',
      type: 'City',
      'state': 'Delhi'
    },
    {
      value: '7806',
      label: 'Taranga',
      type: 'City'
    },
    {
      value: '7807',
      label: 'Tarapur',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '7808',
      label: 'Tarapur, Gujarat',
      type: 'City'
    },
    {
      value: '7809',
      label: 'Tarapur, Punjab',
      type: 'City'
    },
    {
      value: '7810',
      label: 'Taravda',
      type: 'City'
    },
    {
      value: '7811',
      label: 'Tariani',
      type: 'City'
    },
    {
      value: '7812',
      label: 'Tarija',
      type: 'City'
    },
    {
      value: '7813',
      label: 'Tarikere',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7814',
      label: 'Tarkarli',
      type: 'City'
    },
    {
      value: '7815',
      label: 'Tarkwari',
      type: 'City'
    },
    {
      value: '7816',
      label: 'Tarn Taran',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '7817',
      label: 'Tarnau',
      type: 'City'
    },
    {
      value: '7818',
      label: 'Tarsai',
      type: 'City'
    },
    {
      value: '7819',
      label: 'Tartagal',
      type: 'City'
    },
    {
      value: '7820',
      label: 'Tarwadi',
      type: 'City'
    },
    {
      value: '7821',
      label: 'Tasgaon (Sangli)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7822',
      label: 'Taswade',
      type: 'City'
    },
    {
      value: '7823',
      label: 'Tata nagar',
      type: 'City',
      'state': 'Jharkhand'
    },
    {
      value: '7824',
      label: 'Tatam',
      type: 'City'
    },
    {
      value: '7825',
      label: 'Tatanagar',
      type: 'City'
    },
    {
      value: '7826',
      label: 'Tataniya',
      type: 'City'
    },
    {
      value: '7827',
      label: 'Tatapani',
      type: 'City'
    },
    {
      value: '7828',
      label: 'Tatarpur',
      type: 'City'
    },
    {
      value: '7829',
      label: 'Tatipaka',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7830',
      label: 'Tauliyasar',
      type: 'City'
    },
    {
      value: '7831',
      label: 'Tauni Devi',
      type: 'City'
    },
    {
      value: '7832',
      label: 'Tavaragere',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7833',
      label: 'Taveda',
      type: 'City'
    },
    {
      value: '7834',
      label: 'Tawab',
      type: 'City'
    },
    {
      value: '7835',
      label: 'Teen Emli Square',
      type: 'City'
    },
    {
      value: '7836',
      label: 'Tejmalta',
      type: 'City'
    },
    {
      value: '7837',
      label: 'Tejpur',
      type: 'City'
    },
    {
      value: '7838',
      label: 'Tejpura',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '7839',
      label: 'Tekanpur',
      type: 'City'
    },
    {
      value: '7840',
      label: 'Tekkali',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7841',
      label: 'Tekkatte',
      type: 'City'
    },
    {
      value: '7842',
      label: 'Tekulapalli Khammam',
      type: 'City'
    },
    {
      value: '7843',
      label: 'Telaprolu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7844',
      label: 'Telgaon',
      type: 'City'
    },
    {
      value: '7845',
      label: 'Telgoan',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7846',
      label: 'Telhara',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7847',
      label: 'Teliamura',
      type: 'City'
    },
    {
      value: '7848',
      label: 'Temagav',
      type: 'City'
    },
    {
      value: '7849',
      label: 'Temburni',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7850',
      label: 'Temuco',
      type: 'City'
    },
    {
      value: '7851',
      label: 'Tenali',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7852',
      label: 'Tendukheda',
      type: 'City'
    },
    {
      value: '7853',
      label: 'Tenkasi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7854',
      label: 'TEODORO SCHMIDT',
      type: 'City'
    },
    {
      value: '7855',
      label: 'Teok',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '7856',
      label: 'Teosa',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7857',
      label: 'Tera',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '7858',
      label: 'Terdal',
      type: 'City'
    },
    {
      value: '7859',
      label: 'test',
      type: 'City'
    },
    {
      value: '7860',
      label: 'Tetiya',
      type: 'City'
    },
    {
      value: '7861',
      label: 'Tezpur',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '7862',
      label: 'Thadach',
      type: 'City'
    },
    {
      value: '7863',
      label: 'Thadichery',
      type: 'City'
    },
    {
      value: '7864',
      label: 'Thagarapuvalasa',
      type: 'City'
    },
    {
      value: '7865',
      label: 'Thakalai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7866',
      label: 'Thakur Dwara',
      type: 'City'
    },
    {
      value: '7867',
      label: 'Thala',
      type: 'City'
    },
    {
      value: '7868',
      label: 'Thalachanvilai',
      type: 'City'
    },
    {
      value: '7869',
      label: 'Thalaguppa',
      type: 'City'
    },
    {
      value: '7870',
      label: 'Thalainayar',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7871',
      label: 'Thalarka',
      type: 'City'
    },
    {
      value: '7872',
      label: 'Thalassery',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '7873',
      label: 'Thalavaipuram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7874',
      label: 'Thalayolaparambu',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '7875',
      label: 'Thalguppa',
      type: 'City'
    },
    {
      value: '7876',
      label: 'Thaliparamba',
      type: 'City'
    },
    {
      value: '7877',
      label: 'Thaliya',
      type: 'City'
    },
    {
      value: '7878',
      label: 'Thallaproddutur',
      type: 'City'
    },
    {
      value: '7879',
      label: 'Thallur (Tamil Nadu)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7880',
      label: 'Thalwar',
      type: 'City'
    },
    {
      value: '7881',
      label: 'Thamarassery',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '7882',
      label: 'Thammampatti',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7883',
      label: 'Thampanoor',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '7884',
      label: 'Thana Kalan',
      type: 'City'
    },
    {
      value: '7885',
      label: 'Thanadhar',
      type: 'City'
    },
    {
      value: '7886',
      label: 'Thanagalol',
      type: 'City'
    },
    {
      value: '7887',
      label: 'Thanagazi',
      type: 'City'
    },
    {
      value: '7888',
      label: 'Thanakallu',
      type: 'City'
    },
    {
      value: '7889',
      label: 'Thandavankadu',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7890',
      label: 'Thandla',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '7891',
      label: 'Thane',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '7892',
      label: 'Thanegaon',
      type: 'City'
    },
    {
      value: '7893',
      label: 'Thangachimadam',
      type: 'City'
    },
    {
      value: '7894',
      label: 'Thangammalpuram',
      type: 'City'
    },
    {
      value: '7895',
      label: 'Thanjavur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7896',
      label: 'Thanjore',
      type: 'City'
    },
    {
      value: '7897',
      label: 'Thankatchimadam',
      type: 'City'
    },
    {
      value: '7898',
      label: 'Thanwala',
      type: 'City'
    },
    {
      value: '7899',
      label: 'Thapan',
      type: 'City'
    },
    {
      value: '7900',
      label: 'Thapettai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7901',
      label: 'Thappukundu',
      type: 'City'
    },
    {
      value: '7902',
      label: 'Thara',
      type: 'City'
    },
    {
      value: '7903',
      label: 'Tharad',
      type: 'City'
    },
    {
      value: '7904',
      label: 'Tharamangalam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7905',
      label: 'Tharangambadi',
      type: 'City'
    },
    {
      value: '7906',
      label: 'Tharoch',
      type: 'City'
    },
    {
      value: '7907',
      label: 'Tharuvaikulam',
      type: 'City'
    },
    {
      value: '7908',
      label: 'Thasgavpur',
      type: 'City'
    },
    {
      value: '7909',
      label: 'Thathangaiarpet',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7910',
      label: 'Thattarmadam(Tirunelveli)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7911',
      label: 'Thawar',
      type: 'City'
    },
    {
      value: '7912',
      label: 'Theba',
      type: 'City'
    },
    {
      value: '7913',
      label: 'Thekkady',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '7914',
      label: 'Thekkatte',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7915',
      label: 'Thekma',
      type: 'City'
    },
    {
      value: '7916',
      label: 'Theni',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7917',
      label: 'Thenkasi',
      type: 'City'
    },
    {
      value: '7918',
      label: 'Thenmala',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '7919',
      label: 'Thennilai',
      type: 'City'
    },
    {
      value: '7920',
      label: 'Theog',
      type: 'City'
    },
    {
      value: '7921',
      label: 'Therlam',
      type: 'City'
    },
    {
      value: '7922',
      label: 'Therthally',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '7923',
      label: 'Thevaram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7924',
      label: 'Thikkanamvalue',
      type: 'City'
    },
    {
      value: '7925',
      label: 'Thikri',
      type: 'City'
    },
    {
      value: '7926',
      label: 'Thimmapuram Pedha Gumuluru',
      type: 'City'
    },
    {
      value: '7927',
      label: 'Thimmaraju Palem',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '7928',
      label: 'Thingal Nagar',
      type: 'City'
    },
    {
      value: '7929',
      label: 'Thingalnagar',
      type: 'City'
    },
    {
      value: '7930',
      label: 'Thirthahalli',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7931',
      label: 'Thirthahalli Road',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7932',
      label: 'Thirthalli',
      type: 'City'
    },
    {
      value: '7933',
      label: 'Thiruchendur',
      type: 'City'
    },
    {
      value: '7934',
      label: 'Thiruchitrambalam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7935',
      label: 'Thirukadaiyur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7936',
      label: 'Thirukalore Tuticorin',
      type: 'City'
    },
    {
      value: '7937',
      label: 'Thirukkolur',
      type: 'City'
    },
    {
      value: '7938',
      label: 'Thirukoilure',
      type: 'City'
    },
    {
      value: '7939',
      label: 'Thirukoshtiyur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7940',
      label: 'Thirumangalam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7941',
      label: 'Thirumanur',
      type: 'City'
    },
    {
      value: '7942',
      label: 'Thirumarugal',
      type: 'City'
    },
    {
      value: '7943',
      label: 'Thirumayam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7944',
      label: 'Thirunagar',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7945',
      label: 'Thirunallar (Pondicherry)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7946',
      label: 'Thirunelveli',
      type: 'City'
    },
    {
      value: '7947',
      label: 'Thirupalaikudi',
      type: 'City'
    },
    {
      value: '7948',
      label: 'Thiruparankundram',
      type: 'City'
    },
    {
      value: '7949',
      label: 'Thirupathur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7950',
      label: 'Thirupati Package',
      type: 'City'
    },
    {
      value: '7951',
      label: 'Thiruppalaikudi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7952',
      label: 'Thirupur',
      type: 'City'
    },
    {
      value: '7953',
      label: 'Thiruthani',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7954',
      label: 'Thiruthuraipoondi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7955',
      label: 'Thiruturaipoondi',
      type: 'City'
    },
    {
      value: '7956',
      label: 'Thiruvadanai kaikaati',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7957',
      label: 'Thiruvaiyaru',
      type: 'City'
    },
    {
      value: '7958',
      label: 'Thiruvalla',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '7959',
      label: 'Thiruvallur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7960',
      label: 'Thiruvananthapuram',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '7961',
      label: 'Thiruvannamalai',
      type: 'City'
    },
    {
      value: '7962',
      label: 'Thiruvarur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7963',
      label: 'Thiruvengadam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7964',
      label: 'Thiruverkadu Chennai',
      type: 'City'
    },
    {
      value: '7965',
      label: 'Thiruverumbur',
      type: 'City'
    },
    {
      value: '7966',
      label: 'Thisayanvilai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7967',
      label: 'Thittakudi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7968',
      label: 'Thob',
      type: 'City'
    },
    {
      value: '7969',
      label: 'Thodambail',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7970',
      label: 'Thodar',
      type: 'City'
    },
    {
      value: '7971',
      label: 'Thodupuzha',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '7972',
      label: 'Thokottu',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7973',
      label: 'Thondi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7974',
      label: 'Thondiyil',
      type: 'City'
    },
    {
      value: '7975',
      label: 'Thoo',
      type: 'City'
    },
    {
      value: '7976',
      label: 'Thoothukudi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7977',
      label: 'Thoppumpady',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '7978',
      label: 'Thopputhurai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7979',
      label: 'Thoradi',
      type: 'City'
    },
    {
      value: '7980',
      label: 'Thotlavalluru',
      type: 'City'
    },
    {
      value: '7981',
      label: 'Thottiyam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7982',
      label: 'Thovalai',
      type: 'City'
    },
    {
      value: '7983',
      label: 'Thrasi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '7984',
      label: 'Thrikaripur',
      type: 'City'
    },
    {
      value: '7985',
      label: 'Thrippunithra',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '7986',
      label: 'Thriprayar',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '7987',
      label: 'Thrissur',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '7988',
      label: 'Thrissur Bypass',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '7989',
      label: 'Thuckalay',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7990',
      label: 'Thugundram',
      type: 'City'
    },
    {
      value: '7991',
      label: 'Thugundrum',
      type: 'City'
    },
    {
      value: '7992',
      label: 'Thulasiyapattinam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7993',
      label: 'Thulukkapatti',
      type: 'City'
    },
    {
      value: '7994',
      label: 'Thumbe',
      type: 'City'
    },
    {
      value: '7995',
      label: 'Thumdi',
      type: 'City'
    },
    {
      value: '7996',
      label: 'Thunag',
      type: 'City'
    },
    {
      value: '7997',
      label: 'Thuni',
      type: 'City'
    },
    {
      value: '7998',
      label: 'Thuraiyur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '7999',
      label: 'Thural',
      type: 'City'
    },
    {
      value: '8000',
      label: 'Thuravoor',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '8001',
      label: 'Thurimella',
      type: 'City'
    },
    {
      value: '8002',
      label: 'Thuvakudi',
      type: 'City'
    },
    {
      value: '8003',
      label: 'Thuvarankuruchi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8004',
      label: 'Tibi',
      type: 'City'
    },
    {
      value: '8005',
      label: 'Tihra',
      type: 'City'
    },
    {
      value: '8006',
      label: 'Tijara',
      type: 'City'
    },
    {
      value: '8007',
      label: 'Tikamgarh',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '8008',
      label: 'Tikkar',
      type: 'City'
    },
    {
      value: '8009',
      label: 'Tikunia',
      type: 'City'
    },
    {
      value: '8010',
      label: 'Tilakvada',
      type: 'City'
    },
    {
      value: '8011',
      label: 'Tilora',
      type: 'City'
    },
    {
      value: '8012',
      label: 'Timarni',
      type: 'City'
    },
    {
      value: '8013',
      label: 'Timba',
      type: 'City'
    },
    {
      value: '8014',
      label: 'Timbadi Jam',
      type: 'City'
    },
    {
      value: '8015',
      label: 'Timbi',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8016',
      label: 'Timmapuram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8017',
      label: 'Tindivanam',
      type: 'City'
    },
    {
      value: '8018',
      label: 'Tinsukia',
      type: 'City',
      'state': 'Assam'
    },
    {
      value: '8019',
      label: 'Tintarwani',
      type: 'City'
    },
    {
      value: '8020',
      label: 'Tintoi',
      type: 'City'
    },
    {
      value: '8021',
      label: 'Tipiguda',
      type: 'City'
    },
    {
      value: '8022',
      label: 'Tiptur',
      type: 'City'
    },
    {
      value: '8023',
      label: 'Tirora',
      type: 'City'
    },
    {
      value: '8024',
      label: 'Tiruchendur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8025',
      label: 'Tiruchengode',
      type: 'City'
    },
    {
      value: '8026',
      label: 'Tiruchengodu',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8027',
      label: 'Tiruchi',
      type: 'City'
    },
    {
      value: '8028',
      label: 'Tiruchirapalli',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8029',
      label: 'Tiruchirapally',
      type: 'City'
    },
    {
      value: '8030',
      label: 'Tiruchirappalli',
      type: 'City'
    },
    {
      value: '8031',
      label: 'Tirukostiyur',
      type: 'City'
    },
    {
      value: '8032',
      label: 'Tirumala',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8033',
      label: 'Tirumangalam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8034',
      label: 'Tirunchenkod',
      type: 'City'
    },
    {
      value: '8035',
      label: 'Tirunelveli',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8036',
      label: 'Tirupati',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8037',
      label: 'Tirupattur (Vellore)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8038',
      label: 'Tirupur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8039',
      label: 'Tirur',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '8040',
      label: 'Tiruthanni',
      type: 'City'
    },
    {
      value: '8041',
      label: 'Tiruvalla',
      type: 'City'
    },
    {
      value: '8042',
      label: 'Tiruvallur',
      type: 'City'
    },
    {
      value: '8043',
      label: 'Tiruvananthapuram',
      type: 'City'
    },
    {
      value: '8044',
      label: 'Tiruvannamalai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8045',
      label: 'Tiruvanthapuram',
      type: 'City'
    },
    {
      value: '8046',
      label: 'Tiruvuru',
      type: 'City'
    },
    {
      value: '8047',
      label: 'Tirwaganj',
      type: 'City'
    },
    {
      value: '8048',
      label: 'Tisgaon',
      type: 'City'
    },
    {
      value: '8049',
      label: 'Tiuni',
      type: 'City'
    },
    {
      value: '8050',
      label: 'Tiwari',
      type: 'City'
    },
    {
      value: '8051',
      label: 'Toank',
      type: 'City'
    },
    {
      value: '8052',
      label: 'Toda',
      type: 'City'
    },
    {
      value: '8053',
      label: 'Todiya',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8054',
      label: 'Togari',
      type: 'City'
    },
    {
      value: '8055',
      label: 'Tohana',
      type: 'City'
    },
    {
      value: '8056',
      label: 'Tokapal',
      type: 'City'
    },
    {
      value: '8057',
      label: 'Toliyasar',
      type: 'City'
    },
    {
      value: '8058',
      label: 'TOLTEN',
      type: 'City'
    },
    {
      value: '8059',
      label: 'Tongpal',
      type: 'City'
    },
    {
      value: '8060',
      label: 'Tonk',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '8061',
      label: 'Toomuluru',
      type: 'City'
    },
    {
      value: '8062',
      label: 'Toonga',
      type: 'City'
    },
    {
      value: '8063',
      label: 'Toranagallu',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8064',
      label: 'Tori',
      type: 'City'
    },
    {
      value: '8065',
      label: 'Toshina',
      type: 'City'
    },
    {
      value: '8066',
      label: 'Totaniyala',
      type: 'City'
    },
    {
      value: '8067',
      label: 'Toticorin',
      type: 'City'
    },
    {
      value: '8068',
      label: 'Totu Shimla',
      type: 'City'
    },
    {
      value: '8069',
      label: 'TP Gudem Bypass',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8070',
      label: 'Trakuda',
      type: 'City'
    },
    {
      value: '8071',
      label: 'Trambakpur',
      type: 'City'
    },
    {
      value: '8072',
      label: 'Tran Patiya',
      type: 'City'
    },
    {
      value: '8073',
      label: 'Trapaj',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8074',
      label: 'Trasi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8075',
      label: 'Trelew',
      type: 'City'
    },
    {
      value: '8076',
      label: 'Tres Arroyos',
      type: 'City'
    },
    {
      value: '8077',
      label: 'Triambakeshwar',
      type: 'City'
    },
    {
      value: '8078',
      label: 'Trichy',
      type: 'City'
    },
    {
      value: '8079',
      label: 'Trikaripur Bus Stand',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '8080',
      label: 'Trimbak',
      type: 'City'
    },
    {
      value: '8081',
      label: 'Triprayar',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '8082',
      label: 'Tripunatura',
      type: 'City'
    },
    {
      value: '8083',
      label: 'Tripunithura',
      type: 'City'
    },
    {
      value: '8084',
      label: 'Trivandram',
      type: 'City'
    },
    {
      value: '8085',
      label: 'Triveniganj',
      type: 'City'
    },
    {
      value: '8086',
      label: 'Tugaon',
      type: 'City'
    },
    {
      value: '8087',
      label: 'Tugela Plaza',
      type: 'City'
    },
    {
      value: '8088',
      label: 'Tukaithad',
      type: 'City'
    },
    {
      value: '8089',
      label: 'Tulah',
      type: 'City'
    },
    {
      value: '8090',
      label: 'Tulajapur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8091',
      label: 'Tulasipaka',
      type: 'City'
    },
    {
      value: '8092',
      label: 'Tuljapur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8093',
      label: 'Tulsipur',
      type: 'City'
    },
    {
      value: '8094',
      label: 'Tumakuru',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8095',
      label: 'Tumberla',
      type: 'City'
    },
    {
      value: '8096',
      label: 'Tumkar',
      type: 'City'
    },
    {
      value: '8097',
      label: 'Tummidi',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8098',
      label: 'Tumnar',
      type: 'City'
    },
    {
      value: '8099',
      label: 'Tumsar',
      type: 'City'
    },
    {
      value: '8100',
      label: 'Tumuluru',
      type: 'City'
    },
    {
      value: '8101',
      label: 'Tundla',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '8102',
      label: 'Tuni',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8103',
      label: 'Tunuhatti',
      type: 'City'
    },
    {
      value: '8104',
      label: 'Tupran',
      type: 'City'
    },
    {
      value: '8105',
      label: 'Tura',
      type: 'City'
    },
    {
      value: '8106',
      label: 'Tural',
      type: 'City'
    },
    {
      value: '8107',
      label: 'Turukwadi',
      type: 'City'
    },
    {
      value: '8108',
      label: 'Tuticorin',
      type: 'City'
    },
    {
      value: '8109',
      label: 'Tutukudi',
      type: 'City'
    },
    {
      value: '8110',
      label: 'Uchi Bassi',
      type: 'City'
    },
    {
      value: '8111',
      label: 'Uchila',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8112',
      label: 'Uchipuli',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8113',
      label: 'Udaipur',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '8114',
      label: 'Udaipurwati',
      type: 'City'
    },
    {
      value: '8115',
      label: 'Udakishanganj',
      type: 'City'
    },
    {
      value: '8116',
      label: 'Udankudi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8117',
      label: 'Udayagiri (Andhra Pradesh)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8118',
      label: 'Udayarpatti',
      type: 'City'
    },
    {
      value: '8119',
      label: 'Udgir',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8120',
      label: 'Udhampur',
      type: 'City',
      'state': 'Jammu & Kashmir'
    },
    {
      value: '8121',
      label: 'Udhna Pandesra',
      type: 'City'
    },
    {
      value: '8122',
      label: 'Udhna Surat',
      type: 'City'
    },
    {
      value: '8123',
      label: 'Udi',
      type: 'City'
    },
    {
      value: '8124',
      label: 'Udma',
      type: 'City'
    },
    {
      value: '8125',
      label: 'Udowal',
      type: 'City'
    },
    {
      value: '8126',
      label: 'Udumalpet',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8127',
      label: 'Udupi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8128',
      label: 'Udvada',
      type: 'City'
    },
    {
      value: '8129',
      label: 'Udyavara',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8130',
      label: 'Udyavara Udupi',
      type: 'City'
    },
    {
      value: '8131',
      label: 'Ugamedi',
      type: 'City'
    },
    {
      value: '8132',
      label: 'Ugar',
      type: 'City'
    },
    {
      value: '8133',
      label: 'Ugar Budruk',
      type: 'City'
    },
    {
      value: '8134',
      label: 'Ugar Khurd',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8135',
      label: 'Uhal',
      type: 'City'
    },
    {
      value: '8136',
      label: 'Uijre',
      type: 'City'
    },
    {
      value: '8137',
      label: 'Ujada',
      type: 'City'
    },
    {
      value: '8138',
      label: 'Ujala Mota',
      type: 'City'
    },
    {
      value: '8139',
      label: 'Ujani',
      type: 'City'
    },
    {
      value: '8140',
      label: 'Ujire',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8141',
      label: 'Ujjain',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '8142',
      label: 'Ujjaini',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8143',
      label: 'Ujlan',
      type: 'City'
    },
    {
      value: '8144',
      label: 'Ukai',
      type: 'City'
    },
    {
      value: '8145',
      label: 'Ukhli',
      type: 'City'
    },
    {
      value: '8146',
      label: 'Ukkadam Coimbatore',
      type: 'City'
    },
    {
      value: '8147',
      label: 'Ukkirankotai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8148',
      label: 'Ukkirankottai',
      type: 'City'
    },
    {
      value: '8149',
      label: 'Uklana Bypass',
      type: 'City'
    },
    {
      value: '8150',
      label: 'Ukwa',
      type: 'City'
    },
    {
      value: '8151',
      label: 'Ulavapadu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8152',
      label: 'Ulhasnagar',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8153',
      label: 'Ulikkal',
      type: 'City'
    },
    {
      value: '8154',
      label: 'Ullagallu',
      type: 'City'
    },
    {
      value: '8155',
      label: 'Ullasnagar',
      type: 'City'
    },
    {
      value: '8156',
      label: 'Ullikkal',
      type: 'City'
    },
    {
      value: '8157',
      label: 'Ulliyeri',
      type: 'City'
    },
    {
      value: '8158',
      label: 'Ulundurpet',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8159',
      label: 'Umadi',
      type: 'City'
    },
    {
      value: '8160',
      label: 'Umar',
      type: 'City'
    },
    {
      value: '8161',
      label: 'Umarala',
      type: 'City'
    },
    {
      value: '8162',
      label: 'Umargam',
      type: 'City'
    },
    {
      value: '8163',
      label: 'Umari',
      type: 'City'
    },
    {
      value: '8164',
      label: 'Umaria',
      type: 'City'
    },
    {
      value: '8165',
      label: 'Umarikadu',
      type: 'City'
    },
    {
      value: '8166',
      label: 'Umariya',
      type: 'City'
    },
    {
      value: '8167',
      label: 'Umarkhed (Yavatmal)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8168',
      label: 'Umbraj',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8169',
      label: 'Umednagar',
      type: 'City'
    },
    {
      value: '8170',
      label: 'Umedpur',
      type: 'City'
    },
    {
      value: '8171',
      label: 'Umerga',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8172',
      label: 'Umerkote',
      type: 'City'
    },
    {
      value: '8173',
      label: 'Ummedabad',
      type: 'City'
    },
    {
      value: '8174',
      label: 'Umrain',
      type: 'City'
    },
    {
      value: '8175',
      label: 'Umrala',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8176',
      label: 'Umrali',
      type: 'City'
    },
    {
      value: '8177',
      label: 'Umred',
      type: 'City'
    },
    {
      value: '8178',
      label: 'Umrethi',
      type: 'City'
    },
    {
      value: '8179',
      label: 'Umri',
      type: 'City'
    },
    {
      value: '8180',
      label: 'Umru',
      type: 'City'
    },
    {
      value: '8181',
      label: 'Umta',
      type: 'City'
    },
    {
      value: '8182',
      label: 'Umuahia',
      type: 'City'
    },
    {
      value: '8183',
      label: 'Una (Gujarat)',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8184',
      label: 'Una (Himachal Pradesh)',
      type: 'City',
      'state': 'Himachal Pradesh'
    },
    {
      value: '8185',
      label: 'Unagatala',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8186',
      label: 'Unai',
      type: 'City'
    },
    {
      value: '8187',
      label: 'Unari',
      type: 'City'
    },
    {
      value: '8188',
      label: 'Unava',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8189',
      label: 'Unchahar',
      type: 'City'
    },
    {
      value: '8190',
      label: 'Unchi Bassi',
      type: 'City'
    },
    {
      value: '8191',
      label: 'Undi',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8192',
      label: 'Undoo',
      type: 'City'
    },
    {
      value: '8193',
      label: 'Undri',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8194',
      label: 'Unduru',
      type: 'City'
    },
    {
      value: '8195',
      label: 'Unguturu (Andhra Pradesh)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8196',
      label: 'Unhel',
      type: 'City'
    },
    {
      value: '8197',
      label: 'Unjha',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8198',
      label: 'Unnao',
      type: 'City'
    },
    {
      value: '8199',
      label: 'Untvad',
      type: 'City'
    },
    {
      value: '8200',
      label: 'Upleta',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8201',
      label: 'Uppala',
      type: 'City'
    },
    {
      value: '8202',
      label: 'Uppargudem',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8203',
      label: 'Uppiliapuram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8204',
      label: 'Uppinakote',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8205',
      label: 'Uppinangadi',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8206',
      label: 'Uppinkote Brahmavar',
      type: 'City'
    },
    {
      value: '8207',
      label: 'Upplla',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8208',
      label: 'Uppunda',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8209',
      label: 'Uppur',
      type: 'City'
    },
    {
      value: '8210',
      label: 'Uppur (Tamil Nadu)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8211',
      label: 'Upputur(Prakasam Dist.)',
      type: 'City'
    },
    {
      value: '8212',
      label: 'Upunda',
      type: 'City'
    },
    {
      value: '8213',
      label: 'Uran Islampur',
      type: 'City'
    },
    {
      value: '8214',
      label: 'Uravakonda',
      type: 'City'
    },
    {
      value: '8215',
      label: 'Uruli Kanchan',
      type: 'City'
    },
    {
      value: '8216',
      label: 'Ushuaia',
      type: 'City'
    },
    {
      value: '8217',
      label: 'Usilampatti',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8218',
      label: 'Usmanabad',
      type: 'City'
    },
    {
      value: '8219',
      label: 'Usrahar',
      type: 'City'
    },
    {
      value: '8220',
      label: 'Utchipuli',
      type: 'City'
    },
    {
      value: '8221',
      label: 'Uthamapalayam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8222',
      label: 'Uthamapalyam',
      type: 'City'
    },
    {
      value: '8223',
      label: 'Uthangarai',
      type: 'City'
    },
    {
      value: '8224',
      label: 'Uthramvalue',
      type: 'City'
    },
    {
      value: '8225',
      label: 'Utraula',
      type: 'City'
    },
    {
      value: '8226',
      label: 'Uttarlai',
      type: 'City'
    },
    {
      value: '8227',
      label: 'Uttarsanda',
      type: 'City'
    },
    {
      value: '8228',
      label: 'Utthangarai',
      type: 'City'
    },
    {
      value: '8229',
      label: 'Uttur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8230',
      label: 'Uvari',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8231',
      label: 'V.Kota Pond',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8232',
      label: 'V.M.Chatram',
      type: 'City'
    },
    {
      value: '8233',
      label: 'Vada',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8234',
      label: 'Vadachery(Pattukottai)',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8235',
      label: 'Vadagam',
      type: 'City'
    },
    {
      value: '8236',
      label: 'Vadakara',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '8237',
      label: 'Vadakkancherry',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '8238',
      label: 'Vadal',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8239',
      label: 'Vadali',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8240',
      label: 'Vadalur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8241',
      label: 'Vadamadurai',
      type: 'City'
    },
    {
      value: '8242',
      label: 'Vadanapilly',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '8243',
      label: 'Vadanappally',
      type: 'City'
    },
    {
      value: '8244',
      label: 'Vadani',
      type: 'City'
    },
    {
      value: '8245',
      label: 'Vadapalli',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8246',
      label: 'Vadaseri',
      type: 'City'
    },
    {
      value: '8247',
      label: 'Vadasery Nagercoil',
      type: 'City'
    },
    {
      value: '8248',
      label: 'Vadasserikkara',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '8249',
      label: 'Vadavli',
      type: 'City'
    },
    {
      value: '8250',
      label: 'Vadgam',
      type: 'City'
    },
    {
      value: '8251',
      label: 'Vadgaon',
      type: 'City'
    },
    {
      value: '8252',
      label: 'Vadhera',
      type: 'City'
    },
    {
      value: '8253',
      label: 'Vadinar',
      type: 'City'
    },
    {
      value: '8254',
      label: 'Vadipatti',
      type: 'City'
    },
    {
      value: '8255',
      label: 'Vadisaleru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8256',
      label: 'Vadiya',
      type: 'City'
    },
    {
      value: '8257',
      label: 'Vadkhal',
      type: 'City'
    },
    {
      value: '8258',
      label: 'Vadlamannadu',
      type: 'City'
    },
    {
      value: '8259',
      label: 'Vadlamudi',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8260',
      label: 'Vadnagar',
      type: 'City'
    },
    {
      value: '8261',
      label: 'Vadodara',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8262',
      label: 'Vadu',
      type: 'City'
    },
    {
      value: '8263',
      label: 'Vadugapatti',
      type: 'City'
    },
    {
      value: '8264',
      label: 'Vadviyala',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8265',
      label: 'Vagaikulam',
      type: 'City'
    },
    {
      value: '8266',
      label: 'Vagdod',
      type: 'City'
    },
    {
      value: '8267',
      label: 'Vaggampalle',
      type: 'City'
    },
    {
      value: '8268',
      label: 'Vaghaniya',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8269',
      label: 'Vaghaniya Juna',
      type: 'City'
    },
    {
      value: '8270',
      label: 'Vaghniya',
      type: 'City'
    },
    {
      value: '8271',
      label: 'Vai',
      type: 'City'
    },
    {
      value: '8272',
      label: 'Vaibhavwadi',
      type: 'City'
    },
    {
      value: '8273',
      label: 'Vaideeswaran Koil',
      type: 'City'
    },
    {
      value: '8274',
      label: 'Vaideeswaran Koil Street',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8275',
      label: 'Vaijapur',
      type: 'City'
    },
    {
      value: '8276',
      label: 'Vaikkom',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '8277',
      label: 'Vaikom',
      type: 'City'
    },
    {
      value: '8278',
      label: 'Vaimedu',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8279',
      label: 'Vairag',
      type: 'City'
    },
    {
      value: '8280',
      label: 'Vairavanpatti',
      type: 'City'
    },
    {
      value: '8281',
      label: 'Vaishali',
      type: 'City'
    },
    {
      value: '8282',
      label: 'Vaitheeswaran koil',
      type: 'City'
    },
    {
      value: '8283',
      label: 'Vaitheeswarankoil',
      type: 'City'
    },
    {
      value: '8284',
      label: 'Vaitheeswarankovil',
      type: 'City'
    },
    {
      value: '8285',
      label: 'Vaitla',
      type: 'City'
    },
    {
      value: '8286',
      label: 'Vajdi',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8287',
      label: 'Vajjapur',
      type: 'City'
    },
    {
      value: '8288',
      label: 'Vakiya',
      type: 'City'
    },
    {
      value: '8289',
      label: 'Vakkalagadda',
      type: 'City'
    },
    {
      value: '8290',
      label: 'Valakom',
      type: 'City'
    },
    {
      value: '8291',
      label: 'Valam',
      type: 'City'
    },
    {
      value: '8292',
      label: 'Valancheri',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '8293',
      label: 'Valangaiman',
      type: 'City'
    },
    {
      value: '8294',
      label: 'Valappadi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8295',
      label: 'Valaradi',
      type: 'City'
    },
    {
      value: '8296',
      label: 'Valasna',
      type: 'City'
    },
    {
      value: '8297',
      label: 'Valbhipur',
      type: 'City'
    },
    {
      value: '8298',
      label: 'Valdivia',
      type: 'City'
    },
    {
      value: '8299',
      label: 'Vallabh Vidhyanagar Anand',
      type: 'City'
    },
    {
      value: '8300',
      label: 'Vallabh Vidyanagar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8301',
      label: 'Vallabhipur',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8302',
      label: 'Vallam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8303',
      label: 'Valliyur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8304',
      label: 'Valluvambram',
      type: 'City'
    },
    {
      value: '8305',
      label: 'Valparaiso',
      type: 'City'
    },
    {
      value: '8306',
      label: 'Valsad',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8307',
      label: 'Valudhur',
      type: 'City'
    },
    {
      value: '8308',
      label: 'Valukad',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8309',
      label: 'Valunj',
      type: 'City'
    },
    {
      value: '8310',
      label: 'Vamanapuram',
      type: 'City'
    },
    {
      value: '8311',
      label: 'Vamanjoor',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8312',
      label: 'Vamanjur',
      type: 'City'
    },
    {
      value: '8313',
      label: 'Vamasa',
      type: 'City'
    },
    {
      value: '8314',
      label: 'Vana',
      type: 'City'
    },
    {
      value: '8315',
      label: 'Vanaramutti',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8316',
      label: 'Vanasthali',
      type: 'City'
    },
    {
      value: '8317',
      label: 'Vanathirupathi',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8318',
      label: 'Vanda',
      type: 'City'
    },
    {
      value: '8319',
      label: 'Vandaliya',
      type: 'City'
    },
    {
      value: '8320',
      label: 'Vandiperiyar',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '8321',
      label: 'Vandse',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8322',
      label: 'Vangal',
      type: 'City'
    },
    {
      value: '8323',
      label: 'Vani',
      type: 'City'
    },
    {
      value: '8324',
      label: 'Vani (Nashik)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8325',
      label: 'Vaniambad',
      type: 'City'
    },
    {
      value: '8326',
      label: 'Vaniyambadi',
      type: 'City'
    },
    {
      value: '8327',
      label: 'Vankaner',
      type: 'City'
    },
    {
      value: '8328',
      label: 'Vankayalapadu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8329',
      label: 'Vankiya',
      type: 'City'
    },
    {
      value: '8330',
      label: 'Vannicondendal',
      type: 'City'
    },
    {
      value: '8331',
      label: 'Vannikonendal',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8332',
      label: 'Vansda',
      type: 'City'
    },
    {
      value: '8333',
      label: 'Vansjaliya',
      type: 'City'
    },
    {
      value: '8334',
      label: 'Vanthali',
      type: 'City'
    },
    {
      value: '8335',
      label: 'Vanthli',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8336',
      label: 'Vapi',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8337',
      label: 'Vapsi',
      type: 'City'
    },
    {
      value: '8338',
      label: 'Varada',
      type: 'City'
    },
    {
      value: '8339',
      label: 'Varadahalli',
      type: 'City'
    },
    {
      value: '8340',
      label: 'Varagani',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8341',
      label: 'Varahi',
      type: 'City'
    },
    {
      value: '8342',
      label: 'Varana',
      type: 'City'
    },
    {
      value: '8343',
      label: 'Varanasi',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '8344',
      label: 'Varanasi(Banaras)',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '8345',
      label: 'Varanasi/Banaras',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '8346',
      label: 'Varanga',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8347',
      label: 'Varangaon',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8348',
      label: 'Varasada',
      type: 'City'
    },
    {
      value: '8349',
      label: 'Varasda',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8350',
      label: 'Varda',
      type: 'City'
    },
    {
      value: '8351',
      label: 'Varikuntapadu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8352',
      label: 'Varkhedi',
      type: 'City'
    },
    {
      value: '8353',
      label: 'Varman',
      type: 'City'
    },
    {
      value: '8354',
      label: 'Varmanagar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8355',
      label: 'Varshi',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8356',
      label: 'Vartej',
      type: 'City'
    },
    {
      value: '8357',
      label: 'Varvada',
      type: 'City'
    },
    {
      value: '8358',
      label: 'Vasad',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8359',
      label: 'Vasai',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8360',
      label: 'Vasan',
      type: 'City'
    },
    {
      value: '8361',
      label: 'Vasavad',
      type: 'City'
    },
    {
      value: '8362',
      label: 'Vasco',
      type: 'City',
      'state': 'Goa'
    },
    {
      value: '8363',
      label: 'Vashi',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8364',
      label: 'Vasmat',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8365',
      label: 'Vasudevanallur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8366',
      label: 'Vatalagundu',
      type: 'City'
    },
    {
      value: '8367',
      label: 'Vataman',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8368',
      label: 'Vathalagundu',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8369',
      label: 'Vati',
      type: 'City'
    },
    {
      value: '8370',
      label: 'Vatlapalem',
      type: 'City'
    },
    {
      value: '8371',
      label: 'Vav',
      type: 'City'
    },
    {
      value: '8372',
      label: 'Vavdi',
      type: 'City'
    },
    {
      value: '8373',
      label: 'Vavera',
      type: 'City'
    },
    {
      value: '8374',
      label: 'Vayalpadu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8375',
      label: 'Vayangani',
      type: 'City'
    },
    {
      value: '8376',
      label: 'Vayor',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8377',
      label: 'Vazhaiyadi',
      type: 'City'
    },
    {
      value: '8378',
      label: 'Vazhakkulam',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '8379',
      label: 'Vazhakulam',
      type: 'City'
    },
    {
      value: '8380',
      label: 'Vedachandur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8381',
      label: 'Vedancha',
      type: 'City'
    },
    {
      value: '8382',
      label: 'Vedaranayam',
      type: 'City'
    },
    {
      value: '8383',
      label: 'Vedaranyam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8384',
      label: 'Vedasandur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8385',
      label: 'Vedullapalli',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8386',
      label: 'Vedullapally',
      type: 'City'
    },
    {
      value: '8387',
      label: 'Veerakeralampudur',
      type: 'City'
    },
    {
      value: '8388',
      label: 'Veerana',
      type: 'City'
    },
    {
      value: '8389',
      label: 'Veeranam',
      type: 'City'
    },
    {
      value: '8390',
      label: 'Veerapandianpattinam',
      type: 'City'
    },
    {
      value: '8391',
      label: 'Veerapanenipally',
      type: 'City'
    },
    {
      value: '8392',
      label: 'Veerasigamani',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8393',
      label: 'Veeravalli',
      type: 'City'
    },
    {
      value: '8394',
      label: 'Veeravanallur',
      type: 'City'
    },
    {
      value: '8395',
      label: 'Veeravasaram (Andhra Pradesh)',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8396',
      label: 'Veerpur',
      type: 'City'
    },
    {
      value: '8397',
      label: 'Vegendla X Road',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8398',
      label: 'Vekariya',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8399',
      label: 'Vekra',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8400',
      label: 'Velachery',
      type: 'City'
    },
    {
      value: '8401',
      label: 'Velachery Chennai',
      type: 'City'
    },
    {
      value: '8402',
      label: 'Velangi',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8403',
      label: 'Velankanni',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8404',
      label: 'Velapur',
      type: 'City'
    },
    {
      value: '8405',
      label: 'Velavadar',
      type: 'City'
    },
    {
      value: '8406',
      label: 'Velayuthampalayam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8407',
      label: 'Vele (Satara)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8408',
      label: 'Vellakoil',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8409',
      label: 'Vellangari',
      type: 'City'
    },
    {
      value: '8410',
      label: 'Vellaturu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8411',
      label: 'Vellore',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8412',
      label: 'Vellore (Chennai)',
      type: 'City'
    },
    {
      value: '8413',
      label: 'Vellore By Pass',
      type: 'City'
    },
    {
      value: '8414',
      label: 'Vellore Golden Temple',
      type: 'City'
    },
    {
      value: '8415',
      label: 'Veloor',
      type: 'City'
    },
    {
      value: '8416',
      label: 'Velur',
      type: 'City'
    },
    {
      value: '8417',
      label: 'Vemagiri',
      type: 'City'
    },
    {
      value: '8418',
      label: 'Vemavaram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8419',
      label: 'Vembakkotai',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8420',
      label: 'Vembar',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8421',
      label: 'Vempalli',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8422',
      label: 'Vemulapadu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8423',
      label: 'Vemuru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8424',
      label: 'Venado Tuerto',
      type: 'City'
    },
    {
      value: '8425',
      label: 'Vengurla (Maharashtra)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8426',
      label: 'Venjaramoodu',
      type: 'City'
    },
    {
      value: '8427',
      label: 'Venkatachalapuram',
      type: 'City'
    },
    {
      value: '8428',
      label: 'Venkatagiri',
      type: 'City'
    },
    {
      value: '8429',
      label: 'Venkatagirikota',
      type: 'City'
    },
    {
      value: '8430',
      label: 'Venkatapuram, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '8431',
      label: 'Venkatapuram, Telangana',
      type: 'City'
    },
    {
      value: '8432',
      label: 'Vennandur',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8433',
      label: 'Venoor',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8434',
      label: 'Ventrapragada',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8435',
      label: 'Venur',
      type: 'City'
    },
    {
      value: '8436',
      label: 'Venuru',
      type: 'City'
    },
    {
      value: '8437',
      label: 'Veppalodai Thoothukudi',
      type: 'City'
    },
    {
      value: '8438',
      label: 'Veppankadu',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8439',
      label: 'Verad',
      type: 'City'
    },
    {
      value: '8440',
      label: 'Veraval',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8441',
      label: 'Veriya',
      type: 'City'
    },
    {
      value: '8442',
      label: 'Verka',
      type: 'City'
    },
    {
      value: '8443',
      label: 'Vermanagar',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8444',
      label: 'Verna',
      type: 'City',
      'state': 'Goa'
    },
    {
      value: '8445',
      label: 'Verul',
      type: 'City'
    },
    {
      value: '8446',
      label: 'Vetapalem',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8447',
      label: 'Vethalagundu',
      type: 'City'
    },
    {
      value: '8448',
      label: 'Vettichira',
      type: 'City'
    },
    {
      value: '8449',
      label: 'Vickramasingapuram',
      type: 'City'
    },
    {
      value: '8450',
      label: 'Vidayagiri Bagalkot',
      type: 'City'
    },
    {
      value: '8451',
      label: 'Vidhyanagar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8452',
      label: 'Vidhyanagar, Andhra Pradesh',
      type: 'City'
    },
    {
      value: '8453',
      label: 'Vidhyanagar, Gujarat',
      type: 'City'
    },
    {
      value: '8454',
      label: 'Vidisha',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '8455',
      label: 'Viedma',
      type: 'City'
    },
    {
      value: '8456',
      label: 'VIGNAN LARA',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8457',
      label: 'Vignan Lara College',
      type: 'City'
    },
    {
      value: '8458',
      label: 'Vijapadi',
      type: 'City'
    },
    {
      value: '8459',
      label: 'Vijapur',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8460',
      label: 'Vijay Nagar',
      type: 'City',
      'state': 'Rajasthan'
    },
    {
      value: '8461',
      label: 'Vijayabagh',
      type: 'City'
    },
    {
      value: '8462',
      label: 'Vijayamangalam Tollgate',
      type: 'City'
    },
    {
      value: '8463',
      label: 'Vijayanagar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8464',
      label: 'Vijayapathi',
      type: 'City'
    },
    {
      value: '8465',
      label: 'Vijayapura',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8466',
      label: 'Vijayawada',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8467',
      label: 'Vijaydurg',
      type: 'City'
    },
    {
      value: '8468',
      label: 'Vijaynagar, Gujarat',
      type: 'City'
    },
    {
      value: '8469',
      label: 'Vijaypur',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '8470',
      label: 'Vijayrai',
      type: 'City'
    },
    {
      value: '8471',
      label: 'Vijjeshwaram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8472',
      label: 'Vikasnagar(Uttarakhand)',
      type: 'City'
    },
    {
      value: '8473',
      label: 'Vikramasingapuram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8474',
      label: 'Vilasagar',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8475',
      label: 'Vilathikulam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8476',
      label: 'Villianur',
      type: 'City'
    },
    {
      value: '8477',
      label: 'Villiseri',
      type: 'City'
    },
    {
      value: '8478',
      label: 'Villukuri',
      type: 'City'
    },
    {
      value: '8479',
      label: 'Villupuram',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8480',
      label: 'Vinchhiya',
      type: 'City'
    },
    {
      value: '8481',
      label: 'Vinchur',
      type: 'City'
    },
    {
      value: '8482',
      label: 'Vinjamoor',
      type: 'City'
    },
    {
      value: '8483',
      label: 'Vinukonda',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8484',
      label: 'Virajpet',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8485',
      label: 'Virali Malai',
      type: 'City'
    },
    {
      value: '8486',
      label: 'Viramgam',
      type: 'City'
    },
    {
      value: '8487',
      label: 'Virar',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8488',
      label: 'Virasigamani',
      type: 'City'
    },
    {
      value: '8489',
      label: 'Virat Nagar',
      type: 'City'
    },
    {
      value: '8490',
      label: 'Viratra',
      type: 'City'
    },
    {
      value: '8491',
      label: 'Virdi',
      type: 'City'
    },
    {
      value: '8492',
      label: 'Viregaon',
      type: 'City'
    },
    {
      value: '8493',
      label: 'Virpur',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8494',
      label: 'Virudhachalam',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8495',
      label: 'Virudhnagar',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8496',
      label: 'Visannapeta',
      type: 'City'
    },
    {
      value: '8497',
      label: 'Visarwadi',
      type: 'City'
    },
    {
      value: '8498',
      label: 'Visavadar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8499',
      label: 'Vishol',
      type: 'City'
    },
    {
      value: '8500',
      label: 'Vishrambag',
      type: 'City'
    },
    {
      value: '8501',
      label: 'Visnagar',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8502',
      label: 'Vissakoderu',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8503',
      label: 'Vissannapetaa',
      type: 'City'
    },
    {
      value: '8504',
      label: 'Vita',
      type: 'City'
    },
    {
      value: '8505',
      label: 'Vita(Maharashtra)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8506',
      label: 'Vithon',
      type: 'City'
    },
    {
      value: '8507',
      label: 'Vitta',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8508',
      label: 'Vittal',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8509',
      label: 'Vitthalwadi',
      type: 'City'
    },
    {
      value: '8510',
      label: 'Vittla',
      type: 'City'
    },
    {
      value: '8511',
      label: 'Vizag',
      type: 'City'
    },
    {
      value: '8512',
      label: 'Vijayanagaram',
      type: 'City'
    },
    {
      value: '8513',
      label: 'Vm Banjara Penuballi',
      type: 'City'
    },
    {
      value: '8514',
      label: 'Vontimitta',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8515',
      label: 'Vrindavan',
      type: 'City',
      'state': 'Uttar Pradesh'
    },
    {
      value: '8516',
      label: 'Vuyyuru',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8517',
      label: 'Vyara',
      type: 'City',
      'state': 'Gujarat'
    },
    {
      value: '8518',
      label: 'Vyas',
      type: 'City',
      'state': 'Punjab'
    },
    {
      value: '8519',
      label: 'Vytheswarankoil',
      type: 'City',
      'state': 'Tamil Nadu'
    },
    {
      value: '8520',
      label: 'Vythiri',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '8521',
      label: 'Vyttila',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '8522',
      label: 'Vyttila Kochi',
      type: 'City'
    },
    {
      value: '8523',
      label: 'Wada',
      type: 'City'
    },
    {
      value: '8524',
      label: 'Wadakkanchery',
      type: 'City'
    },
    {
      value: '8525',
      label: 'Wadakkenchery',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '8526',
      label: 'Wadatar',
      type: 'City'
    },
    {
      value: '8527',
      label: 'Wadi',
      type: 'City'
    },
    {
      value: '8528',
      label: 'Wadner Bholji',
      type: 'City'
    },
    {
      value: '8529',
      label: 'Wadraf Nagar',
      type: 'City'
    },
    {
      value: '8530',
      label: 'Wadsa (Bhandara)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8531',
      label: 'Wadwani (Beed)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8532',
      label: 'Wagada',
      type: 'City'
    },
    {
      value: '8533',
      label: 'Waghali',
      type: 'City'
    },
    {
      value: '8534',
      label: 'Wagholi',
      type: 'City'
    },
    {
      value: '8535',
      label: 'Wai',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8536',
      label: 'Wai Phata',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8537',
      label: 'Waidhan',
      type: 'City'
    },
    {
      value: '8538',
      label: 'Waki',
      type: 'City'
    },
    {
      value: '8539',
      label: 'Waknaghat',
      type: 'City'
    },
    {
      value: '8540',
      label: 'Walajabad',
      type: 'City'
    },
    {
      value: '8541',
      label: 'Walandi',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8542',
      label: 'Walayar',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '8543',
      label: 'Walpur',
      type: 'City'
    },
    {
      value: '8544',
      label: 'Waluj',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8545',
      label: 'Walwad',
      type: 'City'
    },
    {
      value: '8546',
      label: 'Wandli',
      type: 'City'
    },
    {
      value: '8547',
      label: 'Wangtu',
      type: 'City'
    },
    {
      value: '8548',
      label: 'Wani',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8549',
      label: 'Wankaner',
      type: 'City'
    },
    {
      value: '8550',
      label: 'Waranga Phata',
      type: 'City'
    },
    {
      value: '8551',
      label: 'Waraseoni',
      type: 'City',
      'state': 'Madhya Pradesh'
    },
    {
      value: '8552',
      label: 'Warden',
      type: 'City'
    },
    {
      value: '8553',
      label: 'Wardha',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8554',
      label: 'Wargaon',
      type: 'City'
    },
    {
      value: '8555',
      label: 'Warisganj',
      type: 'City'
    },
    {
      value: '8556',
      label: 'Warora',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8557',
      label: 'Warud',
      type: 'City'
    },
    {
      value: '8558',
      label: 'Warud (Amravati)',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8559',
      label: 'Warul',
      type: 'City'
    },
    {
      value: '8560',
      label: 'Warwat Bakal',
      type: 'City'
    },
    {
      value: '8561',
      label: 'Washi(Osmanabad)',
      type: 'City'
    },
    {
      value: '8562',
      label: 'Washim',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8563',
      label: 'Watar',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8564',
      label: 'Wathar',
      type: 'City'
    },
    {
      value: '8565',
      label: 'Watrap',
      type: 'City'
    },
    {
      value: '8566',
      label: 'Wattur Phata',
      type: 'City'
    },
    {
      value: '8567',
      label: 'Watul',
      type: 'City'
    },
    {
      value: '8568',
      label: 'Watur Phata',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8569',
      label: 'Wayamgani',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8570',
      label: 'Wayanad',
      type: 'City',
      'state': 'Kerala'
    },
    {
      value: '8571',
      label: 'Wazedu',
      type: 'City'
    },
    {
      value: '8572',
      label: 'Wazir Ganj',
      type: 'City'
    },
    {
      value: '8573',
      label: 'Wele',
      type: 'City'
    },
    {
      value: '8574',
      label: 'Workshop',
      type: 'City'
    },
    {
      value: '8575',
      label: 'Wyra',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8576',
      label: 'Y.G-Palem',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8577',
      label: 'Yadagiri',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8578',
      label: 'Yadgir',
      type: 'City'
    },
    {
      value: '8579',
      label: 'Yadshi',
      type: 'City'
    },
    {
      value: '8580',
      label: 'Yadthare',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8581',
      label: 'Yadur',
      type: 'City'
    },
    {
      value: '8582',
      label: 'Yadur (shimoga)',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8583',
      label: 'Yajali',
      type: 'City'
    },
    {
      value: '8584',
      label: 'Yalamanchilli',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8585',
      label: 'Yalburga',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8586',
      label: 'Yallapur',
      type: 'City'
    },
    {
      value: '8587',
      label: 'Yallapura',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8588',
      label: 'Yamuna Nagar',
      type: 'City',
      'state': 'Haryana'
    },
    {
      value: '8589',
      label: 'Yamunotri',
      type: 'City'
    },
    {
      value: '8590',
      label: 'Yanam',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8591',
      label: 'Yanam Bridge',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8592',
      label: 'Yaragatti',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8593',
      label: 'Yarlagadda',
      type: 'City'
    },
    {
      value: '8594',
      label: 'Yarravaram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8595',
      label: 'Yaval',
      type: 'City'
    },
    {
      value: '8596',
      label: 'Yavat',
      type: 'City'
    },
    {
      value: '8597',
      label: 'Yavatmal',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8598',
      label: 'Yawal',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8599',
      label: 'Yedapadav',
      type: 'City'
    },
    {
      value: '8600',
      label: 'Yedapadavu',
      type: 'City'
    },
    {
      value: '8601',
      label: 'Yedashi',
      type: 'City'
    },
    {
      value: '8602',
      label: 'Yedsi',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8603',
      label: 'Yedthady',
      type: 'City'
    },
    {
      value: '8604',
      label: 'Yedthare',
      type: 'City'
    },
    {
      value: '8605',
      label: 'Yedullapalli',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8606',
      label: 'Yeduru Lanka',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8607',
      label: 'Yelamanchili',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8608',
      label: 'Yelburga',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8609',
      label: 'Yellamanchili',
      type: 'City'
    },
    {
      value: '8610',
      label: 'Yellandu',
      type: 'City'
    },
    {
      value: '8611',
      label: 'Yellapur',
      type: 'City',
      'state': 'Karnataka'
    },
    {
      value: '8612',
      label: 'Yellapura',
      type: 'City'
    },
    {
      value: '8613',
      label: 'Yemmiganur',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8614',
      label: 'Yeola',
      type: 'City',
      'state': 'Maharashtra'
    },
    {
      value: '8615',
      label: 'Yeraguntla',
      type: 'City'
    },
    {
      value: '8616',
      label: 'Yermal',
      type: 'City'
    },
    {
      value: '8617',
      label: 'Yermal Thenka',
      type: 'City'
    },
    {
      value: '8618',
      label: 'Yermala',
      type: 'City'
    },
    {
      value: '8619',
      label: 'Yernagudem',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8620',
      label: 'Yerrabalem',
      type: 'City'
    },
    {
      value: '8621',
      label: 'Yerragondapalem',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8622',
      label: 'Yerraguntla',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8623',
      label: 'Yerravaram',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8624',
      label: 'Yol',
      type: 'City'
    },
    {
      value: '8625',
      label: 'Zabuva',
      type: 'City'
    },
    {
      value: '8626',
      label: 'Zadkala',
      type: 'City'
    },
    {
      value: '8627',
      label: 'Zaheerabad',
      type: 'City',
      'state': 'Andhra Pradesh'
    },
    {
      value: '8628',
      label: 'Zalansar',
      type: 'City'
    },
    {
      value: '8629',
      label: 'Zamrala',
      type: 'City'
    },
    {
      value: '8630',
      label: 'Zapala',
      type: 'City'
    },
    {
      value: '8631',
      label: 'Zarap',
      type: 'City'
    },
    {
      value: '8632',
      label: 'Zari',
      type: 'City'
    },
    {
      value: '8633',
      label: 'Zebediela',
      type: 'City'
    },
    {
      value: '8634',
      label: 'Zero Phata',
      type: 'City'
    },
    {
      value: '8635',
      label: 'Ziliya',
      type: 'City'
    },
    {
      value: '8636',
      label: 'Zira',
      type: 'City'
    },
    {
      value: '8637',
      label: 'Zirakpur',
      type: 'City'
    },
    {
      value: '8638',
      label: 'Sullurpeta',
      type: 'City'
    },
    {
      value: '8639',
      label: 'Guduru (Nellore District)',
      type: 'City'
    },
    {
      value: '8640',
      label: 'Karaikal (Pondicherry)',
      type: 'City'
    }
  ]

  export default cities;
